export interface Icons {
  bootstrap:
    | '123'
    | 'activity'
    | 'alarm'
    | 'alarm-fill'
    | 'align-bottom'
    | 'align-center'
    | 'align-end'
    | 'align-middle'
    | 'align-start'
    | 'align-top'
    | 'alt'
    | 'app'
    | 'app-indicator'
    | 'apple'
    | 'archive'
    | 'archive-fill'
    | 'arrow-90deg-down'
    | 'arrow-90deg-left'
    | 'arrow-90deg-right'
    | 'arrow-90deg-up'
    | 'arrow-bar-down'
    | 'arrow-bar-left'
    | 'arrow-bar-right'
    | 'arrow-bar-up'
    | 'arrow-clockwise'
    | 'arrow-counterclockwise'
    | 'arrow-down'
    | 'arrow-down-circle'
    | 'arrow-down-circle-fill'
    | 'arrow-down-left'
    | 'arrow-down-left-circle'
    | 'arrow-down-left-circle-fill'
    | 'arrow-down-left-square'
    | 'arrow-down-left-square-fill'
    | 'arrow-down-right'
    | 'arrow-down-right-circle'
    | 'arrow-down-right-circle-fill'
    | 'arrow-down-right-square'
    | 'arrow-down-right-square-fill'
    | 'arrow-down-short'
    | 'arrow-down-square'
    | 'arrow-down-square-fill'
    | 'arrow-down-up'
    | 'arrow-left'
    | 'arrow-left-circle'
    | 'arrow-left-circle-fill'
    | 'arrow-left-right'
    | 'arrow-left-short'
    | 'arrow-left-square'
    | 'arrow-left-square-fill'
    | 'arrow-repeat'
    | 'arrow-return-left'
    | 'arrow-return-right'
    | 'arrow-right'
    | 'arrow-right-circle'
    | 'arrow-right-circle-fill'
    | 'arrow-right-short'
    | 'arrow-right-square'
    | 'arrow-right-square-fill'
    | 'arrow-through-heart'
    | 'arrow-through-heart-fill'
    | 'arrow-up'
    | 'arrow-up-circle'
    | 'arrow-up-circle-fill'
    | 'arrow-up-left'
    | 'arrow-up-left-circle'
    | 'arrow-up-left-circle-fill'
    | 'arrow-up-left-square'
    | 'arrow-up-left-square-fill'
    | 'arrow-up-right'
    | 'arrow-up-right-circle'
    | 'arrow-up-right-circle-fill'
    | 'arrow-up-right-square'
    | 'arrow-up-right-square-fill'
    | 'arrow-up-short'
    | 'arrow-up-square'
    | 'arrow-up-square-fill'
    | 'arrows-angle-contract'
    | 'arrows-angle-expand'
    | 'arrows-collapse'
    | 'arrows-expand'
    | 'arrows-fullscreen'
    | 'arrows-move'
    | 'aspect-ratio'
    | 'aspect-ratio-fill'
    | 'asterisk'
    | 'at'
    | 'award'
    | 'award-fill'
    | 'back'
    | 'backspace'
    | 'backspace-fill'
    | 'backspace-reverse'
    | 'backspace-reverse-fill'
    | 'badge-3d'
    | 'badge-3d-fill'
    | 'badge-4k'
    | 'badge-4k-fill'
    | 'badge-8k'
    | 'badge-8k-fill'
    | 'badge-ad'
    | 'badge-ad-fill'
    | 'badge-ar'
    | 'badge-ar-fill'
    | 'badge-cc'
    | 'badge-cc-fill'
    | 'badge-hd'
    | 'badge-hd-fill'
    | 'badge-sd'
    | 'badge-sd-fill'
    | 'badge-tm'
    | 'badge-tm-fill'
    | 'badge-vo'
    | 'badge-vo-fill'
    | 'badge-vr'
    | 'badge-vr-fill'
    | 'badge-wc'
    | 'badge-wc-fill'
    | 'bag'
    | 'bag-check'
    | 'bag-check-fill'
    | 'bag-dash'
    | 'bag-dash-fill'
    | 'bag-fill'
    | 'bag-heart'
    | 'bag-heart-fill'
    | 'bag-plus'
    | 'bag-plus-fill'
    | 'bag-x'
    | 'bag-x-fill'
    | 'balloon'
    | 'balloon-fill'
    | 'balloon-heart'
    | 'balloon-heart-fill'
    | 'bandaid'
    | 'bandaid-fill'
    | 'bank'
    | 'bank2'
    | 'bar-chart'
    | 'bar-chart-fill'
    | 'bar-chart-line'
    | 'bar-chart-line-fill'
    | 'bar-chart-steps'
    | 'basket'
    | 'basket-fill'
    | 'basket2'
    | 'basket2-fill'
    | 'basket3'
    | 'basket3-fill'
    | 'battery'
    | 'battery-charging'
    | 'battery-full'
    | 'battery-half'
    | 'behance'
    | 'bell'
    | 'bell-fill'
    | 'bell-slash'
    | 'bell-slash-fill'
    | 'bezier'
    | 'bezier2'
    | 'bicycle'
    | 'binoculars'
    | 'binoculars-fill'
    | 'blockquote-left'
    | 'blockquote-right'
    | 'bluetooth'
    | 'body-text'
    | 'book'
    | 'book-fill'
    | 'book-half'
    | 'bookmark'
    | 'bookmark-check'
    | 'bookmark-check-fill'
    | 'bookmark-dash'
    | 'bookmark-dash-fill'
    | 'bookmark-fill'
    | 'bookmark-heart'
    | 'bookmark-heart-fill'
    | 'bookmark-plus'
    | 'bookmark-plus-fill'
    | 'bookmark-star'
    | 'bookmark-star-fill'
    | 'bookmark-x'
    | 'bookmark-x-fill'
    | 'bookmarks'
    | 'bookmarks-fill'
    | 'bookshelf'
    | 'boombox'
    | 'boombox-fill'
    | 'bootstrap'
    | 'bootstrap-fill'
    | 'bootstrap-reboot'
    | 'border'
    | 'border-all'
    | 'border-bottom'
    | 'border-center'
    | 'border-inner'
    | 'border-left'
    | 'border-middle'
    | 'border-outer'
    | 'border-right'
    | 'border-style'
    | 'border-top'
    | 'border-width'
    | 'bounding-box'
    | 'bounding-box-circles'
    | 'box'
    | 'box-arrow-down'
    | 'box-arrow-down-left'
    | 'box-arrow-down-right'
    | 'box-arrow-in-down'
    | 'box-arrow-in-down-left'
    | 'box-arrow-in-down-right'
    | 'box-arrow-in-left'
    | 'box-arrow-in-right'
    | 'box-arrow-in-up'
    | 'box-arrow-in-up-left'
    | 'box-arrow-in-up-right'
    | 'box-arrow-left'
    | 'box-arrow-right'
    | 'box-arrow-up'
    | 'box-arrow-up-left'
    | 'box-arrow-up-right'
    | 'box-seam'
    | 'box2'
    | 'box2-fill'
    | 'box2-heart'
    | 'box2-heart-fill'
    | 'boxes'
    | 'braces'
    | 'braces-asterisk'
    | 'bricks'
    | 'briefcase'
    | 'briefcase-fill'
    | 'brightness-alt-high'
    | 'brightness-alt-high-fill'
    | 'brightness-alt-low'
    | 'brightness-alt-low-fill'
    | 'brightness-high'
    | 'brightness-high-fill'
    | 'brightness-low'
    | 'brightness-low-fill'
    | 'broadcast'
    | 'broadcast-pin'
    | 'brush'
    | 'brush-fill'
    | 'bucket'
    | 'bucket-fill'
    | 'bug'
    | 'bug-fill'
    | 'building'
    | 'bullseye'
    | 'calculator'
    | 'calculator-fill'
    | 'calendar'
    | 'calendar-check'
    | 'calendar-check-fill'
    | 'calendar-date'
    | 'calendar-date-fill'
    | 'calendar-day'
    | 'calendar-day-fill'
    | 'calendar-event'
    | 'calendar-event-fill'
    | 'calendar-fill'
    | 'calendar-heart'
    | 'calendar-heart-fill'
    | 'calendar-minus'
    | 'calendar-minus-fill'
    | 'calendar-month'
    | 'calendar-month-fill'
    | 'calendar-plus'
    | 'calendar-plus-fill'
    | 'calendar-range'
    | 'calendar-range-fill'
    | 'calendar-week'
    | 'calendar-week-fill'
    | 'calendar-x'
    | 'calendar-x-fill'
    | 'calendar2'
    | 'calendar2-check'
    | 'calendar2-check-fill'
    | 'calendar2-date'
    | 'calendar2-date-fill'
    | 'calendar2-day'
    | 'calendar2-day-fill'
    | 'calendar2-event'
    | 'calendar2-event-fill'
    | 'calendar2-fill'
    | 'calendar2-heart'
    | 'calendar2-heart-fill'
    | 'calendar2-minus'
    | 'calendar2-minus-fill'
    | 'calendar2-month'
    | 'calendar2-month-fill'
    | 'calendar2-plus'
    | 'calendar2-plus-fill'
    | 'calendar2-range'
    | 'calendar2-range-fill'
    | 'calendar2-week'
    | 'calendar2-week-fill'
    | 'calendar2-x'
    | 'calendar2-x-fill'
    | 'calendar3'
    | 'calendar3-event'
    | 'calendar3-event-fill'
    | 'calendar3-fill'
    | 'calendar3-range'
    | 'calendar3-range-fill'
    | 'calendar3-week'
    | 'calendar3-week-fill'
    | 'calendar4'
    | 'calendar4-event'
    | 'calendar4-range'
    | 'calendar4-week'
    | 'camera'
    | 'camera-fill'
    | 'camera-reels'
    | 'camera-reels-fill'
    | 'camera-video'
    | 'camera-video-fill'
    | 'camera-video-off'
    | 'camera-video-off-fill'
    | 'camera2'
    | 'capslock'
    | 'capslock-fill'
    | 'card-checklist'
    | 'card-heading'
    | 'card-image'
    | 'card-list'
    | 'card-text'
    | 'caret-down'
    | 'caret-down-fill'
    | 'caret-down-square'
    | 'caret-down-square-fill'
    | 'caret-left'
    | 'caret-left-fill'
    | 'caret-left-square'
    | 'caret-left-square-fill'
    | 'caret-right'
    | 'caret-right-fill'
    | 'caret-right-square'
    | 'caret-right-square-fill'
    | 'caret-up'
    | 'caret-up-fill'
    | 'caret-up-square'
    | 'caret-up-square-fill'
    | 'cart'
    | 'cart-check'
    | 'cart-check-fill'
    | 'cart-dash'
    | 'cart-dash-fill'
    | 'cart-fill'
    | 'cart-plus'
    | 'cart-plus-fill'
    | 'cart-x'
    | 'cart-x-fill'
    | 'cart2'
    | 'cart3'
    | 'cart4'
    | 'cash'
    | 'cash-coin'
    | 'cash-stack'
    | 'cast'
    | 'chat'
    | 'chat-dots'
    | 'chat-dots-fill'
    | 'chat-fill'
    | 'chat-heart'
    | 'chat-heart-fill'
    | 'chat-left'
    | 'chat-left-dots'
    | 'chat-left-dots-fill'
    | 'chat-left-fill'
    | 'chat-left-heart'
    | 'chat-left-heart-fill'
    | 'chat-left-quote'
    | 'chat-left-quote-fill'
    | 'chat-left-text'
    | 'chat-left-text-fill'
    | 'chat-quote'
    | 'chat-quote-fill'
    | 'chat-right'
    | 'chat-right-dots'
    | 'chat-right-dots-fill'
    | 'chat-right-fill'
    | 'chat-right-heart'
    | 'chat-right-heart-fill'
    | 'chat-right-quote'
    | 'chat-right-quote-fill'
    | 'chat-right-text'
    | 'chat-right-text-fill'
    | 'chat-square'
    | 'chat-square-dots'
    | 'chat-square-dots-fill'
    | 'chat-square-fill'
    | 'chat-square-heart'
    | 'chat-square-heart-fill'
    | 'chat-square-quote'
    | 'chat-square-quote-fill'
    | 'chat-square-text'
    | 'chat-square-text-fill'
    | 'chat-text'
    | 'chat-text-fill'
    | 'check'
    | 'check-all'
    | 'check-circle'
    | 'check-circle-fill'
    | 'check-lg'
    | 'check-square'
    | 'check-square-fill'
    | 'check2'
    | 'check2-all'
    | 'check2-circle'
    | 'check2-square'
    | 'chevron-bar-contract'
    | 'chevron-bar-down'
    | 'chevron-bar-expand'
    | 'chevron-bar-left'
    | 'chevron-bar-right'
    | 'chevron-bar-up'
    | 'chevron-compact-down'
    | 'chevron-compact-left'
    | 'chevron-compact-right'
    | 'chevron-compact-up'
    | 'chevron-contract'
    | 'chevron-double-down'
    | 'chevron-double-left'
    | 'chevron-double-right'
    | 'chevron-double-up'
    | 'chevron-down'
    | 'chevron-expand'
    | 'chevron-left'
    | 'chevron-right'
    | 'chevron-up'
    | 'circle'
    | 'circle-fill'
    | 'circle-half'
    | 'circle-square'
    | 'clipboard'
    | 'clipboard-check'
    | 'clipboard-check-fill'
    | 'clipboard-data'
    | 'clipboard-data-fill'
    | 'clipboard-fill'
    | 'clipboard-heart'
    | 'clipboard-heart-fill'
    | 'clipboard-minus'
    | 'clipboard-minus-fill'
    | 'clipboard-plus'
    | 'clipboard-plus-fill'
    | 'clipboard-pulse'
    | 'clipboard-x'
    | 'clipboard-x-fill'
    | 'clipboard2'
    | 'clipboard2-check'
    | 'clipboard2-check-fill'
    | 'clipboard2-data'
    | 'clipboard2-data-fill'
    | 'clipboard2-fill'
    | 'clipboard2-heart'
    | 'clipboard2-heart-fill'
    | 'clipboard2-minus'
    | 'clipboard2-minus-fill'
    | 'clipboard2-plus'
    | 'clipboard2-plus-fill'
    | 'clipboard2-pulse'
    | 'clipboard2-pulse-fill'
    | 'clipboard2-x'
    | 'clipboard2-x-fill'
    | 'clock'
    | 'clock-fill'
    | 'clock-history'
    | 'cloud'
    | 'cloud-arrow-down'
    | 'cloud-arrow-down-fill'
    | 'cloud-arrow-up'
    | 'cloud-arrow-up-fill'
    | 'cloud-check'
    | 'cloud-check-fill'
    | 'cloud-download'
    | 'cloud-download-fill'
    | 'cloud-drizzle'
    | 'cloud-drizzle-fill'
    | 'cloud-fill'
    | 'cloud-fog'
    | 'cloud-fog-fill'
    | 'cloud-fog2'
    | 'cloud-fog2-fill'
    | 'cloud-hail'
    | 'cloud-hail-fill'
    | 'cloud-haze'
    | 'cloud-haze-fill'
    | 'cloud-haze2'
    | 'cloud-haze2-fill'
    | 'cloud-lightning'
    | 'cloud-lightning-fill'
    | 'cloud-lightning-rain'
    | 'cloud-lightning-rain-fill'
    | 'cloud-minus'
    | 'cloud-minus-fill'
    | 'cloud-moon'
    | 'cloud-moon-fill'
    | 'cloud-plus'
    | 'cloud-plus-fill'
    | 'cloud-rain'
    | 'cloud-rain-fill'
    | 'cloud-rain-heavy'
    | 'cloud-rain-heavy-fill'
    | 'cloud-slash'
    | 'cloud-slash-fill'
    | 'cloud-sleet'
    | 'cloud-sleet-fill'
    | 'cloud-snow'
    | 'cloud-snow-fill'
    | 'cloud-sun'
    | 'cloud-sun-fill'
    | 'cloud-upload'
    | 'cloud-upload-fill'
    | 'clouds'
    | 'clouds-fill'
    | 'cloudy'
    | 'cloudy-fill'
    | 'code'
    | 'code-slash'
    | 'code-square'
    | 'coin'
    | 'collection'
    | 'collection-fill'
    | 'collection-play'
    | 'collection-play-fill'
    | 'columns'
    | 'columns-gap'
    | 'command'
    | 'compass'
    | 'compass-fill'
    | 'cone'
    | 'cone-striped'
    | 'controller'
    | 'cpu'
    | 'cpu-fill'
    | 'credit-card'
    | 'credit-card-2-back'
    | 'credit-card-2-back-fill'
    | 'credit-card-2-front'
    | 'credit-card-2-front-fill'
    | 'credit-card-fill'
    | 'crop'
    | 'cup'
    | 'cup-fill'
    | 'cup-straw'
    | 'currency-bitcoin'
    | 'currency-dollar'
    | 'currency-euro'
    | 'currency-exchange'
    | 'currency-pound'
    | 'currency-yen'
    | 'cursor'
    | 'cursor-fill'
    | 'cursor-text'
    | 'dash'
    | 'dash-circle'
    | 'dash-circle-dotted'
    | 'dash-circle-fill'
    | 'dash-lg'
    | 'dash-square'
    | 'dash-square-dotted'
    | 'dash-square-fill'
    | 'device-hdd'
    | 'device-hdd-fill'
    | 'device-ssd'
    | 'device-ssd-fill'
    | 'diagram-2'
    | 'diagram-2-fill'
    | 'diagram-3'
    | 'diagram-3-fill'
    | 'diamond'
    | 'diamond-fill'
    | 'diamond-half'
    | 'dice-1'
    | 'dice-1-fill'
    | 'dice-2'
    | 'dice-2-fill'
    | 'dice-3'
    | 'dice-3-fill'
    | 'dice-4'
    | 'dice-4-fill'
    | 'dice-5'
    | 'dice-5-fill'
    | 'dice-6'
    | 'dice-6-fill'
    | 'disc'
    | 'disc-fill'
    | 'discord'
    | 'display'
    | 'display-fill'
    | 'displayport'
    | 'displayport-fill'
    | 'distribute-horizontal'
    | 'distribute-vertical'
    | 'door-closed'
    | 'door-closed-fill'
    | 'door-open'
    | 'door-open-fill'
    | 'dot'
    | 'download'
    | 'dpad'
    | 'dpad-fill'
    | 'dribbble'
    | 'droplet'
    | 'droplet-fill'
    | 'droplet-half'
    | 'ear'
    | 'ear-fill'
    | 'earbuds'
    | 'easel'
    | 'easel-fill'
    | 'easel2'
    | 'easel2-fill'
    | 'easel3'
    | 'easel3-fill'
    | 'egg'
    | 'egg-fill'
    | 'egg-fried'
    | 'eject'
    | 'eject-fill'
    | 'emoji-angry'
    | 'emoji-angry-fill'
    | 'emoji-dizzy'
    | 'emoji-dizzy-fill'
    | 'emoji-expressionless'
    | 'emoji-expressionless-fill'
    | 'emoji-frown'
    | 'emoji-frown-fill'
    | 'emoji-heart-eyes'
    | 'emoji-heart-eyes-fill'
    | 'emoji-kiss'
    | 'emoji-kiss-fill'
    | 'emoji-laughing'
    | 'emoji-laughing-fill'
    | 'emoji-neutral'
    | 'emoji-neutral-fill'
    | 'emoji-smile'
    | 'emoji-smile-fill'
    | 'emoji-smile-upside-down'
    | 'emoji-smile-upside-down-fill'
    | 'emoji-sunglasses'
    | 'emoji-sunglasses-fill'
    | 'emoji-wink'
    | 'emoji-wink-fill'
    | 'envelope'
    | 'envelope-check'
    | 'envelope-check-fill'
    | 'envelope-dash'
    | 'envelope-dash-fill'
    | 'envelope-exclamation'
    | 'envelope-exclamation-fill'
    | 'envelope-fill'
    | 'envelope-heart'
    | 'envelope-heart-fill'
    | 'envelope-open'
    | 'envelope-open-fill'
    | 'envelope-open-heart'
    | 'envelope-open-heart-fill'
    | 'envelope-paper'
    | 'envelope-paper-fill'
    | 'envelope-paper-heart'
    | 'envelope-paper-heart-fill'
    | 'envelope-plus'
    | 'envelope-plus-fill'
    | 'envelope-slash'
    | 'envelope-slash-fill'
    | 'envelope-x'
    | 'envelope-x-fill'
    | 'eraser'
    | 'eraser-fill'
    | 'ethernet'
    | 'exclamation'
    | 'exclamation-circle'
    | 'exclamation-circle-fill'
    | 'exclamation-diamond'
    | 'exclamation-diamond-fill'
    | 'exclamation-lg'
    | 'exclamation-octagon'
    | 'exclamation-octagon-fill'
    | 'exclamation-square'
    | 'exclamation-square-fill'
    | 'exclamation-triangle'
    | 'exclamation-triangle-fill'
    | 'exclude'
    | 'explicit'
    | 'explicit-fill'
    | 'eye'
    | 'eye-fill'
    | 'eye-slash'
    | 'eye-slash-fill'
    | 'eyedropper'
    | 'eyeglasses'
    | 'facebook'
    | 'fan'
    | 'file'
    | 'file-arrow-down'
    | 'file-arrow-down-fill'
    | 'file-arrow-up'
    | 'file-arrow-up-fill'
    | 'file-bar-graph'
    | 'file-bar-graph-fill'
    | 'file-binary'
    | 'file-binary-fill'
    | 'file-break'
    | 'file-break-fill'
    | 'file-check'
    | 'file-check-fill'
    | 'file-code'
    | 'file-code-fill'
    | 'file-diff'
    | 'file-diff-fill'
    | 'file-earmark'
    | 'file-earmark-arrow-down'
    | 'file-earmark-arrow-down-fill'
    | 'file-earmark-arrow-up'
    | 'file-earmark-arrow-up-fill'
    | 'file-earmark-bar-graph'
    | 'file-earmark-bar-graph-fill'
    | 'file-earmark-binary'
    | 'file-earmark-binary-fill'
    | 'file-earmark-break'
    | 'file-earmark-break-fill'
    | 'file-earmark-check'
    | 'file-earmark-check-fill'
    | 'file-earmark-code'
    | 'file-earmark-code-fill'
    | 'file-earmark-diff'
    | 'file-earmark-diff-fill'
    | 'file-earmark-easel'
    | 'file-earmark-easel-fill'
    | 'file-earmark-excel'
    | 'file-earmark-excel-fill'
    | 'file-earmark-fill'
    | 'file-earmark-font'
    | 'file-earmark-font-fill'
    | 'file-earmark-image'
    | 'file-earmark-image-fill'
    | 'file-earmark-lock'
    | 'file-earmark-lock-fill'
    | 'file-earmark-lock2'
    | 'file-earmark-lock2-fill'
    | 'file-earmark-medical'
    | 'file-earmark-medical-fill'
    | 'file-earmark-minus'
    | 'file-earmark-minus-fill'
    | 'file-earmark-music'
    | 'file-earmark-music-fill'
    | 'file-earmark-pdf'
    | 'file-earmark-pdf-fill'
    | 'file-earmark-person'
    | 'file-earmark-person-fill'
    | 'file-earmark-play'
    | 'file-earmark-play-fill'
    | 'file-earmark-plus'
    | 'file-earmark-plus-fill'
    | 'file-earmark-post'
    | 'file-earmark-post-fill'
    | 'file-earmark-ppt'
    | 'file-earmark-ppt-fill'
    | 'file-earmark-richtext'
    | 'file-earmark-richtext-fill'
    | 'file-earmark-ruled'
    | 'file-earmark-ruled-fill'
    | 'file-earmark-slides'
    | 'file-earmark-slides-fill'
    | 'file-earmark-spreadsheet'
    | 'file-earmark-spreadsheet-fill'
    | 'file-earmark-text'
    | 'file-earmark-text-fill'
    | 'file-earmark-word'
    | 'file-earmark-word-fill'
    | 'file-earmark-x'
    | 'file-earmark-x-fill'
    | 'file-earmark-zip'
    | 'file-earmark-zip-fill'
    | 'file-easel'
    | 'file-easel-fill'
    | 'file-excel'
    | 'file-excel-fill'
    | 'file-fill'
    | 'file-font'
    | 'file-font-fill'
    | 'file-image'
    | 'file-image-fill'
    | 'file-lock'
    | 'file-lock-fill'
    | 'file-lock2'
    | 'file-lock2-fill'
    | 'file-medical'
    | 'file-medical-fill'
    | 'file-minus'
    | 'file-minus-fill'
    | 'file-music'
    | 'file-music-fill'
    | 'file-pdf'
    | 'file-pdf-fill'
    | 'file-person'
    | 'file-person-fill'
    | 'file-play'
    | 'file-play-fill'
    | 'file-plus'
    | 'file-plus-fill'
    | 'file-post'
    | 'file-post-fill'
    | 'file-ppt'
    | 'file-ppt-fill'
    | 'file-richtext'
    | 'file-richtext-fill'
    | 'file-ruled'
    | 'file-ruled-fill'
    | 'file-slides'
    | 'file-slides-fill'
    | 'file-spreadsheet'
    | 'file-spreadsheet-fill'
    | 'file-text'
    | 'file-text-fill'
    | 'file-word'
    | 'file-word-fill'
    | 'file-x'
    | 'file-x-fill'
    | 'file-zip'
    | 'file-zip-fill'
    | 'files'
    | 'files-alt'
    | 'filetype-aac'
    | 'filetype-ai'
    | 'filetype-bmp'
    | 'filetype-cs'
    | 'filetype-css'
    | 'filetype-csv'
    | 'filetype-doc'
    | 'filetype-docx'
    | 'filetype-exe'
    | 'filetype-gif'
    | 'filetype-heic'
    | 'filetype-html'
    | 'filetype-java'
    | 'filetype-jpg'
    | 'filetype-js'
    | 'filetype-json'
    | 'filetype-jsx'
    | 'filetype-key'
    | 'filetype-m4p'
    | 'filetype-md'
    | 'filetype-mdx'
    | 'filetype-mov'
    | 'filetype-mp3'
    | 'filetype-mp4'
    | 'filetype-otf'
    | 'filetype-pdf'
    | 'filetype-php'
    | 'filetype-png'
    | 'filetype-ppt'
    | 'filetype-pptx'
    | 'filetype-psd'
    | 'filetype-py'
    | 'filetype-raw'
    | 'filetype-rb'
    | 'filetype-sass'
    | 'filetype-scss'
    | 'filetype-sh'
    | 'filetype-svg'
    | 'filetype-tiff'
    | 'filetype-tsx'
    | 'filetype-ttf'
    | 'filetype-txt'
    | 'filetype-wav'
    | 'filetype-woff'
    | 'filetype-xls'
    | 'filetype-xlsx'
    | 'filetype-xml'
    | 'filetype-yml'
    | 'film'
    | 'filter'
    | 'filter-circle'
    | 'filter-circle-fill'
    | 'filter-left'
    | 'filter-right'
    | 'filter-square'
    | 'filter-square-fill'
    | 'fingerprint'
    | 'flag'
    | 'flag-fill'
    | 'flower1'
    | 'flower2'
    | 'flower3'
    | 'folder'
    | 'folder-check'
    | 'folder-fill'
    | 'folder-minus'
    | 'folder-plus'
    | 'folder-symlink'
    | 'folder-symlink-fill'
    | 'folder-x'
    | 'folder2'
    | 'folder2-open'
    | 'fonts'
    | 'forward'
    | 'forward-fill'
    | 'front'
    | 'fullscreen'
    | 'fullscreen-exit'
    | 'funnel'
    | 'funnel-fill'
    | 'gear'
    | 'gear-fill'
    | 'gear-wide'
    | 'gear-wide-connected'
    | 'gem'
    | 'gender-ambiguous'
    | 'gender-female'
    | 'gender-male'
    | 'gender-trans'
    | 'geo'
    | 'geo-alt'
    | 'geo-alt-fill'
    | 'geo-fill'
    | 'gift'
    | 'gift-fill'
    | 'git'
    | 'github'
    | 'globe'
    | 'globe2'
    | 'google'
    | 'gpu-card'
    | 'graph-down'
    | 'graph-down-arrow'
    | 'graph-up'
    | 'graph-up-arrow'
    | 'grid'
    | 'grid-1x2'
    | 'grid-1x2-fill'
    | 'grid-3x2'
    | 'grid-3x2-gap'
    | 'grid-3x2-gap-fill'
    | 'grid-3x3'
    | 'grid-3x3-gap'
    | 'grid-3x3-gap-fill'
    | 'grid-fill'
    | 'grip-horizontal'
    | 'grip-vertical'
    | 'hammer'
    | 'hand-index'
    | 'hand-index-fill'
    | 'hand-index-thumb'
    | 'hand-index-thumb-fill'
    | 'hand-thumbs-down'
    | 'hand-thumbs-down-fill'
    | 'hand-thumbs-up'
    | 'hand-thumbs-up-fill'
    | 'handbag'
    | 'handbag-fill'
    | 'hash'
    | 'hdd'
    | 'hdd-fill'
    | 'hdd-network'
    | 'hdd-network-fill'
    | 'hdd-rack'
    | 'hdd-rack-fill'
    | 'hdd-stack'
    | 'hdd-stack-fill'
    | 'hdmi'
    | 'hdmi-fill'
    | 'headphones'
    | 'headset'
    | 'headset-vr'
    | 'heart'
    | 'heart-arrow'
    | 'heart-fill'
    | 'heart-half'
    | 'heart-pulse'
    | 'heart-pulse-fill'
    | 'heartbreak'
    | 'heartbreak-fill'
    | 'hearts'
    | 'heptagon'
    | 'heptagon-fill'
    | 'heptagon-half'
    | 'hexagon'
    | 'hexagon-fill'
    | 'hexagon-half'
    | 'hospital'
    | 'hospital-fill'
    | 'hourglass'
    | 'hourglass-bottom'
    | 'hourglass-split'
    | 'hourglass-top'
    | 'house'
    | 'house-door'
    | 'house-door-fill'
    | 'house-fill'
    | 'house-heart'
    | 'house-heart-fill'
    | 'hr'
    | 'hurricane'
    | 'hypnotize'
    | 'image'
    | 'image-alt'
    | 'image-fill'
    | 'images'
    | 'inbox'
    | 'inbox-fill'
    | 'inboxes'
    | 'inboxes-fill'
    | 'incognito'
    | 'infinity'
    | 'info'
    | 'info-circle'
    | 'info-circle-fill'
    | 'info-lg'
    | 'info-square'
    | 'info-square-fill'
    | 'input-cursor'
    | 'input-cursor-text'
    | 'instagram'
    | 'intersect'
    | 'journal'
    | 'journal-album'
    | 'journal-arrow-down'
    | 'journal-arrow-up'
    | 'journal-bookmark'
    | 'journal-bookmark-fill'
    | 'journal-check'
    | 'journal-code'
    | 'journal-medical'
    | 'journal-minus'
    | 'journal-plus'
    | 'journal-richtext'
    | 'journal-text'
    | 'journal-x'
    | 'journals'
    | 'joystick'
    | 'justify'
    | 'justify-left'
    | 'justify-right'
    | 'kanban'
    | 'kanban-fill'
    | 'key'
    | 'key-fill'
    | 'keyboard'
    | 'keyboard-fill'
    | 'ladder'
    | 'lamp'
    | 'lamp-fill'
    | 'laptop'
    | 'laptop-fill'
    | 'layer-backward'
    | 'layer-forward'
    | 'layers'
    | 'layers-fill'
    | 'layers-half'
    | 'layout-sidebar'
    | 'layout-sidebar-inset'
    | 'layout-sidebar-inset-reverse'
    | 'layout-sidebar-reverse'
    | 'layout-split'
    | 'layout-text-sidebar'
    | 'layout-text-sidebar-reverse'
    | 'layout-text-window'
    | 'layout-text-window-reverse'
    | 'layout-three-columns'
    | 'layout-wtf'
    | 'life-preserver'
    | 'lightbulb'
    | 'lightbulb-fill'
    | 'lightbulb-off'
    | 'lightbulb-off-fill'
    | 'lightning'
    | 'lightning-charge'
    | 'lightning-charge-fill'
    | 'lightning-fill'
    | 'line'
    | 'link'
    | 'link-45deg'
    | 'linkedin'
    | 'list'
    | 'list-check'
    | 'list-columns'
    | 'list-columns-reverse'
    | 'list-nested'
    | 'list-ol'
    | 'list-stars'
    | 'list-task'
    | 'list-ul'
    | 'lock'
    | 'lock-fill'
    | 'magic'
    | 'magnet'
    | 'magnet-fill'
    | 'mailbox'
    | 'mailbox2'
    | 'map'
    | 'map-fill'
    | 'markdown'
    | 'markdown-fill'
    | 'mask'
    | 'mastodon'
    | 'medium'
    | 'megaphone'
    | 'megaphone-fill'
    | 'memory'
    | 'menu-app'
    | 'menu-app-fill'
    | 'menu-button'
    | 'menu-button-fill'
    | 'menu-button-wide'
    | 'menu-button-wide-fill'
    | 'menu-down'
    | 'menu-up'
    | 'messenger'
    | 'meta'
    | 'mic'
    | 'mic-fill'
    | 'mic-mute'
    | 'mic-mute-fill'
    | 'microsoft'
    | 'minecart'
    | 'minecart-loaded'
    | 'modem'
    | 'modem-fill'
    | 'moisture'
    | 'moon'
    | 'moon-fill'
    | 'moon-stars'
    | 'moon-stars-fill'
    | 'mortarboard'
    | 'mortarboard-fill'
    | 'motherboard'
    | 'motherboard-fill'
    | 'mouse'
    | 'mouse-fill'
    | 'mouse2'
    | 'mouse2-fill'
    | 'mouse3'
    | 'mouse3-fill'
    | 'music-note'
    | 'music-note-beamed'
    | 'music-note-list'
    | 'music-player'
    | 'music-player-fill'
    | 'newspaper'
    | 'nintendo-switch'
    | 'node-minus'
    | 'node-minus-fill'
    | 'node-plus'
    | 'node-plus-fill'
    | 'nut'
    | 'nut-fill'
    | 'octagon'
    | 'octagon-fill'
    | 'octagon-half'
    | 'optical-audio'
    | 'optical-audio-fill'
    | 'option'
    | 'outlet'
    | 'paint-bucket'
    | 'palette'
    | 'palette-fill'
    | 'palette2'
    | 'paperclip'
    | 'paragraph'
    | 'patch-check'
    | 'patch-check-fill'
    | 'patch-exclamation'
    | 'patch-exclamation-fill'
    | 'patch-minus'
    | 'patch-minus-fill'
    | 'patch-plus'
    | 'patch-plus-fill'
    | 'patch-question'
    | 'patch-question-fill'
    | 'pause'
    | 'pause-btn'
    | 'pause-btn-fill'
    | 'pause-circle'
    | 'pause-circle-fill'
    | 'pause-fill'
    | 'paypal'
    | 'pc'
    | 'pc-display'
    | 'pc-display-horizontal'
    | 'pc-horizontal'
    | 'pci-card'
    | 'peace'
    | 'peace-fill'
    | 'pen'
    | 'pen-fill'
    | 'pencil'
    | 'pencil-fill'
    | 'pencil-square'
    | 'pentagon'
    | 'pentagon-fill'
    | 'pentagon-half'
    | 'people'
    | 'people-fill'
    | 'percent'
    | 'person'
    | 'person-badge'
    | 'person-badge-fill'
    | 'person-bounding-box'
    | 'person-check'
    | 'person-check-fill'
    | 'person-circle'
    | 'person-dash'
    | 'person-dash-fill'
    | 'person-fill'
    | 'person-heart'
    | 'person-hearts'
    | 'person-lines-fill'
    | 'person-plus'
    | 'person-plus-fill'
    | 'person-rolodex'
    | 'person-square'
    | 'person-video'
    | 'person-video2'
    | 'person-video3'
    | 'person-workspace'
    | 'person-x'
    | 'person-x-fill'
    | 'phone'
    | 'phone-fill'
    | 'phone-flip'
    | 'phone-landscape'
    | 'phone-landscape-fill'
    | 'phone-vibrate'
    | 'phone-vibrate-fill'
    | 'pie-chart'
    | 'pie-chart-fill'
    | 'piggy-bank'
    | 'piggy-bank-fill'
    | 'pin'
    | 'pin-angle'
    | 'pin-angle-fill'
    | 'pin-fill'
    | 'pin-map'
    | 'pin-map-fill'
    | 'pinterest'
    | 'pip'
    | 'pip-fill'
    | 'play'
    | 'play-btn'
    | 'play-btn-fill'
    | 'play-circle'
    | 'play-circle-fill'
    | 'play-fill'
    | 'playstation'
    | 'plug'
    | 'plug-fill'
    | 'plugin'
    | 'plus'
    | 'plus-circle'
    | 'plus-circle-dotted'
    | 'plus-circle-fill'
    | 'plus-lg'
    | 'plus-slash-minus'
    | 'plus-square'
    | 'plus-square-dotted'
    | 'plus-square-fill'
    | 'postage'
    | 'postage-fill'
    | 'postage-heart'
    | 'postage-heart-fill'
    | 'postcard'
    | 'postcard-fill'
    | 'postcard-heart'
    | 'postcard-heart-fill'
    | 'power'
    | 'printer'
    | 'printer-fill'
    | 'projector'
    | 'projector-fill'
    | 'puzzle'
    | 'puzzle-fill'
    | 'qr-code'
    | 'qr-code-scan'
    | 'question'
    | 'question-circle'
    | 'question-circle-fill'
    | 'question-diamond'
    | 'question-diamond-fill'
    | 'question-lg'
    | 'question-octagon'
    | 'question-octagon-fill'
    | 'question-square'
    | 'question-square-fill'
    | 'quora'
    | 'quote'
    | 'radioactive'
    | 'rainbow'
    | 'receipt'
    | 'receipt-cutoff'
    | 'reception-0'
    | 'reception-1'
    | 'reception-2'
    | 'reception-3'
    | 'reception-4'
    | 'record'
    | 'record-btn'
    | 'record-btn-fill'
    | 'record-circle'
    | 'record-circle-fill'
    | 'record-fill'
    | 'record2'
    | 'record2-fill'
    | 'recycle'
    | 'reddit'
    | 'reply'
    | 'reply-all'
    | 'reply-all-fill'
    | 'reply-fill'
    | 'robot'
    | 'router'
    | 'router-fill'
    | 'rss'
    | 'rss-fill'
    | 'rulers'
    | 'safe'
    | 'safe-fill'
    | 'safe2'
    | 'safe2-fill'
    | 'save'
    | 'save-fill'
    | 'save2'
    | 'save2-fill'
    | 'scissors'
    | 'screwdriver'
    | 'sd-card'
    | 'sd-card-fill'
    | 'search'
    | 'search-heart'
    | 'search-heart-fill'
    | 'segmented-nav'
    | 'send'
    | 'send-check'
    | 'send-check-fill'
    | 'send-dash'
    | 'send-dash-fill'
    | 'send-exclamation'
    | 'send-exclamation-fill'
    | 'send-fill'
    | 'send-plus'
    | 'send-plus-fill'
    | 'send-slash'
    | 'send-slash-fill'
    | 'send-x'
    | 'send-x-fill'
    | 'server'
    | 'share'
    | 'share-fill'
    | 'shield'
    | 'shield-check'
    | 'shield-exclamation'
    | 'shield-fill'
    | 'shield-fill-check'
    | 'shield-fill-exclamation'
    | 'shield-fill-minus'
    | 'shield-fill-plus'
    | 'shield-fill-x'
    | 'shield-lock'
    | 'shield-lock-fill'
    | 'shield-minus'
    | 'shield-plus'
    | 'shield-shaded'
    | 'shield-slash'
    | 'shield-slash-fill'
    | 'shield-x'
    | 'shift'
    | 'shift-fill'
    | 'shop'
    | 'shop-window'
    | 'shuffle'
    | 'signal'
    | 'signpost'
    | 'signpost-2'
    | 'signpost-2-fill'
    | 'signpost-fill'
    | 'signpost-split'
    | 'signpost-split-fill'
    | 'sim'
    | 'sim-fill'
    | 'skip-backward'
    | 'skip-backward-btn'
    | 'skip-backward-btn-fill'
    | 'skip-backward-circle'
    | 'skip-backward-circle-fill'
    | 'skip-backward-fill'
    | 'skip-end'
    | 'skip-end-btn'
    | 'skip-end-btn-fill'
    | 'skip-end-circle'
    | 'skip-end-circle-fill'
    | 'skip-end-fill'
    | 'skip-forward'
    | 'skip-forward-btn'
    | 'skip-forward-btn-fill'
    | 'skip-forward-circle'
    | 'skip-forward-circle-fill'
    | 'skip-forward-fill'
    | 'skip-start'
    | 'skip-start-btn'
    | 'skip-start-btn-fill'
    | 'skip-start-circle'
    | 'skip-start-circle-fill'
    | 'skip-start-fill'
    | 'skype'
    | 'slack'
    | 'slash'
    | 'slash-circle'
    | 'slash-circle-fill'
    | 'slash-lg'
    | 'slash-square'
    | 'slash-square-fill'
    | 'sliders'
    | 'sliders2'
    | 'sliders2-vertical'
    | 'smartwatch'
    | 'snapchat'
    | 'snow'
    | 'snow2'
    | 'snow3'
    | 'sort-alpha-down'
    | 'sort-alpha-down-alt'
    | 'sort-alpha-up'
    | 'sort-alpha-up-alt'
    | 'sort-down'
    | 'sort-down-alt'
    | 'sort-numeric-down'
    | 'sort-numeric-down-alt'
    | 'sort-numeric-up'
    | 'sort-numeric-up-alt'
    | 'sort-up'
    | 'sort-up-alt'
    | 'soundwave'
    | 'speaker'
    | 'speaker-fill'
    | 'speedometer'
    | 'speedometer2'
    | 'spellcheck'
    | 'spotify'
    | 'square'
    | 'square-fill'
    | 'square-half'
    | 'stack'
    | 'stack-overflow'
    | 'star'
    | 'star-fill'
    | 'star-half'
    | 'stars'
    | 'steam'
    | 'stickies'
    | 'stickies-fill'
    | 'sticky'
    | 'sticky-fill'
    | 'stop'
    | 'stop-btn'
    | 'stop-btn-fill'
    | 'stop-circle'
    | 'stop-circle-fill'
    | 'stop-fill'
    | 'stoplights'
    | 'stoplights-fill'
    | 'stopwatch'
    | 'stopwatch-fill'
    | 'strava'
    | 'subtract'
    | 'suit-club'
    | 'suit-club-fill'
    | 'suit-diamond'
    | 'suit-diamond-fill'
    | 'suit-heart'
    | 'suit-heart-fill'
    | 'suit-spade'
    | 'suit-spade-fill'
    | 'sun'
    | 'sun-fill'
    | 'sunglasses'
    | 'sunrise'
    | 'sunrise-fill'
    | 'sunset'
    | 'sunset-fill'
    | 'symmetry-horizontal'
    | 'symmetry-vertical'
    | 'table'
    | 'tablet'
    | 'tablet-fill'
    | 'tablet-landscape'
    | 'tablet-landscape-fill'
    | 'tag'
    | 'tag-fill'
    | 'tags'
    | 'tags-fill'
    | 'telegram'
    | 'telephone'
    | 'telephone-fill'
    | 'telephone-forward'
    | 'telephone-forward-fill'
    | 'telephone-inbound'
    | 'telephone-inbound-fill'
    | 'telephone-minus'
    | 'telephone-minus-fill'
    | 'telephone-outbound'
    | 'telephone-outbound-fill'
    | 'telephone-plus'
    | 'telephone-plus-fill'
    | 'telephone-x'
    | 'telephone-x-fill'
    | 'terminal'
    | 'terminal-dash'
    | 'terminal-fill'
    | 'terminal-plus'
    | 'terminal-split'
    | 'terminal-x'
    | 'text-center'
    | 'text-indent-left'
    | 'text-indent-right'
    | 'text-left'
    | 'text-paragraph'
    | 'text-right'
    | 'textarea'
    | 'textarea-resize'
    | 'textarea-t'
    | 'thermometer'
    | 'thermometer-half'
    | 'thermometer-high'
    | 'thermometer-low'
    | 'thermometer-snow'
    | 'thermometer-sun'
    | 'three-dots'
    | 'three-dots-vertical'
    | 'thunderbolt'
    | 'thunderbolt-fill'
    | 'ticket'
    | 'ticket-detailed'
    | 'ticket-detailed-fill'
    | 'ticket-fill'
    | 'ticket-perforated'
    | 'ticket-perforated-fill'
    | 'tiktok'
    | 'toggle-off'
    | 'toggle-on'
    | 'toggle2-off'
    | 'toggle2-on'
    | 'toggles'
    | 'toggles2'
    | 'tools'
    | 'tornado'
    | 'translate'
    | 'trash'
    | 'trash-fill'
    | 'trash2'
    | 'trash2-fill'
    | 'trash3'
    | 'trash3-fill'
    | 'tree'
    | 'tree-fill'
    | 'triangle'
    | 'triangle-fill'
    | 'triangle-half'
    | 'trophy'
    | 'trophy-fill'
    | 'tropical-storm'
    | 'truck'
    | 'truck-flatbed'
    | 'tsunami'
    | 'tv'
    | 'tv-fill'
    | 'twitch'
    | 'twitter'
    | 'type'
    | 'type-bold'
    | 'type-h1'
    | 'type-h2'
    | 'type-h3'
    | 'type-italic'
    | 'type-strikethrough'
    | 'type-underline'
    | 'ui-checks'
    | 'ui-checks-grid'
    | 'ui-radios'
    | 'ui-radios-grid'
    | 'umbrella'
    | 'umbrella-fill'
    | 'union'
    | 'unlock'
    | 'unlock-fill'
    | 'upc'
    | 'upc-scan'
    | 'upload'
    | 'usb'
    | 'usb-c'
    | 'usb-c-fill'
    | 'usb-drive'
    | 'usb-drive-fill'
    | 'usb-fill'
    | 'usb-micro'
    | 'usb-micro-fill'
    | 'usb-mini'
    | 'usb-mini-fill'
    | 'usb-plug'
    | 'usb-plug-fill'
    | 'usb-symbol'
    | 'valentine'
    | 'valentine2'
    | 'vector-pen'
    | 'view-list'
    | 'view-stacked'
    | 'vimeo'
    | 'vinyl'
    | 'vinyl-fill'
    | 'voicemail'
    | 'volume-down'
    | 'volume-down-fill'
    | 'volume-mute'
    | 'volume-mute-fill'
    | 'volume-off'
    | 'volume-off-fill'
    | 'volume-up'
    | 'volume-up-fill'
    | 'vr'
    | 'wallet'
    | 'wallet-fill'
    | 'wallet2'
    | 'watch'
    | 'water'
    | 'webcam'
    | 'webcam-fill'
    | 'whatsapp'
    | 'wifi'
    | 'wifi-1'
    | 'wifi-2'
    | 'wifi-off'
    | 'wind'
    | 'window'
    | 'window-dash'
    | 'window-desktop'
    | 'window-dock'
    | 'window-fullscreen'
    | 'window-plus'
    | 'window-sidebar'
    | 'window-split'
    | 'window-stack'
    | 'window-x'
    | 'windows'
    | 'wordpress'
    | 'wrench'
    | 'wrench-adjustable'
    | 'wrench-adjustable-circle'
    | 'wrench-adjustable-circle-fill'
    | 'x'
    | 'x-circle'
    | 'x-circle-fill'
    | 'x-diamond'
    | 'x-diamond-fill'
    | 'x-lg'
    | 'x-octagon'
    | 'x-octagon-fill'
    | 'x-square'
    | 'x-square-fill'
    | 'xbox'
    | 'yin-yang'
    | 'youtube'
    | 'zoom-in'
    | 'zoom-out'
  boxicons: {
    solid:
      | 'add-to-queue'
      | 'adjust'
      | 'adjust-alt'
      | 'alarm'
      | 'alarm-add'
      | 'alarm-exclamation'
      | 'alarm-off'
      | 'alarm-snooze'
      | 'album'
      | 'ambulance'
      | 'analyse'
      | 'angry'
      | 'arch'
      | 'archive'
      | 'archive-in'
      | 'archive-out'
      | 'area'
      | 'arrow-from-bottom'
      | 'arrow-from-left'
      | 'arrow-from-right'
      | 'arrow-from-top'
      | 'arrow-to-bottom'
      | 'arrow-to-left'
      | 'arrow-to-right'
      | 'arrow-to-top'
      | 'award'
      | 'baby-carriage'
      | 'backpack'
      | 'badge'
      | 'badge-check'
      | 'badge-dollar'
      | 'baguette'
      | 'ball'
      | 'band-aid'
      | 'bank'
      | 'bar-chart-alt-2'
      | 'bar-chart-square'
      | 'barcode'
      | 'baseball'
      | 'basket'
      | 'basketball'
      | 'bath'
      | 'battery'
      | 'battery-charging'
      | 'battery-full'
      | 'battery-low'
      | 'bed'
      | 'been-here'
      | 'beer'
      | 'bell'
      | 'bell-minus'
      | 'bell-off'
      | 'bell-plus'
      | 'bell-ring'
      | 'bible'
      | 'binoculars'
      | 'blanket'
      | 'bolt'
      | 'bolt-circle'
      | 'bomb'
      | 'bone'
      | 'bong'
      | 'book'
      | 'book-add'
      | 'book-alt'
      | 'book-bookmark'
      | 'book-content'
      | 'book-heart'
      | 'book-open'
      | 'book-reader'
      | 'bookmark'
      | 'bookmark-alt'
      | 'bookmark-alt-minus'
      | 'bookmark-alt-plus'
      | 'bookmark-heart'
      | 'bookmark-minus'
      | 'bookmark-plus'
      | 'bookmark-star'
      | 'bookmarks'
      | 'bot'
      | 'bowl-hot'
      | 'bowl-rice'
      | 'bowling-ball'
      | 'box'
      | 'brain'
      | 'briefcase'
      | 'briefcase-alt'
      | 'briefcase-alt-2'
      | 'brightness'
      | 'brightness-half'
      | 'brush'
      | 'brush-alt'
      | 'bug'
      | 'bug-alt'
      | 'building'
      | 'building-house'
      | 'buildings'
      | 'bulb'
      | 'bullseye'
      | 'buoy'
      | 'bus'
      | 'bus-school'
      | 'business'
      | 'cabinet'
      | 'cable-car'
      | 'cake'
      | 'calculator'
      | 'calendar'
      | 'calendar-alt'
      | 'calendar-check'
      | 'calendar-edit'
      | 'calendar-event'
      | 'calendar-exclamation'
      | 'calendar-heart'
      | 'calendar-minus'
      | 'calendar-plus'
      | 'calendar-star'
      | 'calendar-week'
      | 'calendar-x'
      | 'camera'
      | 'camera-home'
      | 'camera-movie'
      | 'camera-off'
      | 'camera-plus'
      | 'capsule'
      | 'captions'
      | 'car'
      | 'car-battery'
      | 'car-crash'
      | 'car-garage'
      | 'car-mechanic'
      | 'car-wash'
      | 'card'
      | 'caret-down-circle'
      | 'caret-down-square'
      | 'caret-left-circle'
      | 'caret-left-square'
      | 'caret-right-circle'
      | 'caret-right-square'
      | 'caret-up-circle'
      | 'caret-up-square'
      | 'carousel'
      | 'cart'
      | 'cart-add'
      | 'cart-alt'
      | 'cart-download'
      | 'cat'
      | 'category'
      | 'category-alt'
      | 'cctv'
      | 'certification'
      | 'chalkboard'
      | 'chart'
      | 'chat'
      | 'check-circle'
      | 'check-shield'
      | 'check-square'
      | 'checkbox'
      | 'checkbox-checked'
      | 'checkbox-minus'
      | 'cheese'
      | 'chess'
      | 'chevron-down'
      | 'chevron-down-circle'
      | 'chevron-down-square'
      | 'chevron-left'
      | 'chevron-left-circle'
      | 'chevron-left-square'
      | 'chevron-right'
      | 'chevron-right-circle'
      | 'chevron-right-square'
      | 'chevron-up'
      | 'chevron-up-circle'
      | 'chevron-up-square'
      | 'chevrons-down'
      | 'chevrons-left'
      | 'chevrons-right'
      | 'chevrons-up'
      | 'chip'
      | 'church'
      | 'circle'
      | 'circle-half'
      | 'circle-quarter'
      | 'circle-three-quarter'
      | 'city'
      | 'clinic'
      | 'cloud'
      | 'cloud-download'
      | 'cloud-lightning'
      | 'cloud-rain'
      | 'cloud-upload'
      | 'coffee'
      | 'coffee-alt'
      | 'coffee-togo'
      | 'cog'
      | 'coin'
      | 'coin-stack'
      | 'collection'
      | 'color'
      | 'color-fill'
      | 'comment'
      | 'comment-add'
      | 'comment-check'
      | 'comment-detail'
      | 'comment-dots'
      | 'comment-edit'
      | 'comment-error'
      | 'comment-minus'
      | 'comment-x'
      | 'compass'
      | 'component'
      | 'confused'
      | 'contact'
      | 'conversation'
      | 'cookie'
      | 'cool'
      | 'copy'
      | 'copy-alt'
      | 'copyright'
      | 'coupon'
      | 'credit-card'
      | 'credit-card-alt'
      | 'credit-card-front'
      | 'cricket-ball'
      | 'crop'
      | 'crown'
      | 'cube'
      | 'cube-alt'
      | 'cuboid'
      | 'customize'
      | 'cylinder'
      | 'dashboard'
      | 'data'
      | 'detail'
      | 'devices'
      | 'diamond'
      | 'dice-1'
      | 'dice-2'
      | 'dice-3'
      | 'dice-4'
      | 'dice-5'
      | 'dice-6'
      | 'direction-left'
      | 'direction-right'
      | 'directions'
      | 'disc'
      | 'discount'
      | 'dish'
      | 'dislike'
      | 'dizzy'
      | 'dock-bottom'
      | 'dock-left'
      | 'dock-right'
      | 'dock-top'
      | 'dog'
      | 'dollar-circle'
      | 'donate-blood'
      | 'donate-heart'
      | 'door-open'
      | 'doughnut-chart'
      | 'down-arrow'
      | 'down-arrow-alt'
      | 'down-arrow-circle'
      | 'down-arrow-square'
      | 'download'
      | 'downvote'
      | 'drink'
      | 'droplet'
      | 'droplet-half'
      | 'dryer'
      | 'duplicate'
      | 'edit'
      | 'edit-alt'
      | 'edit-location'
      | 'eject'
      | 'envelope'
      | 'envelope-open'
      | 'eraser'
      | 'error'
      | 'error-alt'
      | 'error-circle'
      | 'ev-station'
      | 'exit'
      | 'extension'
      | 'eyedropper'
      | 'face'
      | 'face-mask'
      | 'factory'
      | 'fast-forward-circle'
      | 'file'
      | 'file-archive'
      | 'file-blank'
      | 'file-css'
      | 'file-doc'
      | 'file-export'
      | 'file-find'
      | 'file-gif'
      | 'file-html'
      | 'file-image'
      | 'file-import'
      | 'file-jpg'
      | 'file-js'
      | 'file-json'
      | 'file-md'
      | 'file-pdf'
      | 'file-plus'
      | 'file-png'
      | 'file-txt'
      | 'film'
      | 'filter-alt'
      | 'first-aid'
      | 'flag'
      | 'flag-alt'
      | 'flag-checkered'
      | 'flame'
      | 'flask'
      | 'florist'
      | 'folder'
      | 'folder-minus'
      | 'folder-open'
      | 'folder-plus'
      | 'food-menu'
      | 'fridge'
      | 'game'
      | 'gas-pump'
      | 'ghost'
      | 'gift'
      | 'graduation'
      | 'grid'
      | 'grid-alt'
      | 'group'
      | 'guitar-amp'
      | 'hand'
      | 'hand-down'
      | 'hand-left'
      | 'hand-right'
      | 'hand-up'
      | 'happy'
      | 'happy-alt'
      | 'happy-beaming'
      | 'happy-heart-eyes'
      | 'hard-hat'
      | 'hdd'
      | 'heart'
      | 'heart-circle'
      | 'heart-square'
      | 'help-circle'
      | 'hide'
      | 'home'
      | 'home-alt-2'
      | 'home-circle'
      | 'home-heart'
      | 'home-smile'
      | 'hot'
      | 'hotel'
      | 'hourglass'
      | 'hourglass-bottom'
      | 'hourglass-top'
      | 'id-card'
      | 'image'
      | 'image-add'
      | 'image-alt'
      | 'inbox'
      | 'info-circle'
      | 'info-square'
      | 'injection'
      | 'institution'
      | 'invader'
      | 'joystick'
      | 'joystick-alt'
      | 'joystick-button'
      | 'key'
      | 'keyboard'
      | 'label'
      | 'landmark'
      | 'landscape'
      | 'laugh'
      | 'layer'
      | 'layer-minus'
      | 'layer-plus'
      | 'layout'
      | 'leaf'
      | 'left-arrow'
      | 'left-arrow-alt'
      | 'left-arrow-circle'
      | 'left-arrow-square'
      | 'left-down-arrow-circle'
      | 'left-top-arrow-circle'
      | 'lemon'
      | 'like'
      | 'location-plus'
      | 'lock'
      | 'lock-alt'
      | 'lock-open'
      | 'lock-open-alt'
      | 'log-in'
      | 'log-in-circle'
      | 'log-out'
      | 'log-out-circle'
      | 'low-vision'
      | 'magic-wand'
      | 'magnet'
      | 'map'
      | 'map-alt'
      | 'map-pin'
      | 'mask'
      | 'medal'
      | 'megaphone'
      | 'meh'
      | 'meh-alt'
      | 'meh-blank'
      | 'memory-card'
      | 'message'
      | 'message-add'
      | 'message-alt'
      | 'message-alt-add'
      | 'message-alt-check'
      | 'message-alt-detail'
      | 'message-alt-dots'
      | 'message-alt-edit'
      | 'message-alt-error'
      | 'message-alt-minus'
      | 'message-alt-x'
      | 'message-check'
      | 'message-detail'
      | 'message-dots'
      | 'message-edit'
      | 'message-error'
      | 'message-minus'
      | 'message-rounded'
      | 'message-rounded-add'
      | 'message-rounded-check'
      | 'message-rounded-detail'
      | 'message-rounded-dots'
      | 'message-rounded-edit'
      | 'message-rounded-error'
      | 'message-rounded-minus'
      | 'message-rounded-x'
      | 'message-square'
      | 'message-square-add'
      | 'message-square-check'
      | 'message-square-detail'
      | 'message-square-dots'
      | 'message-square-edit'
      | 'message-square-error'
      | 'message-square-minus'
      | 'message-square-x'
      | 'message-x'
      | 'meteor'
      | 'microchip'
      | 'microphone'
      | 'microphone-alt'
      | 'microphone-off'
      | 'minus-circle'
      | 'minus-square'
      | 'mobile'
      | 'mobile-vibration'
      | 'moon'
      | 'mouse'
      | 'mouse-alt'
      | 'movie'
      | 'movie-play'
      | 'music'
      | 'navigation'
      | 'network-chart'
      | 'news'
      | 'no-entry'
      | 'note'
      | 'notepad'
      | 'notification'
      | 'notification-off'
      | 'offer'
      | 'package'
      | 'paint'
      | 'paint-roll'
      | 'palette'
      | 'paper-plane'
      | 'parking'
      | 'party'
      | 'paste'
      | 'pen'
      | 'pencil'
      | 'phone'
      | 'phone-call'
      | 'phone-incoming'
      | 'phone-off'
      | 'phone-outgoing'
      | 'photo-album'
      | 'piano'
      | 'pie-chart'
      | 'pie-chart-alt'
      | 'pie-chart-alt-2'
      | 'pin'
      | 'pizza'
      | 'plane'
      | 'plane-alt'
      | 'plane-land'
      | 'plane-take-off'
      | 'planet'
      | 'playlist'
      | 'plug'
      | 'plus-circle'
      | 'plus-square'
      | 'pointer'
      | 'polygon'
      | 'popsicle'
      | 'printer'
      | 'purchase-tag'
      | 'purchase-tag-alt'
      | 'pyramid'
      | 'quote-alt-left'
      | 'quote-alt-right'
      | 'quote-left'
      | 'quote-right'
      | 'quote-single-left'
      | 'quote-single-right'
      | 'radiation'
      | 'radio'
      | 'receipt'
      | 'rectangle'
      | 'registered'
      | 'rename'
      | 'report'
      | 'rewind-circle'
      | 'right-arrow'
      | 'right-arrow-alt'
      | 'right-arrow-circle'
      | 'right-arrow-square'
      | 'right-down-arrow-circle'
      | 'right-top-arrow-circle'
      | 'rocket'
      | 'ruler'
      | 'sad'
      | 'save'
      | 'school'
      | 'search'
      | 'search-alt-2'
      | 'select-multiple'
      | 'send'
      | 'server'
      | 'shapes'
      | 'share'
      | 'share-alt'
      | 'shield'
      | 'shield-alt-2'
      | 'shield-x'
      | 'ship'
      | 'shocked'
      | 'shopping-bag'
      | 'shopping-bag-alt'
      | 'shopping-bags'
      | 'show'
      | 'skip-next-circle'
      | 'skip-previous-circle'
      | 'skull'
      | 'sleepy'
      | 'slideshow'
      | 'smile'
      | 'sort-alt'
      | 'spa'
      | 'speaker'
      | 'spray-can'
      | 'spreadsheet'
      | 'square'
      | 'square-rounded'
      | 'star'
      | 'star-half'
      | 'sticker'
      | 'stopwatch'
      | 'store'
      | 'store-alt'
      | 'sun'
      | 't-shirt'
      | 'tachometer'
      | 'tag'
      | 'tag-alt'
      | 'tag-x'
      | 'taxi'
      | 'tennis-ball'
      | 'terminal'
      | 'thermometer'
      | 'time'
      | 'time-five'
      | 'timer'
      | 'tired'
      | 'to-top'
      | 'toggle-left'
      | 'toggle-right'
      | 'tone'
      | 'torch'
      | 'traffic'
      | 'traffic-barrier'
      | 'traffic-cone'
      | 'train'
      | 'trash'
      | 'trash-alt'
      | 'tree'
      | 'tree-alt'
      | 'trophy'
      | 'truck'
      | 'tv'
      | 'up-arrow'
      | 'up-arrow-alt'
      | 'up-arrow-circle'
      | 'up-arrow-square'
      | 'upside-down'
      | 'upvote'
      | 'user'
      | 'user-account'
      | 'user-badge'
      | 'user-check'
      | 'user-circle'
      | 'user-detail'
      | 'user-minus'
      | 'user-pin'
      | 'user-plus'
      | 'user-rectangle'
      | 'user-voice'
      | 'user-x'
      | 'vector'
      | 'vial'
      | 'video'
      | 'video-off'
      | 'video-plus'
      | 'video-recording'
      | 'videos'
      | 'virus'
      | 'virus-block'
      | 'volume'
      | 'volume-full'
      | 'volume-low'
      | 'volume-mute'
      | 'wallet'
      | 'wallet-alt'
      | 'washer'
      | 'watch'
      | 'watch-alt'
      | 'webcam'
      | 'widget'
      | 'window-alt'
      | 'wine'
      | 'wink-smile'
      | 'wink-tongue'
      | 'wrench'
      | 'x-circle'
      | 'x-square'
      | 'yin-yang'
      | 'zap'
      | 'zoom-in'
      | 'zoom-out'
    regular:
      | 'abacus'
      | 'accessibility'
      | 'add-to-queue'
      | 'adjust'
      | 'alarm'
      | 'alarm-add'
      | 'alarm-exclamation'
      | 'alarm-off'
      | 'alarm-snooze'
      | 'album'
      | 'align-justify'
      | 'align-left'
      | 'align-middle'
      | 'align-right'
      | 'analyse'
      | 'anchor'
      | 'angry'
      | 'aperture'
      | 'arch'
      | 'archive'
      | 'archive-in'
      | 'archive-out'
      | 'area'
      | 'arrow-back'
      | 'arrow-from-bottom'
      | 'arrow-from-left'
      | 'arrow-from-right'
      | 'arrow-from-top'
      | 'arrow-to-bottom'
      | 'arrow-to-left'
      | 'arrow-to-right'
      | 'arrow-to-top'
      | 'at'
      | 'atom'
      | 'award'
      | 'badge'
      | 'badge-check'
      | 'baguette'
      | 'ball'
      | 'band-aid'
      | 'bar-chart'
      | 'bar-chart-alt'
      | 'bar-chart-alt-2'
      | 'bar-chart-square'
      | 'barcode'
      | 'barcode-reader'
      | 'baseball'
      | 'basket'
      | 'basketball'
      | 'bath'
      | 'battery'
      | 'bed'
      | 'been-here'
      | 'beer'
      | 'bell'
      | 'bell-minus'
      | 'bell-off'
      | 'bell-plus'
      | 'bible'
      | 'bitcoin'
      | 'blanket'
      | 'block'
      | 'bluetooth'
      | 'body'
      | 'bold'
      | 'bolt-circle'
      | 'bomb'
      | 'bone'
      | 'bong'
      | 'book'
      | 'book-add'
      | 'book-alt'
      | 'book-bookmark'
      | 'book-content'
      | 'book-heart'
      | 'book-open'
      | 'book-reader'
      | 'bookmark'
      | 'bookmark-alt'
      | 'bookmark-alt-minus'
      | 'bookmark-alt-plus'
      | 'bookmark-heart'
      | 'bookmark-minus'
      | 'bookmark-plus'
      | 'bookmarks'
      | 'border-all'
      | 'border-bottom'
      | 'border-inner'
      | 'border-left'
      | 'border-none'
      | 'border-outer'
      | 'border-radius'
      | 'border-right'
      | 'border-top'
      | 'bot'
      | 'bowl-hot'
      | 'bowl-rice'
      | 'bowling-ball'
      | 'box'
      | 'bracket'
      | 'braille'
      | 'brain'
      | 'briefcase'
      | 'briefcase-alt'
      | 'briefcase-alt-2'
      | 'brightness'
      | 'brightness-half'
      | 'broadcast'
      | 'brush'
      | 'brush-alt'
      | 'bug'
      | 'bug-alt'
      | 'building'
      | 'building-house'
      | 'buildings'
      | 'bulb'
      | 'bullseye'
      | 'buoy'
      | 'bus'
      | 'bus-school'
      | 'cabinet'
      | 'cable-car'
      | 'cake'
      | 'calculator'
      | 'calendar'
      | 'calendar-alt'
      | 'calendar-check'
      | 'calendar-edit'
      | 'calendar-event'
      | 'calendar-exclamation'
      | 'calendar-heart'
      | 'calendar-minus'
      | 'calendar-plus'
      | 'calendar-star'
      | 'calendar-week'
      | 'calendar-x'
      | 'camera'
      | 'camera-home'
      | 'camera-movie'
      | 'camera-off'
      | 'candles'
      | 'capsule'
      | 'captions'
      | 'car'
      | 'card'
      | 'caret-down'
      | 'caret-down-circle'
      | 'caret-down-square'
      | 'caret-left'
      | 'caret-left-circle'
      | 'caret-left-square'
      | 'caret-right'
      | 'caret-right-circle'
      | 'caret-right-square'
      | 'caret-up'
      | 'caret-up-circle'
      | 'caret-up-square'
      | 'carousel'
      | 'cart'
      | 'cart-add'
      | 'cart-alt'
      | 'cart-download'
      | 'cast'
      | 'category'
      | 'category-alt'
      | 'cctv'
      | 'certification'
      | 'chair'
      | 'chalkboard'
      | 'chart'
      | 'chat'
      | 'check'
      | 'check-circle'
      | 'check-double'
      | 'check-shield'
      | 'check-square'
      | 'checkbox'
      | 'checkbox-checked'
      | 'checkbox-minus'
      | 'checkbox-square'
      | 'cheese'
      | 'chevron-down'
      | 'chevron-down-circle'
      | 'chevron-down-square'
      | 'chevron-left'
      | 'chevron-left-circle'
      | 'chevron-left-square'
      | 'chevron-right'
      | 'chevron-right-circle'
      | 'chevron-right-square'
      | 'chevron-up'
      | 'chevron-up-circle'
      | 'chevron-up-square'
      | 'chevrons-down'
      | 'chevrons-left'
      | 'chevrons-right'
      | 'chevrons-up'
      | 'chip'
      | 'church'
      | 'circle'
      | 'circle-half'
      | 'circle-quarter'
      | 'circle-three-quarter'
      | 'clinic'
      | 'clipboard'
      | 'closet'
      | 'cloud'
      | 'cloud-download'
      | 'cloud-drizzle'
      | 'cloud-light-rain'
      | 'cloud-lightning'
      | 'cloud-rain'
      | 'cloud-snow'
      | 'cloud-upload'
      | 'code'
      | 'code-alt'
      | 'code-block'
      | 'code-curly'
      | 'coffee'
      | 'coffee-togo'
      | 'cog'
      | 'coin'
      | 'coin-stack'
      | 'collapse'
      | 'collapse-alt'
      | 'collapse-horizontal'
      | 'collapse-vertical'
      | 'collection'
      | 'color'
      | 'color-fill'
      | 'columns'
      | 'command'
      | 'comment'
      | 'comment-add'
      | 'comment-check'
      | 'comment-detail'
      | 'comment-dots'
      | 'comment-edit'
      | 'comment-error'
      | 'comment-minus'
      | 'comment-x'
      | 'compass'
      | 'confused'
      | 'conversation'
      | 'cookie'
      | 'cool'
      | 'copy'
      | 'copy-alt'
      | 'copyright'
      | 'credit-card'
      | 'credit-card-alt'
      | 'credit-card-front'
      | 'cricket-ball'
      | 'crop'
      | 'cross'
      | 'crosshair'
      | 'crown'
      | 'cube'
      | 'cube-alt'
      | 'cuboid'
      | 'current-location'
      | 'customize'
      | 'cut'
      | 'cycling'
      | 'cylinder'
      | 'data'
      | 'desktop'
      | 'detail'
      | 'devices'
      | 'dialpad'
      | 'dialpad-alt'
      | 'diamond'
      | 'dice-1'
      | 'dice-2'
      | 'dice-3'
      | 'dice-4'
      | 'dice-5'
      | 'dice-6'
      | 'directions'
      | 'disc'
      | 'dish'
      | 'dislike'
      | 'dizzy'
      | 'dna'
      | 'dock-bottom'
      | 'dock-left'
      | 'dock-right'
      | 'dock-top'
      | 'dollar'
      | 'dollar-circle'
      | 'donate-blood'
      | 'donate-heart'
      | 'door-open'
      | 'dots-horizontal'
      | 'dots-horizontal-rounded'
      | 'dots-vertical'
      | 'dots-vertical-rounded'
      | 'doughnut-chart'
      | 'down-arrow'
      | 'down-arrow-alt'
      | 'down-arrow-circle'
      | 'download'
      | 'downvote'
      | 'drink'
      | 'droplet'
      | 'dumbbell'
      | 'duplicate'
      | 'edit'
      | 'edit-alt'
      | 'envelope'
      | 'envelope-open'
      | 'equalizer'
      | 'eraser'
      | 'error'
      | 'error-alt'
      | 'error-circle'
      | 'euro'
      | 'exclude'
      | 'exit'
      | 'exit-fullscreen'
      | 'expand'
      | 'expand-alt'
      | 'expand-horizontal'
      | 'expand-vertical'
      | 'export'
      | 'extension'
      | 'face'
      | 'fast-forward'
      | 'fast-forward-circle'
      | 'female'
      | 'female-sign'
      | 'file'
      | 'file-blank'
      | 'file-find'
      | 'film'
      | 'filter'
      | 'filter-alt'
      | 'fingerprint'
      | 'first-aid'
      | 'first-page'
      | 'flag'
      | 'folder'
      | 'folder-minus'
      | 'folder-open'
      | 'folder-plus'
      | 'font'
      | 'font-color'
      | 'font-family'
      | 'font-size'
      | 'food-menu'
      | 'food-tag'
      | 'football'
      | 'fork'
      | 'fridge'
      | 'fullscreen'
      | 'game'
      | 'gas-pump'
      | 'ghost'
      | 'gift'
      | 'git-branch'
      | 'git-commit'
      | 'git-compare'
      | 'git-merge'
      | 'git-pull-request'
      | 'git-repo-forked'
      | 'glasses'
      | 'glasses-alt'
      | 'globe'
      | 'globe-alt'
      | 'grid'
      | 'grid-alt'
      | 'grid-horizontal'
      | 'grid-small'
      | 'grid-vertical'
      | 'group'
      | 'handicap'
      | 'happy'
      | 'happy-alt'
      | 'happy-beaming'
      | 'happy-heart-eyes'
      | 'hard-hat'
      | 'hash'
      | 'hdd'
      | 'heading'
      | 'headphone'
      | 'health'
      | 'heart'
      | 'heart-circle'
      | 'heart-square'
      | 'help-circle'
      | 'hide'
      | 'highlight'
      | 'history'
      | 'hive'
      | 'home'
      | 'home-alt'
      | 'home-alt-2'
      | 'home-circle'
      | 'home-heart'
      | 'home-smile'
      | 'horizontal-center'
      | 'hotel'
      | 'hourglass'
      | 'id-card'
      | 'image'
      | 'image-add'
      | 'image-alt'
      | 'images'
      | 'import'
      | 'infinite'
      | 'info-circle'
      | 'info-square'
      | 'injection'
      | 'intersect'
      | 'italic'
      | 'joystick'
      | 'joystick-alt'
      | 'joystick-button'
      | 'key'
      | 'knife'
      | 'label'
      | 'landscape'
      | 'laptop'
      | 'last-page'
      | 'laugh'
      | 'layer'
      | 'layer-minus'
      | 'layer-plus'
      | 'layout'
      | 'leaf'
      | 'left-arrow'
      | 'left-arrow-alt'
      | 'left-arrow-circle'
      | 'left-down-arrow-circle'
      | 'left-indent'
      | 'left-top-arrow-circle'
      | 'lemon'
      | 'library'
      | 'like'
      | 'line-chart'
      | 'line-chart-down'
      | 'link'
      | 'link-alt'
      | 'link-external'
      | 'lira'
      | 'list-check'
      | 'list-minus'
      | 'list-ol'
      | 'list-plus'
      | 'list-ul'
      | 'loader'
      | 'loader-alt'
      | 'loader-circle'
      | 'location-plus'
      | 'lock'
      | 'lock-alt'
      | 'lock-open'
      | 'lock-open-alt'
      | 'log-in'
      | 'log-in-circle'
      | 'log-out'
      | 'log-out-circle'
      | 'low-vision'
      | 'magnet'
      | 'mail-send'
      | 'male'
      | 'male-female'
      | 'male-sign'
      | 'map'
      | 'map-alt'
      | 'map-pin'
      | 'mask'
      | 'math'
      | 'medal'
      | 'meh'
      | 'meh-alt'
      | 'meh-blank'
      | 'memory-card'
      | 'menu'
      | 'menu-alt-left'
      | 'menu-alt-right'
      | 'merge'
      | 'message'
      | 'message-add'
      | 'message-alt'
      | 'message-alt-add'
      | 'message-alt-check'
      | 'message-alt-detail'
      | 'message-alt-dots'
      | 'message-alt-edit'
      | 'message-alt-error'
      | 'message-alt-minus'
      | 'message-alt-x'
      | 'message-check'
      | 'message-detail'
      | 'message-dots'
      | 'message-edit'
      | 'message-error'
      | 'message-minus'
      | 'message-rounded'
      | 'message-rounded-add'
      | 'message-rounded-check'
      | 'message-rounded-detail'
      | 'message-rounded-dots'
      | 'message-rounded-edit'
      | 'message-rounded-error'
      | 'message-rounded-minus'
      | 'message-rounded-x'
      | 'message-square'
      | 'message-square-add'
      | 'message-square-check'
      | 'message-square-detail'
      | 'message-square-dots'
      | 'message-square-edit'
      | 'message-square-error'
      | 'message-square-minus'
      | 'message-square-x'
      | 'message-x'
      | 'meteor'
      | 'microchip'
      | 'microphone'
      | 'microphone-off'
      | 'minus'
      | 'minus-back'
      | 'minus-circle'
      | 'minus-front'
      | 'mobile'
      | 'mobile-alt'
      | 'mobile-landscape'
      | 'mobile-vibration'
      | 'money'
      | 'money-withdraw'
      | 'moon'
      | 'mouse'
      | 'mouse-alt'
      | 'move'
      | 'move-horizontal'
      | 'move-vertical'
      | 'movie'
      | 'movie-play'
      | 'music'
      | 'navigation'
      | 'network-chart'
      | 'news'
      | 'no-entry'
      | 'no-signal'
      | 'note'
      | 'notepad'
      | 'notification'
      | 'notification-off'
      | 'outline'
      | 'package'
      | 'paint'
      | 'paint-roll'
      | 'palette'
      | 'paper-plane'
      | 'paperclip'
      | 'paragraph'
      | 'party'
      | 'paste'
      | 'pause'
      | 'pause-circle'
      | 'pen'
      | 'pencil'
      | 'phone'
      | 'phone-call'
      | 'phone-incoming'
      | 'phone-off'
      | 'phone-outgoing'
      | 'photo-album'
      | 'pie-chart'
      | 'pie-chart-alt'
      | 'pie-chart-alt-2'
      | 'pin'
      | 'planet'
      | 'play'
      | 'play-circle'
      | 'plug'
      | 'plus'
      | 'plus-circle'
      | 'plus-medical'
      | 'podcast'
      | 'pointer'
      | 'poll'
      | 'polygon'
      | 'popsicle'
      | 'pound'
      | 'power-off'
      | 'printer'
      | 'pulse'
      | 'purchase-tag'
      | 'purchase-tag-alt'
      | 'pyramid'
      | 'qr'
      | 'qr-scan'
      | 'question-mark'
      | 'radar'
      | 'radio'
      | 'radio-circle'
      | 'radio-circle-marked'
      | 'receipt'
      | 'rectangle'
      | 'recycle'
      | 'redo'
      | 'reflect-horizontal'
      | 'reflect-vertical'
      | 'refresh'
      | 'registered'
      | 'rename'
      | 'repeat'
      | 'reply'
      | 'reply-all'
      | 'repost'
      | 'reset'
      | 'restaurant'
      | 'revision'
      | 'rewind'
      | 'rewind-circle'
      | 'right-arrow'
      | 'right-arrow-alt'
      | 'right-arrow-circle'
      | 'right-down-arrow-circle'
      | 'right-indent'
      | 'right-top-arrow-circle'
      | 'rocket'
      | 'rotate-left'
      | 'rotate-right'
      | 'rss'
      | 'ruble'
      | 'ruler'
      | 'run'
      | 'rupee'
      | 'sad'
      | 'save'
      | 'scan'
      | 'scatter-chart'
      | 'screenshot'
      | 'search'
      | 'search-alt'
      | 'search-alt-2'
      | 'select-multiple'
      | 'selection'
      | 'send'
      | 'server'
      | 'shape-circle'
      | 'shape-polygon'
      | 'shape-square'
      | 'shape-triangle'
      | 'share'
      | 'share-alt'
      | 'shekel'
      | 'shield'
      | 'shield-alt'
      | 'shield-alt-2'
      | 'shield-quarter'
      | 'shield-x'
      | 'shocked'
      | 'shopping-bag'
      | 'show'
      | 'show-alt'
      | 'shuffle'
      | 'sidebar'
      | 'signal-1'
      | 'signal-2'
      | 'signal-3'
      | 'signal-4'
      | 'signal-5'
      | 'sitemap'
      | 'skip-next'
      | 'skip-next-circle'
      | 'skip-previous'
      | 'skip-previous-circle'
      | 'sleepy'
      | 'slider'
      | 'slider-alt'
      | 'slideshow'
      | 'smile'
      | 'sort'
      | 'sort-a-z'
      | 'sort-alt-2'
      | 'sort-down'
      | 'sort-up'
      | 'sort-z-a'
      | 'spa'
      | 'space-bar'
      | 'speaker'
      | 'spray-can'
      | 'spreadsheet'
      | 'square'
      | 'square-rounded'
      | 'star'
      | 'station'
      | 'stats'
      | 'sticker'
      | 'stop'
      | 'stop-circle'
      | 'stopwatch'
      | 'store'
      | 'store-alt'
      | 'street-view'
      | 'strikethrough'
      | 'subdirectory-left'
      | 'subdirectory-right'
      | 'sun'
      | 'support'
      | 'swim'
      | 'sync'
      | 'tab'
      | 'table'
      | 'tachometer'
      | 'tag'
      | 'tag-alt'
      | 'target-lock'
      | 'task'
      | 'task-x'
      | 'taxi'
      | 'tennis-ball'
      | 'terminal'
      | 'test-tube'
      | 'text'
      | 'time'
      | 'time-five'
      | 'timer'
      | 'tired'
      | 'toggle-left'
      | 'toggle-right'
      | 'tone'
      | 'traffic-cone'
      | 'train'
      | 'transfer'
      | 'transfer-alt'
      | 'trash'
      | 'trash-alt'
      | 'trending-down'
      | 'trending-up'
      | 'trim'
      | 'trip'
      | 'trophy'
      | 'tv'
      | 'underline'
      | 'undo'
      | 'unite'
      | 'unlink'
      | 'up-arrow'
      | 'up-arrow-alt'
      | 'up-arrow-circle'
      | 'upload'
      | 'upside-down'
      | 'upvote'
      | 'usb'
      | 'user'
      | 'user-check'
      | 'user-circle'
      | 'user-minus'
      | 'user-pin'
      | 'user-plus'
      | 'user-voice'
      | 'user-x'
      | 'vector'
      | 'vertical-center'
      | 'vial'
      | 'video'
      | 'video-off'
      | 'video-plus'
      | 'video-recording'
      | 'voicemail'
      | 'volume'
      | 'volume-full'
      | 'volume-low'
      | 'volume-mute'
      | 'walk'
      | 'wallet'
      | 'wallet-alt'
      | 'water'
      | 'webcam'
      | 'wifi'
      | 'wifi-0'
      | 'wifi-1'
      | 'wifi-2'
      | 'wifi-off'
      | 'wind'
      | 'window'
      | 'window-alt'
      | 'window-close'
      | 'window-open'
      | 'windows'
      | 'wine'
      | 'wink-smile'
      | 'wink-tongue'
      | 'won'
      | 'world'
      | 'wrench'
      | 'x'
      | 'x-circle'
      | 'yen'
      | 'zoom-in'
      | 'zoom-out'
    logos:
      | '99designs'
      | '500px'
      | 'adobe'
      | 'airbnb'
      | 'algolia'
      | 'amazon'
      | 'android'
      | 'angular'
      | 'apple'
      | 'audible'
      | 'aws'
      | 'baidu'
      | 'behance'
      | 'bing'
      | 'bitcoin'
      | 'blender'
      | 'blogger'
      | 'bootstrap'
      | 'c-plus-plus'
      | 'chrome'
      | 'codepen'
      | 'creative-commons'
      | 'css3'
      | 'dailymotion'
      | 'deezer'
      | 'dev-to'
      | 'deviantart'
      | 'digg'
      | 'digitalocean'
      | 'discord'
      | 'discord-alt'
      | 'discourse'
      | 'django'
      | 'docker'
      | 'dribbble'
      | 'dropbox'
      | 'drupal'
      | 'ebay'
      | 'edge'
      | 'etsy'
      | 'facebook'
      | 'facebook-circle'
      | 'facebook-square'
      | 'figma'
      | 'firebase'
      | 'firefox'
      | 'flask'
      | 'flickr'
      | 'flickr-square'
      | 'flutter'
      | 'foursquare'
      | 'git'
      | 'github'
      | 'gitlab'
      | 'gmail'
      | 'go-lang'
      | 'google'
      | 'google-cloud'
      | 'google-plus'
      | 'google-plus-circle'
      | 'heroku'
      | 'html5'
      | 'imdb'
      | 'instagram'
      | 'instagram-alt'
      | 'internet-explorer'
      | 'invision'
      | 'java'
      | 'javascript'
      | 'joomla'
      | 'jquery'
      | 'jsfiddle'
      | 'kickstarter'
      | 'kubernetes'
      | 'less'
      | 'linkedin'
      | 'linkedin-square'
      | 'magento'
      | 'mailchimp'
      | 'markdown'
      | 'mastercard'
      | 'mastodon'
      | 'medium'
      | 'medium-old'
      | 'medium-square'
      | 'messenger'
      | 'meta'
      | 'microsoft'
      | 'microsoft-teams'
      | 'mongodb'
      | 'netlify'
      | 'nodejs'
      | 'ok-ru'
      | 'opera'
      | 'patreon'
      | 'paypal'
      | 'periscope'
      | 'php'
      | 'pinterest'
      | 'pinterest-alt'
      | 'play-store'
      | 'pocket'
      | 'postgresql'
      | 'product-hunt'
      | 'python'
      | 'quora'
      | 'react'
      | 'redbubble'
      | 'reddit'
      | 'redux'
      | 'sass'
      | 'shopify'
      | 'sketch'
      | 'skype'
      | 'slack'
      | 'slack-old'
      | 'snapchat'
      | 'soundcloud'
      | 'spotify'
      | 'spring-boot'
      | 'squarespace'
      | 'stack-overflow'
      | 'steam'
      | 'stripe'
      | 'tailwind-css'
      | 'telegram'
      | 'tiktok'
      | 'trello'
      | 'trip-advisor'
      | 'tumblr'
      | 'tux'
      | 'twitch'
      | 'twitter'
      | 'unity'
      | 'unsplash'
      | 'upwork'
      | 'venmo'
      | 'vimeo'
      | 'visa'
      | 'visual-studio'
      | 'vk'
      | 'vuejs'
      | 'whatsapp'
      | 'whatsapp-square'
      | 'wikipedia'
      | 'windows'
      | 'wix'
      | 'wordpress'
      | 'xing'
      | 'yahoo'
      | 'yelp'
      | 'youtube'
      | 'zoom'
  }
  bytesize:
    | 'activity'
    | 'alert'
    | 'archive'
    | 'arrow-bottom'
    | 'arrow-left'
    | 'arrow-right'
    | 'arrow-top'
    | 'backwards'
    | 'bag'
    | 'ban'
    | 'bell'
    | 'book'
    | 'bookmark'
    | 'calendar'
    | 'camera'
    | 'caret-bottom'
    | 'caret-left'
    | 'caret-right'
    | 'caret-top'
    | 'cart'
    | 'checkmark'
    | 'chevron-bottom'
    | 'chevron-left'
    | 'chevron-right'
    | 'chevron-top'
    | 'clipboard'
    | 'clock'
    | 'close'
    | 'code'
    | 'compose'
    | 'creditcard'
    | 'desktop'
    | 'download'
    | 'edit'
    | 'eject'
    | 'ellipsis-horizontal'
    | 'ellipsis-vertical'
    | 'end'
    | 'export'
    | 'external'
    | 'eye'
    | 'feed'
    | 'file'
    | 'filter'
    | 'flag'
    | 'folder'
    | 'folder-open'
    | 'forwards'
    | 'fullscreen'
    | 'fullscreen-exit'
    | 'gift'
    | 'github'
    | 'heart'
    | 'home'
    | 'import'
    | 'inbox'
    | 'info'
    | 'lightning'
    | 'link'
    | 'location'
    | 'lock'
    | 'mail'
    | 'menu'
    | 'message'
    | 'microphone'
    | 'minus'
    | 'mobile'
    | 'moon'
    | 'move'
    | 'music'
    | 'mute'
    | 'options'
    | 'paperclip'
    | 'pause'
    | 'photo'
    | 'play'
    | 'plus'
    | 'portfolio'
    | 'print'
    | 'reload'
    | 'reply'
    | 'search'
    | 'send'
    | 'settings'
    | 'sign-in'
    | 'sign-out'
    | 'star'
    | 'start'
    | 'tag'
    | 'telephone'
    | 'trash'
    | 'twitter'
    | 'unlock'
    | 'upload'
    | 'user'
    | 'video'
    | 'volume'
    | 'work'
    | 'zoom-in'
    | 'zoom-out'
    | 'zoom-reset'
  cssgg:
    | 'abstract'
    | 'add'
    | 'add-r'
    | 'adidas'
    | 'airplane'
    | 'alarm'
    | 'album'
    | 'align-bottom'
    | 'align-center'
    | 'align-left'
    | 'align-middle'
    | 'align-right'
    | 'align-top'
    | 'anchor'
    | 'apple-watch'
    | 'arrange-back'
    | 'arrange-front'
    | 'arrow-align-h'
    | 'arrow-align-v'
    | 'arrow-bottom-left'
    | 'arrow-bottom-left-o'
    | 'arrow-bottom-left-r'
    | 'arrow-bottom-right'
    | 'arrow-bottom-right-o'
    | 'arrow-bottom-right-r'
    | 'arrow-down'
    | 'arrow-down-o'
    | 'arrow-down-r'
    | 'arrow-left'
    | 'arrow-left-o'
    | 'arrow-left-r'
    | 'arrow-long-down'
    | 'arrow-long-down-c'
    | 'arrow-long-down-e'
    | 'arrow-long-down-l'
    | 'arrow-long-down-r'
    | 'arrow-long-left'
    | 'arrow-long-left-c'
    | 'arrow-long-left-e'
    | 'arrow-long-left-l'
    | 'arrow-long-left-r'
    | 'arrow-long-right'
    | 'arrow-long-right-c'
    | 'arrow-long-right-e'
    | 'arrow-long-right-l'
    | 'arrow-long-right-r'
    | 'arrow-long-up'
    | 'arrow-long-up-c'
    | 'arrow-long-up-e'
    | 'arrow-long-up-l'
    | 'arrow-long-up-r'
    | 'arrow-right'
    | 'arrow-right-o'
    | 'arrow-right-r'
    | 'arrow-top-left'
    | 'arrow-top-left-o'
    | 'arrow-top-left-r'
    | 'arrow-top-right'
    | 'arrow-top-right-o'
    | 'arrow-top-right-r'
    | 'arrow-up'
    | 'arrow-up-o'
    | 'arrow-up-r'
    | 'arrows-breake-h'
    | 'arrows-breake-v'
    | 'arrows-exchange'
    | 'arrows-exchange-alt'
    | 'arrows-exchange-alt-v'
    | 'arrows-exchange-v'
    | 'arrows-expand-down-left'
    | 'arrows-expand-down-right'
    | 'arrows-expand-left'
    | 'arrows-expand-left-alt'
    | 'arrows-expand-right'
    | 'arrows-expand-right-alt'
    | 'arrows-expand-up-left'
    | 'arrows-expand-up-right'
    | 'arrows-h'
    | 'arrows-h-alt'
    | 'arrows-merge-alt-h'
    | 'arrows-merge-alt-v'
    | 'arrows-scroll-h'
    | 'arrows-scroll-v'
    | 'arrows-shrink-h'
    | 'arrows-shrink-v'
    | 'arrows-v'
    | 'arrows-v-alt'
    | 'assign'
    | 'asterisk'
    | 'atlasian'
    | 'attachment'
    | 'attribution'
    | 'awards'
    | 'backspace'
    | 'band-aid'
    | 'battery'
    | 'battery-empty'
    | 'battery-full'
    | 'bee'
    | 'bell'
    | 'bitbucket'
    | 'block'
    | 'bmw'
    | 'board'
    | 'bolt'
    | 'bookmark'
    | 'border-all'
    | 'border-bottom'
    | 'border-left'
    | 'border-right'
    | 'border-style-dashed'
    | 'border-style-dotted'
    | 'border-style-solid'
    | 'border-top'
    | 'bot'
    | 'bowl'
    | 'box'
    | 'boy'
    | 'brackets'
    | 'briefcase'
    | 'browse'
    | 'browser'
    | 'brush'
    | 'bulb'
    | 'c-plus-plus'
    | 'calculator'
    | 'calendar'
    | 'calendar-dates'
    | 'calendar-due'
    | 'calendar-next'
    | 'calendar-today'
    | 'calendar-two'
    | 'calibrate'
    | 'camera'
    | 'cap'
    | 'captions'
    | 'card-clubs'
    | 'card-diamonds'
    | 'card-hearts'
    | 'card-spades'
    | 'carousel'
    | 'cast'
    | 'chanel'
    | 'chart'
    | 'check'
    | 'check-o'
    | 'check-r'
    | 'chevron-double-down'
    | 'chevron-double-down-o'
    | 'chevron-double-down-r'
    | 'chevron-double-left'
    | 'chevron-double-left-o'
    | 'chevron-double-left-r'
    | 'chevron-double-right'
    | 'chevron-double-right-o'
    | 'chevron-double-right-r'
    | 'chevron-double-up'
    | 'chevron-double-up-o'
    | 'chevron-double-up-r'
    | 'chevron-down'
    | 'chevron-down-o'
    | 'chevron-down-r'
    | 'chevron-left'
    | 'chevron-left-o'
    | 'chevron-left-r'
    | 'chevron-right'
    | 'chevron-right-o'
    | 'chevron-right-r'
    | 'chevron-up'
    | 'chevron-up-o'
    | 'chevron-up-r'
    | 'circleci'
    | 'clapper-board'
    | 'clipboard'
    | 'close'
    | 'close-o'
    | 'close-r'
    | 'cloud'
    | 'code'
    | 'code-climate'
    | 'code-slash'
    | 'coffee'
    | 'collage'
    | 'color-bucket'
    | 'color-picker'
    | 'comedy-central'
    | 'comment'
    | 'community'
    | 'components'
    | 'compress'
    | 'compress-left'
    | 'compress-right'
    | 'compress-v'
    | 'controller'
    | 'copy'
    | 'copyright'
    | 'corner-double-down-left'
    | 'corner-double-down-right'
    | 'corner-double-left-down'
    | 'corner-double-left-up'
    | 'corner-double-right-down'
    | 'corner-double-right-up'
    | 'corner-double-up-left'
    | 'corner-double-up-right'
    | 'corner-down-left'
    | 'corner-down-right'
    | 'corner-left-down'
    | 'corner-left-up'
    | 'corner-right-down'
    | 'corner-right-up'
    | 'corner-up-left'
    | 'corner-up-right'
    | 'credit-card'
    | 'crop'
    | 'cross'
    | 'crowdfire'
    | 'crown'
    | 'danger'
    | 'dark-mode'
    | 'data'
    | 'database'
    | 'debug'
    | 'designmodo'
    | 'desktop'
    | 'details-less'
    | 'details-more'
    | 'dialpad'
    | 'dice-1'
    | 'dice-2'
    | 'dice-3'
    | 'dice-4'
    | 'dice-5'
    | 'dice-6'
    | 'digitalocean'
    | 'disc'
    | 'display-flex'
    | 'display-fullwidth'
    | 'display-grid'
    | 'display-spacing'
    | 'distribute-horizontal'
    | 'distribute-vertical'
    | 'dock-bottom'
    | 'dock-left'
    | 'dock-right'
    | 'dock-window'
    | 'dolby'
    | 'dollar'
    | 'dribbble'
    | 'drive'
    | 'drop'
    | 'drop-invert'
    | 'drop-opacity'
    | 'duplicate'
    | 'edit-black-point'
    | 'edit-contrast'
    | 'edit-exposure'
    | 'edit-fade'
    | 'edit-flip-h'
    | 'edit-flip-v'
    | 'edit-highlight'
    | 'edit-markup'
    | 'edit-mask'
    | 'edit-noise'
    | 'edit-shadows'
    | 'edit-straight'
    | 'edit-unmask'
    | 'eject'
    | 'enter'
    | 'erase'
    | 'ereader'
    | 'ericsson'
    | 'ethernet'
    | 'euro'
    | 'eventbrite'
    | 'expand'
    | 'export'
    | 'extension'
    | 'extension-add'
    | 'extension-alt'
    | 'extension-remove'
    | 'external'
    | 'eye'
    | 'eye-alt'
    | 'facebook'
    | 'feed'
    | 'figma'
    | 'file'
    | 'file-add'
    | 'file-document'
    | 'file-remove'
    | 'film'
    | 'filters'
    | 'flag'
    | 'flag-alt'
    | 'folder'
    | 'folder-add'
    | 'folder-remove'
    | 'font-height'
    | 'font-spacing'
    | 'format-bold'
    | 'format-center'
    | 'format-color'
    | 'format-heading'
    | 'format-indent-decrease'
    | 'format-indent-increase'
    | 'format-italic'
    | 'format-justify'
    | 'format-left'
    | 'format-line-height'
    | 'format-right'
    | 'format-separator'
    | 'format-slash'
    | 'format-strike'
    | 'format-text'
    | 'format-underline'
    | 'format-uppercase'
    | 'framer'
    | 'games'
    | 'gender-female'
    | 'gender-male'
    | 'ghost'
    | 'ghost-character'
    | 'gift'
    | 'girl'
    | 'git-branch'
    | 'git-commit'
    | 'git-fork'
    | 'git-pull'
    | 'gitter'
    | 'glass'
    | 'glass-alt'
    | 'globe'
    | 'globe-alt'
    | 'google'
    | 'google-tasks'
    | 'gym'
    | 'hashtag'
    | 'headset'
    | 'heart'
    | 'hello'
    | 'home'
    | 'home-alt'
    | 'home-screen'
    | 'icecream'
    | 'if-design'
    | 'image'
    | 'import'
    | 'inbox'
    | 'indie-hackers'
    | 'infinity'
    | 'info'
    | 'inpicture'
    | 'insert-after'
    | 'insert-after-o'
    | 'insert-after-r'
    | 'insert-before'
    | 'insert-before-o'
    | 'insert-before-r'
    | 'insights'
    | 'instagram'
    | 'internal'
    | 'key'
    | 'keyboard'
    | 'keyhole'
    | 'laptop'
    | 'lastpass'
    | 'layout-grid'
    | 'layout-grid-small'
    | 'layout-list'
    | 'layout-pin'
    | 'linear'
    | 'link'
    | 'list'
    | 'list-tree'
    | 'live-photo'
    | 'loadbar'
    | 'loadbar-alt'
    | 'loadbar-doc'
    | 'loadbar-sound'
    | 'lock'
    | 'lock-unlock'
    | 'log-in'
    | 'log-off'
    | 'log-out'
    | 'loupe'
    | 'magnet'
    | 'mail'
    | 'mail-forward'
    | 'mail-open'
    | 'mail-reply'
    | 'math-divide'
    | 'math-equal'
    | 'math-minus'
    | 'math-percent'
    | 'math-plus'
    | 'maximize'
    | 'maximize-alt'
    | 'maze'
    | 'media-live'
    | 'media-podcast'
    | 'menu'
    | 'menu-boxed'
    | 'menu-cake'
    | 'menu-cheese'
    | 'menu-grid-o'
    | 'menu-grid-r'
    | 'menu-hotdog'
    | 'menu-left'
    | 'menu-left-alt'
    | 'menu-motion'
    | 'menu-oreos'
    | 'menu-right'
    | 'menu-right-alt'
    | 'menu-round'
    | 'merge-horizontal'
    | 'merge-vertical'
    | 'mic'
    | 'microbit'
    | 'microsoft'
    | 'mini-player'
    | 'minimize'
    | 'minimize-alt'
    | 'modem'
    | 'monday'
    | 'moon'
    | 'more'
    | 'more-alt'
    | 'more-o'
    | 'more-r'
    | 'more-vertical'
    | 'more-vertical-alt'
    | 'more-vertical-o'
    | 'more-vertical-r'
    | 'mouse'
    | 'move-down'
    | 'move-left'
    | 'move-right'
    | 'move-task'
    | 'move-up'
    | 'music'
    | 'music-note'
    | 'music-speaker'
    | 'nametag'
    | 'notes'
    | 'notifications'
    | 'npm'
    | 'oculus'
    | 'open-collective'
    | 'options'
    | 'organisation'
    | 'overflow'
    | 'pacman'
    | 'password'
    | 'path-back'
    | 'path-crop'
    | 'path-divide'
    | 'path-exclude'
    | 'path-front'
    | 'path-intersect'
    | 'path-outline'
    | 'path-trim'
    | 'path-unite'
    | 'patreon'
    | 'paypal'
    | 'pen'
    | 'pentagon-bottom-left'
    | 'pentagon-bottom-right'
    | 'pentagon-down'
    | 'pentagon-left'
    | 'pentagon-right'
    | 'pentagon-top-left'
    | 'pentagon-top-right'
    | 'pentagon-up'
    | 'performance'
    | 'pexels'
    | 'phone'
    | 'photoscan'
    | 'piano'
    | 'pill'
    | 'pin'
    | 'pin-alt'
    | 'pin-bottom'
    | 'pin-top'
    | 'play-backwards'
    | 'play-button'
    | 'play-button-o'
    | 'play-button-r'
    | 'play-forwards'
    | 'play-list'
    | 'play-list-add'
    | 'play-list-check'
    | 'play-list-remove'
    | 'play-list-search'
    | 'play-pause'
    | 'play-pause-o'
    | 'play-pause-r'
    | 'play-stop'
    | 'play-stop-o'
    | 'play-stop-r'
    | 'play-track-next'
    | 'play-track-next-o'
    | 'play-track-next-r'
    | 'play-track-prev'
    | 'play-track-prev-o'
    | 'play-track-prev-r'
    | 'plug'
    | 'pocket'
    | 'pokemon'
    | 'polaroid'
    | 'poll'
    | 'presentation'
    | 'printer'
    | 'product-hunt'
    | 'profile'
    | 'pull-clear'
    | 'push-chevron-down'
    | 'push-chevron-down-o'
    | 'push-chevron-down-r'
    | 'push-chevron-left'
    | 'push-chevron-left-o'
    | 'push-chevron-left-r'
    | 'push-chevron-right'
    | 'push-chevron-right-o'
    | 'push-chevron-right-r'
    | 'push-chevron-up'
    | 'push-chevron-up-o'
    | 'push-chevron-up-r'
    | 'push-down'
    | 'push-left'
    | 'push-right'
    | 'push-up'
    | 'qr'
    | 'quote'
    | 'quote-o'
    | 'radio-check'
    | 'radio-checked'
    | 'ratio'
    | 'read'
    | 'readme'
    | 'record'
    | 'redo'
    | 'remote'
    | 'remove'
    | 'remove-r'
    | 'rename'
    | 'reorder'
    | 'repeat'
    | 'ring'
    | 'row-first'
    | 'row-last'
    | 'ruler'
    | 'sand-clock'
    | 'scan'
    | 'screen'
    | 'screen-mirror'
    | 'screen-shot'
    | 'screen-wide'
    | 'scroll-h'
    | 'scroll-v'
    | 'search'
    | 'search-found'
    | 'search-loading'
    | 'select'
    | 'select-o'
    | 'select-r'
    | 'server'
    | 'serverless'
    | 'shape-circle'
    | 'shape-half-circle'
    | 'shape-hexagon'
    | 'shape-rhombus'
    | 'shape-square'
    | 'shape-triangle'
    | 'shape-zigzag'
    | 'share'
    | 'shield'
    | 'shopping-bag'
    | 'shopping-cart'
    | 'shortcut'
    | 'shutterstock'
    | 'sidebar'
    | 'sidebar-open'
    | 'sidebar-right'
    | 'signal'
    | 'size'
    | 'sketch'
    | 'slack'
    | 'sleep'
    | 'smart-home-boiler'
    | 'smart-home-cooker'
    | 'smart-home-heat'
    | 'smart-home-light'
    | 'smart-home-refrigerator'
    | 'smart-home-wash-machine'
    | 'smartphone'
    | 'smartphone-chip'
    | 'smartphone-ram'
    | 'smartphone-shake'
    | 'smile'
    | 'smile-mouth-open'
    | 'smile-neutral'
    | 'smile-no-mouth'
    | 'smile-none'
    | 'smile-sad'
    | 'smile-upside'
    | 'software-download'
    | 'software-upload'
    | 'sort-az'
    | 'sort-za'
    | 'space-between'
    | 'space-between-v'
    | 'spectrum'
    | 'spinner'
    | 'spinner-alt'
    | 'spinner-two'
    | 'spinner-two-alt'
    | 'square'
    | 'stack'
    | 'stark'
    | 'stopwatch'
    | 'stories'
    | 'studio'
    | 'style'
    | 'sun'
    | 'support'
    | 'swap'
    | 'swap-vertical'
    | 'sweden'
    | 'swiss'
    | 'sync'
    | 'tab'
    | 'tag'
    | 'tally'
    | 'tap-double'
    | 'tap-single'
    | 'template'
    | 'tennis'
    | 'terminal'
    | 'terrain'
    | 'thermometer'
    | 'thermostat'
    | 'tikcode'
    | 'time'
    | 'timelapse'
    | 'timer'
    | 'today'
    | 'toggle-off'
    | 'toggle-on'
    | 'toggle-square'
    | 'toggle-square-off'
    | 'toolbar-bottom'
    | 'toolbar-left'
    | 'toolbar-right'
    | 'toolbar-top'
    | 'toolbox'
    | 'touchpad'
    | 'track'
    | 'transcript'
    | 'trash'
    | 'trash-empty'
    | 'tree'
    | 'trees'
    | 'trello'
    | 'trending'
    | 'trending-down'
    | 'trophy'
    | 'tv'
    | 'twilio'
    | 'twitter'
    | 'ui-kit'
    | 'umbrella'
    | 'unavailable'
    | 'unblock'
    | 'undo'
    | 'unfold'
    | 'unsplash'
    | 'usb'
    | 'usb-c'
    | 'user'
    | 'user-add'
    | 'user-list'
    | 'user-remove'
    | 'userlane'
    | 'view-cols'
    | 'view-comfortable'
    | 'view-day'
    | 'view-grid'
    | 'view-list'
    | 'view-month'
    | 'view-split'
    | 'vinyl'
    | 'voicemail'
    | 'voicemail-o'
    | 'voicemail-r'
    | 'volume'
    | 'webcam'
    | 'website'
    | 'windows'
    | 'work-alt'
    | 'yinyang'
    | 'youtube'
    | 'zeit'
    | 'zoom-in'
    | 'zoom-out'
  emojicc:
    | 'a'
    | 'ab'
    | 'abc'
    | 'abcd'
    | 'accept'
    | 'aerialTramway'
    | 'airplane'
    | 'airplaneArriving'
    | 'airplaneDeparture'
    | 'airplaneSmall'
    | 'alarmClock'
    | 'alembic'
    | 'alien'
    | 'ambulance'
    | 'amphora'
    | 'anchor'
    | 'angel'
    | 'angelTone1'
    | 'angelTone2'
    | 'angelTone3'
    | 'angelTone4'
    | 'angelTone5'
    | 'anger'
    | 'angerRight'
    | 'angry'
    | 'anguished'
    | 'ant'
    | 'apple'
    | 'aquarius'
    | 'aries'
    | 'arrowBackward'
    | 'arrowDoubleDown'
    | 'arrowDoubleUp'
    | 'arrowDown'
    | 'arrowDownSmall'
    | 'arrowForward'
    | 'arrowHeadingDown'
    | 'arrowHeadingUp'
    | 'arrowLeft'
    | 'arrowLowerLeft'
    | 'arrowLowerRight'
    | 'arrowRight'
    | 'arrowRightHook'
    | 'arrowsClockwise'
    | 'arrowsCounterclockwise'
    | 'arrowUp'
    | 'arrowUpDown'
    | 'arrowUpperLeft'
    | 'arrowUpperRight'
    | 'arrowUpSmall'
    | 'art'
    | 'articulatedLorry'
    | 'asterisk'
    | 'astonished'
    | 'athleticShoe'
    | 'atm'
    | 'atom'
    | 'avocado'
    | 'b'
    | 'baby'
    | 'babyBottle'
    | 'babyChick'
    | 'babySymbol'
    | 'babyTone1'
    | 'babyTone2'
    | 'babyTone3'
    | 'babyTone4'
    | 'babyTone5'
    | 'back'
    | 'bacon'
    | 'badminton'
    | 'baggageClaim'
    | 'balloon'
    | 'ballotBox'
    | 'ballotBoxWithCheck'
    | 'bamboo'
    | 'banana'
    | 'bangbang'
    | 'bank'
    | 'barber'
    | 'barChart'
    | 'baseball'
    | 'basketball'
    | 'basketballPlayer'
    | 'basketballPlayerTone1'
    | 'basketballPlayerTone2'
    | 'basketballPlayerTone3'
    | 'basketballPlayerTone4'
    | 'basketballPlayerTone5'
    | 'bat'
    | 'bath'
    | 'bathTone1'
    | 'bathTone2'
    | 'bathTone3'
    | 'bathTone4'
    | 'bathTone5'
    | 'bathtub'
    | 'battery'
    | 'beach'
    | 'beachUmbrella'
    | 'bear'
    | 'bed'
    | 'bee'
    | 'beer'
    | 'beers'
    | 'beetle'
    | 'beginner'
    | 'bell'
    | 'bellhop'
    | 'bento'
    | 'bicyclist'
    | 'bicyclistTone1'
    | 'bicyclistTone2'
    | 'bicyclistTone3'
    | 'bicyclistTone4'
    | 'bicyclistTone5'
    | 'bike'
    | 'bikini'
    | 'biohazard'
    | 'bird'
    | 'birthday'
    | 'blackCircle'
    | 'blackHeart'
    | 'blackJoker'
    | 'blackLargeSquare'
    | 'blackMediumSmallSquare'
    | 'blackMediumSquare'
    | 'blackNib'
    | 'blackSmallSquare'
    | 'blackSquareButton'
    | 'blossom'
    | 'blowfish'
    | 'blueBook'
    | 'blueCar'
    | 'blueCircle'
    | 'blueHeart'
    | 'blush'
    | 'boar'
    | 'bomb'
    | 'book'
    | 'bookmark'
    | 'bookmarkTabs'
    | 'books'
    | 'boom'
    | 'boot'
    | 'bouquet'
    | 'bow'
    | 'bowAndArrow'
    | 'bowling'
    | 'bowTone1'
    | 'bowTone2'
    | 'bowTone3'
    | 'bowTone4'
    | 'bowTone5'
    | 'boxingGlove'
    | 'boy'
    | 'boyTone1'
    | 'boyTone2'
    | 'boyTone3'
    | 'boyTone4'
    | 'boyTone5'
    | 'bread'
    | 'brideWithVeil'
    | 'brideWithVeilTone1'
    | 'brideWithVeilTone2'
    | 'brideWithVeilTone3'
    | 'brideWithVeilTone4'
    | 'brideWithVeilTone5'
    | 'bridgeAtNight'
    | 'briefcase'
    | 'brokenHeart'
    | 'bug'
    | 'bulb'
    | 'bullettrainFront'
    | 'bullettrainSide'
    | 'burrito'
    | 'bus'
    | 'busstop'
    | 'bustInSilhouette'
    | 'bustsInSilhouette'
    | 'butterfly'
    | 'cactus'
    | 'cake'
    | 'calendar'
    | 'calendarSpiral'
    | 'calling'
    | 'callMe'
    | 'callMeTone1'
    | 'callMeTone2'
    | 'callMeTone3'
    | 'callMeTone4'
    | 'callMeTone5'
    | 'camel'
    | 'camera'
    | 'cameraWithFlash'
    | 'camping'
    | 'cancer'
    | 'candle'
    | 'candy'
    | 'canoe'
    | 'capitalAbcd'
    | 'capricorn'
    | 'cardBox'
    | 'cardIndex'
    | 'carouselHorse'
    | 'carrot'
    | 'cartwheel'
    | 'cartwheelTone1'
    | 'cartwheelTone2'
    | 'cartwheelTone3'
    | 'cartwheelTone4'
    | 'cartwheelTone5'
    | 'cat'
    | 'cat2'
    | 'cd'
    | 'chains'
    | 'champagne'
    | 'champagneGlass'
    | 'chart'
    | 'chartWithDownwardsTrend'
    | 'chartWithUpwardsTrend'
    | 'checkeredFlag'
    | 'cheese'
    | 'cherries'
    | 'cherryBlossom'
    | 'chestnut'
    | 'chicken'
    | 'childrenCrossing'
    | 'chipmunk'
    | 'chocolateBar'
    | 'christmasTree'
    | 'church'
    | 'cinema'
    | 'circusTent'
    | 'cityDusk'
    | 'cityscape'
    | 'citySunset'
    | 'cl'
    | 'clap'
    | 'clapper'
    | 'clapTone1'
    | 'clapTone2'
    | 'clapTone3'
    | 'clapTone4'
    | 'clapTone5'
    | 'classicalBuilding'
    | 'clipboard'
    | 'clock'
    | 'clock1'
    | 'clock2'
    | 'clock3'
    | 'clock4'
    | 'clock5'
    | 'clock6'
    | 'clock7'
    | 'clock8'
    | 'clock9'
    | 'clock10'
    | 'clock11'
    | 'clock12'
    | 'clock130'
    | 'clock230'
    | 'clock330'
    | 'clock430'
    | 'clock530'
    | 'clock630'
    | 'clock730'
    | 'clock830'
    | 'clock930'
    | 'clock1030'
    | 'clock1130'
    | 'clock1230'
    | 'closedBook'
    | 'closedLockWithKey'
    | 'closedUmbrella'
    | 'cloud'
    | 'cloudLightning'
    | 'cloudRain'
    | 'cloudSnow'
    | 'cloudTornado'
    | 'clown'
    | 'clubs'
    | 'cocktail'
    | 'coffee'
    | 'coffin'
    | 'coldSweat'
    | 'comet'
    | 'compression'
    | 'computer'
    | 'confettiBall'
    | 'confounded'
    | 'confused'
    | 'congratulations'
    | 'construction'
    | 'constructionSite'
    | 'constructionWorker'
    | 'constructionWorkerTone1'
    | 'constructionWorkerTone2'
    | 'constructionWorkerTone3'
    | 'constructionWorkerTone4'
    | 'constructionWorkerTone5'
    | 'controlKnobs'
    | 'convenienceStore'
    | 'cookie'
    | 'cooking'
    | 'cool'
    | 'cop'
    | 'copTone1'
    | 'copTone2'
    | 'copTone3'
    | 'copTone4'
    | 'copTone5'
    | 'copyright'
    | 'corn'
    | 'couch'
    | 'couple'
    | 'couplekiss'
    | 'coupleMm'
    | 'coupleWithHeart'
    | 'coupleWw'
    | 'cow'
    | 'cow2'
    | 'cowboy'
    | 'crab'
    | 'crayon'
    | 'creditCard'
    | 'crescentMoon'
    | 'cricket'
    | 'crocodile'
    | 'croissant'
    | 'cross'
    | 'crossedFlags'
    | 'crossedSwords'
    | 'crown'
    | 'cruiseShip'
    | 'cry'
    | 'cryingCatFace'
    | 'crystalBall'
    | 'cucumber'
    | 'cupid'
    | 'curlyLoop'
    | 'currencyExchange'
    | 'curry'
    | 'custard'
    | 'customs'
    | 'cyclone'
    | 'dagger'
    | 'dancer'
    | 'dancers'
    | 'dancerTone1'
    | 'dancerTone2'
    | 'dancerTone3'
    | 'dancerTone4'
    | 'dancerTone5'
    | 'dango'
    | 'darkSunglasses'
    | 'dart'
    | 'dash'
    | 'date'
    | 'deciduousTree'
    | 'deer'
    | 'departmentStore'
    | 'desert'
    | 'desktop'
    | 'diamonds'
    | 'diamondShapeWithADotInside'
    | 'disappointed'
    | 'disappointedRelieved'
    | 'dividers'
    | 'dizzy'
    | 'dizzyFace'
    | 'dog'
    | 'dog2'
    | 'dollar'
    | 'dolls'
    | 'dolphin'
    | 'doNotLitter'
    | 'door'
    | 'doughnut'
    | 'dove'
    | 'dragon'
    | 'dragonFace'
    | 'dress'
    | 'dromedaryCamel'
    | 'droolingFace'
    | 'droplet'
    | 'drum'
    | 'duck'
    | 'dvd'
    | 'eagle'
    | 'ear'
    | 'earOfRice'
    | 'earthAfrica'
    | 'earthAmericas'
    | 'earthAsia'
    | 'earTone1'
    | 'earTone2'
    | 'earTone3'
    | 'earTone4'
    | 'earTone5'
    | 'egg'
    | 'eggplant'
    | 'eight'
    | 'eightBall'
    | 'eightPointedBlackStar'
    | 'eightSpokedAsterisk'
    | 'eject'
    | 'electricPlug'
    | 'elephant'
    | 'eMail'
    | 'end'
    | 'envelope'
    | 'envelopeWithArrow'
    | 'euro'
    | 'europeanCastle'
    | 'europeanPostOffice'
    | 'evergreenTree'
    | 'exclamation'
    | 'expressionless'
    | 'eye'
    | 'eyeglasses'
    | 'eyeInSpeechBubble'
    | 'eyes'
    | 'facePalm'
    | 'facePalmTone1'
    | 'facePalmTone2'
    | 'facePalmTone3'
    | 'facePalmTone4'
    | 'facePalmTone5'
    | 'factory'
    | 'fallenLeaf'
    | 'family'
    | 'familyMmb'
    | 'familyMmbb'
    | 'familyMmg'
    | 'familyMmgb'
    | 'familyMmgg'
    | 'familyMwbb'
    | 'familyMwg'
    | 'familyMwgb'
    | 'familyMwgg'
    | 'familyWwb'
    | 'familyWwbb'
    | 'familyWwg'
    | 'familyWwgb'
    | 'familyWwgg'
    | 'fastForward'
    | 'fax'
    | 'fearful'
    | 'feet'
    | 'fencer'
    | 'ferrisWheel'
    | 'ferry'
    | 'fieldHockey'
    | 'fileCabinet'
    | 'fileFolder'
    | 'filmFrames'
    | 'fingersCrossed'
    | 'fingersCrossedTone1'
    | 'fingersCrossedTone2'
    | 'fingersCrossedTone3'
    | 'fingersCrossedTone4'
    | 'fingersCrossedTone5'
    | 'fire'
    | 'fireEngine'
    | 'fireworks'
    | 'firstPlace'
    | 'firstQuarterMoon'
    | 'firstQuarterMoonWithFace'
    | 'fish'
    | 'fishCake'
    | 'fishingPoleAndFish'
    | 'fist'
    | 'fistTone1'
    | 'fistTone2'
    | 'fistTone3'
    | 'fistTone4'
    | 'fistTone5'
    | 'five'
    | 'flagAC'
    | 'flagAD'
    | 'flagAE'
    | 'flagAF'
    | 'flagAG'
    | 'flagAI'
    | 'flagAL'
    | 'flagAM'
    | 'flagAO'
    | 'flagAQ'
    | 'flagAR'
    | 'flagAS'
    | 'flagAT'
    | 'flagAU'
    | 'flagAW'
    | 'flagAX'
    | 'flagAZ'
    | 'flagBA'
    | 'flagBB'
    | 'flagBD'
    | 'flagBE'
    | 'flagBF'
    | 'flagBG'
    | 'flagBH'
    | 'flagBI'
    | 'flagBJ'
    | 'flagBL'
    | 'flagBlack'
    | 'flagBM'
    | 'flagBN'
    | 'flagBO'
    | 'flagBQ'
    | 'flagBR'
    | 'flagBS'
    | 'flagBT'
    | 'flagBV'
    | 'flagBW'
    | 'flagBY'
    | 'flagBZ'
    | 'flagCA'
    | 'flagCC'
    | 'flagCD'
    | 'flagCF'
    | 'flagCG'
    | 'flagCH'
    | 'flagCI'
    | 'flagCK'
    | 'flagCL'
    | 'flagCM'
    | 'flagCN'
    | 'flagCO'
    | 'flagCP'
    | 'flagCR'
    | 'flagCU'
    | 'flagCV'
    | 'flagCW'
    | 'flagCX'
    | 'flagCY'
    | 'flagCZ'
    | 'flagDE'
    | 'flagDG'
    | 'flagDJ'
    | 'flagDK'
    | 'flagDM'
    | 'flagDO'
    | 'flagDZ'
    | 'flagEA'
    | 'flagEC'
    | 'flagEE'
    | 'flagEG'
    | 'flagEH'
    | 'flagER'
    | 'flagES'
    | 'flagET'
    | 'flagEU'
    | 'flagFI'
    | 'flagFJ'
    | 'flagFK'
    | 'flagFM'
    | 'flagFO'
    | 'flagFR'
    | 'flagGA'
    | 'flagGB'
    | 'flagGD'
    | 'flagGE'
    | 'flagGF'
    | 'flagGG'
    | 'flagGH'
    | 'flagGI'
    | 'flagGL'
    | 'flagGM'
    | 'flagGN'
    | 'flagGP'
    | 'flagGQ'
    | 'flagGR'
    | 'flagGS'
    | 'flagGT'
    | 'flagGU'
    | 'flagGW'
    | 'flagGY'
    | 'flagHK'
    | 'flagHM'
    | 'flagHN'
    | 'flagHR'
    | 'flagHT'
    | 'flagHU'
    | 'flagIC'
    | 'flagID'
    | 'flagIE'
    | 'flagIL'
    | 'flagIM'
    | 'flagIN'
    | 'flagIO'
    | 'flagIQ'
    | 'flagIR'
    | 'flagIS'
    | 'flagIT'
    | 'flagJE'
    | 'flagJM'
    | 'flagJO'
    | 'flagJP'
    | 'flagKE'
    | 'flagKG'
    | 'flagKH'
    | 'flagKI'
    | 'flagKM'
    | 'flagKN'
    | 'flagKP'
    | 'flagKR'
    | 'flagKW'
    | 'flagKY'
    | 'flagKZ'
    | 'flagLA'
    | 'flagLB'
    | 'flagLC'
    | 'flagLI'
    | 'flagLK'
    | 'flagLR'
    | 'flagLS'
    | 'flagLT'
    | 'flagLU'
    | 'flagLV'
    | 'flagLY'
    | 'flagMA'
    | 'flagMC'
    | 'flagMD'
    | 'flagME'
    | 'flagMF'
    | 'flagMG'
    | 'flagMH'
    | 'flagMK'
    | 'flagML'
    | 'flagMM'
    | 'flagMN'
    | 'flagMO'
    | 'flagMP'
    | 'flagMQ'
    | 'flagMR'
    | 'flagMS'
    | 'flagMT'
    | 'flagMU'
    | 'flagMV'
    | 'flagMW'
    | 'flagMX'
    | 'flagMY'
    | 'flagMZ'
    | 'flagNA'
    | 'flagNC'
    | 'flagNE'
    | 'flagNF'
    | 'flagNG'
    | 'flagNI'
    | 'flagNL'
    | 'flagNO'
    | 'flagNP'
    | 'flagNR'
    | 'flagNU'
    | 'flagNZ'
    | 'flagOM'
    | 'flagPA'
    | 'flagPE'
    | 'flagPF'
    | 'flagPG'
    | 'flagPH'
    | 'flagPK'
    | 'flagPL'
    | 'flagPM'
    | 'flagPN'
    | 'flagPR'
    | 'flagPS'
    | 'flagPT'
    | 'flagPW'
    | 'flagPY'
    | 'flagQA'
    | 'flagRE'
    | 'flagRO'
    | 'flagRS'
    | 'flagRU'
    | 'flagRW'
    | 'flags'
    | 'flagSA'
    | 'flagSB'
    | 'flagSC'
    | 'flagSD'
    | 'flagSE'
    | 'flagSG'
    | 'flagSH'
    | 'flagSI'
    | 'flagSJ'
    | 'flagSK'
    | 'flagSL'
    | 'flagSM'
    | 'flagSN'
    | 'flagSO'
    | 'flagSR'
    | 'flagSS'
    | 'flagST'
    | 'flagSV'
    | 'flagSX'
    | 'flagSY'
    | 'flagSZ'
    | 'flagTA'
    | 'flagTC'
    | 'flagTD'
    | 'flagTF'
    | 'flagTG'
    | 'flagTH'
    | 'flagTJ'
    | 'flagTK'
    | 'flagTL'
    | 'flagTM'
    | 'flagTN'
    | 'flagTO'
    | 'flagTR'
    | 'flagTT'
    | 'flagTV'
    | 'flagTW'
    | 'flagTZ'
    | 'flagUA'
    | 'flagUG'
    | 'flagUM'
    | 'flagUS'
    | 'flagUY'
    | 'flagUZ'
    | 'flagVA'
    | 'flagVC'
    | 'flagVE'
    | 'flagVG'
    | 'flagVI'
    | 'flagVN'
    | 'flagVU'
    | 'flagWF'
    | 'flagWhite'
    | 'flagWS'
    | 'flagXK'
    | 'flagYE'
    | 'flagYT'
    | 'flagZA'
    | 'flagZM'
    | 'flagZW'
    | 'flashlight'
    | 'fleurDeLis'
    | 'floppyDisk'
    | 'flowerPlayingCards'
    | 'flushed'
    | 'fog'
    | 'foggy'
    | 'football'
    | 'footprints'
    | 'forkAndKnife'
    | 'forkKnifePlate'
    | 'fountain'
    | 'four'
    | 'fourLeafClover'
    | 'fox'
    | 'framePhoto'
    | 'free'
    | 'frenchBread'
    | 'friedShrimp'
    | 'fries'
    | 'frog'
    | 'frowning'
    | 'frowning2'
    | 'fuelpump'
    | 'fullMoon'
    | 'fullMoonWithFace'
    | 'gameDie'
    | 'gear'
    | 'gem'
    | 'gemini'
    | 'ghost'
    | 'gift'
    | 'giftHeart'
    | 'girl'
    | 'girlTone1'
    | 'girlTone2'
    | 'girlTone3'
    | 'girlTone4'
    | 'girlTone5'
    | 'globeWithMeridians'
    | 'goal'
    | 'goat'
    | 'golf'
    | 'golfer'
    | 'gorilla'
    | 'grapes'
    | 'greenApple'
    | 'greenBook'
    | 'greenHeart'
    | 'greyExclamation'
    | 'greyQuestion'
    | 'grimacing'
    | 'grin'
    | 'grinning'
    | 'guardsman'
    | 'guardsmanTone1'
    | 'guardsmanTone2'
    | 'guardsmanTone3'
    | 'guardsmanTone4'
    | 'guardsmanTone5'
    | 'guitar'
    | 'gun'
    | 'haircut'
    | 'haircutTone1'
    | 'haircutTone2'
    | 'haircutTone3'
    | 'haircutTone4'
    | 'haircutTone5'
    | 'hamburger'
    | 'hammer'
    | 'hammerPick'
    | 'hamster'
    | 'handbag'
    | 'handball'
    | 'handballTone1'
    | 'handballTone2'
    | 'handballTone3'
    | 'handballTone4'
    | 'handballTone5'
    | 'handshake'
    | 'handshakeTone1'
    | 'handshakeTone2'
    | 'handshakeTone3'
    | 'handshakeTone4'
    | 'handshakeTone5'
    | 'handSplayed'
    | 'handSplayedTone1'
    | 'handSplayedTone2'
    | 'handSplayedTone3'
    | 'handSplayedTone4'
    | 'handSplayedTone5'
    | 'hash'
    | 'hatchedChick'
    | 'hatchingChick'
    | 'headBandage'
    | 'headphones'
    | 'hearNoEvil'
    | 'heart'
    | 'heartbeat'
    | 'heartDecoration'
    | 'heartExclamation'
    | 'heartEyes'
    | 'heartEyesCat'
    | 'heartpulse'
    | 'hearts'
    | 'heavyCheckMark'
    | 'heavyDivisionSign'
    | 'heavyDollarSign'
    | 'heavyMinusSign'
    | 'heavyMultiplicationX'
    | 'heavyPlusSign'
    | 'helicopter'
    | 'helmetWithCross'
    | 'herb'
    | 'hibiscus'
    | 'highBrightness'
    | 'highHeel'
    | 'hockey'
    | 'hole'
    | 'homes'
    | 'honeyPot'
    | 'horse'
    | 'horseRacing'
    | 'horseRacingTone1'
    | 'horseRacingTone2'
    | 'horseRacingTone3'
    | 'horseRacingTone4'
    | 'horseRacingTone5'
    | 'hospital'
    | 'hotdog'
    | 'hotel'
    | 'hotPepper'
    | 'hotsprings'
    | 'hourglass'
    | 'hourglassFlowingSand'
    | 'house'
    | 'houseAbandoned'
    | 'houseWithGarden'
    | 'hugging'
    | 'hundred'
    | 'hushed'
    | 'icecream'
    | 'iceSkate'
    | 'id'
    | 'ideographAdvantage'
    | 'imp'
    | 'inboxTray'
    | 'incomingEnvelope'
    | 'informationDeskPerson'
    | 'informationDeskPersonTone1'
    | 'informationDeskPersonTone2'
    | 'informationDeskPersonTone3'
    | 'informationDeskPersonTone4'
    | 'informationDeskPersonTone5'
    | 'informationSource'
    | 'innocent'
    | 'interrobang'
    | 'iphone'
    | 'island'
    | 'izakayaLantern'
    | 'jackOLantern'
    | 'japan'
    | 'japaneseCastle'
    | 'japaneseGoblin'
    | 'japaneseOgre'
    | 'jeans'
    | 'joy'
    | 'joyCat'
    | 'joystick'
    | 'juggling'
    | 'jugglingTone1'
    | 'jugglingTone2'
    | 'jugglingTone3'
    | 'jugglingTone4'
    | 'jugglingTone5'
    | 'kaaba'
    | 'key'
    | 'key2'
    | 'keyboard'
    | 'keycapTen'
    | 'kimono'
    | 'kiss'
    | 'kissing'
    | 'kissingCat'
    | 'kissingClosedEyes'
    | 'kissingHeart'
    | 'kissingSmilingEyes'
    | 'kissMm'
    | 'kissWw'
    | 'kiwi'
    | 'knife'
    | 'koala'
    | 'koko'
    | 'label'
    | 'largeBlueDiamond'
    | 'largeOrangeDiamond'
    | 'lastQuarterMoon'
    | 'lastQuarterMoonWithFace'
    | 'laughing'
    | 'leaves'
    | 'ledger'
    | 'leftFacingFist'
    | 'leftFacingFistTone1'
    | 'leftFacingFistTone2'
    | 'leftFacingFistTone3'
    | 'leftFacingFistTone4'
    | 'leftFacingFistTone5'
    | 'leftLuggage'
    | 'leftRightArrow'
    | 'leftwardsArrowWithHook'
    | 'lemon'
    | 'leo'
    | 'leopard'
    | 'levelSlider'
    | 'levitate'
    | 'libra'
    | 'lifter'
    | 'lifterTone1'
    | 'lifterTone2'
    | 'lifterTone3'
    | 'lifterTone4'
    | 'lifterTone5'
    | 'lightRail'
    | 'link'
    | 'lionFace'
    | 'lips'
    | 'lipstick'
    | 'lizard'
    | 'lock'
    | 'lockWithInkPen'
    | 'lollipop'
    | 'loop'
    | 'loudSound'
    | 'loudspeaker'
    | 'loveHotel'
    | 'loveLetter'
    | 'lowBrightness'
    | 'lyingFace'
    | 'm'
    | 'mag'
    | 'magRight'
    | 'mahjong'
    | 'mailbox'
    | 'mailboxClosed'
    | 'mailboxWithMail'
    | 'mailboxWithNoMail'
    | 'man'
    | 'manDancing'
    | 'manDancingTone1'
    | 'manDancingTone2'
    | 'manDancingTone3'
    | 'manDancingTone4'
    | 'manDancingTone5'
    | 'manInTuxedo'
    | 'manInTuxedoTone1'
    | 'manInTuxedoTone2'
    | 'manInTuxedoTone3'
    | 'manInTuxedoTone4'
    | 'manInTuxedoTone5'
    | 'mansShoe'
    | 'manTone1'
    | 'manTone2'
    | 'manTone3'
    | 'manTone4'
    | 'manTone5'
    | 'manWithGuaPiMao'
    | 'manWithGuaPiMaoTone1'
    | 'manWithGuaPiMaoTone2'
    | 'manWithGuaPiMaoTone3'
    | 'manWithGuaPiMaoTone4'
    | 'manWithGuaPiMaoTone5'
    | 'manWithTurban'
    | 'manWithTurbanTone1'
    | 'manWithTurbanTone2'
    | 'manWithTurbanTone3'
    | 'manWithTurbanTone4'
    | 'manWithTurbanTone5'
    | 'map'
    | 'mapleLeaf'
    | 'martialArtsUniform'
    | 'mask'
    | 'massage'
    | 'massageTone1'
    | 'massageTone2'
    | 'massageTone3'
    | 'massageTone4'
    | 'massageTone5'
    | 'meatOnBone'
    | 'medal'
    | 'mega'
    | 'melon'
    | 'menorah'
    | 'mens'
    | 'metal'
    | 'metalTone1'
    | 'metalTone2'
    | 'metalTone3'
    | 'metalTone4'
    | 'metalTone5'
    | 'metro'
    | 'microphone'
    | 'microphone2'
    | 'microscope'
    | 'middleFinger'
    | 'middleFingerTone1'
    | 'middleFingerTone2'
    | 'middleFingerTone3'
    | 'middleFingerTone4'
    | 'middleFingerTone5'
    | 'militaryMedal'
    | 'milk'
    | 'milkyWay'
    | 'minibus'
    | 'minidisc'
    | 'mobilePhoneOff'
    | 'moneybag'
    | 'moneyMouth'
    | 'moneyWithWings'
    | 'monkey'
    | 'monkeyFace'
    | 'monorail'
    | 'mortarBoard'
    | 'mosque'
    | 'motorboat'
    | 'motorcycle'
    | 'motorScooter'
    | 'motorway'
    | 'mountain'
    | 'mountainBicyclist'
    | 'mountainBicyclistTone1'
    | 'mountainBicyclistTone2'
    | 'mountainBicyclistTone3'
    | 'mountainBicyclistTone4'
    | 'mountainBicyclistTone5'
    | 'mountainCableway'
    | 'mountainRailway'
    | 'mountainSnow'
    | 'mountFuji'
    | 'mouse'
    | 'mouse2'
    | 'mouseThreeButton'
    | 'movieCamera'
    | 'moyai'
    | 'mrsClaus'
    | 'mrsClausTone1'
    | 'mrsClausTone2'
    | 'mrsClausTone3'
    | 'mrsClausTone4'
    | 'mrsClausTone5'
    | 'muscle'
    | 'muscleTone1'
    | 'muscleTone2'
    | 'muscleTone3'
    | 'muscleTone4'
    | 'muscleTone5'
    | 'mushroom'
    | 'musicalKeyboard'
    | 'musicalNote'
    | 'musicalScore'
    | 'mute'
    | 'nailCare'
    | 'nailCareTone1'
    | 'nailCareTone2'
    | 'nailCareTone3'
    | 'nailCareTone4'
    | 'nailCareTone5'
    | 'nameBadge'
    | 'nauseatedFace'
    | 'necktie'
    | 'negativeSquaredCrossMark'
    | 'nerd'
    | 'neutralFace'
    | 'new'
    | 'newMoon'
    | 'newMoonWithFace'
    | 'newspaper'
    | 'newspaper2'
    | 'ng'
    | 'nightWithStars'
    | 'nine'
    | 'noBell'
    | 'noBicycles'
    | 'noEntry'
    | 'noEntrySign'
    | 'noGood'
    | 'noGoodTone1'
    | 'noGoodTone2'
    | 'noGoodTone3'
    | 'noGoodTone4'
    | 'noGoodTone5'
    | 'noMobilePhones'
    | 'noMouth'
    | 'nonPotableWater'
    | 'noPedestrians'
    | 'nose'
    | 'noseTone1'
    | 'noseTone2'
    | 'noseTone3'
    | 'noseTone4'
    | 'noseTone5'
    | 'noSmoking'
    | 'notebook'
    | 'notebookWithDecorativeCover'
    | 'notepadSpiral'
    | 'notes'
    | 'nutAndBolt'
    | 'o'
    | 'o2'
    | 'ocean'
    | 'octagonalSign'
    | 'octopus'
    | 'oden'
    | 'office'
    | 'oil'
    | 'ok'
    | 'okHand'
    | 'okHandTone1'
    | 'okHandTone2'
    | 'okHandTone3'
    | 'okHandTone4'
    | 'okHandTone5'
    | 'okWoman'
    | 'okWomanTone1'
    | 'okWomanTone2'
    | 'okWomanTone3'
    | 'okWomanTone4'
    | 'okWomanTone5'
    | 'olderMan'
    | 'olderManTone1'
    | 'olderManTone2'
    | 'olderManTone3'
    | 'olderManTone4'
    | 'olderManTone5'
    | 'olderWoman'
    | 'olderWomanTone1'
    | 'olderWomanTone2'
    | 'olderWomanTone3'
    | 'olderWomanTone4'
    | 'olderWomanTone5'
    | 'omSymbol'
    | 'on'
    | 'oncomingAutomobile'
    | 'oncomingBus'
    | 'oncomingPoliceCar'
    | 'oncomingTaxi'
    | 'one'
    | 'oneTwoThreeFour'
    | 'openFileFolder'
    | 'openHands'
    | 'openHandsTone1'
    | 'openHandsTone2'
    | 'openHandsTone3'
    | 'openHandsTone4'
    | 'openHandsTone5'
    | 'openMouth'
    | 'ophiuchus'
    | 'orangeBook'
    | 'orthodoxCross'
    | 'outboxTray'
    | 'owl'
    | 'ox'
    | 'package'
    | 'pageFacingUp'
    | 'pager'
    | 'pageWithCurl'
    | 'paintbrush'
    | 'palmTree'
    | 'pancakes'
    | 'pandaFace'
    | 'paperclip'
    | 'paperclips'
    | 'park'
    | 'parking'
    | 'partAlternationMark'
    | 'partlySunny'
    | 'passportControl'
    | 'pauseButton'
    | 'peace'
    | 'peach'
    | 'peanuts'
    | 'pear'
    | 'penBallpoint'
    | 'pencil'
    | 'pencil2'
    | 'penFountain'
    | 'penguin'
    | 'pensive'
    | 'performingArts'
    | 'persevere'
    | 'personFrowning'
    | 'personFrowningTone1'
    | 'personFrowningTone2'
    | 'personFrowningTone3'
    | 'personFrowningTone4'
    | 'personFrowningTone5'
    | 'personWithBlondHair'
    | 'personWithBlondHairTone1'
    | 'personWithBlondHairTone2'
    | 'personWithBlondHairTone3'
    | 'personWithBlondHairTone4'
    | 'personWithBlondHairTone5'
    | 'personWithPoutingFace'
    | 'personWithPoutingFaceTone1'
    | 'personWithPoutingFaceTone2'
    | 'personWithPoutingFaceTone3'
    | 'personWithPoutingFaceTone4'
    | 'personWithPoutingFaceTone5'
    | 'pick'
    | 'pig'
    | 'pig2'
    | 'pigNose'
    | 'pill'
    | 'pineapple'
    | 'pingPong'
    | 'pisces'
    | 'pizza'
    | 'placeOfWorship'
    | 'playPause'
    | 'pointDown'
    | 'pointDownTone1'
    | 'pointDownTone2'
    | 'pointDownTone3'
    | 'pointDownTone4'
    | 'pointDownTone5'
    | 'pointLeft'
    | 'pointLeftTone1'
    | 'pointLeftTone2'
    | 'pointLeftTone3'
    | 'pointLeftTone4'
    | 'pointLeftTone5'
    | 'pointRight'
    | 'pointRightTone1'
    | 'pointRightTone2'
    | 'pointRightTone3'
    | 'pointRightTone4'
    | 'pointRightTone5'
    | 'pointUp'
    | 'pointUp2'
    | 'pointUp2Tone1'
    | 'pointUp2Tone2'
    | 'pointUp2Tone3'
    | 'pointUp2Tone4'
    | 'pointUp2Tone5'
    | 'pointUpTone1'
    | 'pointUpTone2'
    | 'pointUpTone3'
    | 'pointUpTone4'
    | 'pointUpTone5'
    | 'policeCar'
    | 'poodle'
    | 'poop'
    | 'popcorn'
    | 'postalHorn'
    | 'postbox'
    | 'postOffice'
    | 'potableWater'
    | 'potato'
    | 'pouch'
    | 'poultryLeg'
    | 'pound'
    | 'poutingCat'
    | 'pray'
    | 'prayerBeads'
    | 'prayTone1'
    | 'prayTone2'
    | 'prayTone3'
    | 'prayTone4'
    | 'prayTone5'
    | 'pregnantWoman'
    | 'pregnantWomanTone1'
    | 'pregnantWomanTone2'
    | 'pregnantWomanTone3'
    | 'pregnantWomanTone4'
    | 'pregnantWomanTone5'
    | 'prince'
    | 'princess'
    | 'princessTone1'
    | 'princessTone2'
    | 'princessTone3'
    | 'princessTone4'
    | 'princessTone5'
    | 'princeTone1'
    | 'princeTone2'
    | 'princeTone3'
    | 'princeTone4'
    | 'princeTone5'
    | 'printer'
    | 'projector'
    | 'punch'
    | 'punchTone1'
    | 'punchTone2'
    | 'punchTone3'
    | 'punchTone4'
    | 'punchTone5'
    | 'purpleHeart'
    | 'purse'
    | 'pushpin'
    | 'putLitterInItsPlace'
    | 'question'
    | 'rabbit'
    | 'rabbit2'
    | 'raceCar'
    | 'racehorse'
    | 'radio'
    | 'radioactive'
    | 'radioButton'
    | 'rage'
    | 'railwayCar'
    | 'railwayTrack'
    | 'rainbow'
    | 'rainbowFlag'
    | 'raisedBackOfHand'
    | 'raisedBackOfHandTone1'
    | 'raisedBackOfHandTone2'
    | 'raisedBackOfHandTone3'
    | 'raisedBackOfHandTone4'
    | 'raisedBackOfHandTone5'
    | 'raisedHand'
    | 'raisedHands'
    | 'raisedHandsTone1'
    | 'raisedHandsTone2'
    | 'raisedHandsTone3'
    | 'raisedHandsTone4'
    | 'raisedHandsTone5'
    | 'raisedHandTone1'
    | 'raisedHandTone2'
    | 'raisedHandTone3'
    | 'raisedHandTone4'
    | 'raisedHandTone5'
    | 'raisingHand'
    | 'raisingHandTone1'
    | 'raisingHandTone2'
    | 'raisingHandTone3'
    | 'raisingHandTone4'
    | 'raisingHandTone5'
    | 'ram'
    | 'ramen'
    | 'rat'
    | 'recordButton'
    | 'recycle'
    | 'redCar'
    | 'redCircle'
    | 'regionalIndicatorA'
    | 'regionalIndicatorB'
    | 'regionalIndicatorC'
    | 'regionalIndicatorD'
    | 'regionalIndicatorE'
    | 'regionalIndicatorF'
    | 'regionalIndicatorG'
    | 'regionalIndicatorH'
    | 'regionalIndicatorI'
    | 'regionalIndicatorJ'
    | 'regionalIndicatorK'
    | 'regionalIndicatorL'
    | 'regionalIndicatorM'
    | 'regionalIndicatorN'
    | 'regionalIndicatorO'
    | 'regionalIndicatorP'
    | 'regionalIndicatorQ'
    | 'regionalIndicatorR'
    | 'regionalIndicatorS'
    | 'regionalIndicatorT'
    | 'regionalIndicatorU'
    | 'regionalIndicatorV'
    | 'regionalIndicatorW'
    | 'regionalIndicatorX'
    | 'regionalIndicatorY'
    | 'regionalIndicatorZ'
    | 'registered'
    | 'relaxed'
    | 'relieved'
    | 'reminderRibbon'
    | 'repeat'
    | 'repeatOne'
    | 'restroom'
    | 'revolvingHearts'
    | 'rewind'
    | 'rhino'
    | 'ribbon'
    | 'rice'
    | 'riceBall'
    | 'riceCracker'
    | 'riceScene'
    | 'rightFacingFist'
    | 'rightFacingFistTone1'
    | 'rightFacingFistTone2'
    | 'rightFacingFistTone3'
    | 'rightFacingFistTone4'
    | 'rightFacingFistTone5'
    | 'ring'
    | 'robot'
    | 'rocket'
    | 'rofl'
    | 'rollerCoaster'
    | 'rollingEyes'
    | 'rooster'
    | 'rose'
    | 'rosette'
    | 'rotatingLight'
    | 'roundPushpin'
    | 'rowboat'
    | 'rowboatTone1'
    | 'rowboatTone2'
    | 'rowboatTone3'
    | 'rowboatTone4'
    | 'rowboatTone5'
    | 'rugbyFootball'
    | 'runner'
    | 'runnerTone1'
    | 'runnerTone2'
    | 'runnerTone3'
    | 'runnerTone4'
    | 'runnerTone5'
    | 'runningShirtWithSash'
    | 'sa'
    | 'sagittarius'
    | 'sailboat'
    | 'sake'
    | 'salad'
    | 'sandal'
    | 'santa'
    | 'santaTone1'
    | 'santaTone2'
    | 'santaTone3'
    | 'santaTone4'
    | 'santaTone5'
    | 'satellite'
    | 'satelliteOrbital'
    | 'saxophone'
    | 'scales'
    | 'school'
    | 'schoolSatchel'
    | 'scissors'
    | 'scooter'
    | 'scorpion'
    | 'scorpius'
    | 'scream'
    | 'screamCat'
    | 'scroll'
    | 'seat'
    | 'secondPlace'
    | 'secret'
    | 'seedling'
    | 'seeNoEvil'
    | 'selfie'
    | 'selfieTone1'
    | 'selfieTone2'
    | 'selfieTone3'
    | 'selfieTone4'
    | 'selfieTone5'
    | 'seven'
    | 'shallowPanOfFood'
    | 'shamrock'
    | 'shark'
    | 'shavedIce'
    | 'sheep'
    | 'shell'
    | 'shield'
    | 'shintoShrine'
    | 'ship'
    | 'shirt'
    | 'shoppingBags'
    | 'shoppingCart'
    | 'shower'
    | 'shrimp'
    | 'shrug'
    | 'shrugTone1'
    | 'shrugTone2'
    | 'shrugTone3'
    | 'shrugTone4'
    | 'shrugTone5'
    | 'signalStrength'
    | 'six'
    | 'sixPointedStar'
    | 'ski'
    | 'skier'
    | 'skull'
    | 'skullCrossbones'
    | 'sleeping'
    | 'sleepingAccommodation'
    | 'sleepy'
    | 'slightFrown'
    | 'slightSmile'
    | 'slotMachine'
    | 'smallBlueDiamond'
    | 'smallOrangeDiamond'
    | 'smallRedTriangle'
    | 'smallRedTriangleDown'
    | 'smile'
    | 'smileCat'
    | 'smiley'
    | 'smileyCat'
    | 'smilingImp'
    | 'smirk'
    | 'smirkCat'
    | 'smoking'
    | 'snail'
    | 'snake'
    | 'sneezingFace'
    | 'snowboarder'
    | 'snowflake'
    | 'snowman'
    | 'snowman2'
    | 'sob'
    | 'soccer'
    | 'soon'
    | 'sos'
    | 'sound'
    | 'spaceInvader'
    | 'spades'
    | 'spaghetti'
    | 'sparkle'
    | 'sparkler'
    | 'sparkles'
    | 'sparklingHeart'
    | 'speaker'
    | 'speakingHead'
    | 'speakNoEvil'
    | 'speechBalloon'
    | 'speechLeft'
    | 'speedboat'
    | 'spider'
    | 'spiderWeb'
    | 'spoon'
    | 'spy'
    | 'spyTone1'
    | 'spyTone2'
    | 'spyTone3'
    | 'spyTone4'
    | 'spyTone5'
    | 'squid'
    | 'stadium'
    | 'star'
    | 'star2'
    | 'starAndCrescent'
    | 'starOfDavid'
    | 'stars'
    | 'station'
    | 'statueOfLiberty'
    | 'steamLocomotive'
    | 'stew'
    | 'stopButton'
    | 'stopwatch'
    | 'straightRuler'
    | 'strawberry'
    | 'stuckOutTongue'
    | 'stuckOutTongueClosedEyes'
    | 'stuckOutTongueWinkingEye'
    | 'stuffedFlatbread'
    | 'sunflower'
    | 'sunglasses'
    | 'sunny'
    | 'sunrise'
    | 'sunriseOverMountains'
    | 'sunWithFace'
    | 'surfer'
    | 'surferTone1'
    | 'surferTone2'
    | 'surferTone3'
    | 'surferTone4'
    | 'surferTone5'
    | 'sushi'
    | 'suspensionRailway'
    | 'sweat'
    | 'sweatDrops'
    | 'sweatSmile'
    | 'sweetPotato'
    | 'swimmer'
    | 'swimmerTone1'
    | 'swimmerTone2'
    | 'swimmerTone3'
    | 'swimmerTone4'
    | 'swimmerTone5'
    | 'symbols'
    | 'synagogue'
    | 'syringe'
    | 'taco'
    | 'tada'
    | 'tanabataTree'
    | 'tangerine'
    | 'taurus'
    | 'taxi'
    | 'tea'
    | 'telephone'
    | 'telephoneReceiver'
    | 'telescope'
    | 'tennis'
    | 'tent'
    | 'thermometer'
    | 'thermometerFace'
    | 'thinking'
    | 'thirdPlace'
    | 'thoughtBalloon'
    | 'three'
    | 'thumbsdown'
    | 'thumbsdownTone1'
    | 'thumbsdownTone2'
    | 'thumbsdownTone3'
    | 'thumbsdownTone4'
    | 'thumbsdownTone5'
    | 'thumbsup'
    | 'thumbsupTone1'
    | 'thumbsupTone2'
    | 'thumbsupTone3'
    | 'thumbsupTone4'
    | 'thumbsupTone5'
    | 'thunderCloudRain'
    | 'ticket'
    | 'tickets'
    | 'tiger'
    | 'tiger2'
    | 'timer'
    | 'tiredFace'
    | 'tm'
    | 'toilet'
    | 'tokyoTower'
    | 'tomato'
    | 'tone1'
    | 'tone2'
    | 'tone3'
    | 'tone4'
    | 'tone5'
    | 'tongue'
    | 'tools'
    | 'top'
    | 'tophat'
    | 'trackball'
    | 'trackNext'
    | 'trackPrevious'
    | 'tractor'
    | 'trafficLight'
    | 'train'
    | 'train2'
    | 'tram'
    | 'triangularFlagOnPost'
    | 'triangularRuler'
    | 'trident'
    | 'triumph'
    | 'trolleybus'
    | 'trophy'
    | 'tropicalDrink'
    | 'tropicalFish'
    | 'truck'
    | 'trumpet'
    | 'tulip'
    | 'tumblerGlass'
    | 'turkey'
    | 'turtle'
    | 'tv'
    | 'twistedRightwardsArrows'
    | 'two'
    | 'twoHearts'
    | 'twoMenHoldingHands'
    | 'twoWomenHoldingHands'
    | 'u6e80'
    | 'u7a7a'
    | 'u55b6'
    | 'u5272'
    | 'u5408'
    | 'u6307'
    | 'u6708'
    | 'u6709'
    | 'u7121'
    | 'u7533'
    | 'u7981'
    | 'umbrella'
    | 'umbrella2'
    | 'unamused'
    | 'underage'
    | 'unicorn'
    | 'unlock'
    | 'up'
    | 'upsideDown'
    | 'urn'
    | 'v'
    | 'verticalTrafficLight'
    | 'vhs'
    | 'vibrationMode'
    | 'videoCamera'
    | 'videoGame'
    | 'violin'
    | 'virgo'
    | 'volcano'
    | 'volleyball'
    | 'vs'
    | 'vTone1'
    | 'vTone2'
    | 'vTone3'
    | 'vTone4'
    | 'vTone5'
    | 'vulcan'
    | 'vulcanTone1'
    | 'vulcanTone2'
    | 'vulcanTone3'
    | 'vulcanTone4'
    | 'vulcanTone5'
    | 'walking'
    | 'walkingTone1'
    | 'walkingTone2'
    | 'walkingTone3'
    | 'walkingTone4'
    | 'walkingTone5'
    | 'waningCrescentMoon'
    | 'waningGibbousMoon'
    | 'warning'
    | 'wastebasket'
    | 'watch'
    | 'waterBuffalo'
    | 'watermelon'
    | 'waterPolo'
    | 'waterPoloTone1'
    | 'waterPoloTone2'
    | 'waterPoloTone3'
    | 'waterPoloTone4'
    | 'waterPoloTone5'
    | 'wave'
    | 'waveTone1'
    | 'waveTone2'
    | 'waveTone3'
    | 'waveTone4'
    | 'waveTone5'
    | 'wavyDash'
    | 'waxingCrescentMoon'
    | 'waxingGibbousMoon'
    | 'wc'
    | 'weary'
    | 'wedding'
    | 'whale'
    | 'whale2'
    | 'wheelchair'
    | 'wheelOfDharma'
    | 'whiteCheckMark'
    | 'whiteCircle'
    | 'whiteFlower'
    | 'whiteLargeSquare'
    | 'whiteMediumSmallSquare'
    | 'whiteMediumSquare'
    | 'whiteSmallSquare'
    | 'whiteSquareButton'
    | 'whiteSunCloud'
    | 'whiteSunRainCloud'
    | 'whiteSunSmallCloud'
    | 'wiltedRose'
    | 'windBlowingFace'
    | 'windChime'
    | 'wineGlass'
    | 'wink'
    | 'wolf'
    | 'woman'
    | 'womansClothes'
    | 'womansHat'
    | 'womanTone1'
    | 'womanTone2'
    | 'womanTone3'
    | 'womanTone4'
    | 'womanTone5'
    | 'womens'
    | 'worried'
    | 'wrench'
    | 'wrestlers'
    | 'wrestlersTone1'
    | 'wrestlersTone2'
    | 'wrestlersTone3'
    | 'wrestlersTone4'
    | 'wrestlersTone5'
    | 'writingHand'
    | 'writingHandTone1'
    | 'writingHandTone2'
    | 'writingHandTone3'
    | 'writingHandTone4'
    | 'writingHandTone5'
    | 'x'
    | 'yellowHeart'
    | 'yen'
    | 'yinYang'
    | 'yum'
    | 'zap'
    | 'zero'
    | 'zipperMouth'
    | 'zzz'
  eos: {
    animated:
      | 'arrow_rotate'
      | 'atom_electron'
      | 'bubble_loading'
      | 'compass'
      | 'hourglass'
      | 'installing'
      | 'loading'
      | 'rotating_gear'
      | 'three_dots_loading'
      | 'typing'
    outlined:
      | '1k'
      | '1k_plus'
      | '1x_mobiledata'
      | '2k'
      | '2k_plus'
      | '2mp'
      | '3d_rotation'
      | '3g_mobiledata'
      | '3k'
      | '3k_plus'
      | '3mp'
      | '3p'
      | '4g_mobiledata'
      | '4g_plus_mobiledata'
      | '4k'
      | '4k_plus'
      | '4mp'
      | '5g'
      | '5k'
      | '5k_plus'
      | '5mp'
      | '6_ft_apart'
      | '6k'
      | '6k_plus'
      | '6mp'
      | '7k'
      | '7k_plus'
      | '7mp'
      | '8k'
      | '8k_plus'
      | '8mp'
      | '9k'
      | '9k_plus'
      | '9mp'
      | '10k'
      | '10mp'
      | '11mp'
      | '12mp'
      | '13mp'
      | '14mp'
      | '15mp'
      | '16mp'
      | '17mp'
      | '18mp'
      | '19mp'
      | '20mp'
      | '21mp'
      | '22mp'
      | '23mp'
      | '24mp'
      | '30fps'
      | '30fps_select'
      | '60fps'
      | '60fps_select'
      | '360'
      | 'abstract'
      | 'abstract_instance'
      | 'ac_unit'
      | 'access_alarm'
      | 'access_time_filled'
      | 'accessibility'
      | 'accessibility_new'
      | 'accessible'
      | 'accessible_forward'
      | 'account_balance'
      | 'account_balance_wallet'
      | 'account_box'
      | 'account_circle'
      | 'account_tree'
      | 'action_chains'
      | 'activate_subscriptions'
      | 'ad_units'
      | 'adb'
      | 'add'
      | 'add_a_photo'
      | 'add_alarm'
      | 'add_alert'
      | 'add_box'
      | 'add_business'
      | 'add_chart'
      | 'add_circle'
      | 'add_comment'
      | 'add_ic_call'
      | 'add_link'
      | 'add_location'
      | 'add_location_alt'
      | 'add_moderator'
      | 'add_photo_alternate'
      | 'add_reaction'
      | 'add_road'
      | 'add_shopping_cart'
      | 'add_task'
      | 'add_to_drive'
      | 'add_to_home_screen'
      | 'add_to_queue'
      | 'addchart'
      | 'adjust'
      | 'admin'
      | 'admin_panel_settings'
      | 'ads_click'
      | 'agriculture'
      | 'ai_healing'
      | 'air'
      | 'airline_seat_flat'
      | 'airline_seat_flat_angled'
      | 'airline_seat_individual_suite'
      | 'airline_seat_legroom_extra'
      | 'airline_seat_legroom_normal'
      | 'airline_seat_legroom_reduced'
      | 'airline_seat_recline_extra'
      | 'airline_seat_recline_normal'
      | 'airplane_ticket'
      | 'airplanemode_inactive'
      | 'airplay'
      | 'airport_shuttle'
      | 'alarm'
      | 'alarm_off'
      | 'alarm_on'
      | 'album'
      | 'align_horizontal_center'
      | 'align_horizontal_left'
      | 'align_horizontal_right'
      | 'align_vertical_bottom'
      | 'align_vertical_center'
      | 'align_vertical_top'
      | 'all_inbox'
      | 'all_inclusive'
      | 'all_out'
      | 'alt_route'
      | 'alternate_email'
      | 'analytics'
      | 'anchor'
      | 'android'
      | 'animation'
      | 'announcement'
      | 'aod'
      | 'apartment'
      | 'api'
      | 'api_alt'
      | 'app_blocking'
      | 'app_registration'
      | 'app_settings_alt'
      | 'application'
      | 'application_incomplete'
      | 'application_instance'
      | 'application_window'
      | 'approval'
      | 'apps'
      | 'architecture'
      | 'archive'
      | 'area_chart'
      | 'arrow_back'
      | 'arrow_back_ios'
      | 'arrow_circle_down'
      | 'arrow_circle_up'
      | 'arrow_downward'
      | 'arrow_drop_down'
      | 'arrow_drop_down_circle'
      | 'arrow_drop_up'
      | 'arrow_forward'
      | 'arrow_forward_ios'
      | 'arrow_left'
      | 'arrow_right'
      | 'arrow_right_alt'
      | 'arrow_upward'
      | 'art_track'
      | 'article'
      | 'aspect_ratio'
      | 'assignment'
      | 'assignment_ind'
      | 'assignment_late'
      | 'assignment_return'
      | 'assignment_returned'
      | 'assignment_turned_in'
      | 'assistant'
      | 'assistant_direction'
      | 'assistant_photo'
      | 'atm'
      | 'attach_email'
      | 'attach_file'
      | 'attach_money'
      | 'attachment'
      | 'attractions'
      | 'attribution'
      | 'audiotrack'
      | 'auto_awesome'
      | 'auto_awesome_mosaic'
      | 'auto_awesome_motion'
      | 'auto_delete'
      | 'auto_fix_high'
      | 'auto_fix_normal'
      | 'auto_fix_off'
      | 'auto_graph'
      | 'auto_stories'
      | 'autofps_select'
      | 'autorenew'
      | 'av_timer'
      | 'baby_changing_station'
      | 'back_hand'
      | 'backpack'
      | 'backspace'
      | 'backup_table'
      | 'badge'
      | 'bakery_dining'
      | 'balcony'
      | 'ballot'
      | 'bar_chart'
      | 'batch_prediction'
      | 'bathroom'
      | 'bathtub'
      | 'battery_alert'
      | 'battery_charging_full'
      | 'battery_full'
      | 'battery_saver'
      | 'battery_unknown'
      | 'beach_access'
      | 'bed'
      | 'bedroom_baby'
      | 'bedroom_child'
      | 'bedroom_parent'
      | 'bedtime'
      | 'beenhere'
      | 'bento'
      | 'bike_scooter'
      | 'biotech'
      | 'blender'
      | 'block'
      | 'bloodtype'
      | 'bluetooth'
      | 'bluetooth_connected'
      | 'bluetooth_disabled'
      | 'bluetooth_drive'
      | 'bluetooth_searching'
      | 'blur_circular'
      | 'blur_linear'
      | 'blur_off'
      | 'blur_on'
      | 'bolt'
      | 'book'
      | 'book_online'
      | 'bookmark'
      | 'bookmark_add'
      | 'bookmark_added'
      | 'bookmark_remove'
      | 'bookmarks'
      | 'bootstrapping'
      | 'border_all'
      | 'border_bottom'
      | 'border_clear'
      | 'border_color'
      | 'border_horizontal'
      | 'border_inner'
      | 'border_left'
      | 'border_outer'
      | 'border_right'
      | 'border_style'
      | 'border_top'
      | 'border_vertical'
      | 'branch'
      | 'branding_watermark'
      | 'breakfast_dining'
      | 'brightness_2'
      | 'brightness_3'
      | 'brightness_4'
      | 'brightness_auto'
      | 'brightness_high'
      | 'brightness_low'
      | 'brightness_medium'
      | 'broken_image'
      | 'browser_not_supported'
      | 'brunch_dining'
      | 'brush'
      | 'bubble_chart'
      | 'bug_report'
      | 'build'
      | 'build_circle'
      | 'bungalow'
      | 'burst_mode'
      | 'bus_alert'
      | 'business'
      | 'business_center'
      | 'cabin'
      | 'cable'
      | 'cached'
      | 'cake'
      | 'calculate'
      | 'calendar_today'
      | 'calendar_view_day'
      | 'calendar_view_month'
      | 'calendar_view_week'
      | 'call'
      | 'call_end'
      | 'call_made'
      | 'call_merge'
      | 'call_missed'
      | 'call_missed_outgoing'
      | 'call_received'
      | 'call_split'
      | 'call_to_action'
      | 'camera'
      | 'camera_alt'
      | 'camera_enhance'
      | 'camera_front'
      | 'camera_indoor'
      | 'camera_outdoor'
      | 'camera_rear'
      | 'camera_roll'
      | 'cameraswitch'
      | 'campaign'
      | 'cancel'
      | 'cancel_presentation'
      | 'cancel_schedule_send'
      | 'car_rental'
      | 'car_repair'
      | 'card_giftcard'
      | 'card_membership'
      | 'card_travel'
      | 'carpenter'
      | 'cases'
      | 'casino'
      | 'cast'
      | 'cast_connected'
      | 'cast_for_education'
      | 'catching_pokemon'
      | 'category'
      | 'celebration'
      | 'cell_wifi'
      | 'center_focus_strong'
      | 'center_focus_weak'
      | 'chair'
      | 'chair_alt'
      | 'chalet'
      | 'change_circle'
      | 'change_history'
      | 'charging_station'
      | 'chat'
      | 'chat_bubble'
      | 'check'
      | 'check_box'
      | 'check_box_blank'
      | 'check_circle'
      | 'check_circle_outline'
      | 'checklist'
      | 'checklist_rtl'
      | 'checkroom'
      | 'child_care'
      | 'child_friendly'
      | 'chrome_reader_mode'
      | 'circle_notifications'
      | 'clean_hands'
      | 'cleaning_services'
      | 'clear_all'
      | 'close'
      | 'close_fullscreen'
      | 'closed_caption'
      | 'closed_caption_disabled'
      | 'closed_caption_off'
      | 'cloud'
      | 'cloud_circle'
      | 'cloud_done'
      | 'cloud_download'
      | 'cloud_off'
      | 'cloud_queue'
      | 'cloud_upload'
      | 'code'
      | 'code_off'
      | 'coffee'
      | 'coffee_maker'
      | 'collections'
      | 'collections_bookmark'
      | 'color_lens'
      | 'colorize'
      | 'comment'
      | 'comment_bank'
      | 'commit'
      | 'commute'
      | 'compare'
      | 'compare_arrows'
      | 'compare_states'
      | 'compass_calibration'
      | 'compost'
      | 'compress'
      | 'computer'
      | 'configuration_file'
      | 'confirmation_number'
      | 'connect_without_contact'
      | 'connected_tv'
      | 'construction'
      | 'contact_mail'
      | 'contact_page'
      | 'contact_phone'
      | 'contact_support'
      | 'contactless'
      | 'contacts'
      | 'container'
      | 'content_copy'
      | 'content_cut'
      | 'content_paste'
      | 'content_paste_off'
      | 'control_camera'
      | 'control_point_duplicate'
      | 'copy_all'
      | 'copyright'
      | 'coronavirus'
      | 'corporate_fare'
      | 'cottage'
      | 'countertops'
      | 'create_new_folder'
      | 'credit_card'
      | 'credit_card_off'
      | 'credit_score'
      | 'crib'
      | 'critical_bug'
      | 'crop'
      | 'crop_3_2'
      | 'crop_5_4'
      | 'crop_7_5'
      | 'crop_16_9'
      | 'crop_din'
      | 'crop_free'
      | 'crop_landscape'
      | 'crop_original'
      | 'crop_portrait'
      | 'crop_rotate'
      | 'crop_square'
      | 'cruelty_free'
      | 'daemon'
      | 'daemon_set'
      | 'dangerous'
      | 'dark_mode'
      | 'dashboard'
      | 'dashboard_customize'
      | 'data_exploration'
      | 'data_saver_on'
      | 'data_scientist'
      | 'data_usage'
      | 'date_range'
      | 'deck'
      | 'dehaze'
      | 'delete'
      | 'delete_forever'
      | 'delete_outline'
      | 'delete_sweep'
      | 'delivery_dining'
      | 'departure_board'
      | 'description'
      | 'design_services'
      | 'desktop_access_disabled'
      | 'desktop_mac'
      | 'desktop_windows'
      | 'details'
      | 'developer_board'
      | 'developer_board_off'
      | 'developer_mode'
      | 'device_hub'
      | 'device_thermostat'
      | 'device_unknown'
      | 'devices'
      | 'devices_other'
      | 'dialer_sip'
      | 'dialpad'
      | 'diff_modified'
      | 'dining'
      | 'dinner_dining'
      | 'directions'
      | 'directions_bike'
      | 'directions_boat'
      | 'directions_bus'
      | 'directions_car'
      | 'directions_off'
      | 'directions_railway'
      | 'directions_run'
      | 'directions_subway'
      | 'directions_transit'
      | 'directions_walk'
      | 'dirty_lens'
      | 'disabled_by_default'
      | 'disabled_visible'
      | 'disc_full'
      | 'do_disturb_off'
      | 'do_not_disturb'
      | 'do_not_disturb_alt'
      | 'do_not_disturb_off'
      | 'do_not_disturb_on'
      | 'do_not_disturb_on_total_silence'
      | 'do_not_step'
      | 'do_not_touch'
      | 'dock'
      | 'document_scanner'
      | 'domain'
      | 'domain_disabled'
      | 'domain_verification'
      | 'done'
      | 'done_all'
      | 'donut_large'
      | 'donut_small'
      | 'door_back'
      | 'door_front'
      | 'door_sliding'
      | 'doorbell'
      | 'double_arrow'
      | 'downhill_skiing'
      | 'download'
      | 'download_done'
      | 'download_for_offline'
      | 'downloading'
      | 'drafts'
      | 'drag_handle'
      | 'drag_indicator'
      | 'draw'
      | 'drive_eta'
      | 'drive_file_move'
      | 'drive_file_move_rtl'
      | 'drive_file_rename'
      | 'drive_folder_upload'
      | 'dry'
      | 'dry_cleaning'
      | 'duo'
      | 'dvr'
      | 'dynamic_feed'
      | 'dynamic_form'
      | 'e_mobiledata'
      | 'earbuds'
      | 'earbuds_battery'
      | 'eco'
      | 'edgesensor_high'
      | 'edgesensor_low'
      | 'edit'
      | 'edit_attributes'
      | 'edit_calendar'
      | 'edit_location'
      | 'edit_location_alt'
      | 'edit_note'
      | 'edit_notifications'
      | 'edit_off'
      | 'edit_road'
      | 'eject'
      | 'elderly'
      | 'electric_bike'
      | 'electric_car'
      | 'electric_moped'
      | 'electric_rickshaw'
      | 'electric_scooter'
      | 'electrical_services'
      | 'elevator'
      | 'email'
      | 'emergency'
      | 'emoji_emotions'
      | 'emoji_events'
      | 'emoji_flags'
      | 'emoji_food_beverage'
      | 'emoji_nature'
      | 'emoji_objects'
      | 'emoji_people'
      | 'emoji_symbols'
      | 'emoji_transportation'
      | 'engineering'
      | 'enhanced_encryption'
      | 'equalizer'
      | 'error'
      | 'escalator'
      | 'escalator_warning'
      | 'euro'
      | 'euro_symbol'
      | 'ev_station'
      | 'event'
      | 'event_available'
      | 'event_busy'
      | 'event_note'
      | 'event_seat'
      | 'exit_to_app'
      | 'expand'
      | 'explicit'
      | 'explore'
      | 'explore_off'
      | 'exposure'
      | 'exposure_neg_1'
      | 'exposure_neg_2'
      | 'exposure_plus_1'
      | 'exposure_plus_2'
      | 'exposure_zero'
      | 'extension'
      | 'extension_off'
      | 'face'
      | 'face_retouching_natural'
      | 'face_retouching_off'
      | 'fact_check'
      | 'family_restroom'
      | 'fast_forward'
      | 'fast_rewind'
      | 'fastfood'
      | 'favorite'
      | 'featured_play_list'
      | 'featured_video'
      | 'feed'
      | 'feedback'
      | 'female'
      | 'fence'
      | 'festival'
      | 'fiber_dvr'
      | 'fiber_manual_record'
      | 'fiber_new'
      | 'fiber_pin'
      | 'fiber_smart_record'
      | 'file_copy'
      | 'file_download_done'
      | 'file_download_off'
      | 'file_present'
      | 'file_system'
      | 'filter'
      | 'filter_1'
      | 'filter_2'
      | 'filter_3'
      | 'filter_4'
      | 'filter_5'
      | 'filter_6'
      | 'filter_7'
      | 'filter_8'
      | 'filter_9'
      | 'filter_9_plus'
      | 'filter_alt'
      | 'filter_b_and_w'
      | 'filter_center_focus'
      | 'filter_drama'
      | 'filter_frames'
      | 'filter_hdr'
      | 'filter_list'
      | 'filter_none'
      | 'filter_tilt_shift'
      | 'filter_vintage'
      | 'find_in_page'
      | 'find_replace'
      | 'fingerprint'
      | 'fire_extinguisher'
      | 'fireplace'
      | 'first_page'
      | 'fit_screen'
      | 'fitness_center'
      | 'flag'
      | 'flaky'
      | 'flare'
      | 'flash_auto'
      | 'flash_off'
      | 'flash_on'
      | 'flashlight_off'
      | 'flashlight_on'
      | 'flatware'
      | 'flight_land'
      | 'flight_takeoff'
      | 'flip'
      | 'flip_camera_android'
      | 'flip_camera_ios'
      | 'flip_to_back'
      | 'flip_to_front'
      | 'flourescent'
      | 'flutter_dash'
      | 'fmd_bad'
      | 'fmd_good'
      | 'folder'
      | 'folder_open'
      | 'folder_shared'
      | 'folder_special'
      | 'follow_the_signs'
      | 'font_download'
      | 'font_download_off'
      | 'food_bank'
      | 'fork'
      | 'format_align_center'
      | 'format_align_justify'
      | 'format_align_left'
      | 'format_align_right'
      | 'format_bold'
      | 'format_clear'
      | 'format_color_fill'
      | 'format_color_reset'
      | 'format_color_text'
      | 'format_indent_decrease'
      | 'format_indent_increase'
      | 'format_italic'
      | 'format_line_spacing'
      | 'format_list_bulleted'
      | 'format_list_numbered'
      | 'format_list_numbered_rtl'
      | 'format_paint'
      | 'format_quote'
      | 'format_shapes'
      | 'format_size'
      | 'format_strikethrough'
      | 'format_textdirection_l_to_r'
      | 'format_textdirection_r_to_l'
      | 'format_underlined'
      | 'forum'
      | 'forward'
      | 'forward_5'
      | 'forward_10'
      | 'forward_30'
      | 'forward_to_inbox'
      | 'foundation'
      | 'free_breakfast'
      | 'free_cancellation'
      | 'front_hand'
      | 'fullscreen'
      | 'fullscreen_exit'
      | 'functions'
      | 'g_mobiledata'
      | 'g_translate'
      | 'gamepad'
      | 'games'
      | 'garage'
      | 'gavel'
      | 'generating_tokens'
      | 'gesture'
      | 'gif'
      | 'gite'
      | 'golf_course'
      | 'gpp_bad'
      | 'gpp_good'
      | 'gpp_maybe'
      | 'gps_fixed'
      | 'gps_not_fixed'
      | 'gps_off'
      | 'grade'
      | 'gradient'
      | 'grading'
      | 'grain'
      | 'graphic_eq'
      | 'grass'
      | 'grid_3x3'
      | 'grid_4x4'
      | 'grid_goldenratio'
      | 'grid_off'
      | 'grid_on'
      | 'grid_view'
      | 'group'
      | 'group_add'
      | 'group_off'
      | 'group_work'
      | 'groups'
      | 'h_mobiledata'
      | 'h_plus_mobiledata'
      | 'hail'
      | 'handyman'
      | 'hardware'
      | 'hd'
      | 'hdr_auto'
      | 'hdr_auto_select'
      | 'hdr_enhanced_select'
      | 'hdr_off'
      | 'hdr_off_select'
      | 'hdr_on'
      | 'hdr_on_select'
      | 'hdr_plus'
      | 'hdr_strong'
      | 'hdr_weak'
      | 'headphones_battery'
      | 'headset'
      | 'headset_mic'
      | 'headset_off'
      | 'healing'
      | 'health_and_safety'
      | 'hearing'
      | 'hearing_disabled'
      | 'height'
      | 'help'
      | 'help_center'
      | 'hevc'
      | 'hide_image'
      | 'hide_source'
      | 'high_quality'
      | 'highlight'
      | 'highlight_alt'
      | 'highlight_off'
      | 'hiking'
      | 'history'
      | 'history_edu'
      | 'history_toggle_off'
      | 'holiday_village'
      | 'home'
      | 'home_max'
      | 'home_mini'
      | 'home_repair_service'
      | 'home_work'
      | 'horizontal_distribute'
      | 'horizontal_rule'
      | 'horizontal_split'
      | 'hot_tub'
      | 'hotel'
      | 'hotel_class'
      | 'hourglass_bottom'
      | 'hourglass_disabled'
      | 'hourglass_empty'
      | 'hourglass_full'
      | 'hourglass_top'
      | 'house'
      | 'house_siding'
      | 'houseboat'
      | 'how_to_reg'
      | 'how_to_vote'
      | 'http'
      | 'https'
      | 'hvac'
      | 'ice_skating'
      | 'icecream'
      | 'image'
      | 'image_aspect_ratio'
      | 'image_not_supported'
      | 'image_search'
      | 'imagesearch_roller'
      | 'import_contacts'
      | 'import_export'
      | 'important_devices'
      | 'inbox'
      | 'incomplete_circle'
      | 'indeterminate_check_box'
      | 'info'
      | 'init_container'
      | 'input'
      | 'insert_chart'
      | 'insert_chart_outlined'
      | 'insert_comment'
      | 'insert_drive_file'
      | 'insert_emoticon'
      | 'insert_invitation'
      | 'insert_link'
      | 'insert_photo'
      | 'insights'
      | 'integration_instructions'
      | 'inventory'
      | 'invert_colors'
      | 'invert_colors_off'
      | 'ios_share'
      | 'ip'
      | 'iron'
      | 'iso'
      | 'kayaking'
      | 'keyboard'
      | 'keyboard_alt'
      | 'keyboard_arrow_down'
      | 'keyboard_arrow_left'
      | 'keyboard_arrow_right'
      | 'keyboard_arrow_up'
      | 'keyboard_backspace'
      | 'keyboard_capslock'
      | 'keyboard_hide'
      | 'keyboard_return'
      | 'keyboard_tab'
      | 'keyboard_voice'
      | 'king_bed'
      | 'kitchen'
      | 'kitesurfing'
      | 'kubelet'
      | 'label'
      | 'label_important'
      | 'label_off'
      | 'landscape'
      | 'language'
      | 'laptop_chromebook'
      | 'laptop_mac'
      | 'laptop_windows'
      | 'last_page'
      | 'launch'
      | 'layers'
      | 'layers_clear'
      | 'leaderboard'
      | 'leak_add'
      | 'leak_remove'
      | 'legend_toggle'
      | 'lens'
      | 'lens_blur'
      | 'library_add'
      | 'library_add_check'
      | 'library_books'
      | 'library_music'
      | 'light'
      | 'light_mode'
      | 'lightbulb'
      | 'line_style'
      | 'line_weight'
      | 'linear_scale'
      | 'link'
      | 'link_off'
      | 'linked_camera'
      | 'liquor'
      | 'list'
      | 'list_alt'
      | 'live_help'
      | 'live_tv'
      | 'living'
      | 'local_activity'
      | 'local_atm'
      | 'local_bar'
      | 'local_cafe'
      | 'local_car_wash'
      | 'local_convenience_store'
      | 'local_dining'
      | 'local_drink'
      | 'local_fire_department'
      | 'local_florist'
      | 'local_gas_station'
      | 'local_hospital'
      | 'local_laundry_service'
      | 'local_library'
      | 'local_mall'
      | 'local_parking'
      | 'local_pharmacy'
      | 'local_phone'
      | 'local_pizza'
      | 'local_play'
      | 'local_police'
      | 'local_post_office'
      | 'local_printshop'
      | 'local_see'
      | 'local_shipping'
      | 'local_taxi'
      | 'location_city'
      | 'location_off'
      | 'location_on'
      | 'lock'
      | 'lock_clock'
      | 'lock_open'
      | 'login'
      | 'logout'
      | 'looks'
      | 'looks_3'
      | 'looks_4'
      | 'looks_5'
      | 'looks_6'
      | 'looks_one'
      | 'looks_two'
      | 'loop'
      | 'loupe'
      | 'low_priority'
      | 'loyalty'
      | 'lte_mobiledata'
      | 'lte_plus_mobiledata'
      | 'luggage'
      | 'lunch_dining'
      | 'machine_learning'
      | 'male'
      | 'manage_accounts'
      | 'manage_search'
      | 'map'
      | 'maps_home_work'
      | 'maps_ugc'
      | 'margin'
      | 'mark_as_unread'
      | 'mark_chat_read'
      | 'mark_chat_unread'
      | 'mark_email_read'
      | 'mark_email_unread'
      | 'markunread_mailbox'
      | 'masks'
      | 'master'
      | 'maximize'
      | 'media_bluetooth_off'
      | 'media_bluetooth_on'
      | 'mediation'
      | 'medical_services'
      | 'medication'
      | 'meeting_room'
      | 'memory'
      | 'menu'
      | 'menu_book'
      | 'menu_open'
      | 'merge'
      | 'merge_type'
      | 'message'
      | 'mic'
      | 'mic_external_off'
      | 'mic_external_on'
      | 'mic_none'
      | 'mic_off'
      | 'microwave'
      | 'military_tech'
      | 'minimize'
      | 'miscellaneous'
      | 'miscellaneous_services'
      | 'missed_video_call'
      | 'mms'
      | 'mobile_friendly'
      | 'mobile_off'
      | 'mobile_screen_share'
      | 'mobiledata_off'
      | 'mode_comment'
      | 'mode_edit'
      | 'mode_night'
      | 'mode_standby'
      | 'model_training'
      | 'modified_date'
      | 'molecules'
      | 'monetization_on'
      | 'money'
      | 'money_off'
      | 'monitor'
      | 'monitor_weight'
      | 'monochrome_photos'
      | 'mood'
      | 'mood_bad'
      | 'moped'
      | 'more'
      | 'more_horiz'
      | 'more_time'
      | 'more_vert'
      | 'motion_photos_auto'
      | 'motion_photos_off'
      | 'motion_photos_on'
      | 'motion_photos_pause'
      | 'motion_photos_paused'
      | 'mouse'
      | 'move_to_inbox'
      | 'movie'
      | 'movie_filter'
      | 'moving'
      | 'mp'
      | 'multiline_chart'
      | 'multiple_stop'
      | 'museum'
      | 'music_note'
      | 'music_off'
      | 'music_video'
      | 'nat'
      | 'nature'
      | 'nature_people'
      | 'navigation'
      | 'near_me'
      | 'near_me_disabled'
      | 'nearby_error'
      | 'nearby_off'
      | 'network_cell'
      | 'network_check'
      | 'network_file_system'
      | 'network_locked'
      | 'network_policy'
      | 'network_wifi'
      | 'new_label'
      | 'new_releases'
      | 'next_plan'
      | 'next_week'
      | 'nfc'
      | 'night_shelter'
      | 'nightlife'
      | 'nightlight'
      | 'nightlight_round'
      | 'nights_stay'
      | 'no_accounts'
      | 'no_backpack'
      | 'no_cell'
      | 'no_drinks'
      | 'no_encryption'
      | 'no_encryption_gmailerrorred'
      | 'no_flash'
      | 'no_food'
      | 'no_luggage'
      | 'no_meals'
      | 'no_meeting_room'
      | 'no_photography'
      | 'no_sim'
      | 'no_stroller'
      | 'no_transfer'
      | 'node'
      | 'nordic_walking'
      | 'north'
      | 'north_east'
      | 'north_west'
      | 'not_accessible'
      | 'not_interested'
      | 'not_listed_location'
      | 'not_started'
      | 'note'
      | 'note_add'
      | 'note_alt'
      | 'notes'
      | 'notification_add'
      | 'notification_important'
      | 'notifications'
      | 'notifications_active'
      | 'notifications_none'
      | 'notifications_off'
      | 'notifications_paused'
      | 'offline_bolt'
      | 'offline_pin'
      | 'offline_share'
      | 'ondemand_video'
      | 'online_prediction'
      | 'opacity'
      | 'open_in_browser'
      | 'open_in_full'
      | 'open_in_new'
      | 'open_in_new_off'
      | 'open_with'
      | 'organisms'
      | 'organization'
      | 'other_houses'
      | 'outbox'
      | 'outdoor_grill'
      | 'outlet'
      | 'outlined_flag'
      | 'package'
      | 'package_upgrade'
      | 'packages'
      | 'padding'
      | 'pages'
      | 'pageview'
      | 'paid'
      | 'palette'
      | 'pan_tool'
      | 'panorama'
      | 'panorama_horizontal'
      | 'panorama_horizontal_select'
      | 'panorama_photosphere'
      | 'panorama_photosphere_select'
      | 'panorama_vertical'
      | 'panorama_vertical_select'
      | 'panorama_wide_angle'
      | 'panorama_wide_angle_select'
      | 'paragliding'
      | 'park'
      | 'party_mode'
      | 'password'
      | 'patch_fixes'
      | 'pattern'
      | 'patterns'
      | 'pause'
      | 'pause_circle'
      | 'pause_presentation'
      | 'payments'
      | 'pedal_bike'
      | 'pending'
      | 'pending_actions'
      | 'people_outline'
      | 'perm_camera_mic'
      | 'perm_contact_calendar'
      | 'perm_data_setting'
      | 'perm_device_information'
      | 'perm_media'
      | 'perm_phone_msg'
      | 'perm_scan_wifi'
      | 'person'
      | 'person_add'
      | 'person_add_alt'
      | 'person_add_disabled'
      | 'person_off'
      | 'person_outline'
      | 'person_pin'
      | 'person_pin_circle'
      | 'person_remove'
      | 'person_search'
      | 'pest_control'
      | 'pest_control_rodent'
      | 'pets'
      | 'phone'
      | 'phone_android'
      | 'phone_bluetooth_speaker'
      | 'phone_callback'
      | 'phone_disabled'
      | 'phone_enabled'
      | 'phone_forwarded'
      | 'phone_in_talk'
      | 'phone_iphone'
      | 'phone_locked'
      | 'phone_missed'
      | 'phone_paused'
      | 'phonelink'
      | 'phonelink_erase'
      | 'phonelink_lock'
      | 'phonelink_off'
      | 'phonelink_ring'
      | 'phonelink_setup'
      | 'photo'
      | 'photo_album'
      | 'photo_camera_back'
      | 'photo_camera_front'
      | 'photo_filter'
      | 'photo_library'
      | 'photo_size_select_actual'
      | 'photo_size_select_large'
      | 'photo_size_select_small'
      | 'piano'
      | 'piano_off'
      | 'picture_as_pdf'
      | 'picture_in_picture'
      | 'picture_in_picture_alt'
      | 'pie_chart'
      | 'pin'
      | 'pin_drop'
      | 'pin_end'
      | 'pin_invoke'
      | 'pin_number'
      | 'pipeline'
      | 'pivot_table_chart'
      | 'plagiarism'
      | 'play_arrow'
      | 'play_circle'
      | 'play_disabled'
      | 'play_for_work'
      | 'play_lesson'
      | 'playlist_add'
      | 'playlist_add_check'
      | 'playlist_play'
      | 'plumbing'
      | 'pod'
      | 'pod_autoscaler'
      | 'pod_security'
      | 'podcasts'
      | 'point_of_sale'
      | 'policy'
      | 'polymer'
      | 'pool'
      | 'portable_wifi_off'
      | 'portrait'
      | 'post_add'
      | 'power'
      | 'power_input'
      | 'power_off'
      | 'power_settings_new'
      | 'precision_manufacturing'
      | 'pregnant_woman'
      | 'present_to_all'
      | 'preview'
      | 'price_change'
      | 'price_check'
      | 'print'
      | 'print_disabled'
      | 'priority_high'
      | 'privacy_tip'
      | 'private_connectivity'
      | 'product_classes'
      | 'product_subscriptions'
      | 'production_quantity_limits'
      | 'products'
      | 'project'
      | 'proxy'
      | 'psychology'
      | 'public'
      | 'public_off'
      | 'publish'
      | 'published_with_changes'
      | 'pull_request'
      | 'push_pin'
      | 'qr_code'
      | 'qr_code_scanner'
      | 'query_stats'
      | 'question_answer'
      | 'queue_music'
      | 'queue_play_next'
      | 'quickreply'
      | 'quiz'
      | 'quota'
      | 'r_mobiledata'
      | 'radar'
      | 'radio'
      | 'radio_button_checked'
      | 'radio_button_unchecked'
      | 'railway_alert'
      | 'ramen_dining'
      | 'rate_review'
      | 'raw_off'
      | 'raw_on'
      | 'read_more'
      | 'receipt'
      | 'receipt_long'
      | 'recent_actors'
      | 'recommend'
      | 'record_voice_over'
      | 'recycling'
      | 'redo'
      | 'reduce_capacity'
      | 'refresh'
      | 'remember_me'
      | 'remove'
      | 'remove_circle'
      | 'remove_done'
      | 'remove_from_queue'
      | 'remove_moderator'
      | 'remove_red_eye'
      | 'remove_shopping_cart'
      | 'reorder'
      | 'repeat'
      | 'repeat_on'
      | 'repeat_one'
      | 'repeat_one_on'
      | 'replay'
      | 'replay_5'
      | 'replay_10'
      | 'replay_30'
      | 'replay_circle'
      | 'reply'
      | 'reply_all'
      | 'report'
      | 'report_gmailerrorred'
      | 'report_off'
      | 'request_quote'
      | 'reset_tv'
      | 'restart_alt'
      | 'restaurant'
      | 'restaurant_menu'
      | 'restore'
      | 'restore_from_trash'
      | 'restore_page'
      | 'reviews'
      | 'rice_bowl'
      | 'ring_volume'
      | 'role_binding'
      | 'roofing'
      | 'room_preferences'
      | 'room_service'
      | 'rotate_90_degrees_ccw'
      | 'rotate_left'
      | 'rotate_right'
      | 'rounded_corner'
      | 'router'
      | 'rowing'
      | 'rss_feed'
      | 'rsvp'
      | 'rtt'
      | 'rule'
      | 'rule_folder'
      | 'run_circle'
      | 'running_with_errors'
      | 'rv_hookup'
      | 'safety_divider'
      | 'sailing'
      | 'sandbox'
      | 'sanitizer'
      | 'satellite'
      | 'save'
      | 'save_alt'
      | 'saved_search'
      | 'savings'
      | 'scanner'
      | 'scatter_plot'
      | 'schedule'
      | 'schedule_send'
      | 'schema'
      | 'school'
      | 'science'
      | 'scientist'
      | 'score'
      | 'screen_lock_landscape'
      | 'screen_lock_portrait'
      | 'screen_lock_rotation'
      | 'screen_rotation'
      | 'screen_search_desktop'
      | 'screen_share'
      | 'screenshot'
      | 'sd'
      | 'sd_card'
      | 'sd_storage'
      | 'search'
      | 'search_off'
      | 'secret'
      | 'secure_data'
      | 'security'
      | 'security_update'
      | 'security_update_good'
      | 'security_update_warning'
      | 'segment'
      | 'select_all'
      | 'self_improvement'
      | 'sell'
      | 'send'
      | 'send_and_archive'
      | 'send_to_mobile'
      | 'sensor_door'
      | 'sensor_window'
      | 'sensors'
      | 'sensors_off'
      | 'sentiment_dissatisfied'
      | 'sentiment_neutral'
      | 'sentiment_satisfied'
      | 'sentiment_very_dissatisfied'
      | 'sentiment_very_satisfied'
      | 'service'
      | 'service_instance'
      | 'service_plan'
      | 'set_meal'
      | 'settings'
      | 'settings_accessibility'
      | 'settings_applications'
      | 'settings_backup_restore'
      | 'settings_bluetooth'
      | 'settings_brightness'
      | 'settings_cell'
      | 'settings_ethernet'
      | 'settings_input_antenna'
      | 'settings_input_component'
      | 'settings_input_hdmi'
      | 'settings_input_svideo'
      | 'settings_overscan'
      | 'settings_phone'
      | 'settings_power'
      | 'settings_remote'
      | 'settings_suggest'
      | 'settings_system_daydream'
      | 'settings_voice'
      | 'share'
      | 'share_location'
      | 'shield'
      | 'shop'
      | 'shop_two'
      | 'shopping_bag'
      | 'shopping_basket'
      | 'shopping_cart'
      | 'short_text'
      | 'shortcut'
      | 'show_chart'
      | 'shower'
      | 'shuffle'
      | 'shuffle_on'
      | 'shutter_speed'
      | 'sick'
      | 'signal_cellular_alt'
      | 'signal_cellular_no_sim'
      | 'signal_cellular_nodata'
      | 'signal_cellular_null'
      | 'signal_cellular_off'
      | 'signal_wifi_bad'
      | 'signal_wifi_off'
      | 'signal_wifi_statusbar_4_bar'
      | 'signal_wifi_statusbar_connected_no_internet_4'
      | 'signal_wifi_statusbar_null'
      | 'sim_card'
      | 'sim_card_alert'
      | 'sim_card_download'
      | 'single_bed'
      | 'sip'
      | 'skateboarding'
      | 'skip_next'
      | 'skip_previous'
      | 'sledding'
      | 'slideshow'
      | 'slow_motion_video'
      | 'smart_button'
      | 'smart_display'
      | 'smart_screen'
      | 'smart_toy'
      | 'smartphone'
      | 'smoke_free'
      | 'smoking_rooms'
      | 'sms'
      | 'sms_failed'
      | 'snippet_folder'
      | 'snooze'
      | 'snowboarding'
      | 'snowmobile'
      | 'snowshoeing'
      | 'soap'
      | 'social_distance'
      | 'software'
      | 'sort'
      | 'sort_by_alpha'
      | 'source'
      | 'south'
      | 'south_east'
      | 'south_west'
      | 'spa'
      | 'space_bar'
      | 'speaker'
      | 'speaker_group'
      | 'speaker_notes'
      | 'speaker_notes_off'
      | 'speaker_phone'
      | 'speed'
      | 'spellcheck'
      | 'splitscreen'
      | 'sports'
      | 'sports_bar'
      | 'sports_baseball'
      | 'sports_basketball'
      | 'sports_cricket'
      | 'sports_esports'
      | 'sports_football'
      | 'sports_golf'
      | 'sports_handball'
      | 'sports_hockey'
      | 'sports_kabaddi'
      | 'sports_mma'
      | 'sports_motorsports'
      | 'sports_rugby'
      | 'sports_score'
      | 'sports_soccer'
      | 'sports_tennis'
      | 'sports_volleyball'
      | 'square_foot'
      | 'stacked_bar_chart'
      | 'stacked_line_chart'
      | 'stairs'
      | 'star'
      | 'star_half'
      | 'star_purple500'
      | 'stars'
      | 'stateful_set'
      | 'stay_current_landscape'
      | 'stay_current_portrait'
      | 'sticky_note'
      | 'stop'
      | 'stop_circle'
      | 'stop_screen_share'
      | 'storage'
      | 'storage_class'
      | 'store'
      | 'storefront'
      | 'storm'
      | 'straighten'
      | 'stream'
      | 'streetview'
      | 'strikethrough_s'
      | 'stroller'
      | 'style'
      | 'subdirectory_arrow_left'
      | 'subdirectory_arrow_right'
      | 'subject'
      | 'subscript'
      | 'subscriptions'
      | 'subscriptions_created'
      | 'subtitles'
      | 'subtitles_off'
      | 'subway'
      | 'summarize'
      | 'superscript'
      | 'supervised_user_circle'
      | 'supervisor_account'
      | 'support'
      | 'support_agent'
      | 'surfing'
      | 'surround_sound'
      | 'swap_calls'
      | 'swap_horiz'
      | 'swap_horizontal_circle'
      | 'swap_vert'
      | 'swap_vertical_circle'
      | 'swipe'
      | 'switch_account'
      | 'switch_camera'
      | 'switch_left'
      | 'switch_right'
      | 'switch_video'
      | 'symlink'
      | 'sync'
      | 'sync_alt'
      | 'sync_disabled'
      | 'sync_problem'
      | 'system_image'
      | 'system_ok'
      | 'system_security_update'
      | 'system_security_update_warning'
      | 'system_update'
      | 'system_update_alt'
      | 'tab'
      | 'tab_unselected'
      | 'table_chart'
      | 'table_rows'
      | 'table_view'
      | 'tablet'
      | 'tablet_android'
      | 'tablet_mac'
      | 'tag'
      | 'tag_faces'
      | 'takeout_dining'
      | 'tap_and_play'
      | 'tapas'
      | 'task'
      | 'task_alt'
      | 'taxi_alert'
      | 'templates'
      | 'terminal'
      | 'terrain'
      | 'text_fields'
      | 'text_format'
      | 'text_rotate_up'
      | 'text_rotate_vertical'
      | 'text_rotation_angledown'
      | 'text_rotation_angleup'
      | 'text_rotation_down'
      | 'text_rotation_none'
      | 'text_snippet'
      | 'textsms'
      | 'texture'
      | 'theater_comedy'
      | 'theaters'
      | 'thermostat'
      | 'thermostat_auto'
      | 'thumb_down'
      | 'thumb_down_off_alt'
      | 'thumb_up'
      | 'thumb_up_off_alt'
      | 'thumbs_up_down'
      | 'time_to_leave'
      | 'timelapse'
      | 'timeline'
      | 'timer'
      | 'timer_3'
      | 'timer_3_select'
      | 'timer_10'
      | 'timer_10_select'
      | 'timer_off'
      | 'tips_and_updates'
      | 'title'
      | 'toc'
      | 'today'
      | 'toggle_off'
      | 'toggle_on'
      | 'toll'
      | 'tonality'
      | 'touch_app'
      | 'tour'
      | 'toys'
      | 'track_changes'
      | 'traffic'
      | 'train'
      | 'tram'
      | 'transfer_within_a_station'
      | 'transform'
      | 'transgender'
      | 'transit_enterexit'
      | 'translate'
      | 'travel_explore'
      | 'trending_down'
      | 'trending_flat'
      | 'trending_up'
      | 'trip_origin'
      | 'try'
      | 'tty'
      | 'tune'
      | 'tungsten'
      | 'tv'
      | 'tv_off'
      | 'two_wheeler'
      | 'umbrella'
      | 'unarchive'
      | 'undo'
      | 'unfold_less'
      | 'unfold_more'
      | 'unpublished'
      | 'unsubscribe'
      | 'upcoming'
      | 'update'
      | 'update_disabled'
      | 'upgrade'
      | 'upload'
      | 'upload_file'
      | 'usb'
      | 'usb_off'
      | 'verified'
      | 'verified_user'
      | 'vertical_align_bottom'
      | 'vertical_align_center'
      | 'vertical_align_top'
      | 'vertical_distribute'
      | 'vertical_split'
      | 'vibration'
      | 'video_call'
      | 'video_camera_back'
      | 'video_camera_front'
      | 'video_label'
      | 'video_library'
      | 'video_settings'
      | 'video_stable'
      | 'videocam'
      | 'videocam_off'
      | 'videogame_asset'
      | 'videogame_asset_off'
      | 'view_agenda'
      | 'view_array'
      | 'view_carousel'
      | 'view_column'
      | 'view_comfy'
      | 'view_compact'
      | 'view_day'
      | 'view_headline'
      | 'view_in_ar'
      | 'view_list'
      | 'view_module'
      | 'view_quilt'
      | 'view_sidebar'
      | 'view_stream'
      | 'view_week'
      | 'vignette'
      | 'villa'
      | 'virtual_reality'
      | 'visibility'
      | 'visibility_off'
      | 'voice_chat'
      | 'voice_over_off'
      | 'voicemail'
      | 'volume'
      | 'volume_binding'
      | 'volume_down'
      | 'volume_mute'
      | 'volume_off'
      | 'volume_up'
      | 'volunteer_activism'
      | 'vpn_key'
      | 'vpn_lock'
      | 'vrpano'
      | 'wallpaper'
      | 'warning'
      | 'wash'
      | 'watch'
      | 'water'
      | 'water_damage'
      | 'water_drop'
      | 'waterfall_chart'
      | 'waves'
      | 'waving_hand'
      | 'wb_auto'
      | 'wb_incandescent'
      | 'wb_iridescent'
      | 'wb_shade'
      | 'wb_sunny'
      | 'wb_twilight'
      | 'wc'
      | 'web'
      | 'web_asset'
      | 'web_asset_off'
      | 'weekend'
      | 'west'
      | 'whatshot'
      | 'wheelchair_pickup'
      | 'where_to_vote'
      | 'widgets'
      | 'wifi'
      | 'wifi_calling'
      | 'wifi_calling_3'
      | 'wifi_lock'
      | 'wifi_off'
      | 'wifi_protected_setup'
      | 'wifi_tethering'
      | 'wifi_tethering_error_rounded'
      | 'wifi_tethering_off'
      | 'window'
      | 'wine_bar'
      | 'work'
      | 'work_off'
      | 'workspaces'
      | 'wrap_text'
      | 'wrong_location'
      | 'wysiwyg'
      | 'yard'
      | 'youtube_searched_for'
      | 'zoom_in'
      | 'zoom_out'
      | 'zoom_out_map'
    solid:
      | '1k'
      | '1k_plus'
      | '1x_mobiledata'
      | '2k'
      | '2k_plus'
      | '2mp'
      | '3d_rotation'
      | '3g_mobiledata'
      | '3k'
      | '3k_plus'
      | '3mp'
      | '3p'
      | '4g_mobiledata'
      | '4g_plus_mobiledata'
      | '4k'
      | '4k_plus'
      | '4mp'
      | '5g'
      | '5k'
      | '5k_plus'
      | '5mp'
      | '6_ft_apart'
      | '6k'
      | '6k_plus'
      | '6mp'
      | '7k'
      | '7k_plus'
      | '7mp'
      | '8k'
      | '8k_plus'
      | '8mp'
      | '9k'
      | '9k_plus'
      | '9mp'
      | '10k'
      | '10mp'
      | '11mp'
      | '12mp'
      | '13mp'
      | '14mp'
      | '15mp'
      | '16mp'
      | '17mp'
      | '18mp'
      | '19mp'
      | '20mp'
      | '21mp'
      | '22mp'
      | '23mp'
      | '24mp'
      | '30fps'
      | '30fps_select'
      | '60fps'
      | '60fps_select'
      | '360'
      | 'abstract'
      | 'abstract_incomplete'
      | 'abstract_instance'
      | 'ac_unit'
      | 'access_alarm'
      | 'accessibility'
      | 'accessibility_new'
      | 'accessible'
      | 'accessible_forward'
      | 'account_balance'
      | 'account_balance_wallet'
      | 'account_box'
      | 'account_circle'
      | 'account_tree'
      | 'action_chains'
      | 'activate_subscriptions'
      | 'ad_units'
      | 'adb'
      | 'add'
      | 'add_a_photo'
      | 'add_alarm'
      | 'add_alert'
      | 'add_box'
      | 'add_business'
      | 'add_chart'
      | 'add_circle'
      | 'add_comment'
      | 'add_ic_call'
      | 'add_link'
      | 'add_location'
      | 'add_location_alt'
      | 'add_moderator'
      | 'add_photo_alternate'
      | 'add_reaction'
      | 'add_road'
      | 'add_shopping_cart'
      | 'add_task'
      | 'add_to_drive'
      | 'add_to_home_screen'
      | 'add_to_queue'
      | 'addchart'
      | 'adjust'
      | 'admin'
      | 'admin_panel_settings'
      | 'ads_click'
      | 'agriculture'
      | 'ai'
      | 'ai_healing'
      | 'ai_operator'
      | 'air'
      | 'airline_seat_flat'
      | 'airline_seat_flat_angled'
      | 'airline_seat_individual_suite'
      | 'airline_seat_legroom_extra'
      | 'airline_seat_legroom_normal'
      | 'airline_seat_legroom_reduced'
      | 'airline_seat_recline_extra'
      | 'airline_seat_recline_normal'
      | 'airplane_ticket'
      | 'airplanemode_inactive'
      | 'airplay'
      | 'airport_shuttle'
      | 'alarm'
      | 'alarm_off'
      | 'alarm_on'
      | 'album'
      | 'align_horizontal_center'
      | 'align_horizontal_left'
      | 'align_horizontal_right'
      | 'align_vertical_bottom'
      | 'align_vertical_center'
      | 'align_vertical_top'
      | 'all_inbox'
      | 'all_inclusive'
      | 'all_out'
      | 'alt_route'
      | 'alternate_email'
      | 'analytics'
      | 'anchor'
      | 'android'
      | 'animation'
      | 'announcement'
      | 'aod'
      | 'apartment'
      | 'api'
      | 'api_alt'
      | 'app_blocking'
      | 'app_registration'
      | 'app_settings_alt'
      | 'application'
      | 'application_incomplete'
      | 'application_instance'
      | 'application_window'
      | 'approval'
      | 'apps'
      | 'architecture'
      | 'archive'
      | 'area_chart'
      | 'arrow_back'
      | 'arrow_back_ios'
      | 'arrow_circle_down'
      | 'arrow_circle_up'
      | 'arrow_downward'
      | 'arrow_drop_down'
      | 'arrow_drop_down_circle'
      | 'arrow_drop_up'
      | 'arrow_forward'
      | 'arrow_forward_ios'
      | 'arrow_left'
      | 'arrow_right'
      | 'arrow_right_alt'
      | 'arrow_upward'
      | 'art_track'
      | 'article'
      | 'aspect_ratio'
      | 'assignment'
      | 'assignment_ind'
      | 'assignment_late'
      | 'assignment_return'
      | 'assignment_returned'
      | 'assignment_turned_in'
      | 'assistant'
      | 'assistant_direction'
      | 'assistant_photo'
      | 'atm'
      | 'attach_email'
      | 'attach_file'
      | 'attach_money'
      | 'attachment'
      | 'attractions'
      | 'attribution'
      | 'audiotrack'
      | 'auto_awesome'
      | 'auto_awesome_mosaic'
      | 'auto_awesome_motion'
      | 'auto_delete'
      | 'auto_fix_high'
      | 'auto_fix_normal'
      | 'auto_fix_off'
      | 'auto_graph'
      | 'auto_stories'
      | 'autofps_select'
      | 'autoinstallation'
      | 'autorenew'
      | 'av_timer'
      | 'baby_changing_station'
      | 'back_hand'
      | 'background_tasks'
      | 'backpack'
      | 'backspace'
      | 'backup_table'
      | 'badge'
      | 'bakery_dining'
      | 'balcony'
      | 'ballot'
      | 'bar_chart'
      | 'batch_prediction'
      | 'bathroom'
      | 'bathtub'
      | 'battery_alert'
      | 'battery_charging_full'
      | 'battery_full'
      | 'battery_saver'
      | 'battery_unknown'
      | 'beach_access'
      | 'bed'
      | 'bedroom_baby'
      | 'bedroom_child'
      | 'bedroom_parent'
      | 'bedtime'
      | 'beenhere'
      | 'bento'
      | 'bike_scooter'
      | 'biotech'
      | 'blender'
      | 'block'
      | 'bloodtype'
      | 'bluetooth'
      | 'bluetooth_connected'
      | 'bluetooth_disabled'
      | 'bluetooth_drive'
      | 'bluetooth_searching'
      | 'blur_circular'
      | 'blur_linear'
      | 'blur_off'
      | 'blur_on'
      | 'bolt'
      | 'book'
      | 'book_online'
      | 'bookmark'
      | 'bookmark_add'
      | 'bookmark_added'
      | 'bookmark_remove'
      | 'bookmarks'
      | 'bootstrapping'
      | 'border_all'
      | 'border_bottom'
      | 'border_clear'
      | 'border_color'
      | 'border_horizontal'
      | 'border_inner'
      | 'border_left'
      | 'border_outer'
      | 'border_right'
      | 'border_style'
      | 'border_top'
      | 'border_vertical'
      | 'branch'
      | 'branding_watermark'
      | 'breakfast_dining'
      | 'brightness_2'
      | 'brightness_3'
      | 'brightness_4'
      | 'brightness_auto'
      | 'brightness_high'
      | 'brightness_low'
      | 'brightness_medium'
      | 'broken_image'
      | 'browser_not_supported'
      | 'brunch_dining'
      | 'brush'
      | 'bubble_chart'
      | 'bug_report'
      | 'build'
      | 'build_circle'
      | 'bungalow'
      | 'burst_mode'
      | 'bus_alert'
      | 'business'
      | 'business_center'
      | 'cabin'
      | 'cable'
      | 'cached'
      | 'cake'
      | 'calculate'
      | 'calendar_today'
      | 'calendar_view_day'
      | 'calendar_view_month'
      | 'calendar_view_week'
      | 'call'
      | 'call_end'
      | 'call_made'
      | 'call_merge'
      | 'call_missed'
      | 'call_missed_outgoing'
      | 'call_received'
      | 'call_split'
      | 'call_to_action'
      | 'camera'
      | 'camera_alt'
      | 'camera_enhance'
      | 'camera_front'
      | 'camera_indoor'
      | 'camera_outdoor'
      | 'camera_rear'
      | 'camera_roll'
      | 'cameraswitch'
      | 'campaign'
      | 'cancel'
      | 'cancel_presentation'
      | 'cancel_schedule_send'
      | 'car_rental'
      | 'car_repair'
      | 'card_giftcard'
      | 'card_membership'
      | 'card_travel'
      | 'carpenter'
      | 'cases'
      | 'casino'
      | 'cast'
      | 'cast_connected'
      | 'cast_for_education'
      | 'catching_pokemon'
      | 'category'
      | 'celebration'
      | 'cell_wifi'
      | 'center_focus_strong'
      | 'center_focus_weak'
      | 'chair'
      | 'chair_alt'
      | 'chalet'
      | 'change_circle'
      | 'change_history'
      | 'charging_station'
      | 'chat'
      | 'chat_bubble'
      | 'check'
      | 'check_box'
      | 'check_box_blank'
      | 'check_circle'
      | 'checklist'
      | 'checklist_rtl'
      | 'checkroom'
      | 'child_care'
      | 'child_friendly'
      | 'chrome_reader_mode'
      | 'circle_notifications'
      | 'clean_hands'
      | 'cleaning_services'
      | 'cleanup'
      | 'clear_all'
      | 'close'
      | 'close_fullscreen'
      | 'closed_caption'
      | 'closed_caption_disabled'
      | 'closed_caption_off'
      | 'cloud'
      | 'cloud_circle'
      | 'cloud_controller_manager'
      | 'cloud_done'
      | 'cloud_download'
      | 'cloud_off'
      | 'cloud_upload'
      | 'cluster_role'
      | 'cluster_role_binding'
      | 'code'
      | 'code_off'
      | 'coffee'
      | 'coffee_maker'
      | 'collections'
      | 'collections_bookmark'
      | 'collocation'
      | 'color_lens'
      | 'colorize'
      | 'comment'
      | 'comment_bank'
      | 'commit'
      | 'commute'
      | 'compare'
      | 'compare_arrows'
      | 'compare_states'
      | 'compass_calibration'
      | 'compost'
      | 'compress'
      | 'computer'
      | 'config_map'
      | 'configuration_file'
      | 'confirmation_number'
      | 'connect_without_contact'
      | 'connected_tv'
      | 'constraint'
      | 'construction'
      | 'contact_mail'
      | 'contact_page'
      | 'contact_phone'
      | 'contact_support'
      | 'contactless'
      | 'contacts'
      | 'container'
      | 'content_copy'
      | 'content_cut'
      | 'content_deleted'
      | 'content_lifecycle_management'
      | 'content_modified'
      | 'content_new'
      | 'content_paste'
      | 'content_paste_off'
      | 'control_camera'
      | 'control_point_duplicate'
      | 'copy_all'
      | 'copyright'
      | 'coronavirus'
      | 'corporate_fare'
      | 'cottage'
      | 'countertops'
      | 'counting'
      | 'create_new_folder'
      | 'credit_card'
      | 'credit_card_off'
      | 'credit_score'
      | 'crib'
      | 'critical_bug'
      | 'cronjob'
      | 'crop'
      | 'crop_3_2'
      | 'crop_5_4'
      | 'crop_7_5'
      | 'crop_16_9'
      | 'crop_din'
      | 'crop_free'
      | 'crop_landscape'
      | 'crop_original'
      | 'crop_portrait'
      | 'crop_rotate'
      | 'crop_square'
      | 'cruelty_free'
      | 'csv_file'
      | 'daemon'
      | 'daemon_set'
      | 'dangerous'
      | 'dark_mode'
      | 'dashboard'
      | 'dashboard_customize'
      | 'data_exploration'
      | 'data_mining'
      | 'data_saver_on'
      | 'data_scientist'
      | 'data_usage'
      | 'date_range'
      | 'deck'
      | 'dehaze'
      | 'delete'
      | 'delete_forever'
      | 'delete_sweep'
      | 'delivery_dining'
      | 'departure_board'
      | 'deploy'
      | 'description'
      | 'design_services'
      | 'desktop_access_disabled'
      | 'desktop_mac'
      | 'desktop_windows'
      | 'details'
      | 'developer_board'
      | 'developer_board_off'
      | 'developer_mode'
      | 'device_hub'
      | 'device_thermostat'
      | 'device_unknown'
      | 'devices'
      | 'devices_other'
      | 'dialer_sip'
      | 'dialpad'
      | 'diff_modified'
      | 'dining'
      | 'dinner_dining'
      | 'directions'
      | 'directions_bike'
      | 'directions_boat'
      | 'directions_bus'
      | 'directions_car'
      | 'directions_off'
      | 'directions_railway'
      | 'directions_run'
      | 'directions_subway'
      | 'directions_walk'
      | 'dirty_lens'
      | 'disabled_by_default'
      | 'disabled_visible'
      | 'disc_full'
      | 'dns'
      | 'do_not_disturb'
      | 'do_not_disturb_alt'
      | 'do_not_disturb_off'
      | 'do_not_disturb_on'
      | 'do_not_disturb_on_total_silence'
      | 'do_not_step'
      | 'do_not_touch'
      | 'dock'
      | 'document_scanner'
      | 'domain'
      | 'domain_disabled'
      | 'domain_verification'
      | 'done'
      | 'done_all'
      | 'donut_large'
      | 'donut_small'
      | 'door_back'
      | 'door_front'
      | 'door_sliding'
      | 'doorbell'
      | 'double_arrow'
      | 'downhill_skiing'
      | 'download'
      | 'download_done'
      | 'download_for_offline'
      | 'downloading'
      | 'drafts'
      | 'drag_handle'
      | 'drag_indicator'
      | 'draw'
      | 'drive_eta'
      | 'drive_file_move'
      | 'drive_file_move_rtl'
      | 'drive_file_rename'
      | 'drive_folder_upload'
      | 'dry'
      | 'dry_cleaning'
      | 'duo'
      | 'dvr'
      | 'dynamic_feed'
      | 'dynamic_form'
      | 'e_mobiledata'
      | 'earbuds'
      | 'earbuds_battery'
      | 'eco'
      | 'edgesensor_high'
      | 'edgesensor_low'
      | 'edit'
      | 'edit_attributes'
      | 'edit_calendar'
      | 'edit_location'
      | 'edit_location_alt'
      | 'edit_note'
      | 'edit_notifications'
      | 'edit_off'
      | 'edit_road'
      | 'eject'
      | 'elderly'
      | 'electric_bike'
      | 'electric_car'
      | 'electric_moped'
      | 'electric_rickshaw'
      | 'electric_scooter'
      | 'electrical_services'
      | 'elevator'
      | 'email'
      | 'emergency'
      | 'emoji_emotions'
      | 'emoji_events'
      | 'emoji_flags'
      | 'emoji_food_beverage'
      | 'emoji_nature'
      | 'emoji_objects'
      | 'emoji_people'
      | 'emoji_symbols'
      | 'emoji_transportation'
      | 'endpoints'
      | 'endpoints_connected'
      | 'endpoints_disconnected'
      | 'engineering'
      | 'enhanced_encryption'
      | 'enhancement'
      | 'equalizer'
      | 'error'
      | 'escalator'
      | 'escalator_warning'
      | 'euro'
      | 'ev_station'
      | 'event'
      | 'event_available'
      | 'event_busy'
      | 'event_note'
      | 'event_seat'
      | 'exit_to_app'
      | 'expand'
      | 'explicit'
      | 'explore'
      | 'explore_off'
      | 'exposure'
      | 'exposure_neg_1'
      | 'exposure_neg_2'
      | 'exposure_plus_1'
      | 'exposure_plus_2'
      | 'exposure_zero'
      | 'extension'
      | 'extension_off'
      | 'face'
      | 'face_retouching_natural'
      | 'face_retouching_off'
      | 'fact_check'
      | 'family_restroom'
      | 'fast_forward'
      | 'fast_rewind'
      | 'fastfood'
      | 'favorite'
      | 'featured_play_list'
      | 'featured_video'
      | 'feed'
      | 'feedback'
      | 'female'
      | 'fence'
      | 'festival'
      | 'fiber_dvr'
      | 'fiber_manual_record'
      | 'fiber_new'
      | 'fiber_pin'
      | 'fiber_smart_record'
      | 'file_copy'
      | 'file_download_done'
      | 'file_download_off'
      | 'file_present'
      | 'file_system'
      | 'filter'
      | 'filter_1'
      | 'filter_2'
      | 'filter_3'
      | 'filter_4'
      | 'filter_5'
      | 'filter_6'
      | 'filter_7'
      | 'filter_8'
      | 'filter_9'
      | 'filter_9_plus'
      | 'filter_alt'
      | 'filter_b_and_w'
      | 'filter_center_focus'
      | 'filter_drama'
      | 'filter_frames'
      | 'filter_hdr'
      | 'filter_list'
      | 'filter_none'
      | 'filter_tilt_shift'
      | 'filter_vintage'
      | 'find_in_page'
      | 'find_replace'
      | 'fingerprint'
      | 'fire_extinguisher'
      | 'fireplace'
      | 'first_page'
      | 'fit_screen'
      | 'fitness_center'
      | 'flag'
      | 'flaky'
      | 'flare'
      | 'flash_auto'
      | 'flash_off'
      | 'flash_on'
      | 'flashlight_off'
      | 'flashlight_on'
      | 'flask'
      | 'flatware'
      | 'flight_land'
      | 'flight_takeoff'
      | 'flip'
      | 'flip_camera_android'
      | 'flip_camera_ios'
      | 'flip_to_back'
      | 'flip_to_front'
      | 'flourescent'
      | 'flutter_dash'
      | 'fmd_bad'
      | 'fmd_good'
      | 'folder'
      | 'folder_open'
      | 'folder_shared'
      | 'folder_special'
      | 'follow_the_signs'
      | 'font_download'
      | 'font_download_off'
      | 'food_bank'
      | 'fork'
      | 'format_align_center'
      | 'format_align_justify'
      | 'format_align_left'
      | 'format_align_right'
      | 'format_bold'
      | 'format_clear'
      | 'format_color_fill'
      | 'format_color_reset'
      | 'format_color_text'
      | 'format_indent_decrease'
      | 'format_indent_increase'
      | 'format_italic'
      | 'format_line_spacing'
      | 'format_list_bulleted'
      | 'format_list_numbered'
      | 'format_list_numbered_rtl'
      | 'format_paint'
      | 'format_quote'
      | 'format_shapes'
      | 'format_size'
      | 'format_strikethrough'
      | 'format_textdirection_l_to_r'
      | 'format_textdirection_r_to_l'
      | 'format_underlined'
      | 'forum'
      | 'forward'
      | 'forward_5'
      | 'forward_10'
      | 'forward_30'
      | 'forward_to_inbox'
      | 'foundation'
      | 'free_breakfast'
      | 'free_cancellation'
      | 'front_hand'
      | 'fullscreen'
      | 'fullscreen_exit'
      | 'functions'
      | 'g_mobiledata'
      | 'g_translate'
      | 'games'
      | 'garage'
      | 'gavel'
      | 'generating_tokens'
      | 'gesture'
      | 'gif'
      | 'gite'
      | 'golf_course'
      | 'gpp_bad'
      | 'gpp_good'
      | 'gpp_maybe'
      | 'gps_fixed'
      | 'gps_not_fixed'
      | 'gps_off'
      | 'grade'
      | 'gradient'
      | 'grading'
      | 'grain'
      | 'graphic_eq'
      | 'grass'
      | 'grid_3x3'
      | 'grid_4x4'
      | 'grid_goldenratio'
      | 'grid_off'
      | 'grid_on'
      | 'grid_view'
      | 'group'
      | 'group_add'
      | 'group_off'
      | 'group_work'
      | 'groups'
      | 'h_mobiledata'
      | 'h_plus_mobiledata'
      | 'hail'
      | 'handyman'
      | 'hardware'
      | 'hd'
      | 'hdr_auto'
      | 'hdr_auto_select'
      | 'hdr_enhanced_select'
      | 'hdr_off'
      | 'hdr_off_select'
      | 'hdr_on'
      | 'hdr_on_select'
      | 'hdr_plus'
      | 'hdr_strong'
      | 'hdr_weak'
      | 'headphones_battery'
      | 'headset'
      | 'headset_mic'
      | 'headset_off'
      | 'healing'
      | 'health_and_safety'
      | 'hearing'
      | 'hearing_disabled'
      | 'height'
      | 'help'
      | 'help_center'
      | 'hevc'
      | 'hide_image'
      | 'hide_source'
      | 'high_quality'
      | 'highlight'
      | 'highlight_alt'
      | 'highlight_off'
      | 'hiking'
      | 'history'
      | 'history_edu'
      | 'history_toggle_off'
      | 'holiday_village'
      | 'home'
      | 'home_max'
      | 'home_mini'
      | 'home_repair_service'
      | 'home_work'
      | 'horizontal_distribute'
      | 'horizontal_rule'
      | 'horizontal_split'
      | 'hot_tub'
      | 'hotel'
      | 'hotel_class'
      | 'hourglass_bottom'
      | 'hourglass_disabled'
      | 'hourglass_empty'
      | 'hourglass_full'
      | 'hourglass_top'
      | 'house'
      | 'house_siding'
      | 'houseboat'
      | 'how_to_reg'
      | 'how_to_vote'
      | 'http'
      | 'hvac'
      | 'ice_skating'
      | 'icecream'
      | 'image'
      | 'image_aspect_ratio'
      | 'image_not_supported'
      | 'image_search'
      | 'imagesearch_roller'
      | 'import_contacts'
      | 'import_export'
      | 'important_devices'
      | 'inbound'
      | 'inbox'
      | 'incomplete_circle'
      | 'indeterminate_check_box'
      | 'info'
      | 'ingress'
      | 'init_container'
      | 'input'
      | 'insert_chart'
      | 'insert_comment'
      | 'insert_drive_file'
      | 'insert_emoticon'
      | 'insert_invitation'
      | 'insert_link'
      | 'insert_photo'
      | 'insights'
      | 'integration_instructions'
      | 'inventory'
      | 'invert_colors'
      | 'invert_colors_off'
      | 'ios_share'
      | 'ip'
      | 'iron'
      | 'iso'
      | 'job'
      | 'kayaking'
      | 'keyboard'
      | 'keyboard_alt'
      | 'keyboard_arrow_down'
      | 'keyboard_arrow_left'
      | 'keyboard_arrow_right'
      | 'keyboard_arrow_up'
      | 'keyboard_backspace'
      | 'keyboard_capslock'
      | 'keyboard_hide'
      | 'keyboard_return'
      | 'keyboard_tab'
      | 'keyboard_voice'
      | 'king_bed'
      | 'kitchen'
      | 'kitesurfing'
      | 'kubelet'
      | 'label'
      | 'label_important'
      | 'label_off'
      | 'landscape'
      | 'language'
      | 'laptop_chromebook'
      | 'laptop_mac'
      | 'laptop_windows'
      | 'last_page'
      | 'launch'
      | 'layers'
      | 'layers_clear'
      | 'leaderboard'
      | 'leak_add'
      | 'leak_remove'
      | 'legend_toggle'
      | 'lens'
      | 'lens_blur'
      | 'library_add'
      | 'library_add_check'
      | 'library_books'
      | 'library_music'
      | 'light'
      | 'light_mode'
      | 'lightbulb'
      | 'line_style'
      | 'line_weight'
      | 'linear_scale'
      | 'link'
      | 'link_off'
      | 'linked_camera'
      | 'liquor'
      | 'list'
      | 'list_alt'
      | 'live_help'
      | 'live_tv'
      | 'living'
      | 'local_activity'
      | 'local_atm'
      | 'local_bar'
      | 'local_cafe'
      | 'local_car_wash'
      | 'local_convenience_store'
      | 'local_dining'
      | 'local_drink'
      | 'local_fire_department'
      | 'local_florist'
      | 'local_gas_station'
      | 'local_hospital'
      | 'local_laundry_service'
      | 'local_library'
      | 'local_mall'
      | 'local_parking'
      | 'local_pharmacy'
      | 'local_phone'
      | 'local_pizza'
      | 'local_play'
      | 'local_police'
      | 'local_post_office'
      | 'local_printshop'
      | 'local_see'
      | 'local_shipping'
      | 'local_taxi'
      | 'location_city'
      | 'location_off'
      | 'location_on'
      | 'lock'
      | 'lock_clock'
      | 'lock_open'
      | 'login'
      | 'logout'
      | 'looks'
      | 'looks_3'
      | 'looks_4'
      | 'looks_5'
      | 'looks_6'
      | 'looks_one'
      | 'looks_two'
      | 'loop'
      | 'loupe'
      | 'low_priority'
      | 'loyalty'
      | 'lte_mobiledata'
      | 'lte_plus_mobiledata'
      | 'luggage'
      | 'lunch_dining'
      | 'machine_learning'
      | 'male'
      | 'manage_accounts'
      | 'manage_search'
      | 'map'
      | 'maps_ugc'
      | 'margin'
      | 'mark_as_unread'
      | 'mark_chat_read'
      | 'mark_chat_unread'
      | 'mark_email_read'
      | 'mark_email_unread'
      | 'markunread_mailbox'
      | 'masks'
      | 'master'
      | 'maximize'
      | 'media_bluetooth_off'
      | 'media_bluetooth_on'
      | 'mediation'
      | 'medical_services'
      | 'medication'
      | 'meeting_room'
      | 'memory'
      | 'menu'
      | 'menu_book'
      | 'menu_open'
      | 'merge'
      | 'merge_type'
      | 'message'
      | 'mic'
      | 'mic_external_off'
      | 'mic_external_on'
      | 'mic_none'
      | 'mic_off'
      | 'microwave'
      | 'military_tech'
      | 'minimize'
      | 'miscellaneous'
      | 'miscellaneous_services'
      | 'missed_video_call'
      | 'mms'
      | 'mobile_friendly'
      | 'mobile_off'
      | 'mobile_screen_share'
      | 'mobiledata_off'
      | 'mode_comment'
      | 'mode_edit'
      | 'mode_night'
      | 'mode_standby'
      | 'model_training'
      | 'modified_date'
      | 'molecules'
      | 'monetization_on'
      | 'money'
      | 'money_off'
      | 'monitor'
      | 'monitor_weight'
      | 'monitoring'
      | 'monochrome_photos'
      | 'mood'
      | 'mood_bad'
      | 'moped'
      | 'more'
      | 'more_horiz'
      | 'more_time'
      | 'more_vert'
      | 'motion_photos_auto'
      | 'motion_photos_off'
      | 'motion_photos_on'
      | 'motion_photos_pause'
      | 'mouse'
      | 'move'
      | 'move_to_inbox'
      | 'movie'
      | 'movie_filter'
      | 'moving'
      | 'mp'
      | 'multiline_chart'
      | 'multiple_stop'
      | 'multistate'
      | 'museum'
      | 'music_note'
      | 'music_off'
      | 'music_video'
      | 'namespace'
      | 'nat'
      | 'nature'
      | 'nature_people'
      | 'navigation'
      | 'near_me'
      | 'near_me_disabled'
      | 'nearby_error'
      | 'nearby_off'
      | 'network'
      | 'network_cell'
      | 'network_check'
      | 'network_file_system'
      | 'network_locked'
      | 'network_policy'
      | 'network_wifi'
      | 'neural_network'
      | 'new_label'
      | 'new_releases'
      | 'next_plan'
      | 'next_week'
      | 'nfc'
      | 'night_shelter'
      | 'nightlife'
      | 'nightlight'
      | 'nightlight_round'
      | 'nights_stay'
      | 'no_accounts'
      | 'no_backpack'
      | 'no_cell'
      | 'no_drinks'
      | 'no_encryption'
      | 'no_flash'
      | 'no_food'
      | 'no_luggage'
      | 'no_meals'
      | 'no_meeting_room'
      | 'no_photography'
      | 'no_sim'
      | 'no_stroller'
      | 'no_transfer'
      | 'node'
      | 'nordic_walking'
      | 'north'
      | 'north_east'
      | 'north_west'
      | 'not_accessible'
      | 'not_interested'
      | 'not_listed_location'
      | 'not_started'
      | 'note'
      | 'note_add'
      | 'note_alt'
      | 'notes'
      | 'notification_add'
      | 'notification_important'
      | 'notifications'
      | 'notifications_active'
      | 'notifications_none'
      | 'notifications_off'
      | 'notifications_paused'
      | 'offline_bolt'
      | 'offline_pin'
      | 'offline_share'
      | 'ondemand_video'
      | 'online_prediction'
      | 'opacity'
      | 'open_in_browser'
      | 'open_in_full'
      | 'open_in_new'
      | 'open_in_new_off'
      | 'open_with'
      | 'organisms'
      | 'organization'
      | 'other_houses'
      | 'outbound'
      | 'outbox'
      | 'outdoor_grill'
      | 'outlet'
      | 'package'
      | 'package_upgrade'
      | 'packages'
      | 'padding'
      | 'pages'
      | 'pageview'
      | 'paid'
      | 'palette'
      | 'pan_tool'
      | 'panorama'
      | 'panorama_horizontal'
      | 'panorama_photosphere'
      | 'panorama_vertical'
      | 'panorama_wide_angle'
      | 'paragliding'
      | 'park'
      | 'party_mode'
      | 'password'
      | 'patch_fixes'
      | 'pattern'
      | 'patterns'
      | 'pause'
      | 'pause_circle'
      | 'pause_presentation'
      | 'payments'
      | 'pedal_bike'
      | 'pending'
      | 'pending_actions'
      | 'performance'
      | 'perm_camera_mic'
      | 'perm_contact_calendar'
      | 'perm_data_setting'
      | 'perm_device_information'
      | 'perm_media'
      | 'perm_phone_msg'
      | 'perm_scan_wifi'
      | 'persistent_volume'
      | 'person'
      | 'person_add'
      | 'person_add_alt'
      | 'person_add_disabled'
      | 'person_off'
      | 'person_pin'
      | 'person_pin_circle'
      | 'person_remove'
      | 'person_search'
      | 'pest_control'
      | 'pest_control_rodent'
      | 'pets'
      | 'phone'
      | 'phone_android'
      | 'phone_bluetooth_speaker'
      | 'phone_callback'
      | 'phone_disabled'
      | 'phone_enabled'
      | 'phone_forwarded'
      | 'phone_in_talk'
      | 'phone_iphone'
      | 'phone_locked'
      | 'phone_missed'
      | 'phone_paused'
      | 'phonelink'
      | 'phonelink_erase'
      | 'phonelink_lock'
      | 'phonelink_off'
      | 'phonelink_ring'
      | 'phonelink_setup'
      | 'photo'
      | 'photo_album'
      | 'photo_camera_back'
      | 'photo_camera_front'
      | 'photo_filter'
      | 'photo_library'
      | 'photo_size_select_actual'
      | 'photo_size_select_large'
      | 'photo_size_select_small'
      | 'piano'
      | 'piano_off'
      | 'picture_as_pdf'
      | 'picture_in_picture'
      | 'picture_in_picture_alt'
      | 'pie_chart'
      | 'pin'
      | 'pin_drop'
      | 'pin_end'
      | 'pin_invoke'
      | 'pin_number'
      | 'pipeline'
      | 'pivot_table_chart'
      | 'plagiarism'
      | 'play_arrow'
      | 'play_circle'
      | 'play_disabled'
      | 'play_for_work'
      | 'play_lesson'
      | 'playlist_add'
      | 'playlist_add_check'
      | 'playlist_play'
      | 'plumbing'
      | 'pod'
      | 'pod_autoscaler'
      | 'pod_security'
      | 'podcasts'
      | 'point_of_sale'
      | 'policy'
      | 'polymer'
      | 'pool'
      | 'portable_wifi_off'
      | 'portrait'
      | 'post_add'
      | 'power'
      | 'power_input'
      | 'power_off'
      | 'power_settings_new'
      | 'precision_manufacturing'
      | 'pregnant_woman'
      | 'present_to_all'
      | 'preview'
      | 'price_change'
      | 'price_check'
      | 'primitive'
      | 'print'
      | 'print_disabled'
      | 'priority_high'
      | 'privacy_tip'
      | 'private_connectivity'
      | 'product_classes'
      | 'product_subscriptions'
      | 'production_quantity_limits'
      | 'products'
      | 'project'
      | 'proxy'
      | 'psychology'
      | 'public'
      | 'public_off'
      | 'publish'
      | 'published_with_changes'
      | 'pull_request'
      | 'push_pin'
      | 'qr_code'
      | 'qr_code_scanner'
      | 'query_stats'
      | 'question_answer'
      | 'queue_music'
      | 'queue_play_next'
      | 'quickreply'
      | 'quiz'
      | 'quota'
      | 'r_mobiledata'
      | 'radar'
      | 'radio'
      | 'radio_button_checked'
      | 'radio_button_unchecked'
      | 'railway_alert'
      | 'ramen_dining'
      | 'rate_review'
      | 'raw_off'
      | 'raw_on'
      | 'read_more'
      | 'receipt'
      | 'receipt_long'
      | 'recent_actors'
      | 'recommend'
      | 'record_voice_over'
      | 'recycling'
      | 'redo'
      | 'reduce_capacity'
      | 'refresh'
      | 'remember_me'
      | 'remove'
      | 'remove_circle'
      | 'remove_done'
      | 'remove_from_queue'
      | 'remove_moderator'
      | 'remove_red_eye'
      | 'remove_shopping_cart'
      | 'reorder'
      | 'repeat'
      | 'repeat_on'
      | 'repeat_one'
      | 'repeat_one_on'
      | 'replay'
      | 'replay_5'
      | 'replay_10'
      | 'replay_30'
      | 'replay_circle'
      | 'replica'
      | 'replica_set'
      | 'reply'
      | 'reply_all'
      | 'report'
      | 'report_off'
      | 'repositories'
      | 'request_quote'
      | 'reset_tv'
      | 'restart_alt'
      | 'restaurant'
      | 'restaurant_menu'
      | 'restore'
      | 'restore_from_trash'
      | 'restore_page'
      | 'reviews'
      | 'rice_bowl'
      | 'ring_volume'
      | 'role_binding'
      | 'roofing'
      | 'room_preferences'
      | 'room_service'
      | 'rotate_90_degrees_ccw'
      | 'rotate_left'
      | 'rotate_right'
      | 'rounded_corner'
      | 'route'
      | 'router'
      | 'rowing'
      | 'rss_feed'
      | 'rsvp'
      | 'rtt'
      | 'rule'
      | 'rule_folder'
      | 'run_circle'
      | 'running_with_errors'
      | 'rv_hookup'
      | 'safety_divider'
      | 'sailing'
      | 'sandbox'
      | 'sanitizer'
      | 'satellite'
      | 'save'
      | 'save_alt'
      | 'saved_search'
      | 'savings'
      | 'scanner'
      | 'scatter_plot'
      | 'schedule'
      | 'schedule_send'
      | 'schema'
      | 'school'
      | 'science'
      | 'scientist'
      | 'score'
      | 'screen_lock_landscape'
      | 'screen_lock_portrait'
      | 'screen_lock_rotation'
      | 'screen_rotation'
      | 'screen_search_desktop'
      | 'screen_share'
      | 'screenshot'
      | 'sd'
      | 'sd_card'
      | 'search'
      | 'search_off'
      | 'secret'
      | 'secure_data'
      | 'security'
      | 'security_update'
      | 'security_update_good'
      | 'security_update_warning'
      | 'segment'
      | 'select_all'
      | 'self_healing'
      | 'self_improvement'
      | 'sell'
      | 'send'
      | 'send_and_archive'
      | 'send_to_mobile'
      | 'sensor_door'
      | 'sensor_window'
      | 'sensors'
      | 'sensors_off'
      | 'sentiment_dissatisfied'
      | 'sentiment_neutral'
      | 'sentiment_satisfied'
      | 'sentiment_very_dissatisfied'
      | 'sentiment_very_satisfied'
      | 'service'
      | 'service_instance'
      | 'service_plan'
      | 'set_meal'
      | 'settings'
      | 'settings_accessibility'
      | 'settings_applications'
      | 'settings_backup_restore'
      | 'settings_bluetooth'
      | 'settings_brightness'
      | 'settings_cell'
      | 'settings_ethernet'
      | 'settings_input_antenna'
      | 'settings_input_component'
      | 'settings_input_hdmi'
      | 'settings_input_svideo'
      | 'settings_overscan'
      | 'settings_phone'
      | 'settings_power'
      | 'settings_remote'
      | 'settings_suggest'
      | 'settings_system_daydream'
      | 'settings_voice'
      | 'share'
      | 'share_location'
      | 'shield'
      | 'shop'
      | 'shop_two'
      | 'shopping_bag'
      | 'shopping_basket'
      | 'shopping_cart'
      | 'short_text'
      | 'shortcut'
      | 'show_chart'
      | 'shower'
      | 'shuffle'
      | 'shuffle_on'
      | 'shutter_speed'
      | 'sick'
      | 'signal_cellular_alt'
      | 'signal_cellular_no_sim'
      | 'signal_cellular_nodata'
      | 'signal_cellular_null'
      | 'signal_cellular_off'
      | 'signal_wifi_bad'
      | 'signal_wifi_off'
      | 'signal_wifi_statusbar_4_bar'
      | 'signal_wifi_statusbar_connected_no_internet_4'
      | 'signal_wifi_statusbar_null'
      | 'sim_card'
      | 'sim_card_alert'
      | 'sim_card_download'
      | 'single_bed'
      | 'sip'
      | 'skateboarding'
      | 'skip_next'
      | 'skip_previous'
      | 'sledding'
      | 'slideshow'
      | 'slow_motion_video'
      | 'smart_button'
      | 'smart_display'
      | 'smart_screen'
      | 'smart_toy'
      | 'smartphone'
      | 'smoke_free'
      | 'smoking_rooms'
      | 'sms'
      | 'sms_failed'
      | 'snapshot_rollback'
      | 'snippet_folder'
      | 'snooze'
      | 'snowboarding'
      | 'snowmobile'
      | 'snowshoeing'
      | 'soap'
      | 'social_distance'
      | 'software'
      | 'sort'
      | 'sort_by_alpha'
      | 'source'
      | 'south'
      | 'south_east'
      | 'south_west'
      | 'spa'
      | 'space_bar'
      | 'speaker'
      | 'speaker_group'
      | 'speaker_notes'
      | 'speaker_notes_off'
      | 'speaker_phone'
      | 'speed'
      | 'spellcheck'
      | 'splitscreen'
      | 'sports'
      | 'sports_bar'
      | 'sports_baseball'
      | 'sports_basketball'
      | 'sports_cricket'
      | 'sports_esports'
      | 'sports_football'
      | 'sports_golf'
      | 'sports_handball'
      | 'sports_hockey'
      | 'sports_kabaddi'
      | 'sports_mma'
      | 'sports_motorsports'
      | 'sports_rugby'
      | 'sports_score'
      | 'sports_soccer'
      | 'sports_tennis'
      | 'sports_volleyball'
      | 'square_foot'
      | 'stacked_bar_chart'
      | 'stacked_line_chart'
      | 'stairs'
      | 'star'
      | 'star_half'
      | 'stars'
      | 'state'
      | 'stateful_set'
      | 'stay_current_landscape'
      | 'stay_current_portrait'
      | 'sticky_note'
      | 'stop'
      | 'stop_circle'
      | 'stop_screen_share'
      | 'storage'
      | 'storage_class'
      | 'store'
      | 'storefront'
      | 'storm'
      | 'straighten'
      | 'stream'
      | 'streetview'
      | 'strikethrough_s'
      | 'stroller'
      | 'style'
      | 'subdirectory_arrow_left'
      | 'subdirectory_arrow_right'
      | 'subject'
      | 'subscript'
      | 'subscription_management'
      | 'subscriptions'
      | 'subscriptions_created'
      | 'subtitles'
      | 'subtitles_off'
      | 'subway'
      | 'summarize'
      | 'superscript'
      | 'supervised_user_circle'
      | 'supervisor_account'
      | 'support'
      | 'support_agent'
      | 'surfing'
      | 'surround_sound'
      | 'swap_calls'
      | 'swap_horiz'
      | 'swap_horizontal_circle'
      | 'swap_vert'
      | 'swap_vertical_circle'
      | 'swipe'
      | 'switch_account'
      | 'switch_camera'
      | 'switch_left'
      | 'switch_right'
      | 'switch_video'
      | 'symlink'
      | 'sync'
      | 'sync_alt'
      | 'sync_disabled'
      | 'sync_problem'
      | 'system_group'
      | 'system_image'
      | 'system_ok'
      | 'system_re_registered'
      | 'system_security_update'
      | 'system_security_update_warning'
      | 'system_update'
      | 'system_update_alt'
      | 'system_warning'
      | 'tab'
      | 'tab_unselected'
      | 'table_chart'
      | 'table_rows'
      | 'table_view'
      | 'tablet'
      | 'tablet_android'
      | 'tablet_mac'
      | 'tag'
      | 'tag_faces'
      | 'takeout_dining'
      | 'tap_and_play'
      | 'tapas'
      | 'task'
      | 'task_alt'
      | 'taxi_alert'
      | 'templates'
      | 'terminal'
      | 'terrain'
      | 'test_tube'
      | 'text_fields'
      | 'text_format'
      | 'text_rotate_up'
      | 'text_rotate_vertical'
      | 'text_rotation_angledown'
      | 'text_rotation_angleup'
      | 'text_rotation_down'
      | 'text_rotation_none'
      | 'text_snippet'
      | 'textsms'
      | 'texture'
      | 'theater_comedy'
      | 'theaters'
      | 'thermostat'
      | 'thermostat_auto'
      | 'thumb_down'
      | 'thumb_up'
      | 'thumbs_up_down'
      | 'time_to_leave'
      | 'timelapse'
      | 'timeline'
      | 'timeout'
      | 'timer'
      | 'timer_3'
      | 'timer_3_select'
      | 'timer_10'
      | 'timer_10_select'
      | 'timer_off'
      | 'tips_and_updates'
      | 'title'
      | 'toc'
      | 'today'
      | 'toggle_off'
      | 'toggle_on'
      | 'toll'
      | 'tonality'
      | 'touch_app'
      | 'tour'
      | 'toys'
      | 'track_changes'
      | 'traffic'
      | 'train'
      | 'tram'
      | 'transfer_within_a_station'
      | 'transform'
      | 'transgender'
      | 'transit_enterexit'
      | 'translate'
      | 'travel_explore'
      | 'trending_down'
      | 'trending_flat'
      | 'trending_up'
      | 'trip_origin'
      | 'troubleshooting'
      | 'trusted_organization'
      | 'try'
      | 'tty'
      | 'tune'
      | 'tungsten'
      | 'tv'
      | 'tv_off'
      | 'two_wheeler'
      | 'umbrella'
      | 'unarchive'
      | 'undo'
      | 'unfold_less'
      | 'unfold_more'
      | 'unpublished'
      | 'unsubscribe'
      | 'upcoming'
      | 'update'
      | 'update_disabled'
      | 'upgrade'
      | 'upload'
      | 'upload_file'
      | 'usb'
      | 'usb_off'
      | 'verified'
      | 'verified_user'
      | 'vertical_align_bottom'
      | 'vertical_align_center'
      | 'vertical_align_top'
      | 'vertical_distribute'
      | 'vertical_split'
      | 'vibration'
      | 'video_call'
      | 'video_camera_back'
      | 'video_camera_front'
      | 'video_label'
      | 'video_library'
      | 'video_settings'
      | 'video_stable'
      | 'videocam'
      | 'videocam_off'
      | 'videogame_asset'
      | 'videogame_asset_off'
      | 'view_agenda'
      | 'view_array'
      | 'view_carousel'
      | 'view_column'
      | 'view_comfy'
      | 'view_compact'
      | 'view_day'
      | 'view_headline'
      | 'view_in_ar'
      | 'view_list'
      | 'view_module'
      | 'view_quilt'
      | 'view_sidebar'
      | 'view_stream'
      | 'view_week'
      | 'vignette'
      | 'villa'
      | 'virtual_guest'
      | 'virtual_host_manager'
      | 'virtual_reality'
      | 'virtual_space'
      | 'visibility'
      | 'visibility_off'
      | 'voice_chat'
      | 'voice_over_off'
      | 'voicemail'
      | 'volume'
      | 'volume_binding'
      | 'volume_down'
      | 'volume_mute'
      | 'volume_off'
      | 'volume_up'
      | 'volunteer_activism'
      | 'vpn_key'
      | 'vpn_lock'
      | 'vrpano'
      | 'wallpaper'
      | 'warning'
      | 'wash'
      | 'watch'
      | 'water'
      | 'water_damage'
      | 'water_drop'
      | 'waterfall_chart'
      | 'waves'
      | 'waving_hand'
      | 'wb_auto'
      | 'wb_incandescent'
      | 'wb_iridescent'
      | 'wb_shade'
      | 'wb_sunny'
      | 'wb_twilight'
      | 'wc'
      | 'web'
      | 'web_asset'
      | 'web_asset_off'
      | 'weekend'
      | 'west'
      | 'whatshot'
      | 'wheelchair_pickup'
      | 'where_to_vote'
      | 'widgets'
      | 'wifi'
      | 'wifi_calling'
      | 'wifi_calling_3'
      | 'wifi_lock'
      | 'wifi_off'
      | 'wifi_protected_setup'
      | 'wifi_tethering'
      | 'wifi_tethering_error_rounded'
      | 'wifi_tethering_off'
      | 'window'
      | 'wine_bar'
      | 'work'
      | 'work_off'
      | 'workload'
      | 'workspaces'
      | 'wrap_text'
      | 'wrong_location'
      | 'wysiwyg'
      | 'yard'
      | 'youtube_searched_for'
      | 'zoom_in'
      | 'zoom_out'
      | 'zoom_out_map'
  }
  feather:
    | 'activity'
    | 'airplay'
    | 'alert-circle'
    | 'alert-octagon'
    | 'alert-triangle'
    | 'align-center'
    | 'align-justify'
    | 'align-left'
    | 'align-right'
    | 'anchor'
    | 'aperture'
    | 'archive'
    | 'arrow-down'
    | 'arrow-down-circle'
    | 'arrow-down-left'
    | 'arrow-down-right'
    | 'arrow-left'
    | 'arrow-left-circle'
    | 'arrow-right'
    | 'arrow-right-circle'
    | 'arrow-up'
    | 'arrow-up-circle'
    | 'arrow-up-left'
    | 'arrow-up-right'
    | 'at-sign'
    | 'award'
    | 'bar-chart'
    | 'bar-chart-2'
    | 'battery'
    | 'battery-charging'
    | 'bell'
    | 'bell-off'
    | 'bluetooth'
    | 'bold'
    | 'book'
    | 'book-open'
    | 'bookmark'
    | 'box'
    | 'briefcase'
    | 'calendar'
    | 'camera'
    | 'camera-off'
    | 'cast'
    | 'check'
    | 'check-circle'
    | 'check-square'
    | 'chevron-down'
    | 'chevron-left'
    | 'chevron-right'
    | 'chevron-up'
    | 'chevrons-down'
    | 'chevrons-left'
    | 'chevrons-right'
    | 'chevrons-up'
    | 'chrome'
    | 'circle'
    | 'clipboard'
    | 'clock'
    | 'cloud'
    | 'cloud-drizzle'
    | 'cloud-lightning'
    | 'cloud-off'
    | 'cloud-rain'
    | 'cloud-snow'
    | 'code'
    | 'codepen'
    | 'codesandbox'
    | 'coffee'
    | 'columns'
    | 'command'
    | 'compass'
    | 'copy'
    | 'corner-down-left'
    | 'corner-down-right'
    | 'corner-left-down'
    | 'corner-left-up'
    | 'corner-right-down'
    | 'corner-right-up'
    | 'corner-up-left'
    | 'corner-up-right'
    | 'cpu'
    | 'credit-card'
    | 'crop'
    | 'crosshair'
    | 'database'
    | 'delete'
    | 'disc'
    | 'divide'
    | 'divide-circle'
    | 'divide-square'
    | 'dollar-sign'
    | 'download'
    | 'download-cloud'
    | 'dribbble'
    | 'droplet'
    | 'edit'
    | 'edit-2'
    | 'edit-3'
    | 'external-link'
    | 'eye'
    | 'eye-off'
    | 'facebook'
    | 'fast-forward'
    | 'feather'
    | 'figma'
    | 'file'
    | 'file-minus'
    | 'file-plus'
    | 'file-text'
    | 'film'
    | 'filter'
    | 'flag'
    | 'folder'
    | 'folder-minus'
    | 'folder-plus'
    | 'framer'
    | 'frown'
    | 'gift'
    | 'git-branch'
    | 'git-commit'
    | 'git-merge'
    | 'git-pull-request'
    | 'github'
    | 'gitlab'
    | 'globe'
    | 'grid'
    | 'hard-drive'
    | 'hash'
    | 'headphones'
    | 'heart'
    | 'help-circle'
    | 'hexagon'
    | 'home'
    | 'image'
    | 'inbox'
    | 'info'
    | 'instagram'
    | 'italic'
    | 'key'
    | 'layers'
    | 'layout'
    | 'life-buoy'
    | 'link'
    | 'link-2'
    | 'linkedin'
    | 'list'
    | 'loader'
    | 'lock'
    | 'log-in'
    | 'log-out'
    | 'mail'
    | 'map'
    | 'map-pin'
    | 'maximize'
    | 'maximize-2'
    | 'meh'
    | 'menu'
    | 'message-circle'
    | 'message-square'
    | 'mic'
    | 'mic-off'
    | 'minimize'
    | 'minimize-2'
    | 'minus'
    | 'minus-circle'
    | 'minus-square'
    | 'monitor'
    | 'moon'
    | 'more-horizontal'
    | 'more-vertical'
    | 'mouse-pointer'
    | 'move'
    | 'music'
    | 'navigation'
    | 'navigation-2'
    | 'octagon'
    | 'package'
    | 'paperclip'
    | 'pause'
    | 'pause-circle'
    | 'pen-tool'
    | 'percent'
    | 'phone'
    | 'phone-call'
    | 'phone-forwarded'
    | 'phone-incoming'
    | 'phone-missed'
    | 'phone-off'
    | 'phone-outgoing'
    | 'pie-chart'
    | 'play'
    | 'play-circle'
    | 'plus'
    | 'plus-circle'
    | 'plus-square'
    | 'pocket'
    | 'power'
    | 'printer'
    | 'radio'
    | 'refresh-ccw'
    | 'refresh-cw'
    | 'repeat'
    | 'rewind'
    | 'rotate-ccw'
    | 'rotate-cw'
    | 'rss'
    | 'save'
    | 'scissors'
    | 'search'
    | 'send'
    | 'server'
    | 'settings'
    | 'share'
    | 'share-2'
    | 'shield'
    | 'shield-off'
    | 'shopping-bag'
    | 'shopping-cart'
    | 'shuffle'
    | 'sidebar'
    | 'skip-back'
    | 'skip-forward'
    | 'slack'
    | 'slash'
    | 'sliders'
    | 'smartphone'
    | 'smile'
    | 'speaker'
    | 'square'
    | 'star'
    | 'stop-circle'
    | 'sun'
    | 'sunrise'
    | 'sunset'
    | 'tablet'
    | 'tag'
    | 'target'
    | 'terminal'
    | 'thermometer'
    | 'thumbs-down'
    | 'thumbs-up'
    | 'toggle-left'
    | 'toggle-right'
    | 'tool'
    | 'trash'
    | 'trash-2'
    | 'trello'
    | 'trending-down'
    | 'trending-up'
    | 'triangle'
    | 'truck'
    | 'tv'
    | 'twitch'
    | 'twitter'
    | 'type'
    | 'umbrella'
    | 'underline'
    | 'unlock'
    | 'upload'
    | 'upload-cloud'
    | 'user'
    | 'user-check'
    | 'user-minus'
    | 'user-plus'
    | 'user-x'
    | 'users'
    | 'video'
    | 'video-off'
    | 'voicemail'
    | 'volume'
    | 'volume-1'
    | 'volume-2'
    | 'volume-x'
    | 'watch'
    | 'wifi'
    | 'wifi-off'
    | 'wind'
    | 'x'
    | 'x-circle'
    | 'x-octagon'
    | 'x-square'
    | 'youtube'
    | 'zap'
    | 'zap-off'
    | 'zoom-in'
    | 'zoom-out'
  flags:
    | 'ad'
    | 'ae'
    | 'af'
    | 'ag'
    | 'ai'
    | 'al'
    | 'am'
    | 'ao'
    | 'aq'
    | 'ar'
    | 'as'
    | 'at'
    | 'au'
    | 'aw'
    | 'ax'
    | 'az'
    | 'ba'
    | 'bb'
    | 'bd'
    | 'be'
    | 'bf'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bj'
    | 'bl'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'bq'
    | 'br'
    | 'bs'
    | 'bt'
    | 'bv'
    | 'bw'
    | 'by'
    | 'bz'
    | 'ca'
    | 'cc'
    | 'cd'
    | 'cf'
    | 'cg'
    | 'ch'
    | 'ci'
    | 'ck'
    | 'cl'
    | 'cm'
    | 'cn'
    | 'co'
    | 'cr'
    | 'cu'
    | 'cv'
    | 'cw'
    | 'cx'
    | 'cy'
    | 'cz'
    | 'de'
    | 'dj'
    | 'dk'
    | 'dm'
    | 'do'
    | 'dz'
    | 'ec'
    | 'ee'
    | 'eg'
    | 'eh'
    | 'er'
    | 'es'
    | 'et'
    | 'eu'
    | 'fi'
    | 'fj'
    | 'fk'
    | 'fm'
    | 'fo'
    | 'fr'
    | 'ga'
    | 'gb'
    | 'gb-eng'
    | 'gb-nir'
    | 'gb-sct'
    | 'gb-wls'
    | 'gd'
    | 'ge'
    | 'gf'
    | 'gg'
    | 'gh'
    | 'gi'
    | 'gl'
    | 'gm'
    | 'gn'
    | 'gp'
    | 'gq'
    | 'gr'
    | 'gs'
    | 'gt'
    | 'gu'
    | 'gw'
    | 'gy'
    | 'hk'
    | 'hm'
    | 'hn'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'id'
    | 'ie'
    | 'il'
    | 'im'
    | 'in'
    | 'io'
    | 'iq'
    | 'ir'
    | 'is'
    | 'it'
    | 'je'
    | 'jm'
    | 'jo'
    | 'jp'
    | 'ke'
    | 'kg'
    | 'kh'
    | 'ki'
    | 'km'
    | 'kn'
    | 'kp'
    | 'kr'
    | 'kw'
    | 'ky'
    | 'kz'
    | 'la'
    | 'lb'
    | 'lc'
    | 'li'
    | 'lk'
    | 'lr'
    | 'ls'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'ly'
    | 'ma'
    | 'mc'
    | 'md'
    | 'me'
    | 'mf'
    | 'mg'
    | 'mh'
    | 'mk'
    | 'ml'
    | 'mm'
    | 'mn'
    | 'mo'
    | 'mp'
    | 'mq'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'mu'
    | 'mv'
    | 'mw'
    | 'mx'
    | 'my'
    | 'mz'
    | 'na'
    | 'nc'
    | 'ne'
    | 'nf'
    | 'ng'
    | 'ni'
    | 'nl'
    | 'no'
    | 'np'
    | 'nr'
    | 'nu'
    | 'nz'
    | 'om'
    | 'pa'
    | 'pe'
    | 'pf'
    | 'pg'
    | 'ph'
    | 'pk'
    | 'pl'
    | 'pm'
    | 'pn'
    | 'pr'
    | 'ps'
    | 'pt'
    | 'pw'
    | 'py'
    | 'qa'
    | 're'
    | 'ro'
    | 'rs'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sb'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'sh'
    | 'si'
    | 'sj'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sr'
    | 'ss'
    | 'st'
    | 'sv'
    | 'sx'
    | 'sy'
    | 'sz'
    | 'tc'
    | 'td'
    | 'tf'
    | 'tg'
    | 'th'
    | 'tj'
    | 'tk'
    | 'tl'
    | 'tm'
    | 'tn'
    | 'to'
    | 'tr'
    | 'tt'
    | 'tv'
    | 'tw'
    | 'tz'
    | 'ua'
    | 'ug'
    | 'um'
    | 'un'
    | 'us'
    | 'uy'
    | 'uz'
    | 'va'
    | 'vc'
    | 've'
    | 'vg'
    | 'vi'
    | 'vn'
    | 'vu'
    | 'wf'
    | 'ws'
    | 'ye'
    | 'yt'
    | 'za'
    | 'zm'
    | 'zw'
  fontawesome: {
    solid:
      | 'ad'
      | 'address-book'
      | 'address-card'
      | 'adjust'
      | 'air-freshener'
      | 'align-center'
      | 'align-justify'
      | 'align-left'
      | 'align-right'
      | 'allergies'
      | 'ambulance'
      | 'american-sign-language-interpreting'
      | 'anchor'
      | 'angle-double-down'
      | 'angle-double-left'
      | 'angle-double-right'
      | 'angle-double-up'
      | 'angle-down'
      | 'angle-left'
      | 'angle-right'
      | 'angle-up'
      | 'angry'
      | 'ankh'
      | 'apple-alt'
      | 'archive'
      | 'archway'
      | 'arrow-alt-circle-down'
      | 'arrow-alt-circle-left'
      | 'arrow-alt-circle-right'
      | 'arrow-alt-circle-up'
      | 'arrow-circle-down'
      | 'arrow-circle-left'
      | 'arrow-circle-right'
      | 'arrow-circle-up'
      | 'arrow-down'
      | 'arrow-left'
      | 'arrow-right'
      | 'arrow-up'
      | 'arrows-alt'
      | 'arrows-alt-h'
      | 'arrows-alt-v'
      | 'assistive-listening-systems'
      | 'asterisk'
      | 'at'
      | 'atlas'
      | 'atom'
      | 'audio-description'
      | 'award'
      | 'baby'
      | 'baby-carriage'
      | 'backspace'
      | 'backward'
      | 'bacon'
      | 'bacteria'
      | 'bacterium'
      | 'bahai'
      | 'balance-scale'
      | 'balance-scale-left'
      | 'balance-scale-right'
      | 'ban'
      | 'band-aid'
      | 'barcode'
      | 'bars'
      | 'baseball-ball'
      | 'basketball-ball'
      | 'bath'
      | 'battery-empty'
      | 'battery-full'
      | 'battery-half'
      | 'battery-quarter'
      | 'battery-three-quarters'
      | 'bed'
      | 'beer'
      | 'bell'
      | 'bell-slash'
      | 'bezier-curve'
      | 'bible'
      | 'bicycle'
      | 'biking'
      | 'binoculars'
      | 'biohazard'
      | 'birthday-cake'
      | 'blender'
      | 'blender-phone'
      | 'blind'
      | 'blog'
      | 'bold'
      | 'bolt'
      | 'bomb'
      | 'bone'
      | 'bong'
      | 'book'
      | 'book-dead'
      | 'book-medical'
      | 'book-open'
      | 'book-reader'
      | 'bookmark'
      | 'border-all'
      | 'border-none'
      | 'border-style'
      | 'bowling-ball'
      | 'box'
      | 'box-open'
      | 'box-tissue'
      | 'boxes'
      | 'braille'
      | 'brain'
      | 'bread-slice'
      | 'briefcase'
      | 'briefcase-medical'
      | 'broadcast-tower'
      | 'broom'
      | 'brush'
      | 'bug'
      | 'building'
      | 'bullhorn'
      | 'bullseye'
      | 'burn'
      | 'bus'
      | 'bus-alt'
      | 'business-time'
      | 'calculator'
      | 'calendar'
      | 'calendar-alt'
      | 'calendar-check'
      | 'calendar-day'
      | 'calendar-minus'
      | 'calendar-plus'
      | 'calendar-times'
      | 'calendar-week'
      | 'camera'
      | 'camera-retro'
      | 'campground'
      | 'candy-cane'
      | 'cannabis'
      | 'capsules'
      | 'car'
      | 'car-alt'
      | 'car-battery'
      | 'car-crash'
      | 'car-side'
      | 'caravan'
      | 'caret-down'
      | 'caret-left'
      | 'caret-right'
      | 'caret-square-down'
      | 'caret-square-left'
      | 'caret-square-right'
      | 'caret-square-up'
      | 'caret-up'
      | 'carrot'
      | 'cart-arrow-down'
      | 'cart-plus'
      | 'cash-register'
      | 'cat'
      | 'certificate'
      | 'chair'
      | 'chalkboard'
      | 'chalkboard-teacher'
      | 'charging-station'
      | 'chart-area'
      | 'chart-bar'
      | 'chart-line'
      | 'chart-pie'
      | 'check'
      | 'check-circle'
      | 'check-double'
      | 'check-square'
      | 'cheese'
      | 'chess'
      | 'chess-bishop'
      | 'chess-board'
      | 'chess-king'
      | 'chess-knight'
      | 'chess-pawn'
      | 'chess-queen'
      | 'chess-rook'
      | 'chevron-circle-down'
      | 'chevron-circle-left'
      | 'chevron-circle-right'
      | 'chevron-circle-up'
      | 'chevron-down'
      | 'chevron-left'
      | 'chevron-right'
      | 'chevron-up'
      | 'child'
      | 'church'
      | 'circle'
      | 'circle-notch'
      | 'city'
      | 'clinic-medical'
      | 'clipboard'
      | 'clipboard-check'
      | 'clipboard-list'
      | 'clock'
      | 'clone'
      | 'closed-captioning'
      | 'cloud'
      | 'cloud-download-alt'
      | 'cloud-meatball'
      | 'cloud-moon'
      | 'cloud-moon-rain'
      | 'cloud-rain'
      | 'cloud-showers-heavy'
      | 'cloud-sun'
      | 'cloud-sun-rain'
      | 'cloud-upload-alt'
      | 'cocktail'
      | 'code'
      | 'code-branch'
      | 'coffee'
      | 'cog'
      | 'cogs'
      | 'coins'
      | 'columns'
      | 'comment'
      | 'comment-alt'
      | 'comment-dollar'
      | 'comment-dots'
      | 'comment-medical'
      | 'comment-slash'
      | 'comments'
      | 'comments-dollar'
      | 'compact-disc'
      | 'compass'
      | 'compress'
      | 'compress-alt'
      | 'compress-arrows-alt'
      | 'concierge-bell'
      | 'cookie'
      | 'cookie-bite'
      | 'copy'
      | 'copyright'
      | 'couch'
      | 'credit-card'
      | 'crop'
      | 'crop-alt'
      | 'cross'
      | 'crosshairs'
      | 'crow'
      | 'crown'
      | 'crutch'
      | 'cube'
      | 'cubes'
      | 'cut'
      | 'database'
      | 'deaf'
      | 'democrat'
      | 'desktop'
      | 'dharmachakra'
      | 'diagnoses'
      | 'dice'
      | 'dice-d6'
      | 'dice-d20'
      | 'dice-five'
      | 'dice-four'
      | 'dice-one'
      | 'dice-six'
      | 'dice-three'
      | 'dice-two'
      | 'digital-tachograph'
      | 'directions'
      | 'disease'
      | 'divide'
      | 'dizzy'
      | 'dna'
      | 'dog'
      | 'dollar-sign'
      | 'dolly'
      | 'dolly-flatbed'
      | 'donate'
      | 'door-closed'
      | 'door-open'
      | 'dot-circle'
      | 'dove'
      | 'download'
      | 'drafting-compass'
      | 'dragon'
      | 'draw-polygon'
      | 'drum'
      | 'drum-steelpan'
      | 'drumstick-bite'
      | 'dumbbell'
      | 'dumpster'
      | 'dumpster-fire'
      | 'dungeon'
      | 'edit'
      | 'egg'
      | 'eject'
      | 'ellipsis-h'
      | 'ellipsis-v'
      | 'envelope'
      | 'envelope-open'
      | 'envelope-open-text'
      | 'envelope-square'
      | 'equals'
      | 'eraser'
      | 'ethernet'
      | 'euro-sign'
      | 'exchange-alt'
      | 'exclamation'
      | 'exclamation-circle'
      | 'exclamation-triangle'
      | 'expand'
      | 'expand-alt'
      | 'expand-arrows-alt'
      | 'external-link-alt'
      | 'external-link-square-alt'
      | 'eye'
      | 'eye-dropper'
      | 'eye-slash'
      | 'fan'
      | 'fast-backward'
      | 'fast-forward'
      | 'faucet'
      | 'fax'
      | 'feather'
      | 'feather-alt'
      | 'female'
      | 'fighter-jet'
      | 'file'
      | 'file-alt'
      | 'file-archive'
      | 'file-audio'
      | 'file-code'
      | 'file-contract'
      | 'file-csv'
      | 'file-download'
      | 'file-excel'
      | 'file-export'
      | 'file-image'
      | 'file-import'
      | 'file-invoice'
      | 'file-invoice-dollar'
      | 'file-medical'
      | 'file-medical-alt'
      | 'file-pdf'
      | 'file-powerpoint'
      | 'file-prescription'
      | 'file-signature'
      | 'file-upload'
      | 'file-video'
      | 'file-word'
      | 'fill'
      | 'fill-drip'
      | 'film'
      | 'filter'
      | 'fingerprint'
      | 'fire'
      | 'fire-alt'
      | 'fire-extinguisher'
      | 'first-aid'
      | 'fish'
      | 'fist-raised'
      | 'flag'
      | 'flag-checkered'
      | 'flag-usa'
      | 'flask'
      | 'flushed'
      | 'folder'
      | 'folder-minus'
      | 'folder-open'
      | 'folder-plus'
      | 'font'
      | 'font-awesome-logo-full'
      | 'football-ball'
      | 'forward'
      | 'frog'
      | 'frown'
      | 'frown-open'
      | 'funnel-dollar'
      | 'futbol'
      | 'gamepad'
      | 'gas-pump'
      | 'gavel'
      | 'gem'
      | 'genderless'
      | 'ghost'
      | 'gift'
      | 'gifts'
      | 'glass-cheers'
      | 'glass-martini'
      | 'glass-martini-alt'
      | 'glass-whiskey'
      | 'glasses'
      | 'globe'
      | 'globe-africa'
      | 'globe-americas'
      | 'globe-asia'
      | 'globe-europe'
      | 'golf-ball'
      | 'gopuram'
      | 'graduation-cap'
      | 'greater-than'
      | 'greater-than-equal'
      | 'grimace'
      | 'grin'
      | 'grin-alt'
      | 'grin-beam'
      | 'grin-beam-sweat'
      | 'grin-hearts'
      | 'grin-squint'
      | 'grin-squint-tears'
      | 'grin-stars'
      | 'grin-tears'
      | 'grin-tongue'
      | 'grin-tongue-squint'
      | 'grin-tongue-wink'
      | 'grin-wink'
      | 'grip-horizontal'
      | 'grip-lines'
      | 'grip-lines-vertical'
      | 'grip-vertical'
      | 'guitar'
      | 'h-square'
      | 'hamburger'
      | 'hammer'
      | 'hamsa'
      | 'hand-holding'
      | 'hand-holding-heart'
      | 'hand-holding-medical'
      | 'hand-holding-usd'
      | 'hand-holding-water'
      | 'hand-lizard'
      | 'hand-middle-finger'
      | 'hand-paper'
      | 'hand-peace'
      | 'hand-point-down'
      | 'hand-point-left'
      | 'hand-point-right'
      | 'hand-point-up'
      | 'hand-pointer'
      | 'hand-rock'
      | 'hand-scissors'
      | 'hand-sparkles'
      | 'hand-spock'
      | 'hands'
      | 'hands-helping'
      | 'hands-wash'
      | 'handshake'
      | 'handshake-alt-slash'
      | 'handshake-slash'
      | 'hanukiah'
      | 'hard-hat'
      | 'hashtag'
      | 'hat-cowboy'
      | 'hat-cowboy-side'
      | 'hat-wizard'
      | 'hdd'
      | 'head-side-cough'
      | 'head-side-cough-slash'
      | 'head-side-mask'
      | 'head-side-virus'
      | 'heading'
      | 'headphones'
      | 'headphones-alt'
      | 'headset'
      | 'heart'
      | 'heart-broken'
      | 'heartbeat'
      | 'helicopter'
      | 'highlighter'
      | 'hiking'
      | 'hippo'
      | 'history'
      | 'hockey-puck'
      | 'holly-berry'
      | 'home'
      | 'horse'
      | 'horse-head'
      | 'hospital'
      | 'hospital-alt'
      | 'hospital-symbol'
      | 'hospital-user'
      | 'hot-tub'
      | 'hotdog'
      | 'hotel'
      | 'hourglass'
      | 'hourglass-end'
      | 'hourglass-half'
      | 'hourglass-start'
      | 'house-damage'
      | 'house-user'
      | 'hryvnia'
      | 'i-cursor'
      | 'ice-cream'
      | 'icicles'
      | 'icons'
      | 'id-badge'
      | 'id-card'
      | 'id-card-alt'
      | 'igloo'
      | 'image'
      | 'images'
      | 'inbox'
      | 'indent'
      | 'industry'
      | 'infinity'
      | 'info'
      | 'info-circle'
      | 'italic'
      | 'jedi'
      | 'joint'
      | 'journal-whills'
      | 'kaaba'
      | 'key'
      | 'keyboard'
      | 'khanda'
      | 'kiss'
      | 'kiss-beam'
      | 'kiss-wink-heart'
      | 'kiwi-bird'
      | 'landmark'
      | 'language'
      | 'laptop'
      | 'laptop-code'
      | 'laptop-house'
      | 'laptop-medical'
      | 'laugh'
      | 'laugh-beam'
      | 'laugh-squint'
      | 'laugh-wink'
      | 'layer-group'
      | 'leaf'
      | 'lemon'
      | 'less-than'
      | 'less-than-equal'
      | 'level-down-alt'
      | 'level-up-alt'
      | 'life-ring'
      | 'lightbulb'
      | 'link'
      | 'lira-sign'
      | 'list'
      | 'list-alt'
      | 'list-ol'
      | 'list-ul'
      | 'location-arrow'
      | 'lock'
      | 'lock-open'
      | 'long-arrow-alt-down'
      | 'long-arrow-alt-left'
      | 'long-arrow-alt-right'
      | 'long-arrow-alt-up'
      | 'low-vision'
      | 'luggage-cart'
      | 'lungs'
      | 'lungs-virus'
      | 'magic'
      | 'magnet'
      | 'mail-bulk'
      | 'male'
      | 'map'
      | 'map-marked'
      | 'map-marked-alt'
      | 'map-marker'
      | 'map-marker-alt'
      | 'map-pin'
      | 'map-signs'
      | 'marker'
      | 'mars'
      | 'mars-double'
      | 'mars-stroke'
      | 'mars-stroke-h'
      | 'mars-stroke-v'
      | 'mask'
      | 'medal'
      | 'medkit'
      | 'meh'
      | 'meh-blank'
      | 'meh-rolling-eyes'
      | 'memory'
      | 'menorah'
      | 'mercury'
      | 'meteor'
      | 'microchip'
      | 'microphone'
      | 'microphone-alt'
      | 'microphone-alt-slash'
      | 'microphone-slash'
      | 'microscope'
      | 'minus'
      | 'minus-circle'
      | 'minus-square'
      | 'mitten'
      | 'mobile'
      | 'mobile-alt'
      | 'money-bill'
      | 'money-bill-alt'
      | 'money-bill-wave'
      | 'money-bill-wave-alt'
      | 'money-check'
      | 'money-check-alt'
      | 'monument'
      | 'moon'
      | 'mortar-pestle'
      | 'mosque'
      | 'motorcycle'
      | 'mountain'
      | 'mouse'
      | 'mouse-pointer'
      | 'mug-hot'
      | 'music'
      | 'network-wired'
      | 'neuter'
      | 'newspaper'
      | 'not-equal'
      | 'notes-medical'
      | 'object-group'
      | 'object-ungroup'
      | 'oil-can'
      | 'om'
      | 'otter'
      | 'outdent'
      | 'pager'
      | 'paint-brush'
      | 'paint-roller'
      | 'palette'
      | 'pallet'
      | 'paper-plane'
      | 'paperclip'
      | 'parachute-box'
      | 'paragraph'
      | 'parking'
      | 'passport'
      | 'pastafarianism'
      | 'paste'
      | 'pause'
      | 'pause-circle'
      | 'paw'
      | 'peace'
      | 'pen'
      | 'pen-alt'
      | 'pen-fancy'
      | 'pen-nib'
      | 'pen-square'
      | 'pencil-alt'
      | 'pencil-ruler'
      | 'people-arrows'
      | 'people-carry'
      | 'pepper-hot'
      | 'percent'
      | 'percentage'
      | 'person-booth'
      | 'phone'
      | 'phone-alt'
      | 'phone-slash'
      | 'phone-square'
      | 'phone-square-alt'
      | 'phone-volume'
      | 'photo-video'
      | 'piggy-bank'
      | 'pills'
      | 'pizza-slice'
      | 'place-of-worship'
      | 'plane'
      | 'plane-arrival'
      | 'plane-departure'
      | 'plane-slash'
      | 'play'
      | 'play-circle'
      | 'plug'
      | 'plus'
      | 'plus-circle'
      | 'plus-square'
      | 'podcast'
      | 'poll'
      | 'poll-h'
      | 'poo'
      | 'poo-storm'
      | 'poop'
      | 'portrait'
      | 'pound-sign'
      | 'power-off'
      | 'pray'
      | 'praying-hands'
      | 'prescription'
      | 'prescription-bottle'
      | 'prescription-bottle-alt'
      | 'print'
      | 'procedures'
      | 'project-diagram'
      | 'pump-medical'
      | 'pump-soap'
      | 'puzzle-piece'
      | 'qrcode'
      | 'question'
      | 'question-circle'
      | 'quidditch'
      | 'quote-left'
      | 'quote-right'
      | 'quran'
      | 'radiation'
      | 'radiation-alt'
      | 'rainbow'
      | 'random'
      | 'receipt'
      | 'record-vinyl'
      | 'recycle'
      | 'redo'
      | 'redo-alt'
      | 'registered'
      | 'remove-format'
      | 'reply'
      | 'reply-all'
      | 'republican'
      | 'restroom'
      | 'retweet'
      | 'ribbon'
      | 'ring'
      | 'road'
      | 'robot'
      | 'rocket'
      | 'route'
      | 'rss'
      | 'rss-square'
      | 'ruble-sign'
      | 'ruler'
      | 'ruler-combined'
      | 'ruler-horizontal'
      | 'ruler-vertical'
      | 'running'
      | 'rupee-sign'
      | 'sad-cry'
      | 'sad-tear'
      | 'satellite'
      | 'satellite-dish'
      | 'save'
      | 'school'
      | 'screwdriver'
      | 'scroll'
      | 'sd-card'
      | 'search'
      | 'search-dollar'
      | 'search-location'
      | 'search-minus'
      | 'search-plus'
      | 'seedling'
      | 'server'
      | 'shapes'
      | 'share'
      | 'share-alt'
      | 'share-alt-square'
      | 'share-square'
      | 'shekel-sign'
      | 'shield-alt'
      | 'shield-virus'
      | 'ship'
      | 'shipping-fast'
      | 'shoe-prints'
      | 'shopping-bag'
      | 'shopping-basket'
      | 'shopping-cart'
      | 'shower'
      | 'shuttle-van'
      | 'sign'
      | 'sign-in-alt'
      | 'sign-language'
      | 'sign-out-alt'
      | 'signal'
      | 'signature'
      | 'sim-card'
      | 'sink'
      | 'sitemap'
      | 'skating'
      | 'skiing'
      | 'skiing-nordic'
      | 'skull'
      | 'skull-crossbones'
      | 'slash'
      | 'sleigh'
      | 'sliders-h'
      | 'smile'
      | 'smile-beam'
      | 'smile-wink'
      | 'smog'
      | 'smoking'
      | 'smoking-ban'
      | 'sms'
      | 'snowboarding'
      | 'snowflake'
      | 'snowman'
      | 'snowplow'
      | 'soap'
      | 'socks'
      | 'solar-panel'
      | 'sort'
      | 'sort-alpha-down'
      | 'sort-alpha-down-alt'
      | 'sort-alpha-up'
      | 'sort-alpha-up-alt'
      | 'sort-amount-down'
      | 'sort-amount-down-alt'
      | 'sort-amount-up'
      | 'sort-amount-up-alt'
      | 'sort-down'
      | 'sort-numeric-down'
      | 'sort-numeric-down-alt'
      | 'sort-numeric-up'
      | 'sort-numeric-up-alt'
      | 'sort-up'
      | 'spa'
      | 'space-shuttle'
      | 'spell-check'
      | 'spider'
      | 'spinner'
      | 'splotch'
      | 'spray-can'
      | 'square'
      | 'square-full'
      | 'square-root-alt'
      | 'stamp'
      | 'star'
      | 'star-and-crescent'
      | 'star-half'
      | 'star-half-alt'
      | 'star-of-david'
      | 'star-of-life'
      | 'step-backward'
      | 'step-forward'
      | 'stethoscope'
      | 'sticky-note'
      | 'stop'
      | 'stop-circle'
      | 'stopwatch'
      | 'stopwatch-20'
      | 'store'
      | 'store-alt'
      | 'store-alt-slash'
      | 'store-slash'
      | 'stream'
      | 'street-view'
      | 'strikethrough'
      | 'stroopwafel'
      | 'subscript'
      | 'subway'
      | 'suitcase'
      | 'suitcase-rolling'
      | 'sun'
      | 'superscript'
      | 'surprise'
      | 'swatchbook'
      | 'swimmer'
      | 'swimming-pool'
      | 'synagogue'
      | 'sync'
      | 'sync-alt'
      | 'syringe'
      | 'table'
      | 'table-tennis'
      | 'tablet'
      | 'tablet-alt'
      | 'tablets'
      | 'tachometer-alt'
      | 'tag'
      | 'tags'
      | 'tape'
      | 'tasks'
      | 'taxi'
      | 'teeth'
      | 'teeth-open'
      | 'temperature-high'
      | 'temperature-low'
      | 'tenge'
      | 'terminal'
      | 'text-height'
      | 'text-width'
      | 'th'
      | 'th-large'
      | 'th-list'
      | 'theater-masks'
      | 'thermometer'
      | 'thermometer-empty'
      | 'thermometer-full'
      | 'thermometer-half'
      | 'thermometer-quarter'
      | 'thermometer-three-quarters'
      | 'thumbs-down'
      | 'thumbs-up'
      | 'thumbtack'
      | 'ticket-alt'
      | 'times'
      | 'times-circle'
      | 'tint'
      | 'tint-slash'
      | 'tired'
      | 'toggle-off'
      | 'toggle-on'
      | 'toilet'
      | 'toilet-paper'
      | 'toilet-paper-slash'
      | 'toolbox'
      | 'tools'
      | 'tooth'
      | 'torah'
      | 'torii-gate'
      | 'tractor'
      | 'trademark'
      | 'traffic-light'
      | 'trailer'
      | 'train'
      | 'tram'
      | 'transgender'
      | 'transgender-alt'
      | 'trash'
      | 'trash-alt'
      | 'trash-restore'
      | 'trash-restore-alt'
      | 'tree'
      | 'trophy'
      | 'truck'
      | 'truck-loading'
      | 'truck-monster'
      | 'truck-moving'
      | 'truck-pickup'
      | 'tshirt'
      | 'tty'
      | 'tv'
      | 'umbrella'
      | 'umbrella-beach'
      | 'underline'
      | 'undo'
      | 'undo-alt'
      | 'universal-access'
      | 'university'
      | 'unlink'
      | 'unlock'
      | 'unlock-alt'
      | 'upload'
      | 'user'
      | 'user-alt'
      | 'user-alt-slash'
      | 'user-astronaut'
      | 'user-check'
      | 'user-circle'
      | 'user-clock'
      | 'user-cog'
      | 'user-edit'
      | 'user-friends'
      | 'user-graduate'
      | 'user-injured'
      | 'user-lock'
      | 'user-md'
      | 'user-minus'
      | 'user-ninja'
      | 'user-nurse'
      | 'user-plus'
      | 'user-secret'
      | 'user-shield'
      | 'user-slash'
      | 'user-tag'
      | 'user-tie'
      | 'user-times'
      | 'users'
      | 'users-cog'
      | 'users-slash'
      | 'utensil-spoon'
      | 'utensils'
      | 'vector-square'
      | 'venus'
      | 'venus-double'
      | 'venus-mars'
      | 'vest'
      | 'vest-patches'
      | 'vial'
      | 'vials'
      | 'video'
      | 'video-slash'
      | 'vihara'
      | 'virus'
      | 'virus-slash'
      | 'viruses'
      | 'voicemail'
      | 'volleyball-ball'
      | 'volume-down'
      | 'volume-mute'
      | 'volume-off'
      | 'volume-up'
      | 'vote-yea'
      | 'vr-cardboard'
      | 'walking'
      | 'wallet'
      | 'warehouse'
      | 'water'
      | 'wave-square'
      | 'weight'
      | 'weight-hanging'
      | 'wheelchair'
      | 'wifi'
      | 'wind'
      | 'window-close'
      | 'window-maximize'
      | 'window-minimize'
      | 'window-restore'
      | 'wine-bottle'
      | 'wine-glass'
      | 'wine-glass-alt'
      | 'won-sign'
      | 'wrench'
      | 'x-ray'
      | 'yen-sign'
      | 'yin-yang'
    regular:
      | 'address-book'
      | 'address-card'
      | 'angry'
      | 'arrow-alt-circle-down'
      | 'arrow-alt-circle-left'
      | 'arrow-alt-circle-right'
      | 'arrow-alt-circle-up'
      | 'bell'
      | 'bell-slash'
      | 'bookmark'
      | 'building'
      | 'calendar'
      | 'calendar-alt'
      | 'calendar-check'
      | 'calendar-minus'
      | 'calendar-plus'
      | 'calendar-times'
      | 'caret-square-down'
      | 'caret-square-left'
      | 'caret-square-right'
      | 'caret-square-up'
      | 'chart-bar'
      | 'check-circle'
      | 'check-square'
      | 'circle'
      | 'clipboard'
      | 'clock'
      | 'clone'
      | 'closed-captioning'
      | 'comment'
      | 'comment-alt'
      | 'comment-dots'
      | 'comments'
      | 'compass'
      | 'copy'
      | 'copyright'
      | 'credit-card'
      | 'dizzy'
      | 'dot-circle'
      | 'edit'
      | 'envelope'
      | 'envelope-open'
      | 'eye'
      | 'eye-slash'
      | 'file'
      | 'file-alt'
      | 'file-archive'
      | 'file-audio'
      | 'file-code'
      | 'file-excel'
      | 'file-image'
      | 'file-pdf'
      | 'file-powerpoint'
      | 'file-video'
      | 'file-word'
      | 'flag'
      | 'flushed'
      | 'folder'
      | 'folder-open'
      | 'font-awesome-logo-full'
      | 'frown'
      | 'frown-open'
      | 'futbol'
      | 'gem'
      | 'grimace'
      | 'grin'
      | 'grin-alt'
      | 'grin-beam'
      | 'grin-beam-sweat'
      | 'grin-hearts'
      | 'grin-squint'
      | 'grin-squint-tears'
      | 'grin-stars'
      | 'grin-tears'
      | 'grin-tongue'
      | 'grin-tongue-squint'
      | 'grin-tongue-wink'
      | 'grin-wink'
      | 'hand-lizard'
      | 'hand-paper'
      | 'hand-peace'
      | 'hand-point-down'
      | 'hand-point-left'
      | 'hand-point-right'
      | 'hand-point-up'
      | 'hand-pointer'
      | 'hand-rock'
      | 'hand-scissors'
      | 'hand-spock'
      | 'handshake'
      | 'hdd'
      | 'heart'
      | 'hospital'
      | 'hourglass'
      | 'id-badge'
      | 'id-card'
      | 'image'
      | 'images'
      | 'keyboard'
      | 'kiss'
      | 'kiss-beam'
      | 'kiss-wink-heart'
      | 'laugh'
      | 'laugh-beam'
      | 'laugh-squint'
      | 'laugh-wink'
      | 'lemon'
      | 'life-ring'
      | 'lightbulb'
      | 'list-alt'
      | 'map'
      | 'meh'
      | 'meh-blank'
      | 'meh-rolling-eyes'
      | 'minus-square'
      | 'money-bill-alt'
      | 'moon'
      | 'newspaper'
      | 'object-group'
      | 'object-ungroup'
      | 'paper-plane'
      | 'pause-circle'
      | 'play-circle'
      | 'plus-square'
      | 'question-circle'
      | 'registered'
      | 'sad-cry'
      | 'sad-tear'
      | 'save'
      | 'share-square'
      | 'smile'
      | 'smile-beam'
      | 'smile-wink'
      | 'snowflake'
      | 'square'
      | 'star'
      | 'star-half'
      | 'sticky-note'
      | 'stop-circle'
      | 'sun'
      | 'surprise'
      | 'thumbs-down'
      | 'thumbs-up'
      | 'times-circle'
      | 'tired'
      | 'trash-alt'
      | 'user'
      | 'user-circle'
      | 'window-close'
      | 'window-maximize'
      | 'window-minimize'
      | 'window-restore'
    brands:
      | '500px'
      | 'accessible-icon'
      | 'accusoft'
      | 'acquisitions-incorporated'
      | 'adn'
      | 'adversal'
      | 'affiliatetheme'
      | 'airbnb'
      | 'algolia'
      | 'alipay'
      | 'amazon'
      | 'amazon-pay'
      | 'amilia'
      | 'android'
      | 'angellist'
      | 'angrycreative'
      | 'angular'
      | 'app-store'
      | 'app-store-ios'
      | 'apper'
      | 'apple'
      | 'apple-pay'
      | 'artstation'
      | 'asymmetrik'
      | 'atlassian'
      | 'audible'
      | 'autoprefixer'
      | 'avianex'
      | 'aviato'
      | 'aws'
      | 'bandcamp'
      | 'battle-net'
      | 'behance'
      | 'behance-square'
      | 'bimobject'
      | 'bitbucket'
      | 'bitcoin'
      | 'bity'
      | 'black-tie'
      | 'blackberry'
      | 'blogger'
      | 'blogger-b'
      | 'bluetooth'
      | 'bluetooth-b'
      | 'bootstrap'
      | 'btc'
      | 'buffer'
      | 'buromobelexperte'
      | 'buy-n-large'
      | 'buysellads'
      | 'canadian-maple-leaf'
      | 'cc-amazon-pay'
      | 'cc-amex'
      | 'cc-apple-pay'
      | 'cc-diners-club'
      | 'cc-discover'
      | 'cc-jcb'
      | 'cc-mastercard'
      | 'cc-paypal'
      | 'cc-stripe'
      | 'cc-visa'
      | 'centercode'
      | 'centos'
      | 'chrome'
      | 'chromecast'
      | 'cloudflare'
      | 'cloudscale'
      | 'cloudsmith'
      | 'cloudversify'
      | 'codepen'
      | 'codiepie'
      | 'confluence'
      | 'connectdevelop'
      | 'contao'
      | 'cotton-bureau'
      | 'cpanel'
      | 'creative-commons'
      | 'creative-commons-by'
      | 'creative-commons-nc'
      | 'creative-commons-nc-eu'
      | 'creative-commons-nc-jp'
      | 'creative-commons-nd'
      | 'creative-commons-pd'
      | 'creative-commons-pd-alt'
      | 'creative-commons-remix'
      | 'creative-commons-sa'
      | 'creative-commons-sampling'
      | 'creative-commons-sampling-plus'
      | 'creative-commons-share'
      | 'creative-commons-zero'
      | 'critical-role'
      | 'css3'
      | 'css3-alt'
      | 'cuttlefish'
      | 'd-and-d'
      | 'd-and-d-beyond'
      | 'dailymotion'
      | 'dashcube'
      | 'deezer'
      | 'delicious'
      | 'deploydog'
      | 'deskpro'
      | 'dev'
      | 'deviantart'
      | 'dhl'
      | 'diaspora'
      | 'digg'
      | 'digital-ocean'
      | 'discord'
      | 'discourse'
      | 'dochub'
      | 'docker'
      | 'draft2digital'
      | 'dribbble'
      | 'dribbble-square'
      | 'dropbox'
      | 'drupal'
      | 'dyalog'
      | 'earlybirds'
      | 'ebay'
      | 'edge'
      | 'edge-legacy'
      | 'elementor'
      | 'ello'
      | 'ember'
      | 'empire'
      | 'envira'
      | 'erlang'
      | 'ethereum'
      | 'etsy'
      | 'evernote'
      | 'expeditedssl'
      | 'facebook'
      | 'facebook-f'
      | 'facebook-messenger'
      | 'facebook-square'
      | 'fantasy-flight-games'
      | 'fedex'
      | 'fedora'
      | 'figma'
      | 'firefox'
      | 'firefox-browser'
      | 'first-order'
      | 'first-order-alt'
      | 'firstdraft'
      | 'flickr'
      | 'flipboard'
      | 'fly'
      | 'font-awesome'
      | 'font-awesome-alt'
      | 'font-awesome-flag'
      | 'font-awesome-logo-full'
      | 'fonticons'
      | 'fonticons-fi'
      | 'fort-awesome'
      | 'fort-awesome-alt'
      | 'forumbee'
      | 'foursquare'
      | 'free-code-camp'
      | 'freebsd'
      | 'fulcrum'
      | 'galactic-republic'
      | 'galactic-senate'
      | 'get-pocket'
      | 'gg'
      | 'gg-circle'
      | 'git'
      | 'git-alt'
      | 'git-square'
      | 'github'
      | 'github-alt'
      | 'github-square'
      | 'gitkraken'
      | 'gitlab'
      | 'gitter'
      | 'glide'
      | 'glide-g'
      | 'gofore'
      | 'goodreads'
      | 'goodreads-g'
      | 'google'
      | 'google-drive'
      | 'google-pay'
      | 'google-play'
      | 'google-plus'
      | 'google-plus-g'
      | 'google-plus-square'
      | 'google-wallet'
      | 'gratipay'
      | 'grav'
      | 'gripfire'
      | 'grunt'
      | 'guilded'
      | 'gulp'
      | 'hacker-news'
      | 'hacker-news-square'
      | 'hackerrank'
      | 'hips'
      | 'hire-a-helper'
      | 'hive'
      | 'hooli'
      | 'hornbill'
      | 'hotjar'
      | 'houzz'
      | 'html5'
      | 'hubspot'
      | 'ideal'
      | 'imdb'
      | 'innosoft'
      | 'instagram'
      | 'instagram-square'
      | 'instalod'
      | 'intercom'
      | 'internet-explorer'
      | 'invision'
      | 'ioxhost'
      | 'itch-io'
      | 'itunes'
      | 'itunes-note'
      | 'java'
      | 'jedi-order'
      | 'jenkins'
      | 'jira'
      | 'joget'
      | 'joomla'
      | 'js'
      | 'js-square'
      | 'jsfiddle'
      | 'kaggle'
      | 'keybase'
      | 'keycdn'
      | 'kickstarter'
      | 'kickstarter-k'
      | 'korvue'
      | 'laravel'
      | 'lastfm'
      | 'lastfm-square'
      | 'leanpub'
      | 'less'
      | 'line'
      | 'linkedin'
      | 'linkedin-in'
      | 'linode'
      | 'linux'
      | 'lyft'
      | 'magento'
      | 'mailchimp'
      | 'mandalorian'
      | 'markdown'
      | 'mastodon'
      | 'maxcdn'
      | 'mdb'
      | 'medapps'
      | 'medium'
      | 'medium-m'
      | 'medrt'
      | 'meetup'
      | 'megaport'
      | 'mendeley'
      | 'microblog'
      | 'microsoft'
      | 'mix'
      | 'mixcloud'
      | 'mixer'
      | 'mizuni'
      | 'modx'
      | 'monero'
      | 'napster'
      | 'neos'
      | 'nimblr'
      | 'node'
      | 'node-js'
      | 'npm'
      | 'ns8'
      | 'nutritionix'
      | 'octopus-deploy'
      | 'odnoklassniki'
      | 'odnoklassniki-square'
      | 'old-republic'
      | 'opencart'
      | 'openid'
      | 'opera'
      | 'optin-monster'
      | 'orcid'
      | 'osi'
      | 'page4'
      | 'pagelines'
      | 'palfed'
      | 'patreon'
      | 'paypal'
      | 'penny-arcade'
      | 'perbyte'
      | 'periscope'
      | 'phabricator'
      | 'phoenix-framework'
      | 'phoenix-squadron'
      | 'php'
      | 'pied-piper'
      | 'pied-piper-alt'
      | 'pied-piper-hat'
      | 'pied-piper-pp'
      | 'pied-piper-square'
      | 'pinterest'
      | 'pinterest-p'
      | 'pinterest-square'
      | 'playstation'
      | 'product-hunt'
      | 'pushed'
      | 'python'
      | 'qq'
      | 'quinscape'
      | 'quora'
      | 'r-project'
      | 'raspberry-pi'
      | 'ravelry'
      | 'react'
      | 'reacteurope'
      | 'readme'
      | 'rebel'
      | 'red-river'
      | 'reddit'
      | 'reddit-alien'
      | 'reddit-square'
      | 'redhat'
      | 'renren'
      | 'replyd'
      | 'researchgate'
      | 'resolving'
      | 'rev'
      | 'rocketchat'
      | 'rockrms'
      | 'rust'
      | 'safari'
      | 'salesforce'
      | 'sass'
      | 'schlix'
      | 'scribd'
      | 'searchengin'
      | 'sellcast'
      | 'sellsy'
      | 'servicestack'
      | 'shirtsinbulk'
      | 'shopify'
      | 'shopware'
      | 'simplybuilt'
      | 'sistrix'
      | 'sith'
      | 'sketch'
      | 'skyatlas'
      | 'skype'
      | 'slack'
      | 'slack-hash'
      | 'slideshare'
      | 'snapchat'
      | 'snapchat-ghost'
      | 'snapchat-square'
      | 'soundcloud'
      | 'sourcetree'
      | 'speakap'
      | 'speaker-deck'
      | 'spotify'
      | 'squarespace'
      | 'stack-exchange'
      | 'stack-overflow'
      | 'stackpath'
      | 'staylinked'
      | 'steam'
      | 'steam-square'
      | 'steam-symbol'
      | 'sticker-mule'
      | 'strava'
      | 'stripe'
      | 'stripe-s'
      | 'studiovinari'
      | 'stumbleupon'
      | 'stumbleupon-circle'
      | 'superpowers'
      | 'supple'
      | 'suse'
      | 'swift'
      | 'symfony'
      | 'teamspeak'
      | 'telegram'
      | 'telegram-plane'
      | 'tencent-weibo'
      | 'the-red-yeti'
      | 'themeco'
      | 'themeisle'
      | 'think-peaks'
      | 'tiktok'
      | 'trade-federation'
      | 'trello'
      | 'tumblr'
      | 'tumblr-square'
      | 'twitch'
      | 'twitter'
      | 'twitter-square'
      | 'typo3'
      | 'uber'
      | 'ubuntu'
      | 'uikit'
      | 'umbraco'
      | 'uncharted'
      | 'uniregistry'
      | 'unity'
      | 'unsplash'
      | 'untappd'
      | 'ups'
      | 'usb'
      | 'usps'
      | 'ussunnah'
      | 'vaadin'
      | 'viacoin'
      | 'viadeo'
      | 'viadeo-square'
      | 'viber'
      | 'vimeo'
      | 'vimeo-square'
      | 'vimeo-v'
      | 'vine'
      | 'vk'
      | 'vnv'
      | 'vuejs'
      | 'watchman-monitoring'
      | 'waze'
      | 'weebly'
      | 'weibo'
      | 'weixin'
      | 'whatsapp'
      | 'whatsapp-square'
      | 'whmcs'
      | 'wikipedia-w'
      | 'windows'
      | 'wix'
      | 'wizards-of-the-coast'
      | 'wodu'
      | 'wolf-pack-battalion'
      | 'wordpress'
      | 'wordpress-simple'
      | 'wpbeginner'
      | 'wpexplorer'
      | 'wpforms'
      | 'wpressr'
      | 'xbox'
      | 'xing'
      | 'xing-square'
      | 'y-combinator'
      | 'yahoo'
      | 'yammer'
      | 'yandex'
      | 'yandex-international'
      | 'yarn'
      | 'yelp'
      | 'yoast'
      | 'youtube'
      | 'youtube-square'
      | 'zhihu'
  }
  iconoir:
    | '1st-medal'
    | '4k-display'
    | '4x4-cell'
    | '360-view'
    | 'accessibility'
    | 'accessibility-sign'
    | 'accessibility-tech'
    | 'activity'
    | 'add-circled-outline'
    | 'add-database-script'
    | 'add-folder'
    | 'add-frame'
    | 'add-hexagon'
    | 'add-keyframe'
    | 'add-keyframe-alt'
    | 'add-keyframes'
    | 'add-lens'
    | 'add-media-image'
    | 'add-media-video'
    | 'add-page'
    | 'add-pin-alt'
    | 'add-selection'
    | 'add-square'
    | 'add-to-cart'
    | 'add-user'
    | 'air-conditioner'
    | 'airplane'
    | 'airplane-helix'
    | 'airplane-helix-45deg'
    | 'airplane-off'
    | 'airplane-rotation'
    | 'airplay'
    | 'alarm'
    | 'album'
    | 'album-carousel'
    | 'album-list'
    | 'album-open'
    | 'align-bottom-box'
    | 'align-center'
    | 'align-justify'
    | 'align-left'
    | 'align-left-box'
    | 'align-right'
    | 'align-right-box'
    | 'align-top-box'
    | 'antenna'
    | 'antenna-off'
    | 'antenna-signal'
    | 'antenna-signal-rounded'
    | 'app-notification'
    | 'apple'
    | 'apple-half'
    | 'apple-half-alt'
    | 'apple-imac-2021'
    | 'apple-imac-2021-side'
    | 'apple-mac'
    | 'apple-swift'
    | 'apple-wallet'
    | 'ar-symbol'
    | 'archery'
    | 'archive'
    | 'area-search'
    | 'arrow-archery'
    | 'arrow-down'
    | 'arrow-down-circled'
    | 'arrow-left'
    | 'arrow-left-circled'
    | 'arrow-right'
    | 'arrow-right-circled'
    | 'arrow-separate'
    | 'arrow-separate-vertical'
    | 'arrow-union'
    | 'arrow-union-vertical'
    | 'arrow-up'
    | 'arrow-up-circled'
    | 'asana'
    | 'atom'
    | 'attachment'
    | 'auto-flash'
    | 'backward-15-seconds'
    | 'bag'
    | 'bank'
    | 'basket-ball'
    | 'basket-ball-alt'
    | 'basketball-field'
    | 'battery-25'
    | 'battery-50'
    | 'battery-75'
    | 'battery-charging'
    | 'battery-empty'
    | 'battery-full'
    | 'battery-indicator'
    | 'battery-warning'
    | 'bbq'
    | 'beach-bag'
    | 'beach-bag-big'
    | 'bell'
    | 'bell-notification'
    | 'bell-off'
    | 'bicycle'
    | 'bin'
    | 'bin-add'
    | 'bin-full'
    | 'bin-half'
    | 'bin-minus'
    | 'bluetooth'
    | 'bluetooth-rounded'
    | 'bold'
    | 'bold-square-outline'
    | 'bonfire'
    | 'book'
    | 'book-stack'
    | 'bookmark-book'
    | 'bookmark-circled'
    | 'bookmark-empty'
    | 'border-bl'
    | 'border-bottom'
    | 'border-br'
    | 'border-inner'
    | 'border-left'
    | 'border-out'
    | 'border-right'
    | 'border-tl'
    | 'border-top'
    | 'border-tr'
    | 'bounce-left'
    | 'bounce-right'
    | 'bowling-ball'
    | 'box'
    | 'box-iso'
    | 'boxing-glove'
    | 'bubble-download'
    | 'bubble-error'
    | 'bubble-income'
    | 'bubble-outcome'
    | 'bubble-search'
    | 'bubble-star'
    | 'bubble-upload'
    | 'bubble-warning'
    | 'building'
    | 'bus-outline'
    | 'bus-stop'
    | 'cable-rounded'
    | 'calculator'
    | 'calendar'
    | 'camera'
    | 'cancel'
    | 'car-outline'
    | 'carbon'
    | 'card-wallet'
    | 'cart'
    | 'cart-alt'
    | 'cash'
    | 'center-align'
    | 'chat-add'
    | 'chat-bubble'
    | 'chat-bubble-check'
    | 'chat-bubble-check-1'
    | 'chat-bubble-empty'
    | 'chat-bubble-error'
    | 'chat-bubble-question'
    | 'chat-bubble-translate'
    | 'chat-bubble-warning'
    | 'chat-lines'
    | 'chat-remove'
    | 'check'
    | 'check-circled-outline'
    | 'chocolate'
    | 'chromecast'
    | 'chromecast-active'
    | 'church'
    | 'church-alt'
    | 'cinema-old'
    | 'circle'
    | 'city'
    | 'clock-outline'
    | 'closet'
    | 'cloud'
    | 'cloud-book-alt'
    | 'cloud-check'
    | 'cloud-desync'
    | 'cloud-download'
    | 'cloud-error'
    | 'cloud-sunny'
    | 'cloud-sync'
    | 'cloud-upload'
    | 'code'
    | 'code-brackets'
    | 'code-brackets-square'
    | 'codepen'
    | 'coin'
    | 'collage-frame'
    | 'collapse'
    | 'color-filter'
    | 'color-picker'
    | 'color-picker-empty'
    | 'combine'
    | 'compact-disc'
    | 'compress'
    | 'compress-lines'
    | 'computer'
    | 'control-slider'
    | 'cookie'
    | 'copy'
    | 'copyright'
    | 'corner-bottom-left'
    | 'corner-bottom-right'
    | 'corner-top-left'
    | 'corner-top-right'
    | 'cpu'
    | 'cpu-warning'
    | 'cracked-egg'
    | 'creative-commons'
    | 'credit-card'
    | 'credit-card-2'
    | 'crop'
    | 'crop-rotate-bl'
    | 'crop-rotate-br'
    | 'crop-rotate-tl'
    | 'crop-rotate-tr'
    | 'css3'
    | 'cursor-pointer'
    | 'cut'
    | 'cut-alt'
    | 'cycling'
    | 'dash-flag'
    | 'dashboard'
    | 'dashboard-dots'
    | 'dashboard-speed'
    | 'data-transfer-both'
    | 'data-transfer-check'
    | 'data-transfer-down'
    | 'data-transfer-up'
    | 'data-transfer-warning'
    | 'database-backup'
    | 'database-export'
    | 'database-monitor'
    | 'database-restore'
    | 'database-rounded'
    | 'database-script'
    | 'database-settings'
    | 'database-star'
    | 'database-stats'
    | 'db'
    | 'db-check'
    | 'db-error'
    | 'db-search'
    | 'db-star'
    | 'db-warning'
    | 'de-compress'
    | 'delete-circled-outline'
    | 'design-pencil'
    | 'dialpad'
    | 'divide-selection-1'
    | 'divide-selection-2'
    | 'doc-search'
    | 'doc-search-alt'
    | 'doc-star'
    | 'doc-star-alt'
    | 'dollar'
    | 'domotic-issue'
    | 'donate'
    | 'double-check'
    | 'down-round-arrow'
    | 'download'
    | 'download-circled-outline'
    | 'download-square-outline'
    | 'drag-hand-gesture'
    | 'drawer'
    | 'dribbble'
    | 'droplet'
    | 'droplet-half'
    | 'ease-curve-control-points'
    | 'ease-in'
    | 'ease-in-control-point'
    | 'ease-in-out'
    | 'ease-out'
    | 'ease-out-control-point'
    | 'edit'
    | 'edit-pencil'
    | 'egg'
    | 'eject'
    | 'electronics-chip'
    | 'electronics-transister'
    | 'emoji'
    | 'emoji-ball'
    | 'emoji-blink-left'
    | 'emoji-blink-right'
    | 'emoji-look-bottom'
    | 'emoji-look-left'
    | 'emoji-look-right'
    | 'emoji-look-top'
    | 'emoji-quite'
    | 'emoji-really'
    | 'emoji-sad'
    | 'emoji-satisfied'
    | 'emoji-sing-left'
    | 'emoji-sing-left-note'
    | 'emoji-sing-right'
    | 'emoji-sing-right-note'
    | 'emoji-surprise'
    | 'emoji-surprise-alt'
    | 'emoji-talking-angry'
    | 'emoji-talking-happy'
    | 'emoji-think-left'
    | 'emoji-think-right'
    | 'empty-page'
    | 'enlarge'
    | 'enlarge-round-arrow'
    | 'euro'
    | 'euro-square'
    | 'ev-charge'
    | 'ev-charge-alt'
    | 'ev-plug'
    | 'ev-plug-charging'
    | 'ev-plug-error'
    | 'ev-rounded'
    | 'ev-station'
    | 'exclude'
    | 'expand'
    | 'expand-lines'
    | 'eye-alt'
    | 'eye-close'
    | 'eye-empty'
    | 'eye-off'
    | 'face-id'
    | 'facebook'
    | 'facebook-squared'
    | 'facetime'
    | 'farm'
    | 'fast-arrow-down'
    | 'fast-arrow-down-box'
    | 'fast-arrow-left'
    | 'fast-arrow-left-box'
    | 'fast-arrow-right'
    | 'fast-arrow-right-box'
    | 'fast-arrow-top'
    | 'fast-arrow-up-box'
    | 'fast-bottom-circle'
    | 'fast-left-circle'
    | 'fast-right-circle'
    | 'fast-top-circle'
    | 'favourite-book'
    | 'female'
    | 'figma'
    | 'file-not-found'
    | 'filter'
    | 'filter-alt'
    | 'finder'
    | 'fingerprint'
    | 'fingerprint-circled'
    | 'fingerprint-circled-error'
    | 'fingerprint-circled-lock'
    | 'fingerprint-circled-ok'
    | 'fingerprint-phone'
    | 'fingerprint-scan'
    | 'fingerprint-squared'
    | 'fire-flame'
    | 'Fishing'
    | 'flare'
    | 'flash'
    | 'flash-off'
    | 'flask'
    | 'flip'
    | 'flip-reverse'
    | 'flower'
    | 'fluorine'
    | 'fog'
    | 'folder'
    | 'folder-alert'
    | 'font-size'
    | 'football'
    | 'football-ball'
    | 'forward-15-seconds'
    | 'forward-outline'
    | 'frame'
    | 'frame-alt'
    | 'frame-alt-empty'
    | 'frame-select'
    | 'frame-simple'
    | 'frame-tool'
    | 'fridge'
    | 'fx'
    | 'fx-rounded'
    | 'garage'
    | 'gas'
    | 'gas-tank'
    | 'gas-tank-drop'
    | 'gift'
    | 'git-branch'
    | 'git-commit'
    | 'git-merge'
    | 'github'
    | 'github-outline'
    | 'gitlab-full'
    | 'glass-empty'
    | 'glass-half'
    | 'glass-half-alt'
    | 'glasses'
    | 'golf'
    | 'google'
    | 'google-circled'
    | 'google-docs'
    | 'google-drive'
    | 'google-drive-check'
    | 'google-drive-sync'
    | 'google-drive-warning'
    | 'google-home'
    | 'google-one'
    | 'gps'
    | 'graph-down'
    | 'graph-up'
    | 'grid-add'
    | 'grid-minus'
    | 'grid-remove'
    | 'group'
    | 'gym'
    | 'half-cookie'
    | 'half-moon'
    | 'hand-brake'
    | 'handbag'
    | 'hard-drive'
    | 'hat'
    | 'hd'
    | 'hd-display'
    | 'hdr'
    | 'headset'
    | 'headset-charge'
    | 'headset-help'
    | 'headset-issue'
    | 'health-shield'
    | 'healthcare'
    | 'heart'
    | 'heavy-rain'
    | 'heptagon'
    | 'her-slips'
    | 'hesa-warning-outline'
    | 'hexagon'
    | 'hexagon-alt'
    | 'high-priority'
    | 'historic-shield'
    | 'historic-shield-alt'
    | 'home'
    | 'home-alt'
    | 'home-alt-slim'
    | 'home-alt-slim-horiz'
    | 'home-hospital'
    | 'home-simple'
    | 'home-simple-door'
    | 'home-user'
    | 'horiz-distribution-left'
    | 'horiz-distribution-right'
    | 'hospital'
    | 'hospital-sign'
    | 'hourglass'
    | 'html5'
    | 'hydrogen'
    | 'iconoir'
    | 'import'
    | 'industry'
    | 'info-empty'
    | 'input-field'
    | 'input-search'
    | 'instagram'
    | 'intersect'
    | 'intersect-alt'
    | 'ios-settings'
    | 'iris-scan'
    | 'italic'
    | 'italic-square-outline'
    | 'journal'
    | 'journal-page'
    | 'key-alt'
    | 'key-alt-back'
    | 'key-alt-minus'
    | 'key-alt-plus'
    | 'key-alt-remove'
    | 'keyframe'
    | 'keyframe-align-center'
    | 'keyframe-align-horizontal'
    | 'keyframe-align-horizontal-1'
    | 'keyframe-position'
    | 'keyframes'
    | 'keyframes-couple'
    | 'label-outline'
    | 'lamp'
    | 'language'
    | 'laptop'
    | 'laptop-charging'
    | 'laptop-fix'
    | 'laptop-issue'
    | 'large-suitcase'
    | 'layout-left'
    | 'layout-right'
    | 'leaderboard'
    | 'leaderboard-star'
    | 'left-round-arrow'
    | 'lens'
    | 'lifebelt'
    | 'light-bulb'
    | 'light-bulb-off'
    | 'light-bulb-on'
    | 'line-space'
    | 'linear'
    | 'link'
    | 'linkedin'
    | 'linux'
    | 'list'
    | 'load-action-floppy'
    | 'lock'
    | 'lock-key'
    | 'locked-book'
    | 'log-denied'
    | 'log-in'
    | 'log-out'
    | 'long-arrow-down-left'
    | 'long-arrow-down-right'
    | 'long-arrow-left-down'
    | 'long-arrow-left-up'
    | 'long-arrow-right-down'
    | 'long-arrow-right-up'
    | 'long-arrow-right-up-1'
    | 'long-arrow-up-left'
    | 'long-arrow-up-right'
    | 'lot-of-cash'
    | 'mac-control-key'
    | 'mac-dock'
    | 'mac-option-key'
    | 'mac-os-window'
    | 'magnet'
    | 'magnet-energy'
    | 'mail'
    | 'mail-opened'
    | 'male'
    | 'map'
    | 'map-issue'
    | 'maps-arrow'
    | 'maps-arrow-diagonal'
    | 'maps-arrow-issue'
    | 'maps-go-straight'
    | 'maps-turn-back'
    | 'maps-turn-left'
    | 'maps-turn-right'
    | 'mask-square'
    | 'math-book'
    | 'maximize'
    | 'medal'
    | 'media-image'
    | 'media-image-folder'
    | 'media-image-list'
    | 'media-video'
    | 'media-video-folder'
    | 'media-video-list'
    | 'medium'
    | 'megaphone'
    | 'menu'
    | 'menu-scale'
    | 'message'
    | 'message-alert'
    | 'message-text'
    | 'metro'
    | 'mic'
    | 'mic-add'
    | 'mic-check'
    | 'mic-mute'
    | 'mic-remove'
    | 'mic-speaking'
    | 'mic-warning'
    | 'minus'
    | 'minus-1'
    | 'minus-hexagon'
    | 'minus-pin-alt'
    | 'minus-square'
    | 'missing-font'
    | 'modern-tv'
    | 'modern-tv-4k'
    | 'money-square'
    | 'moon-sat'
    | 'more-horiz'
    | 'more-horiz-circled-outline'
    | 'more-vert'
    | 'more-vert-circled-outline'
    | 'mouse-button-left'
    | 'mouse-button-right'
    | 'mouse-scroll-wheel'
    | 'move-down'
    | 'move-left'
    | 'move-right'
    | 'move-ruler'
    | 'move-up'
    | 'movie'
    | 'multi-bubble'
    | 'multi-mac-os-window'
    | 'multi-window'
    | 'multiple-pages'
    | 'multiple-pages-add'
    | 'multiple-pages-delete'
    | 'multiple-pages-empty'
    | 'multiple-pages-remove'
    | 'music-1'
    | 'music-1-add'
    | 'music-2'
    | 'music-2-add'
    | 'nav-arrow-down'
    | 'nav-arrow-left'
    | 'nav-arrow-right'
    | 'nav-arrow-up'
    | 'navigator'
    | 'navigator-alt'
    | 'network'
    | 'network-alt'
    | 'network-left'
    | 'network-right'
    | 'nitrogen'
    | 'no-battery'
    | 'no-coin'
    | 'no-credit-card'
    | 'no-lock'
    | 'no-smoking'
    | 'notes'
    | 'numbered-list-left'
    | 'numbered-list-right'
    | 'octagon'
    | 'off-rounded'
    | 'oil-industry'
    | 'on-rounded'
    | 'one-finger-select-hand-gesture'
    | 'open-in-browser'
    | 'open-in-window'
    | 'open-select-hand-gesture'
    | 'open-vpn'
    | 'orange-half'
    | 'orange-slice'
    | 'orange-slice-alt'
    | 'oxygen'
    | 'page'
    | 'page-edit'
    | 'page-flip'
    | 'page-search'
    | 'page-star'
    | 'palette'
    | 'panorama-enlarge'
    | 'panorama-reduce'
    | 'pants'
    | 'pants-alt'
    | 'parking'
    | 'password-cursor'
    | 'password-error'
    | 'password-pass'
    | 'pause-outline'
    | 'pc-mouse'
    | 'pen-connect-bluetooth'
    | 'pen-connect-wifi'
    | 'pen-tablet'
    | 'pen-tablet-connect-usb'
    | 'pen-tablet-connect-wifi'
    | 'pentagon'
    | 'people-rounded'
    | 'percentage'
    | 'percentage-round'
    | 'percentage-square'
    | 'pharmacy-circled-cross'
    | 'pharmacy-squared-cross'
    | 'phone'
    | 'phone-add'
    | 'phone-delete'
    | 'phone-disabled'
    | 'phone-income'
    | 'phone-outcome'
    | 'phone-paused'
    | 'phone-remove'
    | 'piggy-bank'
    | 'pin'
    | 'pin-alt'
    | 'pizza-slice'
    | 'planet'
    | 'planet-alt'
    | 'planet-sat'
    | 'play-outline'
    | 'playlist'
    | 'playlist-add'
    | 'playlist-play'
    | 'plug-type-a'
    | 'plug-type-c'
    | 'plug-type-g'
    | 'plug-type-l'
    | 'plus'
    | 'pocket'
    | 'position'
    | 'position-align'
    | 'pound'
    | 'precision-tool'
    | 'printer'
    | 'printer-alt'
    | 'printing-page'
    | 'priority-down'
    | 'priority-up'
    | 'profile-circled'
    | 'prohibition'
    | 'qr-code'
    | 'question-mark'
    | 'question-mark-circle'
    | 'question-square-outline'
    | 'rain'
    | 'receive-dollars'
    | 'receive-euros'
    | 'receive-pounds'
    | 'receive-yens'
    | 'redo'
    | 'redo-action'
    | 'redo-circle'
    | 'reduce'
    | 'reduce-round-arrow'
    | 'refresh'
    | 'refresh-circular'
    | 'refresh-double'
    | 'reminder-hand-gesture'
    | 'remove-database-script'
    | 'remove-empty'
    | 'remove-folder'
    | 'remove-frame'
    | 'remove-from-cart'
    | 'remove-keyframe'
    | 'remove-keyframe-alt'
    | 'remove-keyframes'
    | 'remove-media-image'
    | 'remove-media-video'
    | 'remove-page'
    | 'remove-pin-alt'
    | 'remove-selection'
    | 'remove-square'
    | 'remove-user'
    | 'repeat'
    | 'repeat-once'
    | 'report-columns'
    | 'reports'
    | 'rewind-outline'
    | 'rhombus'
    | 'right-round-arrow'
    | 'rings'
    | 'rotate-camera-left'
    | 'rotate-camera-right'
    | 'round-flask'
    | 'rss-feed'
    | 'rss-feed-squared'
    | 'ruler'
    | 'ruler-add'
    | 'ruler-combine'
    | 'ruler-remove'
    | 'running'
    | 'safari'
    | 'sandals'
    | 'save-action-floppy'
    | 'save-floppy-disk'
    | 'scale-frame-enlarge'
    | 'scale-frame-reduce'
    | 'scan-qr-code'
    | 'scanning'
    | 'scarf'
    | 'scissor'
    | 'scissor-alt'
    | 'sea-and-sun'
    | 'sea-waves'
    | 'search'
    | 'search-font'
    | 'security-pass'
    | 'selection'
    | 'selective-tool'
    | 'send-dollars'
    | 'send-euros'
    | 'send-pounds'
    | 'send-yens'
    | 'server'
    | 'server-connection'
    | 'settings'
    | 'settings-cloud'
    | 'settings-profiles'
    | 'share-android'
    | 'share-ios'
    | 'shield'
    | 'shield-add'
    | 'shield-alert'
    | 'shield-alt'
    | 'shield-broken'
    | 'shield-check'
    | 'shield-cross'
    | 'shield-download'
    | 'shield-eye'
    | 'shield-loading'
    | 'shield-minus'
    | 'shield-question'
    | 'shield-search'
    | 'shield-upload'
    | 'shop'
    | 'shop-alt'
    | 'shopping-bag'
    | 'shopping-bag-add'
    | 'shopping-bag-alt'
    | 'shopping-bag-arrow-down'
    | 'shopping-bag-arrow-up'
    | 'shopping-bag-check'
    | 'shopping-bag-issue'
    | 'shopping-bag-remove'
    | 'shopping-code'
    | 'shopping-code-check'
    | 'shopping-code-error'
    | 'short-pants'
    | 'short-pants-alt'
    | 'shuffle'
    | 'sidebar-collapse'
    | 'sidebar-expand'
    | 'simple-cart'
    | 'single-tap-gesture'
    | 'skateboard'
    | 'skateboarding'
    | 'skip-next-outline'
    | 'skip-prev-outline'
    | 'small-shop'
    | 'small-shop-alt'
    | 'smartphone-device'
    | 'smoking'
    | 'snapchat'
    | 'snow'
    | 'snow-flake'
    | 'soap'
    | 'soccer-ball'
    | 'sort-down'
    | 'sort-up'
    | 'sound-high'
    | 'sound-low'
    | 'sound-min'
    | 'sound-off'
    | 'spock-hand-gesture'
    | 'square'
    | 'star-dashed'
    | 'star-half-dashed'
    | 'star-outline'
    | 'stat-down'
    | 'stat-up'
    | 'stats-report'
    | 'stats-square-down'
    | 'stats-square-up'
    | 'stretching'
    | 'stroller'
    | 'style-border'
    | 'substract'
    | 'suggestion'
    | 'sun-light'
    | 'swimming'
    | 'swipe-down-gesture'
    | 'swipe-left-gesture'
    | 'swipe-right-gesture'
    | 'swipe-two-fingers-down-gesture'
    | 'swipe-two-fingers-left-gesture'
    | 'swipe-two-fingers-right-gesture'
    | 'swipe-two-fingers-up-gesture'
    | 'swipe-up-gesture'
    | 'switch-off-outline'
    | 'switch-on-outline'
    | 'system-restart'
    | 'system-shut'
    | 'table'
    | 'table-2-columns'
    | 'table-rows'
    | 'task-list'
    | 'telegram'
    | 'telegram-circled'
    | 'tennis-ball'
    | 'tennis-ball-alt'
    | 'terminal-outline'
    | 'terminal-simple'
    | 'test-tube'
    | 'text'
    | 'text-alt'
    | 'text-size'
    | 'three-stars'
    | 'thunderstorm'
    | 'tiktok'
    | 'timer'
    | 'timer-off'
    | 'tower'
    | 'tower-check'
    | 'tower-no-access'
    | 'tower-warning'
    | 'trademark'
    | 'train-outline'
    | 'tram'
    | 'transition-bottom'
    | 'transition-left'
    | 'transition-right'
    | 'transition-top'
    | 'translate'
    | 'trash'
    | 'treadmill'
    | 'trekking'
    | 'trello'
    | 'triangle'
    | 'triangle-flag'
    | 'triangle-flag-circle'
    | 'triangle-flag-full'
    | 'trophy'
    | 'tunnel'
    | 'tv'
    | 'tv-fix'
    | 'tv-issue'
    | 'twitter'
    | 'twitter-verified-badge'
    | 'type'
    | 'umbrella-full'
    | 'underline'
    | 'underline-square-outline'
    | 'undo'
    | 'undo-action'
    | 'undo-circle'
    | 'union'
    | 'union-alt'
    | 'union-horiz-alt'
    | 'unity'
    | 'unity-5'
    | 'up-round-arrow'
    | 'upload'
    | 'upload-square-outline'
    | 'usb'
    | 'user'
    | 'user-bag'
    | 'user-cart'
    | 'user-circle-alt'
    | 'user-scan'
    | 'user-square-alt'
    | 'verified-badge'
    | 'verified-user'
    | 'video-camera'
    | 'video-camera-off'
    | 'view-columns-2'
    | 'view-columns-3'
    | 'view-grid'
    | 'view-structure-down'
    | 'view-structure-up'
    | 'voice'
    | 'voice-circled'
    | 'voice-circled-lock'
    | 'voice-error'
    | 'voice-ok'
    | 'voice-phone'
    | 'voice-scan'
    | 'voice-squared'
    | 'vr-symbol'
    | 'waist'
    | 'walking'
    | 'wallet'
    | 'warning-circled-outline'
    | 'warning-square-outline'
    | 'warning-triangle-outline'
    | 'web-window'
    | 'web-window-close'
    | 'web-window-energy-consumption'
    | 'weight'
    | 'weight-alt'
    | 'white-flag'
    | 'wifi'
    | 'wifi-issue'
    | 'wifi-off'
    | 'wifi-rounded'
    | 'wifi-signal-none'
    | 'wind'
    | 'windows'
    | 'wrap-text'
    | 'wristwatch'
    | 'yen'
    | 'yen-square'
    | 'yoga'
    | 'youtube'
    | 'zoom-in'
    | 'zoom-out'
  iconpark: {
    Datas:
      | 'data-display'
      | 'data-lock'
      | 'data-switching'
      | 'data-user'
      | 'database-alert'
      | 'database-code'
      | 'database-config'
      | 'database-download'
      | 'database-enter'
      | 'database-fail'
      | 'database-first'
      | 'database-forbid'
      | 'database-lock'
      | 'database-network'
      | 'database-network-point'
      | 'database-point'
      | 'database-position'
      | 'database-power'
      | 'database-proportion'
      | 'database-search'
      | 'database-setting'
      | 'database-success'
      | 'database-sync'
      | 'database-time'
    Connect:
      | 'anchor'
      | 'anchor-one'
      | 'anchor-round'
      | 'anchor-squre'
      | 'assembly-line'
      | 'bezier-curve'
      | 'branch-one'
      | 'branch-two'
      | 'bring-to-front-one'
      | 'clue'
      | 'command'
      | 'connect'
      | 'connect-address-one'
      | 'connect-address-two'
      | 'connection'
      | 'connection-point'
      | 'connection-point-two'
      | 'difference-set'
      | 'intersection'
      | 'link-break'
      | 'link-cloud'
      | 'link-cloud-faild'
      | 'link-cloud-sucess'
      | 'link-four'
      | 'link-in'
      | 'link-interrupt'
      | 'link-left'
      | 'link-out'
      | 'link-right'
      | 'link-three'
      | 'minus-the-bottom'
      | 'minus-the-top'
      | 'network-tree'
      | 'relational-graph'
      | 'ring'
      | 'ring-one'
      | 's-turn-down'
      | 's-turn-left'
      | 's-turn-right'
      | 's-turn-up'
      | 'send-to-back'
      | 'share-one'
      | 'split-turn-down-left'
      | 'split-turn-down-right'
      | 'sum'
      | 'tree-diagram'
      | 'u-turn-down'
      | 'u-turn-left'
      | 'u-turn-right'
      | 'u-turn-up'
      | 'whole-site-accelerator'
    Communicate:
      | 'comment'
      | 'comment-one'
      | 'comments'
      | 'communication'
      | 'message'
      | 'message-emoji'
      | 'message-failed'
      | 'message-one'
      | 'message-privacy'
      | 'message-search'
      | 'message-security'
      | 'message-sent'
      | 'message-success'
      | 'message-unread'
      | 'online-meeting'
      | 'tips-one'
      | 'topic'
      | 'topic-discussion'
    Clothes:
      | 'a-cane'
      | 'bachelor-cap'
      | 'backpack'
      | 'baseball-cap'
      | 'basketball-clothes'
      | 'belt'
      | 'boots'
      | 'bow'
      | 'briefcase'
      | 'chef-hat'
      | 'children-cap'
      | 'clothes-briefs'
      | 'clothes-cardigan'
      | 'clothes-crew-neck'
      | 'clothes-diapers'
      | 'clothes-gloves'
      | 'clothes-gloves-two'
      | 'clothes-hoodie'
      | 'clothes-pants'
      | 'clothes-pants-short'
      | 'clothes-pants-sweat'
      | 'clothes-short-sleeve'
      | 'clothes-skates'
      | 'clothes-suit'
      | 'clothes-sweater'
      | 'clothes-turtleneck'
      | 'clothes-windbreaker'
      | 'coat-hanger'
      | 'commuter-bag'
      | 'crown-three'
      | 'diamond-necklace'
      | 'diamond-ring'
      | 'diamonds'
      | 'diapers-one'
      | 'full-dress-longuette'
      | 'glasses-one'
      | 'handbag'
      | 'hanfu-chinese-style'
      | 'hanger-one'
      | 'hat'
      | 'headwear'
      | 'high-heeled-shoes'
      | 'holy-sword'
      | 'magic-hat'
      | 'men-jacket'
      | 'necktie'
      | 'panties'
      | 'perfume'
      | 'retro-bag'
      | 'short-skirt'
      | 'shorts'
      | 'skates'
      | 'slippers'
      | 'slippers-one'
      | 'socks'
      | 'sorcerer-hat'
      | 'straw-hat'
      | 'sun-hat'
      | 'sweater'
      | 'swimsuit'
      | 't-shirt'
      | 'the-single-shoulder-bag'
      | 'trousers-bell-bottoms'
      | 'trunk'
      | 'vest'
      | 'women-coat'
      | 'woolen-hat'
    Child:
      | 'baby-app'
      | 'baby-car-seat'
      | 'baby-feet'
      | 'baby-meal'
      | 'baby-mobile'
      | 'baby-one'
      | 'baby-pants'
      | 'baby-sling'
      | 'baby-taste'
      | 'bib'
      | 'booster-car-seat'
      | 'boy'
      | 'boy-one'
      | 'boy-stroller'
      | 'boy-two'
      | 'breast-pump'
      | 'chair'
      | 'chair-one'
      | 'child-with-pacifier'
      | 'children-pyramid'
      | 'crib'
      | 'crying-baby'
      | 'family'
      | 'float'
      | 'girl'
      | 'girl-one'
      | 'girl-two'
      | 'heart-ballon'
      | 'holding-hands'
      | 'onesies'
      | 'pacifier'
      | 'paper-ship'
      | 'parenting-book'
      | 'party-balloon'
      | 'pokeball-one'
      | 'powder'
      | 'preschool'
      | 'radio-nanny'
      | 'rattle'
      | 'rattle-one'
      | 'rocking-horse'
      | 'romper'
      | 'sippy-cup'
      | 'sleep-one'
      | 'steoller'
      | 'tire-swing'
    Charts:
      | 'activity-source'
      | 'analysis'
      | 'area-map'
      | 'arithmetic'
      | 'arithmetic-one'
      | 'average'
      | 'broadcast-one'
      | 'bubble-chart'
      | 'bullet-map'
      | 'change-date-sort'
      | 'chart-graph'
      | 'chart-histogram'
      | 'chart-histogram-one'
      | 'chart-histogram-two'
      | 'chart-line'
      | 'chart-line-area'
      | 'chart-pie'
      | 'chart-proportion'
      | 'chart-ring'
      | 'chart-scatter'
      | 'chart-stock'
      | 'creation-date-sort'
      | 'data'
      | 'data-all'
      | 'data-arrival'
      | 'data-four'
      | 'data-null'
      | 'data-one'
      | 'data-screen'
      | 'data-sheet'
      | 'data-three'
      | 'data-two'
      | 'deadline-sort'
      | 'end-time-sort'
      | 'follow-up-date-sort'
      | 'form'
      | 'histogram'
      | 'kagi-map'
      | 'maslow-pyramids'
      | 'material-three'
      | 'maximum'
      | 'min'
      | 'multicast'
      | 'negative-dynamics'
      | 'pie'
      | 'pie-five'
      | 'pie-four'
      | 'pie-one'
      | 'pie-seven'
      | 'pie-six'
      | 'pie-three'
      | 'pie-two'
      | 'pivot-table'
      | 'positive-dynamics'
      | 'recent-views-sort'
      | 'start-time-sort'
      | 'timeline'
      | 'unicast'
      | 'vertical-timeline'
      | 'viencharts'
    Character:
      | 'ad'
      | 'add'
      | 'add-one'
      | 'at-sign'
      | 'attention'
      | 'big-x'
      | 'bitcoin'
      | 'ce-marking'
      | 'check'
      | 'check-one'
      | 'check-small'
      | 'close'
      | 'close-one'
      | 'close-small'
      | 'copyright'
      | 'correct'
      | 'division'
      | 'error'
      | 'font-size-two'
      | 'forbid'
      | 'help'
      | 'info'
      | 'minus'
      | 'more-three'
      | 'percentage'
      | 'plus'
      | 'plus-cross'
      | 'reduce'
      | 'reduce-one'
      | 'symbol'
      | 'trademark'
      | 'vip'
    Build:
      | 'application'
      | 'arc-de-triomphe'
      | 'booth'
      | 'brdige-three'
      | 'bridge-one'
      | 'bridge-two'
      | 'building-four'
      | 'building-one'
      | 'building-three'
      | 'building-two'
      | 'castle'
      | 'chimney'
      | 'chinese-pavilion'
      | 'church-one'
      | 'church-two'
      | 'circle-house'
      | 'circus'
      | 'city'
      | 'city-gate'
      | 'city-one'
      | 'clock-tower'
      | 'death-star'
      | 'dome'
      | 'dubai'
      | 'eiffel-tower'
      | 'elevator'
      | 'escalators'
      | 'factory-building'
      | 'fence-one'
      | 'fence-two'
      | 'ferris-wheel'
      | 'future-build-one'
      | 'future-build-three'
      | 'future-build-two'
      | 'garage'
      | 'gate'
      | 'great-wall'
      | 'green-house'
      | 'home-two'
      | 'hospital-two'
      | 'hotel'
      | 'light-house'
      | 'maya'
      | 'monument-one'
      | 'monument-two'
      | 'museum-one'
      | 'museum-two'
      | 'nuclear-plant'
      | 'open-door'
      | 'pagoda'
      | 'palace'
      | 'pearl-of-the-orient'
      | 'phone-booth'
      | 'prison'
      | 'pull-door'
      | 'push-door'
      | 'pyramid'
      | 'school'
      | 'security-stall'
      | 'shop'
      | 'shopping-mall'
      | 'signal-tower-one'
      | 'space-colony'
      | 'taj-mahal'
      | 'tower'
      | 'tower-of-babel'
      | 'tower-of-pisa'
      | 'up-and-down'
      | 'windmill-one'
      | 'xiaodu-home'
    Brand:
      | 'adobe-illustrate'
      | 'adobe-indesign'
      | 'adobe-lightroom'
      | 'adobe-photoshop'
      | 'alipay'
      | 'android'
      | 'app-store'
      | 'apple'
      | 'behance'
      | 'browser-chrome'
      | 'browser-safari'
      | 'bydesign'
      | 'bytedance'
      | 'cc'
      | 'customer'
      | 'dianziqian'
      | 'dongchedi'
      | 'dribble'
      | 'dropbox'
      | 'facebook'
      | 'facebook-one'
      | 'facetime'
      | 'faceu'
      | 'fanqiexiaoshuo'
      | 'feelgood'
      | 'feelgood-one'
      | 'feiyu'
      | 'figma'
      | 'foursquare'
      | 'friends-circle'
      | 'github'
      | 'github-one'
      | 'gitlab'
      | 'google'
      | 'google-ads'
      | 'health'
      | 'html-five'
      | 'huoshanzhibo'
      | 'instagram'
      | 'instagram-one'
      | 'jinritoutiao'
      | 'lark'
      | 'lark-one'
      | 'lincoln'
      | 'maill-one'
      | 'market'
      | 'mediaeditor'
      | 'messages'
      | 'messages-one'
      | 'mitsubishi'
      | 'oceanengine'
      | 'orange-station'
      | 'pangle'
      | 'paypal'
      | 'phone-two'
      | 'qingniao-clue'
      | 'qiyehao'
      | 'renault'
      | 'sketch'
      | 'star-one'
      | 'taobao'
      | 'telegram'
      | 'tencent-qq'
      | 'tiktok'
      | 'topbuzz'
      | 'tuchong'
      | 'tumblr'
      | 'twitter'
      | 'ulikecam'
      | 'vigo'
      | 'volkswagen'
      | 'wechat'
      | 'weibo'
      | 'windows'
      | 'xigua'
      | 'xingfuli'
      | 'xingtu'
      | 'youtobe'
      | 'youtube'
      | 'zijinyunying'
    Books:
      | 'book'
      | 'book-one'
      | 'book-open'
      | 'bookshelf'
      | 'clipboard'
      | 'doc-add'
      | 'doc-detail'
      | 'doc-fail'
      | 'doc-search'
      | 'doc-search-two'
      | 'doc-success'
      | 'envelope'
      | 'folder-block'
      | 'folder-block-one'
      | 'folder-close'
      | 'folder-code'
      | 'folder-code-one'
      | 'folder-conversion'
      | 'folder-conversion-one'
      | 'folder-download'
      | 'folder-failed'
      | 'folder-failed-one'
      | 'folder-focus'
      | 'folder-focus-one'
      | 'folder-lock'
      | 'folder-lock-one'
      | 'folder-minus'
      | 'folder-music'
      | 'folder-music-one'
      | 'folder-open'
      | 'folder-plus'
      | 'folder-protection'
      | 'folder-protection-one'
      | 'folder-quality'
      | 'folder-quality-one'
      | 'folder-search'
      | 'folder-search-one'
      | 'folder-settings'
      | 'folder-settings-one'
      | 'folder-success'
      | 'folder-success-one'
      | 'folder-upload'
      | 'folder-withdrawal'
      | 'folder-withdrawal-one'
      | 'inbox-download-r'
      | 'inbox-r'
      | 'inbox-success-r'
      | 'inbox-upload-r'
      | 'log'
      | 'mail-download'
      | 'newspaper-folding'
      | 'notebook'
      | 'notebook-and-pen'
      | 'notebook-one'
      | 'notepad'
      | 'notes'
      | 'order'
      | 'seo-folder'
      | 'table'
      | 'view-list'
    Base:
      | 'accept-email'
      | 'aiming'
      | 'airplay'
      | 'alarm'
      | 'api'
      | 'balance-two'
      | 'bill'
      | 'bluetooth'
      | 'bookmark'
      | 'bookmark-one'
      | 'box'
      | 'broadcast'
      | 'broadcast-radio'
      | 'browser'
      | 'bug'
      | 'camera'
      | 'carousel-video'
      | 'caution'
      | 'clear'
      | 'click-tap'
      | 'color-card'
      | 'compass'
      | 'config'
      | 'consume'
      | 'coupon'
      | 'cuvette'
      | 'delete'
      | 'delete-one'
      | 'delete-two'
      | 'devices'
      | 'dislike'
      | 'dislike-two'
      | 'document-folder'
      | 'drone'
      | 'electrocardiogram'
      | 'email-block'
      | 'email-delect'
      | 'email-down'
      | 'email-fail'
      | 'email-lock'
      | 'email-push'
      | 'email-search'
      | 'email-security'
      | 'email-successfully'
      | 'endless'
      | 'envelope-one'
      | 'equalizer'
      | 'expand-down'
      | 'expand-left'
      | 'expand-right'
      | 'expand-up'
      | 'experiment'
      | 'experiment-one'
      | 'female'
      | 'filter'
      | 'fire-extinguisher'
      | 'flashlight'
      | 'folder'
      | 'game-ps'
      | 'gift'
      | 'gift-box'
      | 'glasses'
      | 'hamburger-button'
      | 'harm'
      | 'home'
      | 'imbalance'
      | 'inbox'
      | 'inbox-in'
      | 'inbox-out'
      | 'inbox-success'
      | 'inspection'
      | 'key'
      | 'laptop'
      | 'lightning'
      | 'like'
      | 'link'
      | 'loading'
      | 'loading-four'
      | 'loading-three'
      | 'lock'
      | 'mail'
      | 'mail-edit'
      | 'mail-open'
      | 'mail-package'
      | 'mail-review'
      | 'mail-unpacking'
      | 'male'
      | 'map-distance'
      | 'micro-slr-camera'
      | 'mirror-one'
      | 'monitor'
      | 'monitor-off'
      | 'mouse'
      | 'movie'
      | 'page'
      | 'parachute'
      | 'parking'
      | 'pause'
      | 'pause-one'
      | 'phone-call'
      | 'phone-incoming'
      | 'phone-incoming-one'
      | 'phone-missed'
      | 'phone-off'
      | 'phone-outgoing'
      | 'phone-outgoing-one'
      | 'phone-telephone'
      | 'phone-video-call'
      | 'pic'
      | 'platte'
      | 'play'
      | 'play-one'
      | 'playback-progress'
      | 'pound'
      | 'preview-close'
      | 'preview-close-one'
      | 'preview-open'
      | 'projector'
      | 'protect'
      | 'protection'
      | 'puzzle'
      | 'radar'
      | 'radiation'
      | 'red-cross'
      | 'refresh'
      | 'report'
      | 'road-sign-both'
      | 'rocket'
      | 'round-socket'
      | 'rss'
      | 'ruler'
      | 'ruler-one'
      | 'save'
      | 'save-one'
      | 'scan'
      | 'scan-code'
      | 'screenshot'
      | 'search'
      | 'send-email'
      | 'setting'
      | 'setting-config'
      | 'setting-one'
      | 'setting-three'
      | 'setting-two'
      | 'share'
      | 'shield'
      | 'shield-add'
      | 'shopping-bag'
      | 'shopping-cart-one'
      | 'sleep'
      | 'slide'
      | 'stopwatch-start'
      | 'success'
      | 'table-lamp'
      | 'tag'
      | 'tag-one'
      | 'telescope'
      | 'terminal'
      | 'test-tube'
      | 'timed-mail'
      | 'tips'
      | 'tool'
      | 'triangle-ruler'
      | 'trophy'
      | 'turn-off-bluetooth'
      | 'umbrella'
      | 'umbrella-one'
      | 'umbrella-two'
      | 'unlike'
      | 'unlock'
      | 'video'
      | 'view-grid-card'
      | 'view-grid-detail'
      | 'view-grid-list'
      | 'voice-message'
      | 'waterfalls-h'
      | 'waterfalls-v'
      | 'windmill'
      | 'zoom-in'
      | 'zoom-out'
    Arrows:
      | 'arrow-circle-down'
      | 'arrow-circle-left'
      | 'arrow-circle-right'
      | 'arrow-circle-up'
      | 'arrow-down'
      | 'arrow-left'
      | 'arrow-left-down'
      | 'arrow-left-up'
      | 'arrow-right'
      | 'arrow-right-down'
      | 'arrow-right-up'
      | 'arrow-up'
      | 'change'
      | 'circle-double-down'
      | 'circle-double-left'
      | 'circle-double-right'
      | 'circle-double-up'
      | 'circle-left-down'
      | 'circle-left-up'
      | 'circle-right-down'
      | 'circle-right-up'
      | 'click-to-fold'
      | 'collapse-text-input'
      | 'connection-arrow'
      | 'corner-down-left'
      | 'corner-down-right'
      | 'corner-left-down'
      | 'corner-left-up'
      | 'corner-right-down'
      | 'corner-right-up'
      | 'corner-up-left'
      | 'corner-up-right'
      | 'cycle'
      | 'cycle-movement'
      | 'double-down'
      | 'double-left'
      | 'double-right'
      | 'double-up'
      | 'down'
      | 'down-c'
      | 'down-one'
      | 'down-small'
      | 'down-square'
      | 'down-two'
      | 'download'
      | 'download-one'
      | 'download-three'
      | 'download-two'
      | 'expand-down-one'
      | 'expand-text-input'
      | 'figma-flatten-selection'
      | 'fold-up-one'
      | 'full-screen-one'
      | 'full-screen-two'
      | 'go-end'
      | 'go-start'
      | 'incoming'
      | 'install'
      | 'left'
      | 'left-c'
      | 'left-one'
      | 'left-small'
      | 'left-small-down'
      | 'left-small-up'
      | 'left-square'
      | 'left-two'
      | 'login'
      | 'logout'
      | 'loop-once'
      | 'menu-fold'
      | 'menu-fold-one'
      | 'menu-unfold'
      | 'menu-unfold-one'
      | 'move-in'
      | 'off-screen-one'
      | 'off-screen-two'
      | 'outgoing'
      | 'play-cycle'
      | 'play-once'
      | 'recycling'
      | 'recycling-pool'
      | 'redo'
      | 'reject'
      | 'right'
      | 'right-c'
      | 'right-one'
      | 'right-small'
      | 'right-small-down'
      | 'right-small-up'
      | 'right-square'
      | 'right-two'
      | 'rotate'
      | 'rotation-horizontal'
      | 'rotation-vertical'
      | 'send'
      | 'send-one'
      | 'shuffle'
      | 'shuffle-one'
      | 'sort'
      | 'sort-four'
      | 'sort-one'
      | 'sort-three'
      | 'sort-two'
      | 'switch'
      | 'to-bottom'
      | 'to-bottom-one'
      | 'to-left'
      | 'to-right'
      | 'to-top'
      | 'to-top-one'
      | 'transfer-data'
      | 'trending-down'
      | 'trending-up'
      | 'undo'
      | 'up'
      | 'up-c'
      | 'up-one'
      | 'up-small'
      | 'up-square'
      | 'up-two'
      | 'upload'
      | 'upload-one'
      | 'upload-three'
      | 'upload-two'
    Abstract:
      | 'ad-product'
      | 'api-app'
      | 'app-switch'
      | 'application-one'
      | 'association'
      | 'asterisk'
      | 'badge'
      | 'benz'
      | 'blocks-and-arrows'
      | 'category-management'
      | 'circle-five-line'
      | 'circle-four'
      | 'circle-four-line'
      | 'circle-three'
      | 'circle-two-line'
      | 'circles-and-triangles'
      | 'circles-seven'
      | 'circular-connection'
      | 'cone'
      | 'cones'
      | 'converging-gateway'
      | 'coordinate-system'
      | 'cross-ring-two'
      | 'crown-two'
      | 'cube'
      | 'cube-five'
      | 'cube-four'
      | 'cube-three'
      | 'cube-two'
      | 'cycle-arrow'
      | 'cycle-one'
      | 'cylinder'
      | 'display'
      | 'error-prompt'
      | 'exclusive-gateway'
      | 'export'
      | 'external-transmission'
      | 'figma-component'
      | 'figma-reset-instance'
      | 'five-ellipses'
      | 'four-arrows'
      | 'four-leaves'
      | 'four-point-connection'
      | 'four-round-point-connection'
      | 'game-emoji'
      | 'geometric-flowers'
      | 'graphic-design'
      | 'graphic-design-two'
      | 'graphic-stitching'
      | 'graphic-stitching-four'
      | 'graphic-stitching-three'
      | 'halo'
      | 'hexagon-strip'
      | 'hexagonal'
      | 'inclusive-gateway'
      | 'internal-data'
      | 'internal-transmission'
      | 'keyline'
      | 'misaligned-semicircle'
      | 'multi-circular'
      | 'multi-rectangle'
      | 'multi-ring'
      | 'multi-triangular'
      | 'multi-triangular-four'
      | 'multi-triangular-three'
      | 'multi-triangular-two'
      | 'multilayer-sphere'
      | 'nested-arrows'
      | 'nine-points-connected'
      | 'one-third-rotation'
      | 'open-one'
      | 'outbound'
      | 'oval-love'
      | 'oval-love-two'
      | 'parallel-gateway'
      | 'process-line'
      | 'quadrangular-pyramid'
      | 'rectangle-tear'
      | 'rectangle-x'
      | 'rectangular-circular-connection'
      | 'rectangular-circular-separation'
      | 'rectangular-vertebra'
      | 'refraction'
      | 'reverse-operation-in'
      | 'reverse-operation-out'
      | 'right-run'
      | 'round-caliper'
      | 'round-distortion'
      | 'round-mask'
      | 'run-left'
      | 'sales-report'
      | 'seo'
      | 'six-circular-connection'
      | 'six-points'
      | 'smart-optimization'
      | 'sphere'
      | 'split-branch'
      | 'stereo-nesting'
      | 'stereo-perspective'
      | 'switch-contrast'
      | 'symbol-double-x'
      | 'symmetry'
      | 'sync'
      | 'table-report'
      | 'texture'
      | 'texture-two'
      | 'three-hexagons'
      | 'three-slashes'
      | 'three-triangles'
      | 'treasure-chest'
      | 'triangle-round-rectangle'
      | 'triangular-pyramid'
      | 'two-ellipses'
      | 'two-semicircles'
      | 'two-triangles'
      | 'two-triangles-two'
      | 'update-rotation'
      | 'warehousing'
      | 'whirlwind'
    Edit:
      | 'add-four'
      | 'add-item'
      | 'add-subset'
      | 'add-text'
      | 'add-text-two'
      | 'add-three'
      | 'adjacent-item'
      | 'adjustment'
      | 'afferent'
      | 'afferent-two'
      | 'align-bottom'
      | 'align-bottom-two'
      | 'align-horizontal-center-two'
      | 'align-horizontally'
      | 'align-left'
      | 'align-left-one'
      | 'align-left-two'
      | 'align-right'
      | 'align-right-one'
      | 'align-right-two'
      | 'align-text-both'
      | 'align-text-both-one'
      | 'align-text-bottom'
      | 'align-text-bottom-one'
      | 'align-text-center'
      | 'align-text-center-one'
      | 'align-text-left'
      | 'align-text-left-one'
      | 'align-text-middle'
      | 'align-text-middle-one'
      | 'align-text-right'
      | 'align-text-right-one'
      | 'align-text-top'
      | 'align-text-top-one'
      | 'align-top'
      | 'align-top-two'
      | 'align-vertical-center-two'
      | 'align-vertically'
      | 'alignment-bottom-center'
      | 'alignment-bottom-left'
      | 'alignment-bottom-right'
      | 'alignment-horizontal-bottom'
      | 'alignment-horizontal-center'
      | 'alignment-horizontal-top'
      | 'alignment-left-bottom'
      | 'alignment-left-center'
      | 'alignment-left-top'
      | 'alignment-right-bottom'
      | 'alignment-right-center'
      | 'alignment-right-top'
      | 'alignment-top-center'
      | 'alignment-top-left'
      | 'alignment-top-right'
      | 'alignment-vertical-center'
      | 'alignment-vertical-left'
      | 'alignment-vertical-right'
      | 'alphabetical-sorting'
      | 'alphabetical-sorting-two'
      | 'application-two'
      | 'auto-focus'
      | 'auto-height-one'
      | 'auto-line-height'
      | 'auto-line-width'
      | 'auto-width'
      | 'auto-width-one'
      | 'back'
      | 'background-color'
      | 'block'
      | 'bottom-bar'
      | 'brightness'
      | 'bring-forward'
      | 'bring-to-front'
      | 'calendar'
      | 'center-alignment'
      | 'chart-pie-one'
      | 'check-correct'
      | 'clear-format'
      | 'code'
      | 'code-brackets'
      | 'code-download'
      | 'column'
      | 'components'
      | 'copy'
      | 'copy-link'
      | 'cutting'
      | 'cutting-one'
      | 'deeplink'
      | 'delete-themes'
      | 'delete-three'
      | 'direction'
      | 'direction-adjustment'
      | 'direction-adjustment-three'
      | 'direction-adjustment-two'
      | 'distortion'
      | 'distribute-horizontal-spacing'
      | 'distribute-horizontally'
      | 'distribute-vertical-spacing'
      | 'distribute-vertically'
      | 'dividing-line'
      | 'done-all'
      | 'dot'
      | 'download-four'
      | 'drag'
      | 'drop-down-list'
      | 'drop-shadow-down'
      | 'drop-shadow-left'
      | 'drop-shadow-right'
      | 'drop-shadow-up'
      | 'edit'
      | 'edit-movie'
      | 'edit-one'
      | 'edit-two'
      | 'electric-wave'
      | 'endpoint-displacement'
      | 'endpoint-flat'
      | 'endpoint-round'
      | 'endpoint-square'
      | 'enter-the-keyboard'
      | 'equal-ratio'
      | 'excel-one'
      | 'exclude-selection'
      | 'expand-left-and-right'
      | 'extend'
      | 'file-excel'
      | 'file-gif'
      | 'file-jpg'
      | 'file-pdf'
      | 'file-txt'
      | 'file-word'
      | 'fill'
      | 'filter-one'
      | 'find'
      | 'flashlamp'
      | 'flip-horizontally'
      | 'flip-vertically'
      | 'focus'
      | 'font-size'
      | 'format-brush'
      | 'formula'
      | 'freeze-column'
      | 'freeze-line'
      | 'freezing-line-column'
      | 'full-screen'
      | 'full-selection'
      | 'fullwidth'
      | 'go-on'
      | 'grid-four'
      | 'grid-nine'
      | 'grid-sixteen'
      | 'grid-three'
      | 'grid-two'
      | 'group'
      | 'h'
      | 'h1'
      | 'h2'
      | 'h3'
      | 'helpcenter'
      | 'high-light'
      | 'horizontal-spacing-between-items'
      | 'horizontal-tidy-up'
      | 'horizontally-centered'
      | 'increase-the-scale'
      | 'indent-left'
      | 'indent-right'
      | 'inline'
      | 'inner-shadow-bottom-left'
      | 'inner-shadow-bottom-right'
      | 'inner-shadow-down'
      | 'inner-shadow-left'
      | 'inner-shadow-right'
      | 'inner-shadow-top-left'
      | 'inner-shadow-top-right'
      | 'inner-shadow-up'
      | 'insert-table'
      | 'internal-expansion'
      | 'internal-reduction'
      | 'intersect-selection'
      | 'invert-camera'
      | 'layout-five'
      | 'layout-four'
      | 'layout-one'
      | 'layout-three'
      | 'layout-two'
      | 'left-alignment'
      | 'left-bar'
      | 'left-expand'
      | 'lens-alignment'
      | 'level-adjustment'
      | 'level-eight-title'
      | 'level-five-title'
      | 'level-four-title'
      | 'level-nine-title'
      | 'level-seven-title'
      | 'level-six-title'
      | 'link-one'
      | 'link-two'
      | 'list'
      | 'list-alphabet'
      | 'list-bottom'
      | 'list-checkbox'
      | 'list-fail'
      | 'list-middle'
      | 'list-numbers'
      | 'list-one'
      | 'list-success'
      | 'list-top'
      | 'list-two'
      | 'magic-wand'
      | 'many-to-many'
      | 'margin'
      | 'margin-one'
      | 'mask-two'
      | 'merge'
      | 'merge-cells'
      | 'mind-mapping'
      | 'mindmap-list'
      | 'mindmap-map'
      | 'modify'
      | 'modify-two'
      | 'more'
      | 'more-four'
      | 'more-one'
      | 'more-two'
      | 'mosaic'
      | 'move-in-one'
      | 'move-one'
      | 'multi-picture-carousel'
      | 'newlybuild'
      | 'next'
      | 'node-flat'
      | 'node-round'
      | 'node-square'
      | 'off-screen'
      | 'one-to-many'
      | 'one-to-one'
      | 'ordered-list'
      | 'overall-reduction'
      | 'paragraph-alphabet'
      | 'paragraph-break'
      | 'paragraph-break-two'
      | 'paragraph-cut'
      | 'paragraph-rectangle'
      | 'paragraph-round'
      | 'paragraph-triangle'
      | 'paragraph-unfold'
      | 'perspective'
      | 'picture-one'
      | 'plan'
      | 'pound-sign'
      | 'powerpoint'
      | 'proportional-scaling'
      | 'quote'
      | 'reduce-decimal-places'
      | 'reduce-two'
      | 'refresh-one'
      | 'repair'
      | 'return'
      | 'right-bar'
      | 'right-expand'
      | 'rotate-one'
      | 'rotation'
      | 'rotation-one'
      | 'row-height'
      | 'scale'
      | 'scanning'
      | 'scanning-two'
      | 'scatter-alignment'
      | 'screenshot-one'
      | 'screenshot-two'
      | 'selected'
      | 'selected-focus'
      | 'send-backward'
      | 'sent-to-back'
      | 'share-three'
      | 'share-two'
      | 'sort-amount-down'
      | 'sort-amount-up'
      | 'split'
      | 'split-cells'
      | 'stamp'
      | 'star'
      | 'stretching'
      | 'strikethrough'
      | 'subtract-selection'
      | 'subtract-selection-one'
      | 'switch-themes'
      | 'switching-done'
      | 'tailoring'
      | 'tailoring-two'
      | 'text'
      | 'text-bold'
      | 'text-italic'
      | 'text-rotation-down'
      | 'text-rotation-left'
      | 'text-rotation-none'
      | 'text-rotation-up'
      | 'text-style'
      | 'text-style-one'
      | 'text-underline'
      | 'text-wrap-overflow'
      | 'text-wrap-truncation'
      | 'title-level'
      | 'top-bar'
      | 'translation'
      | 'two-dimensional-code'
      | 'two-dimensional-code-one'
      | 'two-dimensional-code-two'
      | 'ungroup'
      | 'union-selection'
      | 'unlink'
      | 'unordered-list'
      | 'upload-logs'
      | 'vertical-spacing-between-items'
      | 'vertical-tidy-up'
      | 'vertically-centered'
      | 'video-two'
      | 'word'
      | 'write'
      | 'writing-fluently'
      | 'zip'
    Emoji:
      | 'angry-face'
      | 'anguished-face'
      | 'astonished-face'
      | 'confounded-face'
      | 'confused-face'
      | 'disappointed-face'
      | 'distraught-face'
      | 'dizzy-face'
      | 'emotion-happy'
      | 'emotion-unhappy'
      | 'expressionless-face'
      | 'face-with-smiling-open-eyes'
      | 'face-without-mouth'
      | 'frowning-face-whit-open-mouth'
      | 'grimacing-face'
      | 'grinning-face'
      | 'grinning-face-with-open-mouth'
      | 'grinning-face-with-squinting-eyes'
      | 'grinning-face-with-tightly-closed-eyes'
      | 'grinning-face-with-tightly-closed-eyes-open-mouth'
      | 'loudly-crying-face'
      | 'loudly-crying-face-whit-open-mouth'
      | 'neutral-face'
      | 'pouting-face'
      | 'relieved-face'
      | 'slightly-frowning-face-whit-open-mouth'
      | 'slightly-smiling-face'
      | 'sly-face-whit-smile'
      | 'smiling-face'
      | 'smiling-face-with-squinting-eyes'
      | 'surprised-face-with-open-big-mouth'
      | 'surprised-face-with-open-mouth'
      | 'upside-down-face'
      | 'weary-face'
      | 'winking-face'
      | 'winking-face-with-open-eyes'
      | 'worried-face'
    Foods:
      | 'apple-one'
      | 'avocado'
      | 'avocado-one'
      | 'banana'
      | 'barbecue'
      | 'beer'
      | 'beer-mug'
      | 'birthday-cake'
      | 'bone'
      | 'bottle-one'
      | 'bottle-three'
      | 'bottle-two'
      | 'bowl'
      | 'bowl-one'
      | 'bread'
      | 'bread-machine'
      | 'bread-one'
      | 'cake'
      | 'cake-five'
      | 'cake-four'
      | 'cake-one'
      | 'cake-three'
      | 'cake-two'
      | 'candy'
      | 'canned-fruit'
      | 'carrot'
      | 'chafing-dish'
      | 'chafing-dish-one'
      | 'cheese'
      | 'chef-hat-one'
      | 'cherry'
      | 'chicken'
      | 'chicken-leg'
      | 'chili'
      | 'chopping-board'
      | 'chopsticks-fork'
      | 'cola'
      | 'cook'
      | 'cooking'
      | 'crab'
      | 'croissant'
      | 'cup-four'
      | 'cup-one'
      | 'doughnut'
      | 'drink'
      | 'drumstick'
      | 'egg'
      | 'egg-one'
      | 'eggplant'
      | 'fish'
      | 'fork-spoon'
      | 'french-fries'
      | 'garlic'
      | 'glove'
      | 'goblet'
      | 'goblet-cracking'
      | 'goblet-full'
      | 'goblet-one'
      | 'hamburger'
      | 'hamburger-one'
      | 'honey-one'
      | 'hot-pot'
      | 'hot-pot-one'
      | 'icecream'
      | 'icecream-five'
      | 'icecream-four'
      | 'icecream-one'
      | 'icecream-three'
      | 'icecream-two'
      | 'juice'
      | 'kettle-one'
      | 'kitchen-knife'
      | 'knife-fork'
      | 'lemon'
      | 'liqueur'
      | 'lollipop'
      | 'macadamia-nut'
      | 'measuring-cup'
      | 'milk'
      | 'milk-one'
      | 'noodles'
      | 'nut'
      | 'orange'
      | 'orange-one'
      | 'oven'
      | 'oven-tray'
      | 'painted-eggshell'
      | 'peach'
      | 'pear'
      | 'peas'
      | 'pineapple'
      | 'popcorn'
      | 'popcorn-one'
      | 'pot'
      | 'pumpkin'
      | 'radish'
      | 'radish-one'
      | 'refrigerator'
      | 'rice'
      | 'sandwich'
      | 'sandwich-one'
      | 'scallion'
      | 'shovel'
      | 'shovel-one'
      | 'shrimp'
      | 'soybean-milk-maker'
      | 'spoon'
      | 'tea'
      | 'tea-drink'
      | 'teapot'
      | 'thermos-cup'
      | 'tomato'
      | 'tray'
      | 'turkey'
      | 'vegetable-basket'
      | 'vegetables'
      | 'vicia-faba'
      | 'watermelon'
      | 'watermelon-one'
    Graphics:
      | 'diamond-one'
      | 'diamond-three'
      | 'diamond-two'
      | 'hexagon-one'
      | 'octagon'
      | 'oval-one'
      | 'parallelogram'
      | 'pentagon-one'
      | 'quadrilateral'
      | 'rectangle'
      | 'rectangle-one'
      | 'rectangle-small'
      | 'right-angle'
      | 'round'
      | 'square'
      | 'square-small'
      | 'trapezoid'
      | 'triangle'
    Hands:
      | 'bad'
      | 'bad-one'
      | 'bad-two'
      | 'bless'
      | 'bye'
      | 'clap'
      | 'click-tap-two'
      | 'come'
      | 'concept-sharing'
      | 'cool'
      | 'delivery'
      | 'easy'
      | 'empty'
      | 'fingerprint'
      | 'fingerprint-three'
      | 'fingerprint-two'
      | 'first'
      | 'fist'
      | 'five'
      | 'five-five'
      | 'flirt'
      | 'four'
      | 'four-four'
      | 'good'
      | 'good-one'
      | 'good-two'
      | 'hand-down'
      | 'hand-drag'
      | 'hand-left'
      | 'hand-right'
      | 'hand-up'
      | 'hi'
      | 'hold'
      | 'hold-interface'
      | 'hold-seeds'
      | 'index-finger'
      | 'mayura-gesture'
      | 'middle-finger'
      | 'move'
      | 'okay'
      | 'one'
      | 'one-one'
      | 'open'
      | 'palm'
      | 'point'
      | 'point-out'
      | 'press'
      | 'reload'
      | 'respect'
      | 'rock'
      | 'rock-gesture'
      | 'six'
      | 'spider-man'
      | 'swing'
      | 'three'
      | 'three-three'
      | 'thumbs-down'
      | 'thumbs-up'
      | 'turn-on'
      | 'two'
      | 'two-fingers'
      | 'two-hands'
      | 'two-two'
      | 'yep'
      | 'zoom'
    Hardware:
      | 'air-conditioning'
      | 'asterisk-key'
      | 'battery-working-one'
      | 'bike'
      | 'bolt-one'
      | 'bus'
      | 'calculator'
      | 'calculator-one'
      | 'camera-five'
      | 'camera-four'
      | 'camera-one'
      | 'camera-three'
      | 'camera-two'
      | 'car'
      | 'cd'
      | 'charging-treasure'
      | 'chip'
      | 'cloud-storage'
      | 'computer'
      | 'computer-one'
      | 'control'
      | 'cpu'
      | 'cup'
      | 'dashboard-one'
      | 'delete-key'
      | 'desk-lamp'
      | 'digital-watches'
      | 'disk-one'
      | 'disk-two'
      | 'dome-light'
      | 'drone-one'
      | 'dvi'
      | 'eight-key'
      | 'electric-iron'
      | 'electronic-door-lock'
      | 'electronic-locks-close'
      | 'electronic-locks-open'
      | 'electronic-pen'
      | 'enter-key-one'
      | 'ethernet-off'
      | 'ethernet-on'
      | 'f-eight-key'
      | 'f-five-key'
      | 'f-four-key'
      | 'f-n-key'
      | 'f-nine-key'
      | 'f-one-key'
      | 'f-seven-key'
      | 'f-six-key'
      | 'f-three-key'
      | 'f-two-key'
      | 'f-zero-key'
      | 'five-key'
      | 'four-key'
      | 'game-console'
      | 'game-console-one'
      | 'game-three'
      | 'gopro'
      | 'hair-dryer-one'
      | 'hand-painted-plate'
      | 'hard-disk'
      | 'hard-disk-one'
      | 'hashtag-key'
      | 'hdd'
      | 'hdmi-cable'
      | 'hdmi-connector'
      | 'headset-two'
      | 'hunting-gear'
      | 'i-mac'
      | 'induction-lock'
      | 'intercom'
      | 'ipad'
      | 'ipad-one'
      | 'iphone'
      | 'iwatch-one'
      | 'iwatch-two'
      | 'kettle'
      | 'keyboard'
      | 'keyboard-one'
      | 'lamp'
      | 'laptop-computer'
      | 'master'
      | 'memory'
      | 'memory-card'
      | 'memory-one'
      | 'micro-sd'
      | 'microphone'
      | 'microphone-one'
      | 'microscope-one'
      | 'microwave-oven'
      | 'microwaves'
      | 'mini-sd-card'
      | 'monitor-camera'
      | 'monitor-one'
      | 'mouse-one'
      | 'network-drive'
      | 'nine-key'
      | 'one-key'
      | 'pad'
      | 'painted-screen'
      | 'phone'
      | 'phone-one'
      | 'phonograph'
      | 'plug-one'
      | 'power-supply'
      | 'power-supply-one'
      | 'printer'
      | 'printer-one'
      | 'printer-two'
      | 'projector-one'
      | 'projector-three'
      | 'projector-two'
      | 'radio'
      | 'radio-one'
      | 'record-player'
      | 'remote-control'
      | 'remote-control-one'
      | 'robot'
      | 'robot-one'
      | 'rocket-one'
      | 'router'
      | 'router-one'
      | 'rs-male'
      | 'sd'
      | 'sd-card'
      | 'seal'
      | 'server'
      | 'seven-key'
      | 'shaver'
      | 'signal-tower'
      | 'sim-card'
      | 'six-key'
      | 'slave'
      | 'solar-energy'
      | 'solid-state-disk'
      | 'sound'
      | 'sound-one'
      | 'speaker'
      | 'speaker-one'
      | 'ssd'
      | 'stapler'
      | 'stereo-one'
      | 'storage-card-one'
      | 'storage-card-two'
      | 'subway'
      | 'surveillance-cameras-one'
      | 'switch-nintendo'
      | 'switch-one'
      | 'three-key'
      | 'thunderbolt'
      | 'timer'
      | 'toilet'
      | 'truck'
      | 'trumpet'
      | 'tv'
      | 'tv-one'
      | 'two-key'
      | 'type-drive'
      | 'u-disk'
      | 'usb-memory-stick'
      | 'usb-micro-one'
      | 'usb-micro-two'
      | 'usb-type-c'
      | 'vacuum-cleaner'
      | 'videocamera'
      | 'videocamera-one'
      | 'virtual-reality-glasses'
      | 'vr-glasses'
      | 'washing-machine'
      | 'washing-machine-one'
      | 'watch-one'
      | 'webcam'
      | 'zero-key'
    Health:
      | 'abdominal'
      | 'anti-corrosion'
      | 'bottle'
      | 'brain'
      | 'cardioelectric'
      | 'cell'
      | 'chest'
      | 'composition'
      | 'detection'
      | 'endocrine'
      | 'eyes'
      | 'gastrointestinal'
      | 'general-branch'
      | 'germs'
      | 'heart'
      | 'hospital'
      | 'injection'
      | 'lung'
      | 'mask'
      | 'medical-box'
      | 'medical-files'
      | 'medicine-bottle'
      | 'microscope'
      | 'nasal'
      | 'nests'
      | 'neural'
      | 'nmr'
      | 'nutrition'
      | 'orthopedic'
      | 'other'
      | 'period'
      | 'pesticide'
      | 'pills'
      | 'plastic-surgery'
      | 'pregnant-women'
      | 'prescription'
      | 'pure-natural'
      | 'renal'
      | 'sperm'
      | 'swallow'
      | 'teeth'
      | 'toxins'
      | 'traditional-chinese-medicine'
      | 'uterus'
      | 'weight'
    Industry:
      | 'fire-extinguisher-one'
      | 'hammer-and-anvil'
      | 'heater-resistor'
      | 'helmet-one'
      | 'industrial-scales'
      | 'ladder'
      | 'land-surveying'
      | 'led-diode'
      | 'oil-industry'
      | 'oscillator'
      | 'petrol'
      | 'potentiometer'
      | 'resistor'
      | 'robot-two'
      | 'solar-energy-one'
      | 'stack-light'
      | 'wind-turbine'
      | 'worker'
    Life:
      | 'beach-umbrella'
      | 'bedside'
      | 'bedside-two'
      | 'door-handle'
      | 'double-bed'
      | 'hair-dryer'
      | 'hanger'
      | 'hanger-two'
      | 'hotel-do-not-clean'
      | 'hotel-please-clean'
      | 'iron'
      | 'iron-disable'
      | 'iron-three'
      | 'iron-two'
      | 'shower-head'
      | 'single-bed'
      | 'sofa-two'
    Makeups:
      | 'afro-pick'
      | 'barber-brush'
      | 'barber-clippers'
      | 'beauty-instrument'
      | 'blade'
      | 'comb'
      | 'conditioner'
      | 'cosmetic-brush'
      | 'english-mustache'
      | 'eyebrow'
      | 'face-powder'
      | 'facial-cleanser'
      | 'fingernail'
      | 'foundation-makeup'
      | 'hair-brush'
      | 'hair-clip'
      | 'hand-cream'
      | 'handwashing'
      | 'handwashing-fluid'
      | 'health-products'
      | 'jewelry'
      | 'lip-gloss'
      | 'lip-tattoo'
      | 'lipstick'
      | 'lipstick-one'
      | 'lotion'
      | 'makeups'
      | 'mascara'
      | 'massage-chair'
      | 'massage-chair-one'
      | 'massage-table'
      | 'mirror'
      | 'mirror-two'
      | 'nail-polish'
      | 'nail-polish-one'
      | 'paint'
      | 'perfumer-bottle'
      | 'razor'
      | 'reel'
      | 'scissors'
      | 'shaver-one'
      | 'shaving'
      | 'soap-bubble'
      | 'spa-candle'
      | 'straight-razor'
    Money:
      | 'add-subtract'
      | 'bank'
      | 'bank-card'
      | 'bank-card-one'
      | 'bank-transfer'
      | 'blockchain'
      | 'commodity'
      | 'credit'
      | 'currency'
      | 'deposit'
      | 'discovery-index'
      | 'dollar'
      | 'exchange'
      | 'exchange-four'
      | 'exchange-one'
      | 'exchange-three'
      | 'exchange-two'
      | 'expenses'
      | 'expenses-one'
      | 'finance'
      | 'financing'
      | 'financing-one'
      | 'financing-two'
      | 'flash-payment'
      | 'funds'
      | 'heavy-metal'
      | 'history-query'
      | 'income'
      | 'income-one'
      | 'insert-card'
      | 'ipo'
      | 'mall-bag'
      | 'medication-time'
      | 'open-an-account'
      | 'optional'
      | 'paper-money-two'
      | 'pay-code-one'
      | 'pay-code-two'
      | 'payment-method'
      | 'red-envelope'
      | 'shopping'
      | 'shopping-cart'
      | 'shopping-cart-add'
      | 'shopping-cart-del'
      | 'stock-market'
      | 'swipe'
      | 'transaction'
      | 'transaction-order'
      | 'wallet'
      | 'wallet-one'
      | 'wallet-two'
    Music:
      | 'acoustic'
      | 'add-music'
      | 'airpods'
      | 'bell-ring'
      | 'close-remind'
      | 'collection-records'
      | 'concern'
      | 'entertainment'
      | 'fm'
      | 'headphone-sound'
      | 'headset'
      | 'headset-one'
      | 'list-add'
      | 'monitor-two'
      | 'music'
      | 'music-cd'
      | 'music-list'
      | 'music-menu'
      | 'music-one'
      | 'music-rhythm'
      | 'mute'
      | 'performance'
      | 'piano'
      | 'play-wrong'
      | 'record'
      | 'record-disc'
      | 'remind'
      | 'remind-disable'
      | 'replay-five'
      | 'replay-music'
      | 'signal-strength'
      | 'sound-wave'
      | 'tape'
      | 'voice'
      | 'voice-off'
      | 'voice-one'
      | 'voicemail'
      | 'volume-down'
      | 'volume-mute'
      | 'volume-notice'
      | 'volume-small'
      | 'volume-up'
      | 'waves-left'
      | 'waves-right'
    Office:
      | 'abnormal'
      | 'add-print'
      | 'agreement'
      | 'application-effect'
      | 'audio-file'
      | 'chinese'
      | 'chinese-one'
      | 'collection-files'
      | 'compression'
      | 'copy-one'
      | 'data-file'
      | 'date-comes-back'
      | 'editor'
      | 'english'
      | 'excel'
      | 'file-addition'
      | 'file-addition-one'
      | 'file-code'
      | 'file-code-one'
      | 'file-collection'
      | 'file-collection-one'
      | 'file-conversion'
      | 'file-conversion-one'
      | 'file-date'
      | 'file-date-one'
      | 'file-display'
      | 'file-display-one'
      | 'file-doc'
      | 'file-editing'
      | 'file-editing-one'
      | 'file-failed'
      | 'file-failed-one'
      | 'file-focus'
      | 'file-focus-one'
      | 'file-hash'
      | 'file-hash-one'
      | 'file-hiding'
      | 'file-hiding-one'
      | 'file-lock'
      | 'file-lock-one'
      | 'file-music'
      | 'file-music-one'
      | 'file-pdf-one'
      | 'file-ppt'
      | 'file-protection'
      | 'file-protection-one'
      | 'file-quality'
      | 'file-quality-one'
      | 'file-question'
      | 'file-removal'
      | 'file-removal-one'
      | 'file-search'
      | 'file-search-one'
      | 'file-search-two'
      | 'file-settings'
      | 'file-settings-one'
      | 'file-staff'
      | 'file-staff-one'
      | 'file-success'
      | 'file-success-one'
      | 'file-text'
      | 'file-text-one'
      | 'file-tips'
      | 'file-tips-one'
      | 'file-txt-one'
      | 'file-withdrawal'
      | 'file-withdrawal-one'
      | 'file-zip'
      | 'find-one'
      | 'font-search'
      | 'form-one'
      | 'format'
      | 'healthy-recognition'
      | 'hourglass'
      | 'image-files'
      | 'increase'
      | 'instruction'
      | 'invalid-files'
      | 'label'
      | 'level'
      | 'list-view'
      | 'market-analysis'
      | 'optimize'
      | 'paperclip'
      | 'permissions'
      | 'picture'
      | 'play-two'
      | 'receive'
      | 'schedule'
      | 'security'
      | 'termination-file'
      | 'text-message'
      | 'text-recognition'
      | 'ticket'
      | 'ticket-one'
      | 'transform'
      | 'video-file'
      | 'video-one'
    Operate:
      | 'add-mode'
      | 'add-pic'
      | 'aperture-priority'
      | 'application-menu'
      | 'beauty'
      | 'bytedance-mini-app'
      | 'checkbox'
      | 'click'
      | 'color-filter'
      | 'contrast'
      | 'contrast-view'
      | 'contrast-view-circle'
      | 'damage-map'
      | 'dark-mode'
      | 'delete-mode'
      | 'effects'
      | 'erase'
      | 'face-recognition'
      | 'figma-mask'
      | 'flip-camera'
      | 'focus-one'
      | 'game-two'
      | 'handle-a'
      | 'handle-b'
      | 'handle-c'
      | 'handle-down'
      | 'handle-left'
      | 'handle-right'
      | 'handle-round'
      | 'handle-square'
      | 'handle-triangle'
      | 'handle-up'
      | 'handle-x'
      | 'handle-y'
      | 'handle-z'
      | 'import-and-export'
      | 'intermediate-mode'
      | 'lattice-pattern'
      | 'loading-one'
      | 'loading-two'
      | 'magnet'
      | 'mask-one'
      | 'material-two'
      | 'natural-mode'
      | 'no-shooting'
      | 'pic-one'
      | 'pin'
      | 'radio-two'
      | 'recycle-bin'
      | 'reverse-lens'
      | 'reverse-lens-one'
      | 'reverse-rotation'
      | 'rotating-add'
      | 'rotating-forward'
      | 'scan-setting'
      | 'screen-rotation'
      | 'shutter-priority'
      | 'stickers'
      | 'switch-track'
      | 'textarea'
      | 'viewfinder'
    Others:
      | 'all-application'
      | 'anchor-two'
      | 'applet-closed'
      | 'arithmetic-buttons'
      | 'arrow-keys'
      | 'audit'
      | 'baby-bottle'
      | 'balance'
      | 'bank-card-two'
      | 'bar-code'
      | 'baseball'
      | 'basketball'
      | 'battery-charge'
      | 'battery-empty'
      | 'battery-full'
      | 'battery-working'
      | 'block-eight'
      | 'block-five'
      | 'block-four'
      | 'block-nine'
      | 'block-one'
      | 'block-seven'
      | 'block-six'
      | 'block-ten'
      | 'block-three'
      | 'block-two'
      | 'brake-pads'
      | 'branch'
      | 'bus-two'
      | 'buy'
      | 'car-battery'
      | 'card-two'
      | 'carousel'
      | 'cast-screen'
      | 'certificate'
      | 'checklist'
      | 'christmas-tree'
      | 'close-wifi'
      | 'connection-box'
      | 'cooking-pot'
      | 'cooperative-handshake'
      | 'coronavirus'
      | 'creative'
      | 'cross-ring'
      | 'crown'
      | 'curve-adjustment'
      | 'dashboard-car'
      | 'dashboard-two'
      | 'data-server'
      | 'degree-hat'
      | 'diamond'
      | 'disk'
      | 'earth'
      | 'energy-socket'
      | 'enter-key'
      | 'express-delivery'
      | 'fan'
      | 'file-cabinet'
      | 'fire'
      | 'fire-two'
      | 'fireworks'
      | 'flag'
      | 'flask'
      | 'football'
      | 'fork'
      | 'full-screen-play'
      | 'game'
      | 'game-handle'
      | 'ghost'
      | 'globe'
      | 'gps'
      | 'green-new-energy'
      | 'guide-board'
      | 'handheld'
      | 'honey'
      | 'hourglass-full'
      | 'hourglass-null'
      | 'id-card'
      | 'international'
      | 'ios-face-recognition'
      | 'joystick'
      | 'keyhole'
      | 'layers'
      | 'leaf'
      | 'leaves'
      | 'lifebuoy'
      | 'light'
      | 'light-member'
      | 'local'
      | 'local-pin'
      | 'local-two'
      | 'luminous'
      | 'mac-finder'
      | 'magic'
      | 'manual-gear'
      | 'map-draw'
      | 'map-road'
      | 'map-road-two'
      | 'map-two'
      | 'mark'
      | 'material'
      | 'more-app'
      | 'mouth'
      | 'movie-board'
      | 'multi-function-knife'
      | 'navigation'
      | 'nintendo-switch'
      | 'outdoor'
      | 'page-template'
      | 'panorama-horizontal'
      | 'paper-money'
      | 'parabola'
      | 'pay-code'
      | 'pennant'
      | 'pinwheel'
      | 'planet'
      | 'plug'
      | 'poker'
      | 'power'
      | 'ppt'
      | 'pull-requests'
      | 'radar-chart'
      | 'ranking'
      | 'ranking-list'
      | 'receiver'
      | 'red-envelopes'
      | 'ripple'
      | 'road'
      | 'road-cone'
      | 'road-sign'
      | 'rugby'
      | 'sapling'
      | 'shake'
      | 'share-sys'
      | 'ship'
      | 'signal'
      | 'signal-one'
      | 'sim'
      | 'sinusoid'
      | 'skull'
      | 'sleaves'
      | 'slide-two'
      | 'sliding-horizontal'
      | 'sliding-vertical'
      | 'snacks'
      | 'sofa'
      | 'steering-wheel'
      | 'stethoscope'
      | 'strongbox'
      | 'surveillance-cameras'
      | 'surveillance-cameras-two'
      | 'switch-button'
      | 'system'
      | 'table-file'
      | 'target'
      | 'taxi'
      | 'tent'
      | 'tent-banner'
      | 'theater'
      | 'theme'
      | 'thermometer'
      | 'thinking-problem'
      | 'three-d-glasses'
      | 'trace'
      | 'translate'
      | 'transporter'
      | 'tree'
      | 'tree-list'
      | 'trend'
      | 'trend-two'
      | 'usb'
      | 'usb-one'
      | 'vial'
      | 'voice-input'
      | 'water'
      | 'water-level'
      | 'water-no'
      | 'water-rate'
      | 'water-rate-two'
      | 'waves'
      | 'weixin-cards-offers'
      | 'weixin-favorites'
      | 'weixin-games'
      | 'weixin-market'
      | 'weixin-mini-app'
      | 'weixin-scan'
      | 'weixin-search'
      | 'weixin-shake'
      | 'weixin-top-stories'
      | 'wheelchair'
      | 'wifi'
      | 'windmill-two'
      | 'workbench'
      | 'world'
      | 'xiaodu'
      | 'zoom-internal'
    Peoples:
      | 'add-user'
      | 'address-book'
      | 'appointment'
      | 'avatar'
      | 'baby'
      | 'classroom'
      | 'edit-name'
      | 'every-user'
      | 'hands'
      | 'id-card-h'
      | 'id-card-v'
      | 'me'
      | 'passport'
      | 'people'
      | 'people-bottom'
      | 'people-bottom-card'
      | 'people-delete'
      | 'people-delete-one'
      | 'people-download'
      | 'people-left'
      | 'people-minus'
      | 'people-minus-one'
      | 'people-plus'
      | 'people-plus-one'
      | 'people-right'
      | 'people-safe'
      | 'people-safe-one'
      | 'people-search'
      | 'people-search-one'
      | 'people-speak'
      | 'people-top'
      | 'people-top-card'
      | 'people-unknown'
      | 'people-upload'
      | 'peoples'
      | 'peoples-two'
      | 'personal-collection'
      | 'personal-privacy'
      | 'public-toilet'
      | 'reduce-user'
      | 'right-user'
      | 'turn-around'
      | 'user'
      | 'user-business'
      | 'user-positioning'
      | 'user-to-user-transmission'
      | 'weixin-people-nearby'
      | 'woman'
      | 'wrong-user'
    Sports:
      | 'archers-bow'
      | 'arena'
      | 'badge-two'
      | 'badminton'
      | 'balance-one'
      | 'baokemeng'
      | 'basketball-one'
      | 'basketball-stand'
      | 'black-eight'
      | 'bottom-bar-one'
      | 'bowling'
      | 'boxing'
      | 'boxing-one'
      | 'checkerboard'
      | 'chess'
      | 'chess-one'
      | 'court'
      | 'curling'
      | 'diving-bottle'
      | 'diving-suit'
      | 'dumbbell'
      | 'five-star-badge'
      | 'gold-medal'
      | 'gold-medal-two'
      | 'golf-course'
      | 'gymnastics'
      | 'gymnastics-one'
      | 'heartbeat'
      | 'helmet'
      | 'hockey'
      | 'kungfu'
      | 'muscle'
      | 'play-basketball'
      | 'play-volleyball'
      | 'riding'
      | 'rings'
      | 'rollerskates'
      | 'rope-skipping'
      | 'rope-skipping-one'
      | 'rowing'
      | 'rugby-one'
      | 'sailboat'
      | 'scoreboard'
      | 'skate'
      | 'skating'
      | 'skiing-nordic'
      | 'soccer'
      | 'soccer-one'
      | 'softball'
      | 'spikedshoes'
      | 'spinning-top'
      | 'sport'
      | 'swimming-pool'
      | 'swimming-ring'
      | 'tabletennis'
      | 'target-one'
      | 'target-two'
      | 'tennis'
      | 'thin'
      | 'torch'
      | 'towel'
      | 'treadmill'
      | 'treadmill-one'
      | 'volleyball'
      | 'waterpolo'
      | 'waterpolo-one'
      | 'weightlifting'
      | 'whistling'
      | 'wingsuit-flying'
    Time:
      | 'alarm-clock'
      | 'big-clock'
      | 'calendar-dot'
      | 'calendar-thirty'
      | 'calendar-thirty-two'
      | 'calendar-three'
      | 'dashboard'
      | 'history'
      | 'iwatch'
      | 'radar-two'
      | 'speed'
      | 'speed-one'
      | 'stopwatch'
      | 'time'
      | 'watch'
    Travel:
      | 'acceleration'
      | 'airplane-window'
      | 'airplane-window-one'
      | 'aviation'
      | 'baggage-delay'
      | 'cable-car'
      | 'camp'
      | 'check-in'
      | 'cocktail'
      | 'coconut-tree'
      | 'compass-one'
      | 'consignment'
      | 'cruise'
      | 'descend'
      | 'diving'
      | 'enquire'
      | 'fishing'
      | 'flight-airflow'
      | 'flight-safety'
      | 'gate-machine'
      | 'homestay'
      | 'hot-air-balloon'
      | 'in-flight'
      | 'journey'
      | 'landscape'
      | 'luggage'
      | 'passport-one'
      | 'photograph'
      | 'pyramid-one'
      | 'railway'
      | 'repositioning'
      | 'resting'
      | 'riding-one'
      | 'round-trip'
      | 'sailing'
      | 'sandals'
      | 'selfie'
      | 'set-off'
      | 'shade'
      | 'sunbath'
      | 'sunrise'
      | 'sunshade'
      | 'take-off'
      | 'tickets-checked'
      | 'tickets-one'
      | 'tickets-two'
      | 'tour-bus'
      | 'transfer'
      | 'transport'
      | 'universal'
    Weather:
      | 'cloudy'
      | 'cloudy-night'
      | 'fog'
      | 'heavy-rain'
      | 'heavy-wind'
      | 'light-rain'
      | 'moon'
      | 'sandstorm'
      | 'snow'
      | 'snowflake'
      | 'sun'
      | 'sun-one'
      | 'sunny'
      | 'thunderstorm'
      | 'thunderstorm-one'
      | 'wind'
  }
  material:
    | 'zoom_out_map'
    | 'zoom_out'
    | 'zoom_in_map'
    | 'zoom_in'
    | 'youtube_searched_for'
    | 'yard'
    | 'wysiwyg'
    | 'wrong_location'
    | 'wrap_text'
    | 'workspaces'
    | 'workspace_premium'
    | 'work_outline'
    | 'work_off'
    | 'work_history'
    | 'work'
    | 'wordpress'
    | 'woo_commerce'
    | 'woman'
    | 'wine_bar'
    | 'window'
    | 'wind_power'
    | 'wifi_tethering_off'
    | 'wifi_tethering_error_rounded'
    | 'wifi_tethering_error'
    | 'wifi_tethering'
    | 'wifi_protected_setup'
    | 'wifi_password'
    | 'wifi_off'
    | 'wifi_lock'
    | 'wifi_find'
    | 'wifi_channel'
    | 'wifi_calling_3'
    | 'wifi_calling'
    | 'wifi_2_bar'
    | 'wifi_1_bar'
    | 'wifi'
    | 'width_wide'
    | 'width_normal'
    | 'width_full'
    | 'widgets'
    | 'where_to_vote'
    | 'wheelchair_pickup'
    | 'whatshot'
    | 'whatsapp'
    | 'west'
    | 'weekend'
    | 'wechat'
    | 'webhook'
    | 'web_asset_off'
    | 'web_asset'
    | 'web'
    | 'wc'
    | 'wb_twilight'
    | 'wb_sunny'
    | 'wb_shade'
    | 'wb_iridescent'
    | 'wb_incandescent'
    | 'wb_cloudy'
    | 'wb_auto'
    | 'waving_hand'
    | 'waves'
    | 'waterfall_chart'
    | 'water_drop'
    | 'water_damage'
    | 'water'
    | 'watch_off'
    | 'watch_later'
    | 'watch'
    | 'wash'
    | 'warning_amber'
    | 'warning'
    | 'warehouse'
    | 'wallpaper'
    | 'wallet'
    | 'vrpano'
    | 'vpn_lock'
    | 'vpn_key_off'
    | 'vpn_key'
    | 'volunteer_activism'
    | 'volume_up'
    | 'volume_off'
    | 'volume_mute'
    | 'volume_down'
    | 'volcano'
    | 'voicemail'
    | 'voice_over_off'
    | 'voice_chat'
    | 'visibility_off'
    | 'visibility'
    | 'villa'
    | 'vignette'
    | 'view_week'
    | 'view_timeline'
    | 'view_stream'
    | 'view_sidebar'
    | 'view_quilt'
    | 'view_module'
    | 'view_list'
    | 'view_kanban'
    | 'view_in_ar'
    | 'view_headline'
    | 'view_day'
    | 'view_cozy'
    | 'view_compact_alt'
    | 'view_compact'
    | 'view_comfy_alt'
    | 'view_comfy'
    | 'view_column'
    | 'view_carousel'
    | 'view_array'
    | 'view_agenda'
    | 'videogame_asset_off'
    | 'videogame_asset'
    | 'videocam_off'
    | 'videocam'
    | 'video_stable'
    | 'video_settings'
    | 'video_library'
    | 'video_label'
    | 'video_file'
    | 'video_camera_front'
    | 'video_camera_back'
    | 'video_call'
    | 'vibration'
    | 'vertical_split'
    | 'vertical_shades_closed'
    | 'vertical_shades'
    | 'vertical_distribute'
    | 'vertical_align_top'
    | 'vertical_align_center'
    | 'vertical_align_bottom'
    | 'verified_user'
    | 'verified'
    | 'vaping_rooms'
    | 'vape_free'
    | 'vaccines'
    | 'usb_off'
    | 'usb'
    | 'upload_file'
    | 'upload'
    | 'upgrade'
    | 'update_disabled'
    | 'update'
    | 'upcoming'
    | 'unsubscribe'
    | 'unpublished'
    | 'unfold_more'
    | 'unfold_less'
    | 'undo'
    | 'unarchive'
    | 'umbrella'
    | 'u_turn_right'
    | 'u_turn_left'
    | 'two_wheeler'
    | 'tv_off'
    | 'tv'
    | 'turned_in_not'
    | 'turned_in'
    | 'turn_slight_right'
    | 'turn_slight_left'
    | 'turn_sharp_right'
    | 'turn_sharp_left'
    | 'turn_right'
    | 'turn_left'
    | 'tungsten'
    | 'tune'
    | 'tty'
    | 'tsunami'
    | 'try'
    | 'trip_origin'
    | 'trending_up'
    | 'trending_flat'
    | 'trending_down'
    | 'travel_explore'
    | 'translate'
    | 'transit_enterexit'
    | 'transgender'
    | 'transform'
    | 'transfer_within_a_station'
    | 'tram'
    | 'train'
    | 'traffic'
    | 'track_changes'
    | 'toys'
    | 'tour'
    | 'touch_app'
    | 'tornado'
    | 'topic'
    | 'tonality'
    | 'toll'
    | 'token'
    | 'toggle_on'
    | 'toggle_off'
    | 'today'
    | 'toc'
    | 'title'
    | 'tire_repair'
    | 'tips_and_updates'
    | 'timer_off'
    | 'timer_10_select'
    | 'timer_10'
    | 'timer_3_select'
    | 'timer_3'
    | 'timer'
    | 'timeline'
    | 'timelapse'
    | 'time_to_leave'
    | 'tiktok'
    | 'thunderstorm'
    | 'thumbs_up_down'
    | 'thumb_up_off_alt'
    | 'thumb_up_alt'
    | 'thumb_up'
    | 'thumb_down_off_alt'
    | 'thumb_down_alt'
    | 'thumb_down'
    | 'thermostat_auto'
    | 'thermostat'
    | 'theaters'
    | 'theater_comedy'
    | 'texture'
    | 'textsms'
    | 'text_snippet'
    | 'text_rotation_none'
    | 'text_rotation_down'
    | 'text_rotation_angleup'
    | 'text_rotation_angledown'
    | 'text_rotate_vertical'
    | 'text_rotate_up'
    | 'text_increase'
    | 'text_format'
    | 'text_fields'
    | 'text_decrease'
    | 'terrain'
    | 'terminal'
    | 'temple_hindu'
    | 'temple_buddhist'
    | 'telegram'
    | 'taxi_alert'
    | 'task_alt'
    | 'task'
    | 'tapas'
    | 'tap_and_play'
    | 'takeout_dining'
    | 'tag_faces'
    | 'tag'
    | 'tablet_mac'
    | 'tablet_android'
    | 'tablet'
    | 'table_view'
    | 'table_rows'
    | 'table_restaurant'
    | 'table_chart'
    | 'table_bar'
    | 'tab_unselected'
    | 'tab'
    | 'system_update_alt'
    | 'system_update'
    | 'system_security_update_warning'
    | 'system_security_update_good'
    | 'system_security_update'
    | 'sync_problem'
    | 'sync_lock'
    | 'sync_disabled'
    | 'sync_alt'
    | 'sync'
    | 'synagogue'
    | 'switch_video'
    | 'switch_right'
    | 'switch_left'
    | 'switch_camera'
    | 'switch_account'
    | 'switch_access_shortcut_add'
    | 'switch_access_shortcut'
    | 'swipe_vertical'
    | 'swipe_up_alt'
    | 'swipe_up'
    | 'swipe_right_alt'
    | 'swipe_right'
    | 'swipe_left_alt'
    | 'swipe_left'
    | 'swipe_down_alt'
    | 'swipe_down'
    | 'swipe'
    | 'swap_vertical_circle'
    | 'swap_vert'
    | 'swap_horizontal_circle'
    | 'swap_horiz'
    | 'swap_calls'
    | 'surround_sound'
    | 'surfing'
    | 'support_agent'
    | 'support'
    | 'supervisor_account'
    | 'supervised_user_circle'
    | 'superscript'
    | 'summarize'
    | 'subway'
    | 'subtitles_off'
    | 'subtitles'
    | 'subscriptions'
    | 'subscript'
    | 'subject'
    | 'subdirectory_arrow_right'
    | 'subdirectory_arrow_left'
    | 'style'
    | 'stroller'
    | 'strikethrough_s'
    | 'streetview'
    | 'stream'
    | 'straighten'
    | 'straight'
    | 'storm'
    | 'storefront'
    | 'store_mall_directory'
    | 'store'
    | 'storage'
    | 'stop_screen_share'
    | 'stop_circle'
    | 'stop'
    | 'sticky_note_2'
    | 'stay_primary_portrait'
    | 'stay_primary_landscape'
    | 'stay_current_portrait'
    | 'stay_current_landscape'
    | 'start'
    | 'stars'
    | 'star_rate'
    | 'star_purple500'
    | 'star_outline'
    | 'star_half'
    | 'star_border_purple500'
    | 'star_border'
    | 'star'
    | 'stairs'
    | 'stadium'
    | 'stacked_line_chart'
    | 'stacked_bar_chart'
    | 'ssid_chart'
    | 'square_foot'
    | 'square'
    | 'sports_volleyball'
    | 'sports_tennis'
    | 'sports_soccer'
    | 'sports_score'
    | 'sports_rugby'
    | 'sports_motorsports'
    | 'sports_mma'
    | 'sports_martial_arts'
    | 'sports_kabaddi'
    | 'sports_hockey'
    | 'sports_handball'
    | 'sports_gymnastics'
    | 'sports_golf'
    | 'sports_football'
    | 'sports_esports'
    | 'sports_cricket'
    | 'sports_basketball'
    | 'sports_baseball'
    | 'sports_bar'
    | 'sports'
    | 'spoke'
    | 'splitscreen'
    | 'spellcheck'
    | 'speed'
    | 'speaker_phone'
    | 'speaker_notes_off'
    | 'speaker_notes'
    | 'speaker_group'
    | 'speaker'
    | 'spatial_tracking'
    | 'spatial_audio_off'
    | 'spatial_audio'
    | 'space_dashboard'
    | 'space_bar'
    | 'spa'
    | 'south_west'
    | 'south_east'
    | 'south_america'
    | 'south'
    | 'source'
    | 'soup_kitchen'
    | 'sos'
    | 'sort_by_alpha'
    | 'sort'
    | 'solar_power'
    | 'social_distance'
    | 'soap'
    | 'snowshoeing'
    | 'snowmobile'
    | 'snowboarding'
    | 'snooze'
    | 'snippet_folder'
    | 'snapchat'
    | 'sms_failed'
    | 'sms'
    | 'smoking_rooms'
    | 'smoke_free'
    | 'smartphone'
    | 'smart_toy'
    | 'smart_screen'
    | 'smart_display'
    | 'smart_button'
    | 'slow_motion_video'
    | 'slideshow'
    | 'sledding'
    | 'skip_previous'
    | 'skip_next'
    | 'skateboarding'
    | 'sip'
    | 'single_bed'
    | 'sim_card_download'
    | 'sim_card_alert'
    | 'sim_card'
    | 'signpost'
    | 'signal_wifi_statusbar_null'
    | 'signal_wifi_statusbar_connected_no_internet_4'
    | 'signal_wifi_statusbar_4_bar'
    | 'signal_wifi_off'
    | 'signal_wifi_connected_no_internet_4'
    | 'signal_wifi_bad'
    | 'signal_wifi_4_bar_lock'
    | 'signal_wifi_4_bar'
    | 'signal_wifi_3_bar_lock'
    | 'signal_wifi_3_bar'
    | 'signal_wifi_2_bar_lock'
    | 'signal_wifi_2_bar'
    | 'signal_wifi_1_bar_lock'
    | 'signal_wifi_1_bar'
    | 'signal_wifi_0_bar'
    | 'signal_cellular_off'
    | 'signal_cellular_null'
    | 'signal_cellular_nodata'
    | 'signal_cellular_no_sim'
    | 'signal_cellular_connected_no_internet_4_bar'
    | 'signal_cellular_connected_no_internet_3_bar'
    | 'signal_cellular_connected_no_internet_2_bar'
    | 'signal_cellular_connected_no_internet_1_bar'
    | 'signal_cellular_connected_no_internet_0_bar'
    | 'signal_cellular_alt_2_bar'
    | 'signal_cellular_alt_1_bar'
    | 'signal_cellular_alt'
    | 'signal_cellular_4_bar'
    | 'signal_cellular_3_bar'
    | 'signal_cellular_2_bar'
    | 'signal_cellular_1_bar'
    | 'signal_cellular_0_bar'
    | 'sign_language'
    | 'sick'
    | 'shutter_speed'
    | 'shuffle_on'
    | 'shuffle'
    | 'shower'
    | 'show_chart'
    | 'shortcut'
    | 'short_text'
    | 'shopping_cart_checkout'
    | 'shopping_cart'
    | 'shopping_basket'
    | 'shopping_bag'
    | 'shopify'
    | 'shop_two'
    | 'shop_2'
    | 'shop'
    | 'shield_moon'
    | 'shield'
    | 'share_location'
    | 'share_arrival_time'
    | 'share'
    | 'severe_cold'
    | 'settings_voice'
    | 'settings_system_daydream'
    | 'settings_suggest'
    | 'settings_remote'
    | 'settings_power'
    | 'settings_phone'
    | 'settings_overscan'
    | 'settings_input_svideo'
    | 'settings_input_hdmi'
    | 'settings_input_composite'
    | 'settings_input_component'
    | 'settings_input_antenna'
    | 'settings_ethernet'
    | 'settings_cell'
    | 'settings_brightness'
    | 'settings_bluetooth'
    | 'settings_backup_restore'
    | 'settings_applications'
    | 'settings_accessibility'
    | 'settings'
    | 'set_meal'
    | 'sentiment_very_satisfied'
    | 'sentiment_very_dissatisfied'
    | 'sentiment_slightly_dissatisfied'
    | 'sentiment_satisfied_alt'
    | 'sentiment_satisfied'
    | 'sentiment_neutral'
    | 'sentiment_dissatisfied'
    | 'sensors_off'
    | 'sensors'
    | 'sensor_window'
    | 'sensor_occupied'
    | 'sensor_door'
    | 'send_to_mobile'
    | 'send_time_extension'
    | 'send_and_archive'
    | 'send'
    | 'sell'
    | 'self_improvement'
    | 'select_all'
    | 'segment'
    | 'security_update_warning'
    | 'security_update_good'
    | 'security_update'
    | 'security'
    | 'search_off'
    | 'search'
    | 'sd_storage'
    | 'sd_card_alert'
    | 'sd_card'
    | 'sd'
    | 'scuba_diving'
    | 'screenshot_monitor'
    | 'screenshot'
    | 'screen_share'
    | 'screen_search_desktop'
    | 'screen_rotation_alt'
    | 'screen_rotation'
    | 'screen_lock_rotation'
    | 'screen_lock_portrait'
    | 'screen_lock_landscape'
    | 'scoreboard'
    | 'score'
    | 'science'
    | 'school'
    | 'schema'
    | 'schedule_send'
    | 'schedule'
    | 'scatter_plot'
    | 'scanner'
    | 'scale'
    | 'savings'
    | 'saved_search'
    | 'save_as'
    | 'save_alt'
    | 'save_all'
    | 'save'
    | 'satellite_alt'
    | 'satellite'
    | 'sanitizer'
    | 'sailing'
    | 'safety_divider'
    | 'safety_check'
    | 'rv_hookup'
    | 'running_with_errors'
    | 'run_circle'
    | 'rule_folder'
    | 'rule'
    | 'rtt'
    | 'rsvp'
    | 'rss_feed'
    | 'rowing'
    | 'router'
    | 'route'
    | 'rounded_corner'
    | 'roundabout_right'
    | 'roundabout_left'
    | 'rotate_right'
    | 'rotate_left'
    | 'rotate_90_degrees_cw'
    | 'rotate_90_degrees_ccw'
    | 'room_service'
    | 'room_preferences'
    | 'room'
    | 'roofing'
    | 'roller_skating'
    | 'roller_shades_closed'
    | 'roller_shades'
    | 'rocket_launch'
    | 'rocket'
    | 'ring_volume'
    | 'rice_bowl'
    | 'reviews'
    | 'restore_page'
    | 'restore_from_trash'
    | 'restore'
    | 'restaurant_menu'
    | 'restaurant'
    | 'restart_alt'
    | 'reset_tv'
    | 'request_quote'
    | 'request_page'
    | 'report_problem'
    | 'report_off'
    | 'report_gmailerrorred'
    | 'report'
    | 'reply_all'
    | 'reply'
    | 'replay_circle_filled'
    | 'replay_30'
    | 'replay_10'
    | 'replay_5'
    | 'replay'
    | 'repeat_one_on'
    | 'repeat_one'
    | 'repeat_on'
    | 'repeat'
    | 'reorder'
    | 'remove_shopping_cart'
    | 'remove_road'
    | 'remove_red_eye'
    | 'remove_moderator'
    | 'remove_from_queue'
    | 'remove_done'
    | 'remove_circle_outline'
    | 'remove_circle'
    | 'remove'
    | 'remember_me'
    | 'refresh'
    | 'reduce_capacity'
    | 'redo'
    | 'redeem'
    | 'reddit'
    | 'recycling'
    | 'rectangle'
    | 'record_voice_over'
    | 'recommend'
    | 'recent_actors'
    | 'receipt_long'
    | 'receipt'
    | 'real_estate_agent'
    | 'read_more'
    | 'raw_on'
    | 'raw_off'
    | 'rate_review'
    | 'ramp_right'
    | 'ramp_left'
    | 'ramen_dining'
    | 'railway_alert'
    | 'radio_button_unchecked'
    | 'radio_button_checked'
    | 'radio'
    | 'radar'
    | 'r_mobiledata'
    | 'quora'
    | 'quiz'
    | 'quickreply'
    | 'queue_play_next'
    | 'queue_music'
    | 'queue'
    | 'question_mark'
    | 'question_answer'
    | 'query_stats'
    | 'query_builder'
    | 'qrcode'
    | 'qr_code_scanner'
    | 'qr_code_2'
    | 'qr_code'
    | 'push_pin'
    | 'punch_clock'
    | 'published_with_changes'
    | 'publish'
    | 'public_off'
    | 'public'
    | 'psychology'
    | 'propane_tank'
    | 'propane'
    | 'production_quantity_limits'
    | 'private_connectivity'
    | 'privacy_tip'
    | 'priority_high'
    | 'print_disabled'
    | 'print'
    | 'price_check'
    | 'price_change'
    | 'preview'
    | 'present_to_all'
    | 'pregnant_woman'
    | 'precision_manufacturing'
    | 'power_settings_new'
    | 'power_off'
    | 'power_input'
    | 'power'
    | 'post_add'
    | 'portrait'
    | 'portable_wifi_off'
    | 'pool'
    | 'polymer'
    | 'polyline'
    | 'poll'
    | 'policy'
    | 'point_of_sale'
    | 'podcasts'
    | 'plus_one'
    | 'plus_minus_alt'
    | 'plus_minus'
    | 'plus'
    | 'plumbing'
    | 'playlist_remove'
    | 'playlist_play'
    | 'playlist_add_circle'
    | 'playlist_add_check_circle'
    | 'playlist_add_check'
    | 'playlist_add'
    | 'play_lesson'
    | 'play_for_work'
    | 'play_disabled'
    | 'play_circle_outline'
    | 'play_circle_filled_white'
    | 'play_circle_filled'
    | 'play_circle'
    | 'play_arrow'
    | 'plagiarism'
    | 'place'
    | 'pix'
    | 'pivot_table_chart'
    | 'pinch'
    | 'pin_off'
    | 'pin_invoke'
    | 'pin_end'
    | 'pin_drop'
    | 'pin'
    | 'pie_chart_outline'
    | 'pie_chart'
    | 'picture_in_picture_alt'
    | 'picture_in_picture'
    | 'picture_as_pdf'
    | 'piano_off'
    | 'piano'
    | 'php'
    | 'photo_size_select_small'
    | 'photo_size_select_large'
    | 'photo_size_select_actual'
    | 'photo_library'
    | 'photo_filter'
    | 'photo_camera_front'
    | 'photo_camera_back'
    | 'photo_camera'
    | 'photo_album'
    | 'photo'
    | 'phonelink_setup'
    | 'phonelink_ring'
    | 'phonelink_off'
    | 'phonelink_lock'
    | 'phonelink_erase'
    | 'phonelink'
    | 'phone_paused'
    | 'phone_missed'
    | 'phone_locked'
    | 'phone_iphone'
    | 'phone_in_talk'
    | 'phone_forwarded'
    | 'phone_enabled'
    | 'phone_disabled'
    | 'phone_callback'
    | 'phone_bluetooth_speaker'
    | 'phone_android'
    | 'phone'
    | 'phishing'
    | 'pets'
    | 'pest_control_rodent'
    | 'pest_control'
    | 'personal_video'
    | 'personal_injury'
    | 'person_search'
    | 'person_remove_alt_1'
    | 'person_remove'
    | 'person_pin_circle'
    | 'person_pin'
    | 'person_outline'
    | 'person_off'
    | 'person_add_disabled'
    | 'person_add_alt_1'
    | 'person_add_alt'
    | 'person_add'
    | 'person'
    | 'perm_scan_wifi'
    | 'perm_phone_msg'
    | 'perm_media'
    | 'perm_identity'
    | 'perm_device_information'
    | 'perm_data_setting'
    | 'perm_contact_calendar'
    | 'perm_camera_mic'
    | 'percentage'
    | 'percent'
    | 'people_outline'
    | 'people_alt'
    | 'people'
    | 'pentagon'
    | 'pending_actions'
    | 'pending'
    | 'pedal_bike'
    | 'paypal'
    | 'payments'
    | 'payment'
    | 'pause_presentation'
    | 'pause_circle_outline'
    | 'pause_circle_filled'
    | 'pause_circle'
    | 'pause'
    | 'pattern'
    | 'password'
    | 'party_mode'
    | 'park'
    | 'paragliding'
    | 'panorama_wide_angle_select'
    | 'panorama_wide_angle'
    | 'panorama_vertical_select'
    | 'panorama_vertical'
    | 'panorama_photosphere_select'
    | 'panorama_photosphere'
    | 'panorama_horizontal_select'
    | 'panorama_horizontal'
    | 'panorama_fish_eye'
    | 'panorama'
    | 'pan_tool_alt'
    | 'pan_tool'
    | 'palette'
    | 'paid'
    | 'pageview'
    | 'pages'
    | 'padding'
    | 'output'
    | 'outlined_flag'
    | 'outlet'
    | 'outdoor_grill'
    | 'outbox'
    | 'outbound'
    | 'outbond'
    | 'other_houses'
    | 'open_with'
    | 'open_in_new_off'
    | 'open_in_new'
    | 'open_in_full'
    | 'open_in_browser'
    | 'opacity'
    | 'online_prediction'
    | 'ondemand_video'
    | 'on_device_training'
    | 'oil_barrel'
    | 'offline_share'
    | 'offline_pin'
    | 'offline_bolt'
    | 'numbers'
    | 'notifications_paused'
    | 'notifications_off'
    | 'notifications_none'
    | 'notifications_active'
    | 'notifications'
    | 'notification_important'
    | 'notification_add'
    | 'notes'
    | 'note_alt'
    | 'note_add'
    | 'note'
    | 'not_started'
    | 'not_listed_location'
    | 'not_interested'
    | 'not_equal'
    | 'not_accessible'
    | 'north_west'
    | 'north_east'
    | 'north'
    | 'nordic_walking'
    | 'noise_control_off'
    | 'noise_aware'
    | 'no_transfer'
    | 'no_stroller'
    | 'no_sim'
    | 'no_photography'
    | 'no_meeting_room'
    | 'no_meals'
    | 'no_luggage'
    | 'no_food'
    | 'no_flash'
    | 'no_encryption_gmailerrorred'
    | 'no_encryption'
    | 'no_drinks'
    | 'no_crash'
    | 'no_cell'
    | 'no_backpack'
    | 'no_adult_content'
    | 'no_accounts'
    | 'nights_stay'
    | 'nightlight_round'
    | 'nightlight'
    | 'nightlife'
    | 'night_shelter'
    | 'nfc'
    | 'next_week'
    | 'next_plan'
    | 'newspaper'
    | 'new_releases'
    | 'new_label'
    | 'network_wifi_3_bar'
    | 'network_wifi_2_bar'
    | 'network_wifi_1_bar'
    | 'network_wifi'
    | 'network_ping'
    | 'network_locked'
    | 'network_check'
    | 'network_cell'
    | 'nest_cam_wired_stand'
    | 'nearby_off'
    | 'nearby_error'
    | 'near_me_disabled'
    | 'near_me'
    | 'navigation'
    | 'navigate_next'
    | 'navigate_before'
    | 'nature_people'
    | 'nature'
    | 'nat'
    | 'my_location'
    | 'music_video'
    | 'music_off'
    | 'music_note'
    | 'museum'
    | 'multiple_stop'
    | 'multiline_chart'
    | 'mp'
    | 'moving'
    | 'movie_filter'
    | 'movie_creation'
    | 'movie'
    | 'move_up'
    | 'move_to_inbox'
    | 'move_down'
    | 'mouse'
    | 'motorcycle'
    | 'motion_photos_paused'
    | 'motion_photos_pause'
    | 'motion_photos_on'
    | 'motion_photos_off'
    | 'motion_photos_auto'
    | 'mosque'
    | 'more_vert'
    | 'more_time'
    | 'more_horiz'
    | 'more'
    | 'moped'
    | 'mood_bad'
    | 'mood'
    | 'monochrome_photos'
    | 'monitor_weight'
    | 'monitor_heart'
    | 'monitor'
    | 'money_off_csred'
    | 'money_off'
    | 'money'
    | 'monetization_on'
    | 'model_training'
    | 'mode_standby'
    | 'mode_of_travel'
    | 'mode_night'
    | 'mode_fan_off'
    | 'mode_edit_outline'
    | 'mode_edit'
    | 'mode_comment'
    | 'mode'
    | 'mobiledata_off'
    | 'mobile_screen_share'
    | 'mobile_off'
    | 'mobile_friendly'
    | 'mms'
    | 'missed_video_call'
    | 'miscellaneous_services'
    | 'minus'
    | 'minor_crash'
    | 'minimize'
    | 'military_tech'
    | 'microwave'
    | 'mic_off'
    | 'mic_none'
    | 'mic_external_on'
    | 'mic_external_off'
    | 'mic'
    | 'message'
    | 'merge_type'
    | 'merge'
    | 'menu_open'
    | 'menu_book'
    | 'menu'
    | 'memory'
    | 'meeting_room'
    | 'medication_liquid'
    | 'medication'
    | 'medical_services'
    | 'medical_information'
    | 'mediation'
    | 'media_bluetooth_on'
    | 'media_bluetooth_off'
    | 'maximize'
    | 'masks'
    | 'markunread_mailbox'
    | 'markunread'
    | 'mark_unread_chat_alt'
    | 'mark_email_unread'
    | 'mark_email_read'
    | 'mark_chat_unread'
    | 'mark_chat_read'
    | 'mark_as_unread'
    | 'margin'
    | 'maps_ugc'
    | 'maps_home_work'
    | 'map'
    | 'manage_search'
    | 'manage_history'
    | 'manage_accounts'
    | 'man'
    | 'male'
    | 'mail_outline'
    | 'mail_lock'
    | 'mail'
    | 'lyrics'
    | 'lunch_dining'
    | 'luggage'
    | 'lte_plus_mobiledata'
    | 'lte_mobiledata'
    | 'loyalty'
    | 'low_priority'
    | 'loupe'
    | 'loop'
    | 'looks_two'
    | 'looks_one'
    | 'looks_6'
    | 'looks_5'
    | 'looks_4'
    | 'looks_3'
    | 'looks'
    | 'logout'
    | 'logo_dev'
    | 'login'
    | 'log_out'
    | 'log_in'
    | 'lock_reset'
    | 'lock_person'
    | 'lock_open'
    | 'lock_clock'
    | 'lock'
    | 'location_searching'
    | 'location_on'
    | 'location_off'
    | 'location_disabled'
    | 'location_city'
    | 'local_taxi'
    | 'local_shipping'
    | 'local_see'
    | 'local_printshop'
    | 'local_post_office'
    | 'local_police'
    | 'local_play'
    | 'local_pizza'
    | 'local_phone'
    | 'local_pharmacy'
    | 'local_parking'
    | 'local_offer'
    | 'local_movies'
    | 'local_mall'
    | 'local_library'
    | 'local_laundry_service'
    | 'local_hotel'
    | 'local_hospital'
    | 'local_grocery_store'
    | 'local_gas_station'
    | 'local_florist'
    | 'local_fire_department'
    | 'local_drink'
    | 'local_dining'
    | 'local_convenience_store'
    | 'local_car_wash'
    | 'local_cafe'
    | 'local_bar'
    | 'local_atm'
    | 'local_airport'
    | 'local_activity'
    | 'living'
    | 'live_tv'
    | 'live_help'
    | 'list_alt'
    | 'list'
    | 'liquor'
    | 'linked_camera'
    | 'link_off'
    | 'link'
    | 'linear_scale'
    | 'line_weight'
    | 'line_style'
    | 'line_axis'
    | 'lightbulb_circle'
    | 'lightbulb'
    | 'light_mode'
    | 'light'
    | 'library_music'
    | 'library_books'
    | 'library_add_check'
    | 'library_add'
    | 'less_than_equal'
    | 'less_than'
    | 'lens_blur'
    | 'lens'
    | 'legend_toggle'
    | 'leave_bags_at_home'
    | 'leak_remove'
    | 'leak_add'
    | 'leaderboard'
    | 'layers_clear'
    | 'layers'
    | 'launch'
    | 'last_page'
    | 'laptop_windows'
    | 'laptop_mac'
    | 'laptop_chromebook'
    | 'laptop'
    | 'language'
    | 'landslide'
    | 'landscape'
    | 'lan'
    | 'label_off'
    | 'label_important'
    | 'label'
    | 'kitesurfing'
    | 'kitchen'
    | 'king_bed'
    | 'keyboard_voice'
    | 'keyboard_tab'
    | 'keyboard_return'
    | 'keyboard_option_key'
    | 'keyboard_hide'
    | 'keyboard_double_arrow_up'
    | 'keyboard_double_arrow_right'
    | 'keyboard_double_arrow_left'
    | 'keyboard_double_arrow_down'
    | 'keyboard_control_key'
    | 'keyboard_command_key'
    | 'keyboard_capslock'
    | 'keyboard_backspace'
    | 'keyboard_arrow_up'
    | 'keyboard_arrow_right'
    | 'keyboard_arrow_left'
    | 'keyboard_arrow_down'
    | 'keyboard_alt'
    | 'keyboard'
    | 'key_off'
    | 'key'
    | 'kebab_dining'
    | 'kayaking'
    | 'join_right'
    | 'join_left'
    | 'join_inner'
    | 'join_full'
    | 'javascript'
    | 'iso'
    | 'iron'
    | 'ios_share'
    | 'invert_colors_off'
    | 'invert_colors'
    | 'inventory_2'
    | 'inventory'
    | 'interpreter_mode'
    | 'interests'
    | 'integration_instructions'
    | 'install_mobile'
    | 'install_desktop'
    | 'insights'
    | 'insert_photo'
    | 'insert_page_break'
    | 'insert_link'
    | 'insert_invitation'
    | 'insert_emoticon'
    | 'insert_drive_file'
    | 'insert_comment'
    | 'insert_chart_outlined'
    | 'insert_chart'
    | 'input'
    | 'info'
    | 'indeterminate_check_box'
    | 'incomplete_circle'
    | 'inbox'
    | 'important_devices'
    | 'import_export'
    | 'import_contacts'
    | 'imagesearch_roller'
    | 'image_search'
    | 'image_not_supported'
    | 'image_aspect_ratio'
    | 'image'
    | 'icecream'
    | 'ice_skating'
    | 'hvac'
    | 'hub'
    | 'https'
    | 'http'
    | 'html'
    | 'how_to_vote'
    | 'how_to_reg'
    | 'houseboat'
    | 'house_siding'
    | 'house'
    | 'hourglass_top'
    | 'hourglass_full'
    | 'hourglass_empty'
    | 'hourglass_disabled'
    | 'hourglass_bottom'
    | 'hotel_class'
    | 'hotel'
    | 'hot_tub'
    | 'horizontal_split'
    | 'horizontal_rule'
    | 'horizontal_distribute'
    | 'home_work'
    | 'home_repair_service'
    | 'home_mini'
    | 'home_max'
    | 'home'
    | 'holiday_village'
    | 'hls_off'
    | 'hls'
    | 'hive'
    | 'history_toggle_off'
    | 'history_edu'
    | 'history'
    | 'hiking'
    | 'highlight_off'
    | 'highlight_alt'
    | 'highlight'
    | 'high_quality'
    | 'hide_source'
    | 'hide_image'
    | 'hexagon'
    | 'hevc'
    | 'help_outline'
    | 'help_center'
    | 'help'
    | 'height'
    | 'heat_pump'
    | 'heart_broken'
    | 'hearing_disabled'
    | 'hearing'
    | 'health_and_safety'
    | 'healing'
    | 'headset_off'
    | 'headset_mic'
    | 'headset'
    | 'headphones_battery'
    | 'headphones'
    | 'hdr_weak'
    | 'hdr_strong'
    | 'hdr_plus'
    | 'hdr_on_select'
    | 'hdr_on'
    | 'hdr_off_select'
    | 'hdr_off'
    | 'hdr_enhanced_select'
    | 'hdr_auto_select'
    | 'hdr_auto'
    | 'hd'
    | 'hardware'
    | 'handyman'
    | 'handshake'
    | 'hail'
    | 'h_plus_mobiledata'
    | 'h_mobiledata'
    | 'groups'
    | 'group_work'
    | 'group_remove'
    | 'group_off'
    | 'group_add'
    | 'group'
    | 'grid_view'
    | 'grid_on'
    | 'grid_off'
    | 'grid_goldenratio'
    | 'grid_4x4'
    | 'grid_3x3'
    | 'greater_than_equal'
    | 'greater_than'
    | 'grass'
    | 'graphic_eq'
    | 'grain'
    | 'grading'
    | 'gradient'
    | 'grade'
    | 'gps_off'
    | 'gps_not_fixed'
    | 'gps_fixed'
    | 'gpp_maybe'
    | 'gpp_good'
    | 'gpp_bad'
    | 'golf_course'
    | 'gite'
    | 'girl'
    | 'gif_box'
    | 'gif'
    | 'get_app'
    | 'gesture'
    | 'generating_tokens'
    | 'gavel'
    | 'gas_meter'
    | 'garage'
    | 'games'
    | 'gamepad'
    | 'g_translate'
    | 'g_mobiledata'
    | 'functions'
    | 'fullscreen_exit'
    | 'fullscreen'
    | 'front_hand'
    | 'free_cancellation'
    | 'free_breakfast'
    | 'foundation'
    | 'forward_to_inbox'
    | 'forward_30'
    | 'forward_10'
    | 'forward_5'
    | 'forward'
    | 'forum'
    | 'fort'
    | 'format_underlined'
    | 'format_textdirection_r_to_l'
    | 'format_textdirection_l_to_r'
    | 'format_strikethrough'
    | 'format_size'
    | 'format_shapes'
    | 'format_quote'
    | 'format_paint'
    | 'format_overline'
    | 'format_list_numbered_rtl'
    | 'format_list_numbered'
    | 'format_list_bulleted'
    | 'format_line_spacing'
    | 'format_italic'
    | 'format_indent_increase'
    | 'format_indent_decrease'
    | 'format_color_text'
    | 'format_color_reset'
    | 'format_color_fill'
    | 'format_clear'
    | 'format_bold'
    | 'format_align_right'
    | 'format_align_left'
    | 'format_align_justify'
    | 'format_align_center'
    | 'fork_right'
    | 'fork_left'
    | 'forest'
    | 'food_bank'
    | 'font_download_off'
    | 'font_download'
    | 'follow_the_signs'
    | 'folder_zip'
    | 'folder_special'
    | 'folder_shared'
    | 'folder_open'
    | 'folder_off'
    | 'folder_delete'
    | 'folder_copy'
    | 'folder'
    | 'fmd_good'
    | 'fmd_bad'
    | 'flutter_dash'
    | 'flourescent'
    | 'flood'
    | 'flip_to_front'
    | 'flip_to_back'
    | 'flip_camera_ios'
    | 'flip_camera_android'
    | 'flip'
    | 'flight_takeoff'
    | 'flight_land'
    | 'flight_class'
    | 'flight'
    | 'flatware'
    | 'flashlight_on'
    | 'flashlight_off'
    | 'flash_on'
    | 'flash_off'
    | 'flash_auto'
    | 'flare'
    | 'flaky'
    | 'flag_circle'
    | 'flag'
    | 'fitness_center'
    | 'fitbit'
    | 'fit_screen'
    | 'first_page'
    | 'fireplace'
    | 'fire_extinguisher'
    | 'fingerprint'
    | 'find_replace'
    | 'find_in_page'
    | 'filter_vintage'
    | 'filter_tilt_shift'
    | 'filter_none'
    | 'filter_list_off'
    | 'filter_list'
    | 'filter_hdr'
    | 'filter_frames'
    | 'filter_drama'
    | 'filter_center_focus'
    | 'filter_b_and_w'
    | 'filter_alt_off'
    | 'filter_alt'
    | 'filter_9_plus'
    | 'filter_9'
    | 'filter_8'
    | 'filter_7'
    | 'filter_6'
    | 'filter_5'
    | 'filter_4'
    | 'filter_3'
    | 'filter_2'
    | 'filter_1'
    | 'filter'
    | 'file_upload'
    | 'file_present'
    | 'file_open'
    | 'file_download_off'
    | 'file_download_done'
    | 'file_download'
    | 'file_copy'
    | 'fiber_smart_record'
    | 'fiber_pin'
    | 'fiber_new'
    | 'fiber_manual_record'
    | 'fiber_dvr'
    | 'festival'
    | 'fence'
    | 'female'
    | 'feedback'
    | 'feed'
    | 'featured_video'
    | 'featured_play_list'
    | 'fax'
    | 'favorite_border'
    | 'favorite'
    | 'fastfood'
    | 'fast_rewind'
    | 'fast_forward'
    | 'family_restroom'
    | 'factory'
    | 'fact_check'
    | 'facebook'
    | 'face_retouching_off'
    | 'face_retouching_natural'
    | 'face'
    | 'extension_off'
    | 'extension'
    | 'exposure_zero'
    | 'exposure_plus_2'
    | 'exposure_plus_1'
    | 'exposure_neg_2'
    | 'exposure_neg_1'
    | 'exposure'
    | 'explore_off'
    | 'explore'
    | 'explicit'
    | 'expand_more'
    | 'expand_less'
    | 'expand_circle_down'
    | 'expand'
    | 'exit_to_app'
    | 'event_seat'
    | 'event_repeat'
    | 'event_note'
    | 'event_busy'
    | 'event_available'
    | 'event'
    | 'ev_station'
    | 'euro_symbol'
    | 'euro'
    | 'escalator_warning'
    | 'escalator'
    | 'error_outline'
    | 'error'
    | 'equals'
    | 'equalizer'
    | 'enhanced_encryption'
    | 'engineering'
    | 'energy_savings_leaf'
    | 'emoji_transportation'
    | 'emoji_symbols'
    | 'emoji_people'
    | 'emoji_objects'
    | 'emoji_nature'
    | 'emoji_food_beverage'
    | 'emoji_flags'
    | 'emoji_events'
    | 'emoji_emotions'
    | 'emergency_share'
    | 'emergency_recording'
    | 'emergency'
    | 'email'
    | 'elevator'
    | 'electrical_services'
    | 'electric_scooter'
    | 'electric_rickshaw'
    | 'electric_moped'
    | 'electric_meter'
    | 'electric_car'
    | 'electric_bolt'
    | 'electric_bike'
    | 'elderly_woman'
    | 'elderly'
    | 'eject'
    | 'egg_alt'
    | 'egg'
    | 'edit_road'
    | 'edit_off'
    | 'edit_notifications'
    | 'edit_note'
    | 'edit_location_alt'
    | 'edit_location'
    | 'edit_calendar'
    | 'edit_attributes'
    | 'edit'
    | 'edgesensor_low'
    | 'edgesensor_high'
    | 'eco'
    | 'east'
    | 'earbuds_battery'
    | 'earbuds'
    | 'e_mobiledata'
    | 'dynamic_form'
    | 'dynamic_feed'
    | 'dvr'
    | 'duo'
    | 'dry_cleaning'
    | 'dry'
    | 'drive_folder_upload'
    | 'drive_file_rename_outline'
    | 'drive_file_move_rtl'
    | 'drive_file_move'
    | 'drive_eta'
    | 'draw'
    | 'drag_indicator'
    | 'drag_handle'
    | 'drafts'
    | 'downloading'
    | 'download_for_offline'
    | 'download_done'
    | 'download'
    | 'downhill_skiing'
    | 'double_arrow'
    | 'doorbell'
    | 'door_sliding'
    | 'door_front'
    | 'door_back'
    | 'donut_small'
    | 'donut_large'
    | 'done_outline'
    | 'done_all'
    | 'done'
    | 'domain_verification'
    | 'domain_disabled'
    | 'domain_add'
    | 'domain'
    | 'document_scanner'
    | 'dock'
    | 'do_not_touch'
    | 'do_not_step'
    | 'do_not_disturb_on_total_silence'
    | 'do_not_disturb_on'
    | 'do_not_disturb_off'
    | 'do_not_disturb_alt'
    | 'do_not_disturb'
    | 'do_disturb_on'
    | 'do_disturb_off'
    | 'do_disturb_alt'
    | 'do_disturb'
    | 'dns'
    | 'divide'
    | 'display_settings'
    | 'discount'
    | 'discord'
    | 'disc_full'
    | 'disabled_visible'
    | 'disabled_by_default'
    | 'dirty_lens'
    | 'directions_walk'
    | 'directions_transit_filled'
    | 'directions_transit'
    | 'directions_subway_filled'
    | 'directions_subway'
    | 'directions_run'
    | 'directions_railway_filled'
    | 'directions_railway'
    | 'directions_off'
    | 'directions_car_filled'
    | 'directions_car'
    | 'directions_bus_filled'
    | 'directions_bus'
    | 'directions_boat_filled'
    | 'directions_boat'
    | 'directions_bike'
    | 'directions'
    | 'dinner_dining'
    | 'dining'
    | 'difference'
    | 'diamond'
    | 'dialpad'
    | 'dialer_sip'
    | 'devices_other'
    | 'devices_fold'
    | 'devices'
    | 'device_unknown'
    | 'device_thermostat'
    | 'device_hub'
    | 'developer_mode'
    | 'developer_board_off'
    | 'developer_board'
    | 'details'
    | 'desktop_windows'
    | 'desktop_mac'
    | 'desktop_access_disabled'
    | 'desk'
    | 'design_services'
    | 'deselect'
    | 'description'
    | 'departure_board'
    | 'density_small'
    | 'density_medium'
    | 'density_large'
    | 'delivery_dining'
    | 'delete_sweep'
    | 'delete_outline'
    | 'delete_forever'
    | 'delete'
    | 'dehaze'
    | 'deck'
    | 'deblur'
    | 'date_range'
    | 'data_usage'
    | 'data_thresholding'
    | 'data_saver_on'
    | 'data_saver_off'
    | 'data_object'
    | 'data_exploration'
    | 'data_array'
    | 'dashboard_customize'
    | 'dashboard'
    | 'dark_mode'
    | 'dangerous'
    | 'cyclone'
    | 'curtains_closed'
    | 'curtains'
    | 'currency_yuan'
    | 'currency_yen'
    | 'currency_rupee'
    | 'currency_ruble'
    | 'currency_pound'
    | 'currency_lira'
    | 'currency_franc'
    | 'currency_exchange'
    | 'currency_bitcoin'
    | 'css'
    | 'cruelty_free'
    | 'crop_square'
    | 'crop_rotate'
    | 'crop_portrait'
    | 'crop_original'
    | 'crop_landscape'
    | 'crop_free'
    | 'crop_din'
    | 'crop_16_9'
    | 'crop_7_5'
    | 'crop_5_4'
    | 'crop_3_2'
    | 'crop'
    | 'crisis_alert'
    | 'crib'
    | 'credit_score'
    | 'credit_card_off'
    | 'credit_card'
    | 'create_new_folder'
    | 'create'
    | 'countertops'
    | 'cottage'
    | 'corporate_fare'
    | 'coronavirus'
    | 'copyright'
    | 'copy_all'
    | 'cookie'
    | 'control_point_duplicate'
    | 'control_point'
    | 'control_camera'
    | 'contrast'
    | 'content_paste_search'
    | 'content_paste_off'
    | 'content_paste_go'
    | 'content_paste'
    | 'content_cut'
    | 'content_copy'
    | 'contacts'
    | 'contactless'
    | 'contact_support'
    | 'contact_phone'
    | 'contact_page'
    | 'contact_mail'
    | 'construction'
    | 'connecting_airports'
    | 'connected_tv'
    | 'connect_without_contact'
    | 'confirmation_number'
    | 'computer'
    | 'compress'
    | 'compost'
    | 'compass_calibration'
    | 'compare_arrows'
    | 'compare'
    | 'commute'
    | 'commit'
    | 'comments_disabled'
    | 'comment_bank'
    | 'comment'
    | 'colorize'
    | 'color_lens'
    | 'collections_bookmark'
    | 'collections'
    | 'coffee_maker'
    | 'coffee'
    | 'code_off'
    | 'code'
    | 'co2'
    | 'co_present'
    | 'cloud_upload'
    | 'cloud_sync'
    | 'cloud_queue'
    | 'cloud_off'
    | 'cloud_download'
    | 'cloud_done'
    | 'cloud_circle'
    | 'cloud'
    | 'closed_caption_off'
    | 'closed_caption_disabled'
    | 'closed_caption'
    | 'close_fullscreen'
    | 'close'
    | 'clear_all'
    | 'clear'
    | 'cleaning_services'
    | 'clean_hands'
    | 'class'
    | 'circle_notifications'
    | 'circle'
    | 'church'
    | 'chrome_reader_mode'
    | 'child_friendly'
    | 'child_care'
    | 'chevron_right'
    | 'chevron_left'
    | 'checkroom'
    | 'checklist_rtl'
    | 'checklist'
    | 'check_circle_outline'
    | 'check_circle'
    | 'check_box_outline_blank'
    | 'check_box'
    | 'check'
    | 'chat_bubble_outline'
    | 'chat_bubble'
    | 'chat'
    | 'charging_station'
    | 'change_history'
    | 'change_circle'
    | 'chalet'
    | 'chair_alt'
    | 'chair'
    | 'center_focus_weak'
    | 'center_focus_strong'
    | 'cell_wifi'
    | 'cell_tower'
    | 'celebration'
    | 'category'
    | 'catching_pokemon'
    | 'castle'
    | 'cast_for_education'
    | 'cast_connected'
    | 'cast'
    | 'casino'
    | 'cases'
    | 'carpenter'
    | 'card_travel'
    | 'card_membership'
    | 'card_giftcard'
    | 'car_repair'
    | 'car_rental'
    | 'car_crash'
    | 'candlestick_chart'
    | 'cancel_schedule_send'
    | 'cancel_presentation'
    | 'cancel'
    | 'campaign'
    | 'cameraswitch'
    | 'camera_roll'
    | 'camera_rear'
    | 'camera_outdoor'
    | 'camera_indoor'
    | 'camera_front'
    | 'camera_enhance'
    | 'camera_alt'
    | 'camera'
    | 'call_to_action'
    | 'call_split'
    | 'call_received'
    | 'call_missed_outgoing'
    | 'call_missed'
    | 'call_merge'
    | 'call_made'
    | 'call_end'
    | 'call'
    | 'calendar_view_week'
    | 'calendar_view_month'
    | 'calendar_view_day'
    | 'calendar_today'
    | 'calendar_month'
    | 'calculate'
    | 'cake'
    | 'cached'
    | 'cable'
    | 'cabin'
    | 'business_center'
    | 'business'
    | 'bus_alert'
    | 'burst_mode'
    | 'bungalow'
    | 'build_circle'
    | 'build'
    | 'bug_report'
    | 'bubble_chart'
    | 'brush'
    | 'brunch_dining'
    | 'browser_updated'
    | 'browser_not_supported'
    | 'browse_gallery'
    | 'broken_image'
    | 'broadcast_on_personal'
    | 'broadcast_on_home'
    | 'brightness_medium'
    | 'brightness_low'
    | 'brightness_high'
    | 'brightness_auto'
    | 'brightness_7'
    | 'brightness_6'
    | 'brightness_5'
    | 'brightness_4'
    | 'brightness_3'
    | 'brightness_2'
    | 'brightness_1'
    | 'breakfast_dining'
    | 'branding_watermark'
    | 'boy'
    | 'border_vertical'
    | 'border_top'
    | 'border_style'
    | 'border_right'
    | 'border_outer'
    | 'border_left'
    | 'border_inner'
    | 'border_horizontal'
    | 'border_color'
    | 'border_clear'
    | 'border_bottom'
    | 'border_all'
    | 'bookmarks'
    | 'bookmark_remove'
    | 'bookmark_border'
    | 'bookmark_added'
    | 'bookmark_add'
    | 'bookmark'
    | 'book_online'
    | 'book'
    | 'bolt'
    | 'blur_on'
    | 'blur_off'
    | 'blur_linear'
    | 'blur_circular'
    | 'bluetooth_searching'
    | 'bluetooth_drive'
    | 'bluetooth_disabled'
    | 'bluetooth_connected'
    | 'bluetooth_audio'
    | 'bluetooth'
    | 'bloodtype'
    | 'block'
    | 'blinds_closed'
    | 'blinds'
    | 'blender'
    | 'biotech'
    | 'bike_scooter'
    | 'bento'
    | 'beenhere'
    | 'bedtime_off'
    | 'bedtime'
    | 'bedroom_parent'
    | 'bedroom_child'
    | 'bedroom_baby'
    | 'bed'
    | 'beach_access'
    | 'battery_unknown'
    | 'battery_std'
    | 'battery_saver'
    | 'battery_full'
    | 'battery_charging_full'
    | 'battery_charging_90'
    | 'battery_charging_80'
    | 'battery_charging_60'
    | 'battery_charging_50'
    | 'battery_charging_30'
    | 'battery_charging_20'
    | 'battery_alert'
    | 'battery_90'
    | 'battery_80'
    | 'battery_60'
    | 'battery_50'
    | 'battery_30'
    | 'battery_20'
    | 'battery_6_bar'
    | 'battery_5_bar'
    | 'battery_4_bar'
    | 'battery_3_bar'
    | 'battery_2_bar'
    | 'battery_1_bar'
    | 'battery_0_bar'
    | 'bathtub'
    | 'bathroom'
    | 'batch_prediction'
    | 'barcode'
    | 'bar_chart'
    | 'ballot'
    | 'balcony'
    | 'balance'
    | 'bakery_dining'
    | 'badge'
    | 'backup_table'
    | 'backup'
    | 'backspace'
    | 'backpack'
    | 'back_hand'
    | 'baby_changing_station'
    | 'av_timer'
    | 'autorenew'
    | 'autofps_select'
    | 'auto_stories'
    | 'auto_mode'
    | 'auto_graph'
    | 'auto_fix_off'
    | 'auto_fix_normal'
    | 'auto_fix_high'
    | 'auto_delete'
    | 'auto_awesome_motion'
    | 'auto_awesome_mosaic'
    | 'auto_awesome'
    | 'audiotrack'
    | 'audio_file'
    | 'attribution'
    | 'attractions'
    | 'attachment'
    | 'attach_money'
    | 'attach_file'
    | 'attach_email'
    | 'atm'
    | 'assured_workload'
    | 'assistant_photo'
    | 'assistant_direction'
    | 'assistant'
    | 'assignment_turned_in'
    | 'assignment_returned'
    | 'assignment_return'
    | 'assignment_late'
    | 'assignment_ind'
    | 'assignment'
    | 'assessment'
    | 'aspect_ratio'
    | 'article'
    | 'art_track'
    | 'arrow_upward'
    | 'arrow_right_alt'
    | 'arrow_right'
    | 'arrow_left'
    | 'arrow_forward_ios'
    | 'arrow_forward'
    | 'arrow_drop_up'
    | 'arrow_drop_down_circle'
    | 'arrow_drop_down'
    | 'arrow_downward'
    | 'arrow_circle_up'
    | 'arrow_circle_right'
    | 'arrow_circle_left'
    | 'arrow_circle_down'
    | 'arrow_back_ios_new'
    | 'arrow_back_ios'
    | 'arrow_back'
    | 'area_chart'
    | 'archive'
    | 'architecture'
    | 'apps_outage'
    | 'apps'
    | 'approval'
    | 'apple'
    | 'app_shortcut'
    | 'app_settings_alt'
    | 'app_registration'
    | 'app_blocking'
    | 'api'
    | 'apartment'
    | 'aod'
    | 'announcement'
    | 'animation'
    | 'android'
    | 'anchor'
    | 'analytics'
    | 'amp_stories'
    | 'alternate_email'
    | 'alt_route'
    | 'all_out'
    | 'all_inclusive'
    | 'all_inbox'
    | 'align_vertical_top'
    | 'align_vertical_center'
    | 'align_vertical_bottom'
    | 'align_horizontal_right'
    | 'align_horizontal_left'
    | 'align_horizontal_center'
    | 'album'
    | 'alarm_on'
    | 'alarm_off'
    | 'alarm_add'
    | 'alarm'
    | 'airport_shuttle'
    | 'airplay'
    | 'airplanemode_inactive'
    | 'airplanemode_active'
    | 'airplane_ticket'
    | 'airlines'
    | 'airline_stops'
    | 'airline_seat_recline_normal'
    | 'airline_seat_recline_extra'
    | 'airline_seat_legroom_reduced'
    | 'airline_seat_legroom_normal'
    | 'airline_seat_legroom_extra'
    | 'airline_seat_individual_suite'
    | 'airline_seat_flat_angled'
    | 'airline_seat_flat'
    | 'air'
    | 'agriculture'
    | 'ads_click'
    | 'adobe'
    | 'admin_panel_settings'
    | 'adjust'
    | 'adf_scanner'
    | 'addchart'
    | 'add_to_queue'
    | 'add_to_photos'
    | 'add_to_home_screen'
    | 'add_to_drive'
    | 'add_task'
    | 'add_shopping_cart'
    | 'add_road'
    | 'add_reaction'
    | 'add_photo_alternate'
    | 'add_moderator'
    | 'add_location_alt'
    | 'add_location'
    | 'add_link'
    | 'add_ic_call'
    | 'add_comment'
    | 'add_circle_outline'
    | 'add_circle'
    | 'add_chart'
    | 'add_card'
    | 'add_business'
    | 'add_box'
    | 'add_alert'
    | 'add_alarm'
    | 'add_a_photo'
    | 'add'
    | 'adb'
    | 'ad_units'
    | 'account_tree'
    | 'account_circle'
    | 'account_box'
    | 'account_balance_wallet'
    | 'account_balance'
    | 'accessible_forward'
    | 'accessible'
    | 'accessibility_new'
    | 'accessibility'
    | 'access_time_filled'
    | 'access_time'
    | 'access_alarms'
    | 'access_alarm'
    | 'ac_unit'
    | 'abc'
    | '360'
    | '123'
    | '60fps_select'
    | '60fps'
    | '30fps_select'
    | '30fps'
    | '24mp'
    | '23mp'
    | '22mp'
    | '21mp'
    | '20mp'
    | '19mp'
    | '18mp'
    | '18_up_rating'
    | '17mp'
    | '16mp'
    | '15mp'
    | '14mp'
    | '13mp'
    | '12mp'
    | '11mp'
    | '10mp'
    | '10k'
    | '9mp'
    | '9k_plus'
    | '9k'
    | '8mp'
    | '8k_plus'
    | '8k'
    | '7mp'
    | '7k_plus'
    | '7k'
    | '6mp'
    | '6k_plus'
    | '6k'
    | '6_ft_apart'
    | '5mp'
    | '5k_plus'
    | '5k'
    | '5g'
    | '4mp'
    | '4k_plus'
    | '4k'
    | '4g_plus_mobiledata'
    | '4g_mobiledata'
    | '3p'
    | '3mp'
    | '3k_plus'
    | '3k'
    | '3g_mobiledata'
    | '3d_rotation'
    | '2mp'
    | '2k_plus'
    | '2k'
    | '1x_mobiledata'
    | '1k_plus'
    | '1k'
  phosphor: {
    thin:
      | 'activity'
      | 'address-book'
      | 'airplane-in-flight'
      | 'airplane-landing'
      | 'airplane-takeoff'
      | 'airplane'
      | 'airplane-tilt'
      | 'airplay'
      | 'alarm'
      | 'alien'
      | 'align-bottom-simple'
      | 'align-bottom'
      | 'align-center-horizontal-simple'
      | 'align-center-horizontal'
      | 'align-center-vertical-simple'
      | 'align-center-vertical'
      | 'align-left-simple'
      | 'align-left'
      | 'align-right-simple'
      | 'align-right'
      | 'align-top-simple'
      | 'align-top'
      | 'anchor-simple'
      | 'anchor'
      | 'android-logo'
      | 'angular-logo'
      | 'aperture'
      | 'app-store-logo'
      | 'app-window'
      | 'apple-logo'
      | 'apple-podcasts-logo'
      | 'archive-box'
      | 'archive'
      | 'archive-tray'
      | 'armchair'
      | 'arrow-arc-left'
      | 'arrow-arc-right'
      | 'arrow-bend-double-up-left'
      | 'arrow-bend-double-up-right'
      | 'arrow-bend-down-left'
      | 'arrow-bend-down-right'
      | 'arrow-bend-left-down'
      | 'arrow-bend-left-up'
      | 'arrow-bend-right-down'
      | 'arrow-bend-right-up'
      | 'arrow-bend-up-left'
      | 'arrow-bend-up-right'
      | 'arrow-circle-down-left'
      | 'arrow-circle-down-right'
      | 'arrow-circle-down'
      | 'arrow-circle-left'
      | 'arrow-circle-right'
      | 'arrow-circle-up-left'
      | 'arrow-circle-up-right'
      | 'arrow-circle-up'
      | 'arrow-clockwise'
      | 'arrow-counter-clockwise'
      | 'arrow-down-left'
      | 'arrow-down-right'
      | 'arrow-down'
      | 'arrow-elbow-down-left'
      | 'arrow-elbow-down-right'
      | 'arrow-elbow-left-down'
      | 'arrow-elbow-left'
      | 'arrow-elbow-left-up'
      | 'arrow-elbow-right-down'
      | 'arrow-elbow-right'
      | 'arrow-elbow-right-up'
      | 'arrow-elbow-up-left'
      | 'arrow-elbow-up-right'
      | 'arrow-fat-down'
      | 'arrow-fat-left'
      | 'arrow-fat-line-down'
      | 'arrow-fat-line-left'
      | 'arrow-fat-line-right'
      | 'arrow-fat-line-up'
      | 'arrow-fat-lines-down'
      | 'arrow-fat-lines-left'
      | 'arrow-fat-lines-right'
      | 'arrow-fat-lines-up'
      | 'arrow-fat-right'
      | 'arrow-fat-up'
      | 'arrow-left'
      | 'arrow-line-down-left'
      | 'arrow-line-down-right'
      | 'arrow-line-down'
      | 'arrow-line-left'
      | 'arrow-line-right'
      | 'arrow-line-up-left'
      | 'arrow-line-up-right'
      | 'arrow-line-up'
      | 'arrow-right'
      | 'arrow-square-down-left'
      | 'arrow-square-down-right'
      | 'arrow-square-down'
      | 'arrow-square-in'
      | 'arrow-square-left'
      | 'arrow-square-out'
      | 'arrow-square-right'
      | 'arrow-square-up-left'
      | 'arrow-square-up-right'
      | 'arrow-square-up'
      | 'arrow-u-down-left'
      | 'arrow-u-down-right'
      | 'arrow-u-left-down'
      | 'arrow-u-left-up'
      | 'arrow-u-right-down'
      | 'arrow-u-right-up'
      | 'arrow-u-up-left'
      | 'arrow-u-up-right'
      | 'arrow-up-left'
      | 'arrow-up-right'
      | 'arrow-up'
      | 'arrows-clockwise'
      | 'arrows-counter-clockwise'
      | 'arrows-down-up'
      | 'arrows-horizontal'
      | 'arrows-in-cardinal'
      | 'arrows-in-line-horizontal'
      | 'arrows-in-line-vertical'
      | 'arrows-in-simple'
      | 'arrows-in'
      | 'arrows-left-right'
      | 'arrows-out-cardinal'
      | 'arrows-out-line-horizontal'
      | 'arrows-out-line-vertical'
      | 'arrows-out-simple'
      | 'arrows-out'
      | 'arrows-vertical'
      | 'article-medium'
      | 'article-ny-times'
      | 'article'
      | 'asterisk-simple'
      | 'asterisk'
      | 'at'
      | 'atom'
      | 'baby'
      | 'backpack'
      | 'backspace'
      | 'bag-simple'
      | 'bag'
      | 'balloon'
      | 'bandaids'
      | 'bank'
      | 'barbell'
      | 'barcode'
      | 'barricade'
      | 'baseball'
      | 'basketball'
      | 'bathtub'
      | 'battery-charging'
      | 'battery-charging-vertical'
      | 'battery-empty'
      | 'battery-full'
      | 'battery-high'
      | 'battery-low'
      | 'battery-medium'
      | 'battery-plus'
      | 'battery-warning'
      | 'battery-warning-vertical'
      | 'bed'
      | 'beer-bottle'
      | 'behance-logo'
      | 'bell-ringing'
      | 'bell-simple-ringing'
      | 'bell-simple-slash'
      | 'bell-simple'
      | 'bell-simple-z'
      | 'bell-slash'
      | 'bell'
      | 'bell-z'
      | 'bezier-curve'
      | 'bicycle'
      | 'binoculars'
      | 'bird'
      | 'bluetooth-connected'
      | 'bluetooth-slash'
      | 'bluetooth'
      | 'bluetooth-x'
      | 'boat'
      | 'book-bookmark'
      | 'book-open'
      | 'book'
      | 'bookmark-simple'
      | 'bookmark'
      | 'bookmarks-simple'
      | 'bookmarks'
      | 'books'
      | 'bounding-box'
      | 'brackets-angle'
      | 'brackets-curly'
      | 'brackets-round'
      | 'brackets-square'
      | 'brain'
      | 'brandy'
      | 'briefcase-metal'
      | 'briefcase'
      | 'broadcast'
      | 'browser'
      | 'browsers'
      | 'bug-beetle'
      | 'bug-droid'
      | 'bug'
      | 'buildings'
      | 'bus'
      | 'butterfly'
      | 'cactus'
      | 'cake'
      | 'calculator'
      | 'calendar-blank'
      | 'calendar-check'
      | 'calendar-plus'
      | 'calendar'
      | 'calendar-x'
      | 'camera-rotate'
      | 'camera-slash'
      | 'camera'
      | 'campfire'
      | 'car-simple'
      | 'car'
      | 'cardholder'
      | 'cards'
      | 'caret-circle-double-down'
      | 'caret-circle-double-left'
      | 'caret-circle-double-right'
      | 'caret-circle-double-up'
      | 'caret-circle-down'
      | 'caret-circle-left'
      | 'caret-circle-right'
      | 'caret-circle-up'
      | 'caret-double-down'
      | 'caret-double-left'
      | 'caret-double-right'
      | 'caret-double-up'
      | 'caret-down'
      | 'caret-left'
      | 'caret-right'
      | 'caret-up'
      | 'cat'
      | 'cell-signal-full'
      | 'cell-signal-high'
      | 'cell-signal-low'
      | 'cell-signal-medium'
      | 'cell-signal-none'
      | 'cell-signal-slash'
      | 'cell-signal-x'
      | 'chalkboard-simple'
      | 'chalkboard-teacher'
      | 'chalkboard'
      | 'chart-bar-horizontal'
      | 'chart-bar'
      | 'chart-line'
      | 'chart-line-up'
      | 'chart-pie-slice'
      | 'chart-pie'
      | 'chat-centered-dots'
      | 'chat-centered-text'
      | 'chat-centered'
      | 'chat-circle-dots'
      | 'chat-circle-text'
      | 'chat-circle'
      | 'chat-dots'
      | 'chat-teardrop-dots'
      | 'chat-teardrop-text'
      | 'chat-teardrop'
      | 'chat-text'
      | 'chat'
      | 'chats-circle'
      | 'chats-teardrop'
      | 'chats'
      | 'check-circle'
      | 'check-square-offset'
      | 'check-square'
      | 'check'
      | 'checks'
      | 'circle-dashed'
      | 'circle-half'
      | 'circle-half-tilt'
      | 'circle-notch'
      | 'circle'
      | 'circle-wavy-check'
      | 'circle-wavy-question'
      | 'circle-wavy'
      | 'circle-wavy-warning'
      | 'circles-four'
      | 'circles-three-plus'
      | 'circles-three'
      | 'clipboard-text'
      | 'clipboard'
      | 'clock-afternoon'
      | 'clock-clockwise'
      | 'clock-counter-clockwise'
      | 'clock'
      | 'closed-captioning'
      | 'cloud-arrow-down'
      | 'cloud-arrow-up'
      | 'cloud-check'
      | 'cloud-fog'
      | 'cloud-lightning'
      | 'cloud-moon'
      | 'cloud-rain'
      | 'cloud-slash'
      | 'cloud-snow'
      | 'cloud-sun'
      | 'cloud'
      | 'club'
      | 'coat-hanger'
      | 'code-simple'
      | 'code'
      | 'codepen-logo'
      | 'codesandbox-logo'
      | 'coffee'
      | 'coin'
      | 'coin-vertical'
      | 'coins'
      | 'columns'
      | 'command'
      | 'compass'
      | 'computer-tower'
      | 'confetti'
      | 'cookie'
      | 'cooking-pot'
      | 'copy-simple'
      | 'copy'
      | 'copyleft'
      | 'copyright'
      | 'corners-in'
      | 'corners-out'
      | 'cpu'
      | 'credit-card'
      | 'crop'
      | 'crosshair-simple'
      | 'crosshair'
      | 'crown-simple'
      | 'crown'
      | 'cube'
      | 'currency-btc'
      | 'currency-circle-dollar'
      | 'currency-cny'
      | 'currency-dollar-simple'
      | 'currency-dollar'
      | 'currency-eth'
      | 'currency-eur'
      | 'currency-gbp'
      | 'currency-inr'
      | 'currency-jpy'
      | 'currency-krw'
      | 'currency-kzt'
      | 'currency-ngn'
      | 'currency-rub'
      | 'cursor-text'
      | 'cursor'
      | 'cylinder'
      | 'database'
      | 'desktop'
      | 'desktop-tower'
      | 'detective'
      | 'device-mobile-camera'
      | 'device-mobile-speaker'
      | 'device-mobile'
      | 'device-tablet-camera'
      | 'device-tablet-speaker'
      | 'device-tablet'
      | 'diamond'
      | 'diamonds-four'
      | 'dice-five'
      | 'dice-four'
      | 'dice-one'
      | 'dice-six'
      | 'dice-three'
      | 'dice-two'
      | 'disc'
      | 'discord-logo'
      | 'divide'
      | 'dog'
      | 'door'
      | 'dots-nine'
      | 'dots-six'
      | 'dots-six-vertical'
      | 'dots-three-circle'
      | 'dots-three-circle-vertical'
      | 'dots-three-outline'
      | 'dots-three-outline-vertical'
      | 'dots-three'
      | 'dots-three-vertical'
      | 'download-simple'
      | 'download'
      | 'dribbble-logo'
      | 'drop-half-bottom'
      | 'drop-half'
      | 'drop'
      | 'ear-slash'
      | 'ear'
      | 'egg-crack'
      | 'egg'
      | 'eject-simple'
      | 'eject'
      | 'envelope-open'
      | 'envelope-simple-open'
      | 'envelope-simple'
      | 'envelope'
      | 'equalizer'
      | 'equals'
      | 'eraser'
      | 'exam'
      | 'export'
      | 'eye-closed'
      | 'eye-slash'
      | 'eye'
      | 'eyedropper-sample'
      | 'eyedropper'
      | 'eyeglasses'
      | 'face-mask'
      | 'facebook-logo'
      | 'factory'
      | 'faders-horizontal'
      | 'faders'
      | 'fast-forward-circle'
      | 'fast-forward'
      | 'figma-logo'
      | 'file-arrow-down'
      | 'file-arrow-up'
      | 'file-audio'
      | 'file-cloud'
      | 'file-code'
      | 'file-css'
      | 'file-csv'
      | 'file-doc'
      | 'file-dotted'
      | 'file-html'
      | 'file-image'
      | 'file-jpg'
      | 'file-js'
      | 'file-jsx'
      | 'file-lock'
      | 'file-minus'
      | 'file-pdf'
      | 'file-plus'
      | 'file-png'
      | 'file-ppt'
      | 'file-rs'
      | 'file-search'
      | 'file-text'
      | 'file'
      | 'file-ts'
      | 'file-tsx'
      | 'file-video'
      | 'file-vue'
      | 'file-x'
      | 'file-xls'
      | 'file-zip'
      | 'files'
      | 'film-script'
      | 'film-slate'
      | 'film-strip'
      | 'fingerprint-simple'
      | 'fingerprint'
      | 'finn-the-human'
      | 'fire-simple'
      | 'fire'
      | 'first-aid-kit'
      | 'first-aid'
      | 'fish-simple'
      | 'fish'
      | 'flag-banner'
      | 'flag-checkered'
      | 'flag'
      | 'flame'
      | 'flashlight'
      | 'flask'
      | 'floppy-disk-back'
      | 'floppy-disk'
      | 'flow-arrow'
      | 'flower-lotus'
      | 'flower'
      | 'flying-saucer'
      | 'folder-dotted'
      | 'folder-lock'
      | 'folder-minus'
      | 'folder-notch-minus'
      | 'folder-notch-open'
      | 'folder-notch-plus'
      | 'folder-notch'
      | 'folder-open'
      | 'folder-plus'
      | 'folder-simple-dotted'
      | 'folder-simple-lock'
      | 'folder-simple-minus'
      | 'folder-simple-plus'
      | 'folder-simple-star'
      | 'folder-simple'
      | 'folder-simple-user'
      | 'folder-star'
      | 'folder'
      | 'folder-user'
      | 'folders'
      | 'football'
      | 'fork-knife'
      | 'frame-corners'
      | 'framer-logo'
      | 'function'
      | 'funnel-simple'
      | 'funnel'
      | 'game-controller'
      | 'gas-pump'
      | 'gauge'
      | 'gear-six'
      | 'gear'
      | 'gender-female'
      | 'gender-intersex'
      | 'gender-male'
      | 'gender-neuter'
      | 'gender-nonbinary'
      | 'gender-transgender'
      | 'ghost'
      | 'gif'
      | 'gift'
      | 'git-branch'
      | 'git-commit'
      | 'git-diff'
      | 'git-fork'
      | 'git-merge'
      | 'git-pull-request'
      | 'github-logo'
      | 'gitlab-logo-simple'
      | 'gitlab-logo'
      | 'globe-hemisphere-east'
      | 'globe-hemisphere-west'
      | 'globe-simple'
      | 'globe-stand'
      | 'globe'
      | 'google-chrome-logo'
      | 'google-logo'
      | 'google-photos-logo'
      | 'google-play-logo'
      | 'google-podcasts-logo'
      | 'gradient'
      | 'graduation-cap'
      | 'graph'
      | 'grid-four'
      | 'hamburger'
      | 'hand-eye'
      | 'hand-fist'
      | 'hand-grabbing'
      | 'hand-palm'
      | 'hand-pointing'
      | 'hand-soap'
      | 'hand'
      | 'hand-waving'
      | 'handbag-simple'
      | 'handbag'
      | 'hands-clapping'
      | 'handshake'
      | 'hard-drive'
      | 'hard-drives'
      | 'hash-straight'
      | 'hash'
      | 'headlights'
      | 'headphones'
      | 'headset'
      | 'heart-break'
      | 'heart-straight-break'
      | 'heart-straight'
      | 'heart'
      | 'heartbeat'
      | 'hexagon'
      | 'highlighter-circle'
      | 'horse'
      | 'hourglass-high'
      | 'hourglass-low'
      | 'hourglass-medium'
      | 'hourglass-simple-high'
      | 'hourglass-simple-low'
      | 'hourglass-simple-medium'
      | 'hourglass-simple'
      | 'hourglass'
      | 'house-line'
      | 'house-simple'
      | 'house'
      | 'identification-badge'
      | 'identification-card'
      | 'image-square'
      | 'image'
      | 'infinity'
      | 'info'
      | 'instagram-logo'
      | 'intersect'
      | 'jeep'
      | 'kanban'
      | 'key-return'
      | 'key'
      | 'keyboard'
      | 'keyhole'
      | 'knife'
      | 'ladder-simple'
      | 'ladder'
      | 'lamp'
      | 'laptop'
      | 'layout'
      | 'leaf'
      | 'lifebuoy'
      | 'lightbulb-filament'
      | 'lightbulb'
      | 'lightning-slash'
      | 'lightning'
      | 'line-segment'
      | 'line-segments'
      | 'link-break'
      | 'link-simple-break'
      | 'link-simple-horizontal-break'
      | 'link-simple-horizontal'
      | 'link-simple'
      | 'link'
      | 'linkedin-logo'
      | 'linux-logo'
      | 'list-bullets'
      | 'list-checks'
      | 'list-dashes'
      | 'list-numbers'
      | 'list-plus'
      | 'list'
      | 'lock-key-open'
      | 'lock-key'
      | 'lock-laminated-open'
      | 'lock-laminated'
      | 'lock-open'
      | 'lock-simple-open'
      | 'lock-simple'
      | 'lock'
      | 'magic-wand'
      | 'magnet-straight'
      | 'magnet'
      | 'magnifying-glass-minus'
      | 'magnifying-glass-plus'
      | 'magnifying-glass'
      | 'map-pin-line'
      | 'map-pin'
      | 'map-trifold'
      | 'marker-circle'
      | 'martini'
      | 'mask-happy'
      | 'mask-sad'
      | 'math-operations'
      | 'medal'
      | 'medium-logo'
      | 'megaphone-simple'
      | 'megaphone'
      | 'messenger-logo'
      | 'microphone-slash'
      | 'microphone-stage'
      | 'microphone'
      | 'microsoft-excel-logo'
      | 'microsoft-powerpoint-logo'
      | 'microsoft-teams-logo'
      | 'microsoft-word-logo'
      | 'minus-circle'
      | 'minus'
      | 'money'
      | 'monitor-play'
      | 'monitor'
      | 'moon-stars'
      | 'moon'
      | 'mountains'
      | 'mouse-simple'
      | 'mouse'
      | 'music-note-simple'
      | 'music-note'
      | 'music-notes-plus'
      | 'music-notes-simple'
      | 'music-notes'
      | 'navigation-arrow'
      | 'needle'
      | 'newspaper-clipping'
      | 'newspaper'
      | 'note-blank'
      | 'note-pencil'
      | 'note'
      | 'notebook'
      | 'notepad'
      | 'notification'
      | 'number-circle-eight'
      | 'number-circle-five'
      | 'number-circle-four'
      | 'number-circle-nine'
      | 'number-circle-one'
      | 'number-circle-seven'
      | 'number-circle-six'
      | 'number-circle-three'
      | 'number-circle-two'
      | 'number-circle-zero'
      | 'number-eight'
      | 'number-five'
      | 'number-four'
      | 'number-nine'
      | 'number-one'
      | 'number-seven'
      | 'number-six'
      | 'number-square-eight'
      | 'number-square-five'
      | 'number-square-four'
      | 'number-square-nine'
      | 'number-square-one'
      | 'number-square-seven'
      | 'number-square-six'
      | 'number-square-three'
      | 'number-square-two'
      | 'number-square-zero'
      | 'number-three'
      | 'number-two'
      | 'number-zero'
      | 'nut'
      | 'ny-times-logo'
      | 'octagon'
      | 'option'
      | 'package'
      | 'paint-brush-broad'
      | 'paint-brush-household'
      | 'paint-brush'
      | 'paint-bucket'
      | 'paint-roller'
      | 'palette'
      | 'paper-plane-right'
      | 'paper-plane'
      | 'paper-plane-tilt'
      | 'paperclip-horizontal'
      | 'paperclip'
      | 'parachute'
      | 'password'
      | 'path'
      | 'pause-circle'
      | 'pause'
      | 'paw-print'
      | 'peace'
      | 'pen-nib-straight'
      | 'pen-nib'
      | 'pen'
      | 'pencil-circle'
      | 'pencil-line'
      | 'pencil-simple-line'
      | 'pencil-simple'
      | 'pencil'
      | 'percent'
      | 'person-simple-run'
      | 'person-simple'
      | 'person-simple-walk'
      | 'person'
      | 'perspective'
      | 'phone-call'
      | 'phone-disconnect'
      | 'phone-incoming'
      | 'phone-outgoing'
      | 'phone-slash'
      | 'phone'
      | 'phone-x'
      | 'phosphor-logo'
      | 'piano-keys'
      | 'picture-in-picture'
      | 'pill'
      | 'pinterest-logo'
      | 'pinwheel'
      | 'pizza'
      | 'placeholder'
      | 'planet'
      | 'play-circle'
      | 'play'
      | 'playlist'
      | 'plug'
      | 'plugs-connected'
      | 'plugs'
      | 'plus-circle'
      | 'plus-minus'
      | 'plus'
      | 'poker-chip'
      | 'police-car'
      | 'polygon'
      | 'popcorn'
      | 'power'
      | 'prescription'
      | 'presentation-chart'
      | 'presentation'
      | 'printer'
      | 'prohibit-inset'
      | 'prohibit'
      | 'projector-screen-chart'
      | 'projector-screen'
      | 'push-pin-simple-slash'
      | 'push-pin-simple'
      | 'push-pin-slash'
      | 'push-pin'
      | 'puzzle-piece'
      | 'qr-code'
      | 'question'
      | 'queue'
      | 'quotes'
      | 'radical'
      | 'radio-button'
      | 'radio'
      | 'rainbow-cloud'
      | 'rainbow'
      | 'receipt'
      | 'record'
      | 'rectangle'
      | 'recycle'
      | 'reddit-logo'
      | 'repeat-once'
      | 'repeat'
      | 'rewind-circle'
      | 'rewind'
      | 'robot'
      | 'rocket-launch'
      | 'rocket'
      | 'rows'
      | 'rss-simple'
      | 'rss'
      | 'rug'
      | 'ruler'
      | 'scales'
      | 'scan'
      | 'scissors'
      | 'screencast'
      | 'scribble-loop'
      | 'scroll'
      | 'selection-all'
      | 'selection-background'
      | 'selection-foreground'
      | 'selection-inverse'
      | 'selection-plus'
      | 'selection-slash'
      | 'selection'
      | 'share-network'
      | 'share'
      | 'shield-check'
      | 'shield-checkered'
      | 'shield-chevron'
      | 'shield-plus'
      | 'shield-slash'
      | 'shield-star'
      | 'shield'
      | 'shield-warning'
      | 'shopping-bag-open'
      | 'shopping-bag'
      | 'shopping-cart-simple'
      | 'shopping-cart'
      | 'shower'
      | 'shuffle-angular'
      | 'shuffle-simple'
      | 'shuffle'
      | 'sidebar-simple'
      | 'sidebar'
      | 'sign-in'
      | 'sign-out'
      | 'signpost'
      | 'sim-card'
      | 'sketch-logo'
      | 'skip-back-circle'
      | 'skip-back'
      | 'skip-forward-circle'
      | 'skip-forward'
      | 'skull'
      | 'slack-logo'
      | 'sliders-horizontal'
      | 'sliders'
      | 'smiley-blank'
      | 'smiley-meh'
      | 'smiley-nervous'
      | 'smiley-sad'
      | 'smiley-sticker'
      | 'smiley'
      | 'smiley-wink'
      | 'smiley-x-eyes'
      | 'snapchat-logo'
      | 'snowflake'
      | 'soccer-ball'
      | 'sort-ascending'
      | 'sort-descending'
      | 'spade'
      | 'sparkle'
      | 'speaker-high'
      | 'speaker-low'
      | 'speaker-none'
      | 'speaker-simple-high'
      | 'speaker-simple-low'
      | 'speaker-simple-none'
      | 'speaker-simple-slash'
      | 'speaker-simple-x'
      | 'speaker-slash'
      | 'speaker-x'
      | 'spinner-gap'
      | 'spinner'
      | 'spiral'
      | 'spotify-logo'
      | 'square-half-bottom'
      | 'square-half'
      | 'square-logo'
      | 'square'
      | 'squares-four'
      | 'stack-overflow-logo'
      | 'stack-simple'
      | 'stack'
      | 'stamp'
      | 'star-four'
      | 'star-half'
      | 'star'
      | 'sticker'
      | 'stop-circle'
      | 'stop'
      | 'storefront'
      | 'strategy'
      | 'stripe-logo'
      | 'student'
      | 'suitcase-simple'
      | 'suitcase'
      | 'sun-dim'
      | 'sun-horizon'
      | 'sun'
      | 'sunglasses'
      | 'swap'
      | 'swatches'
      | 'sword'
      | 'syringe'
      | 't-shirt'
      | 'table'
      | 'tabs'
      | 'tag-chevron'
      | 'tag-simple'
      | 'tag'
      | 'target'
      | 'taxi'
      | 'telegram-logo'
      | 'television-simple'
      | 'television'
      | 'tennis-ball'
      | 'terminal'
      | 'terminal-window'
      | 'test-tube'
      | 'text-aa'
      | 'text-align-center'
      | 'text-align-justify'
      | 'text-align-left'
      | 'text-align-right'
      | 'text-bolder'
      | 'text-h-five'
      | 'text-h-four'
      | 'text-h-one'
      | 'text-h-six'
      | 'text-h'
      | 'text-h-three'
      | 'text-h-two'
      | 'text-indent'
      | 'text-italic'
      | 'text-outdent'
      | 'text-strikethrough'
      | 'text-t'
      | 'text-underline'
      | 'textbox'
      | 'thermometer-cold'
      | 'thermometer-hot'
      | 'thermometer-simple'
      | 'thermometer'
      | 'thumbs-down'
      | 'thumbs-up'
      | 'ticket'
      | 'tiktok-logo'
      | 'timer'
      | 'toggle-left'
      | 'toggle-right'
      | 'toilet-paper'
      | 'toilet'
      | 'tote-simple'
      | 'tote'
      | 'trademark-registered'
      | 'traffic-cone'
      | 'traffic-sign'
      | 'traffic-signal'
      | 'train-regional'
      | 'train-simple'
      | 'train'
      | 'translate'
      | 'trash-simple'
      | 'trash'
      | 'tray'
      | 'tree-evergreen'
      | 'tree-structure'
      | 'tree'
      | 'trend-down'
      | 'trend-up'
      | 'triangle'
      | 'trophy'
      | 'truck'
      | 'twitch-logo'
      | 'twitter-logo'
      | 'umbrella-simple'
      | 'umbrella'
      | 'upload-simple'
      | 'upload'
      | 'user-circle-gear'
      | 'user-circle-minus'
      | 'user-circle-plus'
      | 'user-circle'
      | 'user-focus'
      | 'user-gear'
      | 'user-list'
      | 'user-minus'
      | 'user-plus'
      | 'user-rectangle'
      | 'user-square'
      | 'user-switch'
      | 'user'
      | 'users-four'
      | 'users'
      | 'users-three'
      | 'vault'
      | 'vibrate'
      | 'video-camera-slash'
      | 'video-camera'
      | 'vignette'
      | 'voicemail'
      | 'volleyball'
      | 'wall'
      | 'wallet'
      | 'warning-circle'
      | 'warning-octagon'
      | 'warning'
      | 'watch'
      | 'wave-sawtooth'
      | 'wave-sine'
      | 'wave-square'
      | 'wave-triangle'
      | 'waves'
      | 'webcam'
      | 'whatsapp-logo'
      | 'wheelchair'
      | 'wifi-high'
      | 'wifi-low'
      | 'wifi-medium'
      | 'wifi-none'
      | 'wifi-slash'
      | 'wifi-x'
      | 'wind'
      | 'windows-logo'
      | 'wine'
      | 'wrench'
      | 'x-circle'
      | 'x-square'
      | 'x'
      | 'yin-yang'
      | 'youtube-logo'
    regular:
      | 'activity'
      | 'address-book'
      | 'airplane'
      | 'airplane-in-flight'
      | 'airplane-landing'
      | 'airplane-takeoff'
      | 'airplane-tilt'
      | 'airplay'
      | 'alarm'
      | 'alien'
      | 'align-bottom'
      | 'align-bottom-simple'
      | 'align-center-horizontal'
      | 'align-center-horizontal-simple'
      | 'align-center-vertical'
      | 'align-center-vertical-simple'
      | 'align-left'
      | 'align-left-simple'
      | 'align-right'
      | 'align-right-simple'
      | 'align-top'
      | 'align-top-simple'
      | 'anchor'
      | 'anchor-simple'
      | 'android-logo'
      | 'angular-logo'
      | 'aperture'
      | 'app-store-logo'
      | 'app-window'
      | 'apple-logo'
      | 'apple-podcasts-logo'
      | 'archive'
      | 'archive-box'
      | 'archive-tray'
      | 'armchair'
      | 'arrow-arc-left'
      | 'arrow-arc-right'
      | 'arrow-bend-double-up-left'
      | 'arrow-bend-double-up-right'
      | 'arrow-bend-down-left'
      | 'arrow-bend-down-right'
      | 'arrow-bend-left-down'
      | 'arrow-bend-left-up'
      | 'arrow-bend-right-down'
      | 'arrow-bend-right-up'
      | 'arrow-bend-up-left'
      | 'arrow-bend-up-right'
      | 'arrow-circle-down'
      | 'arrow-circle-down-left'
      | 'arrow-circle-down-right'
      | 'arrow-circle-left'
      | 'arrow-circle-right'
      | 'arrow-circle-up'
      | 'arrow-circle-up-left'
      | 'arrow-circle-up-right'
      | 'arrow-clockwise'
      | 'arrow-counter-clockwise'
      | 'arrow-down'
      | 'arrow-down-left'
      | 'arrow-down-right'
      | 'arrow-elbow-down-left'
      | 'arrow-elbow-down-right'
      | 'arrow-elbow-left'
      | 'arrow-elbow-left-down'
      | 'arrow-elbow-left-up'
      | 'arrow-elbow-right'
      | 'arrow-elbow-right-down'
      | 'arrow-elbow-right-up'
      | 'arrow-elbow-up-left'
      | 'arrow-elbow-up-right'
      | 'arrow-fat-down'
      | 'arrow-fat-left'
      | 'arrow-fat-line-down'
      | 'arrow-fat-line-left'
      | 'arrow-fat-line-right'
      | 'arrow-fat-line-up'
      | 'arrow-fat-lines-down'
      | 'arrow-fat-lines-left'
      | 'arrow-fat-lines-right'
      | 'arrow-fat-lines-up'
      | 'arrow-fat-right'
      | 'arrow-fat-up'
      | 'arrow-left'
      | 'arrow-line-down'
      | 'arrow-line-down-left'
      | 'arrow-line-down-right'
      | 'arrow-line-left'
      | 'arrow-line-right'
      | 'arrow-line-up'
      | 'arrow-line-up-left'
      | 'arrow-line-up-right'
      | 'arrow-right'
      | 'arrow-square-down'
      | 'arrow-square-down-left'
      | 'arrow-square-down-right'
      | 'arrow-square-in'
      | 'arrow-square-left'
      | 'arrow-square-out'
      | 'arrow-square-right'
      | 'arrow-square-up'
      | 'arrow-square-up-left'
      | 'arrow-square-up-right'
      | 'arrow-u-down-left'
      | 'arrow-u-down-right'
      | 'arrow-u-left-down'
      | 'arrow-u-left-up'
      | 'arrow-u-right-down'
      | 'arrow-u-right-up'
      | 'arrow-u-up-left'
      | 'arrow-u-up-right'
      | 'arrow-up'
      | 'arrow-up-left'
      | 'arrow-up-right'
      | 'arrows-clockwise'
      | 'arrows-counter-clockwise'
      | 'arrows-down-up'
      | 'arrows-horizontal'
      | 'arrows-in'
      | 'arrows-in-cardinal'
      | 'arrows-in-line-horizontal'
      | 'arrows-in-line-vertical'
      | 'arrows-in-simple'
      | 'arrows-left-right'
      | 'arrows-out'
      | 'arrows-out-cardinal'
      | 'arrows-out-line-horizontal'
      | 'arrows-out-line-vertical'
      | 'arrows-out-simple'
      | 'arrows-vertical'
      | 'article'
      | 'article-medium'
      | 'article-ny-times'
      | 'asterisk'
      | 'asterisk-simple'
      | 'at'
      | 'atom'
      | 'baby'
      | 'backpack'
      | 'backspace'
      | 'bag'
      | 'bag-simple'
      | 'balloon'
      | 'bandaids'
      | 'bank'
      | 'barbell'
      | 'barcode'
      | 'barricade'
      | 'baseball'
      | 'basketball'
      | 'bathtub'
      | 'battery-charging'
      | 'battery-charging-vertical'
      | 'battery-empty'
      | 'battery-full'
      | 'battery-high'
      | 'battery-low'
      | 'battery-medium'
      | 'battery-plus'
      | 'battery-warning'
      | 'battery-warning-vertical'
      | 'bed'
      | 'beer-bottle'
      | 'behance-logo'
      | 'bell'
      | 'bell-ringing'
      | 'bell-simple'
      | 'bell-simple-ringing'
      | 'bell-simple-slash'
      | 'bell-simple-z'
      | 'bell-slash'
      | 'bell-z'
      | 'bezier-curve'
      | 'bicycle'
      | 'binoculars'
      | 'bird'
      | 'bluetooth'
      | 'bluetooth-connected'
      | 'bluetooth-slash'
      | 'bluetooth-x'
      | 'boat'
      | 'book'
      | 'book-bookmark'
      | 'book-open'
      | 'bookmark'
      | 'bookmark-simple'
      | 'bookmarks'
      | 'bookmarks-simple'
      | 'books'
      | 'bounding-box'
      | 'brackets-angle'
      | 'brackets-curly'
      | 'brackets-round'
      | 'brackets-square'
      | 'brain'
      | 'brandy'
      | 'briefcase'
      | 'briefcase-metal'
      | 'broadcast'
      | 'browser'
      | 'browsers'
      | 'bug'
      | 'bug-beetle'
      | 'bug-droid'
      | 'buildings'
      | 'bus'
      | 'butterfly'
      | 'cactus'
      | 'cake'
      | 'calculator'
      | 'calendar'
      | 'calendar-blank'
      | 'calendar-check'
      | 'calendar-plus'
      | 'calendar-x'
      | 'camera'
      | 'camera-rotate'
      | 'camera-slash'
      | 'campfire'
      | 'car'
      | 'car-simple'
      | 'cardholder'
      | 'cards'
      | 'caret-circle-double-down'
      | 'caret-circle-double-left'
      | 'caret-circle-double-right'
      | 'caret-circle-double-up'
      | 'caret-circle-down'
      | 'caret-circle-left'
      | 'caret-circle-right'
      | 'caret-circle-up'
      | 'caret-double-down'
      | 'caret-double-left'
      | 'caret-double-right'
      | 'caret-double-up'
      | 'caret-down'
      | 'caret-left'
      | 'caret-right'
      | 'caret-up'
      | 'cat'
      | 'cell-signal-full'
      | 'cell-signal-high'
      | 'cell-signal-low'
      | 'cell-signal-medium'
      | 'cell-signal-none'
      | 'cell-signal-slash'
      | 'cell-signal-x'
      | 'chalkboard'
      | 'chalkboard-simple'
      | 'chalkboard-teacher'
      | 'chart-bar'
      | 'chart-bar-horizontal'
      | 'chart-line'
      | 'chart-line-up'
      | 'chart-pie'
      | 'chart-pie-slice'
      | 'chat'
      | 'chat-centered'
      | 'chat-centered-dots'
      | 'chat-centered-text'
      | 'chat-circle'
      | 'chat-circle-dots'
      | 'chat-circle-text'
      | 'chat-dots'
      | 'chat-teardrop'
      | 'chat-teardrop-dots'
      | 'chat-teardrop-text'
      | 'chat-text'
      | 'chats'
      | 'chats-circle'
      | 'chats-teardrop'
      | 'check'
      | 'check-circle'
      | 'check-square'
      | 'check-square-offset'
      | 'checks'
      | 'circle'
      | 'circle-dashed'
      | 'circle-half'
      | 'circle-half-tilt'
      | 'circle-notch'
      | 'circle-wavy'
      | 'circle-wavy-check'
      | 'circle-wavy-question'
      | 'circle-wavy-warning'
      | 'circles-four'
      | 'circles-three'
      | 'circles-three-plus'
      | 'clipboard'
      | 'clipboard-text'
      | 'clock'
      | 'clock-afternoon'
      | 'clock-clockwise'
      | 'clock-counter-clockwise'
      | 'closed-captioning'
      | 'cloud'
      | 'cloud-arrow-down'
      | 'cloud-arrow-up'
      | 'cloud-check'
      | 'cloud-fog'
      | 'cloud-lightning'
      | 'cloud-moon'
      | 'cloud-rain'
      | 'cloud-slash'
      | 'cloud-snow'
      | 'cloud-sun'
      | 'club'
      | 'coat-hanger'
      | 'code'
      | 'code-simple'
      | 'codepen-logo'
      | 'codesandbox-logo'
      | 'coffee'
      | 'coin'
      | 'coin-vertical'
      | 'coins'
      | 'columns'
      | 'command'
      | 'compass'
      | 'computer-tower'
      | 'confetti'
      | 'cookie'
      | 'cooking-pot'
      | 'copy'
      | 'copy-simple'
      | 'copyleft'
      | 'copyright'
      | 'corners-in'
      | 'corners-out'
      | 'cpu'
      | 'credit-card'
      | 'crop'
      | 'crosshair'
      | 'crosshair-simple'
      | 'crown'
      | 'crown-simple'
      | 'cube'
      | 'currency-btc'
      | 'currency-circle-dollar'
      | 'currency-cny'
      | 'currency-dollar'
      | 'currency-dollar-simple'
      | 'currency-eth'
      | 'currency-eur'
      | 'currency-gbp'
      | 'currency-inr'
      | 'currency-jpy'
      | 'currency-krw'
      | 'currency-kzt'
      | 'currency-ngn'
      | 'currency-rub'
      | 'cursor'
      | 'cursor-text'
      | 'cylinder'
      | 'database'
      | 'desktop'
      | 'desktop-tower'
      | 'detective'
      | 'device-mobile'
      | 'device-mobile-camera'
      | 'device-mobile-speaker'
      | 'device-tablet'
      | 'device-tablet-camera'
      | 'device-tablet-speaker'
      | 'diamond'
      | 'diamonds-four'
      | 'dice-five'
      | 'dice-four'
      | 'dice-one'
      | 'dice-six'
      | 'dice-three'
      | 'dice-two'
      | 'disc'
      | 'discord-logo'
      | 'divide'
      | 'dog'
      | 'door'
      | 'dots-nine'
      | 'dots-six'
      | 'dots-six-vertical'
      | 'dots-three'
      | 'dots-three-circle'
      | 'dots-three-circle-vertical'
      | 'dots-three-outline'
      | 'dots-three-outline-vertical'
      | 'dots-three-vertical'
      | 'download'
      | 'download-simple'
      | 'dribbble-logo'
      | 'drop'
      | 'drop-half'
      | 'drop-half-bottom'
      | 'ear'
      | 'ear-slash'
      | 'egg'
      | 'egg-crack'
      | 'eject'
      | 'eject-simple'
      | 'envelope'
      | 'envelope-open'
      | 'envelope-simple'
      | 'envelope-simple-open'
      | 'equalizer'
      | 'equals'
      | 'eraser'
      | 'exam'
      | 'export'
      | 'eye'
      | 'eye-closed'
      | 'eye-slash'
      | 'eyedropper'
      | 'eyedropper-sample'
      | 'eyeglasses'
      | 'face-mask'
      | 'facebook-logo'
      | 'factory'
      | 'faders'
      | 'faders-horizontal'
      | 'fast-forward'
      | 'fast-forward-circle'
      | 'figma-logo'
      | 'file'
      | 'file-arrow-down'
      | 'file-arrow-up'
      | 'file-audio'
      | 'file-cloud'
      | 'file-code'
      | 'file-css'
      | 'file-csv'
      | 'file-doc'
      | 'file-dotted'
      | 'file-html'
      | 'file-image'
      | 'file-jpg'
      | 'file-js'
      | 'file-jsx'
      | 'file-lock'
      | 'file-minus'
      | 'file-pdf'
      | 'file-plus'
      | 'file-png'
      | 'file-ppt'
      | 'file-rs'
      | 'file-search'
      | 'file-text'
      | 'file-ts'
      | 'file-tsx'
      | 'file-video'
      | 'file-vue'
      | 'file-x'
      | 'file-xls'
      | 'file-zip'
      | 'files'
      | 'film-script'
      | 'film-slate'
      | 'film-strip'
      | 'fingerprint'
      | 'fingerprint-simple'
      | 'finn-the-human'
      | 'fire'
      | 'fire-simple'
      | 'first-aid'
      | 'first-aid-kit'
      | 'fish'
      | 'fish-simple'
      | 'flag'
      | 'flag-banner'
      | 'flag-checkered'
      | 'flame'
      | 'flashlight'
      | 'flask'
      | 'floppy-disk'
      | 'floppy-disk-back'
      | 'flow-arrow'
      | 'flower'
      | 'flower-lotus'
      | 'flying-saucer'
      | 'folder'
      | 'folder-dotted'
      | 'folder-lock'
      | 'folder-minus'
      | 'folder-notch'
      | 'folder-notch-minus'
      | 'folder-notch-open'
      | 'folder-notch-plus'
      | 'folder-open'
      | 'folder-plus'
      | 'folder-simple'
      | 'folder-simple-dotted'
      | 'folder-simple-lock'
      | 'folder-simple-minus'
      | 'folder-simple-plus'
      | 'folder-simple-star'
      | 'folder-simple-user'
      | 'folder-star'
      | 'folder-user'
      | 'folders'
      | 'football'
      | 'fork-knife'
      | 'frame-corners'
      | 'framer-logo'
      | 'function'
      | 'funnel'
      | 'funnel-simple'
      | 'game-controller'
      | 'gas-pump'
      | 'gauge'
      | 'gear'
      | 'gear-six'
      | 'gender-female'
      | 'gender-intersex'
      | 'gender-male'
      | 'gender-neuter'
      | 'gender-nonbinary'
      | 'gender-transgender'
      | 'ghost'
      | 'gif'
      | 'gift'
      | 'git-branch'
      | 'git-commit'
      | 'git-diff'
      | 'git-fork'
      | 'git-merge'
      | 'git-pull-request'
      | 'github-logo'
      | 'gitlab-logo'
      | 'gitlab-logo-simple'
      | 'globe'
      | 'globe-hemisphere-east'
      | 'globe-hemisphere-west'
      | 'globe-simple'
      | 'globe-stand'
      | 'google-chrome-logo'
      | 'google-logo'
      | 'google-photos-logo'
      | 'google-play-logo'
      | 'google-podcasts-logo'
      | 'gradient'
      | 'graduation-cap'
      | 'graph'
      | 'grid-four'
      | 'hamburger'
      | 'hand'
      | 'hand-eye'
      | 'hand-fist'
      | 'hand-grabbing'
      | 'hand-palm'
      | 'hand-pointing'
      | 'hand-soap'
      | 'hand-waving'
      | 'handbag'
      | 'handbag-simple'
      | 'hands-clapping'
      | 'handshake'
      | 'hard-drive'
      | 'hard-drives'
      | 'hash'
      | 'hash-straight'
      | 'headlights'
      | 'headphones'
      | 'headset'
      | 'heart'
      | 'heart-break'
      | 'heart-straight'
      | 'heart-straight-break'
      | 'heartbeat'
      | 'hexagon'
      | 'highlighter-circle'
      | 'horse'
      | 'hourglass'
      | 'hourglass-high'
      | 'hourglass-low'
      | 'hourglass-medium'
      | 'hourglass-simple'
      | 'hourglass-simple-high'
      | 'hourglass-simple-low'
      | 'hourglass-simple-medium'
      | 'house'
      | 'house-line'
      | 'house-simple'
      | 'identification-badge'
      | 'identification-card'
      | 'image'
      | 'image-square'
      | 'infinity'
      | 'info'
      | 'instagram-logo'
      | 'intersect'
      | 'jeep'
      | 'kanban'
      | 'key'
      | 'key-return'
      | 'keyboard'
      | 'keyhole'
      | 'knife'
      | 'ladder'
      | 'ladder-simple'
      | 'lamp'
      | 'laptop'
      | 'layout'
      | 'leaf'
      | 'lifebuoy'
      | 'lightbulb'
      | 'lightbulb-filament'
      | 'lightning'
      | 'lightning-slash'
      | 'line-segment'
      | 'line-segments'
      | 'link'
      | 'link-break'
      | 'link-simple'
      | 'link-simple-break'
      | 'link-simple-horizontal'
      | 'link-simple-horizontal-break'
      | 'linkedin-logo'
      | 'linux-logo'
      | 'list'
      | 'list-bullets'
      | 'list-checks'
      | 'list-dashes'
      | 'list-numbers'
      | 'list-plus'
      | 'lock'
      | 'lock-key'
      | 'lock-key-open'
      | 'lock-laminated'
      | 'lock-laminated-open'
      | 'lock-open'
      | 'lock-simple'
      | 'lock-simple-open'
      | 'magic-wand'
      | 'magnet'
      | 'magnet-straight'
      | 'magnifying-glass'
      | 'magnifying-glass-minus'
      | 'magnifying-glass-plus'
      | 'map-pin'
      | 'map-pin-line'
      | 'map-trifold'
      | 'marker-circle'
      | 'martini'
      | 'mask-happy'
      | 'mask-sad'
      | 'math-operations'
      | 'medal'
      | 'medium-logo'
      | 'megaphone'
      | 'megaphone-simple'
      | 'messenger-logo'
      | 'microphone'
      | 'microphone-slash'
      | 'microphone-stage'
      | 'microsoft-excel-logo'
      | 'microsoft-powerpoint-logo'
      | 'microsoft-teams-logo'
      | 'microsoft-word-logo'
      | 'minus'
      | 'minus-circle'
      | 'money'
      | 'monitor'
      | 'monitor-play'
      | 'moon'
      | 'moon-stars'
      | 'mountains'
      | 'mouse'
      | 'mouse-simple'
      | 'music-note'
      | 'music-note-simple'
      | 'music-notes'
      | 'music-notes-plus'
      | 'music-notes-simple'
      | 'navigation-arrow'
      | 'needle'
      | 'newspaper'
      | 'newspaper-clipping'
      | 'note'
      | 'note-blank'
      | 'note-pencil'
      | 'notebook'
      | 'notepad'
      | 'notification'
      | 'number-circle-eight'
      | 'number-circle-five'
      | 'number-circle-four'
      | 'number-circle-nine'
      | 'number-circle-one'
      | 'number-circle-seven'
      | 'number-circle-six'
      | 'number-circle-three'
      | 'number-circle-two'
      | 'number-circle-zero'
      | 'number-eight'
      | 'number-five'
      | 'number-four'
      | 'number-nine'
      | 'number-one'
      | 'number-seven'
      | 'number-six'
      | 'number-square-eight'
      | 'number-square-five'
      | 'number-square-four'
      | 'number-square-nine'
      | 'number-square-one'
      | 'number-square-seven'
      | 'number-square-six'
      | 'number-square-three'
      | 'number-square-two'
      | 'number-square-zero'
      | 'number-three'
      | 'number-two'
      | 'number-zero'
      | 'nut'
      | 'ny-times-logo'
      | 'octagon'
      | 'option'
      | 'package'
      | 'paint-brush'
      | 'paint-brush-broad'
      | 'paint-brush-household'
      | 'paint-bucket'
      | 'paint-roller'
      | 'palette'
      | 'paper-plane'
      | 'paper-plane-right'
      | 'paper-plane-tilt'
      | 'paperclip'
      | 'paperclip-horizontal'
      | 'parachute'
      | 'password'
      | 'path'
      | 'pause'
      | 'pause-circle'
      | 'paw-print'
      | 'peace'
      | 'pen'
      | 'pen-nib'
      | 'pen-nib-straight'
      | 'pencil'
      | 'pencil-circle'
      | 'pencil-line'
      | 'pencil-simple'
      | 'pencil-simple-line'
      | 'percent'
      | 'person'
      | 'person-simple'
      | 'person-simple-run'
      | 'person-simple-walk'
      | 'perspective'
      | 'phone'
      | 'phone-call'
      | 'phone-disconnect'
      | 'phone-incoming'
      | 'phone-outgoing'
      | 'phone-slash'
      | 'phone-x'
      | 'phosphor-logo'
      | 'piano-keys'
      | 'picture-in-picture'
      | 'pill'
      | 'pinterest-logo'
      | 'pinwheel'
      | 'pizza'
      | 'placeholder'
      | 'planet'
      | 'play'
      | 'play-circle'
      | 'playlist'
      | 'plug'
      | 'plugs'
      | 'plugs-connected'
      | 'plus'
      | 'plus-circle'
      | 'plus-minus'
      | 'poker-chip'
      | 'police-car'
      | 'polygon'
      | 'popcorn'
      | 'power'
      | 'prescription'
      | 'presentation'
      | 'presentation-chart'
      | 'printer'
      | 'prohibit'
      | 'prohibit-inset'
      | 'projector-screen'
      | 'projector-screen-chart'
      | 'push-pin'
      | 'push-pin-simple'
      | 'push-pin-simple-slash'
      | 'push-pin-slash'
      | 'puzzle-piece'
      | 'qr-code'
      | 'question'
      | 'queue'
      | 'quotes'
      | 'radical'
      | 'radio'
      | 'radio-button'
      | 'rainbow'
      | 'rainbow-cloud'
      | 'receipt'
      | 'record'
      | 'rectangle'
      | 'recycle'
      | 'reddit-logo'
      | 'repeat'
      | 'repeat-once'
      | 'rewind'
      | 'rewind-circle'
      | 'robot'
      | 'rocket'
      | 'rocket-launch'
      | 'rows'
      | 'rss'
      | 'rss-simple'
      | 'rug'
      | 'ruler'
      | 'scales'
      | 'scan'
      | 'scissors'
      | 'screencast'
      | 'scribble-loop'
      | 'scroll'
      | 'selection'
      | 'selection-all'
      | 'selection-background'
      | 'selection-foreground'
      | 'selection-inverse'
      | 'selection-plus'
      | 'selection-slash'
      | 'share'
      | 'share-network'
      | 'shield'
      | 'shield-check'
      | 'shield-checkered'
      | 'shield-chevron'
      | 'shield-plus'
      | 'shield-slash'
      | 'shield-star'
      | 'shield-warning'
      | 'shopping-bag'
      | 'shopping-bag-open'
      | 'shopping-cart'
      | 'shopping-cart-simple'
      | 'shower'
      | 'shuffle'
      | 'shuffle-angular'
      | 'shuffle-simple'
      | 'sidebar'
      | 'sidebar-simple'
      | 'sign-in'
      | 'sign-out'
      | 'signpost'
      | 'sim-card'
      | 'sketch-logo'
      | 'skip-back'
      | 'skip-back-circle'
      | 'skip-forward'
      | 'skip-forward-circle'
      | 'skull'
      | 'slack-logo'
      | 'sliders'
      | 'sliders-horizontal'
      | 'smiley'
      | 'smiley-blank'
      | 'smiley-meh'
      | 'smiley-nervous'
      | 'smiley-sad'
      | 'smiley-sticker'
      | 'smiley-wink'
      | 'smiley-x-eyes'
      | 'snapchat-logo'
      | 'snowflake'
      | 'soccer-ball'
      | 'sort-ascending'
      | 'sort-descending'
      | 'spade'
      | 'sparkle'
      | 'speaker-high'
      | 'speaker-low'
      | 'speaker-none'
      | 'speaker-simple-high'
      | 'speaker-simple-low'
      | 'speaker-simple-none'
      | 'speaker-simple-slash'
      | 'speaker-simple-x'
      | 'speaker-slash'
      | 'speaker-x'
      | 'spinner'
      | 'spinner-gap'
      | 'spiral'
      | 'spotify-logo'
      | 'square'
      | 'square-half'
      | 'square-half-bottom'
      | 'square-logo'
      | 'squares-four'
      | 'stack'
      | 'stack-overflow-logo'
      | 'stack-simple'
      | 'stamp'
      | 'star'
      | 'star-four'
      | 'star-half'
      | 'sticker'
      | 'stop'
      | 'stop-circle'
      | 'storefront'
      | 'strategy'
      | 'stripe-logo'
      | 'student'
      | 'suitcase'
      | 'suitcase-simple'
      | 'sun'
      | 'sun-dim'
      | 'sun-horizon'
      | 'sunglasses'
      | 'swap'
      | 'swatches'
      | 'sword'
      | 'syringe'
      | 't-shirt'
      | 'table'
      | 'tabs'
      | 'tag'
      | 'tag-chevron'
      | 'tag-simple'
      | 'target'
      | 'taxi'
      | 'telegram-logo'
      | 'television'
      | 'television-simple'
      | 'tennis-ball'
      | 'terminal'
      | 'terminal-window'
      | 'test-tube'
      | 'text-aa'
      | 'text-align-center'
      | 'text-align-justify'
      | 'text-align-left'
      | 'text-align-right'
      | 'text-bolder'
      | 'text-h'
      | 'text-h-five'
      | 'text-h-four'
      | 'text-h-one'
      | 'text-h-six'
      | 'text-h-three'
      | 'text-h-two'
      | 'text-indent'
      | 'text-italic'
      | 'text-outdent'
      | 'text-strikethrough'
      | 'text-t'
      | 'text-underline'
      | 'textbox'
      | 'thermometer'
      | 'thermometer-cold'
      | 'thermometer-hot'
      | 'thermometer-simple'
      | 'thumbs-down'
      | 'thumbs-up'
      | 'ticket'
      | 'tiktok-logo'
      | 'timer'
      | 'toggle-left'
      | 'toggle-right'
      | 'toilet'
      | 'toilet-paper'
      | 'tote'
      | 'tote-simple'
      | 'trademark-registered'
      | 'traffic-cone'
      | 'traffic-sign'
      | 'traffic-signal'
      | 'train'
      | 'train-regional'
      | 'train-simple'
      | 'translate'
      | 'trash'
      | 'trash-simple'
      | 'tray'
      | 'tree'
      | 'tree-evergreen'
      | 'tree-structure'
      | 'trend-down'
      | 'trend-up'
      | 'triangle'
      | 'trophy'
      | 'truck'
      | 'twitch-logo'
      | 'twitter-logo'
      | 'umbrella'
      | 'umbrella-simple'
      | 'upload'
      | 'upload-simple'
      | 'user'
      | 'user-circle'
      | 'user-circle-gear'
      | 'user-circle-minus'
      | 'user-circle-plus'
      | 'user-focus'
      | 'user-gear'
      | 'user-list'
      | 'user-minus'
      | 'user-plus'
      | 'user-rectangle'
      | 'user-square'
      | 'user-switch'
      | 'users'
      | 'users-four'
      | 'users-three'
      | 'vault'
      | 'vibrate'
      | 'video-camera'
      | 'video-camera-slash'
      | 'vignette'
      | 'voicemail'
      | 'volleyball'
      | 'wall'
      | 'wallet'
      | 'warning'
      | 'warning-circle'
      | 'warning-octagon'
      | 'watch'
      | 'wave-sawtooth'
      | 'wave-sine'
      | 'wave-square'
      | 'wave-triangle'
      | 'waves'
      | 'webcam'
      | 'whatsapp-logo'
      | 'wheelchair'
      | 'wifi-high'
      | 'wifi-low'
      | 'wifi-medium'
      | 'wifi-none'
      | 'wifi-slash'
      | 'wifi-x'
      | 'wind'
      | 'windows-logo'
      | 'wine'
      | 'wrench'
      | 'x'
      | 'x-circle'
      | 'x-square'
      | 'yin-yang'
      | 'youtube-logo'
    light:
      | 'activity'
      | 'address-book'
      | 'airplane-in-flight'
      | 'airplane-landing'
      | 'airplane'
      | 'airplane-takeoff'
      | 'airplane-tilt'
      | 'airplay'
      | 'alarm'
      | 'alien'
      | 'align-bottom'
      | 'align-bottom-simple'
      | 'align-center-horizontal'
      | 'align-center-horizontal-simple'
      | 'align-center-vertical'
      | 'align-center-vertical-simple'
      | 'align-left'
      | 'align-left-simple'
      | 'align-right'
      | 'align-right-simple'
      | 'align-top'
      | 'align-top-simple'
      | 'anchor'
      | 'anchor-simple'
      | 'android-logo'
      | 'angular-logo'
      | 'aperture'
      | 'app-store-logo'
      | 'app-window'
      | 'apple-logo'
      | 'apple-podcasts-logo'
      | 'archive-box'
      | 'archive'
      | 'archive-tray'
      | 'armchair'
      | 'arrow-arc-left'
      | 'arrow-arc-right'
      | 'arrow-bend-double-up-left'
      | 'arrow-bend-double-up-right'
      | 'arrow-bend-down-left'
      | 'arrow-bend-down-right'
      | 'arrow-bend-left-down'
      | 'arrow-bend-left-up'
      | 'arrow-bend-right-down'
      | 'arrow-bend-right-up'
      | 'arrow-bend-up-left'
      | 'arrow-bend-up-right'
      | 'arrow-circle-down-left'
      | 'arrow-circle-down'
      | 'arrow-circle-down-right'
      | 'arrow-circle-left'
      | 'arrow-circle-right'
      | 'arrow-circle-up-left'
      | 'arrow-circle-up'
      | 'arrow-circle-up-right'
      | 'arrow-clockwise'
      | 'arrow-counter-clockwise'
      | 'arrow-down-left'
      | 'arrow-down'
      | 'arrow-down-right'
      | 'arrow-elbow-down-left'
      | 'arrow-elbow-down-right'
      | 'arrow-elbow-left-down'
      | 'arrow-elbow-left'
      | 'arrow-elbow-left-up'
      | 'arrow-elbow-right-down'
      | 'arrow-elbow-right'
      | 'arrow-elbow-right-up'
      | 'arrow-elbow-up-left'
      | 'arrow-elbow-up-right'
      | 'arrow-fat-down'
      | 'arrow-fat-left'
      | 'arrow-fat-line-down'
      | 'arrow-fat-line-left'
      | 'arrow-fat-line-right'
      | 'arrow-fat-line-up'
      | 'arrow-fat-lines-down'
      | 'arrow-fat-lines-left'
      | 'arrow-fat-lines-right'
      | 'arrow-fat-lines-up'
      | 'arrow-fat-right'
      | 'arrow-fat-up'
      | 'arrow-left'
      | 'arrow-line-down-left'
      | 'arrow-line-down'
      | 'arrow-line-down-right'
      | 'arrow-line-left'
      | 'arrow-line-right'
      | 'arrow-line-up-left'
      | 'arrow-line-up'
      | 'arrow-line-up-right'
      | 'arrow-right'
      | 'arrow-square-down-left'
      | 'arrow-square-down'
      | 'arrow-square-down-right'
      | 'arrow-square-in'
      | 'arrow-square-left'
      | 'arrow-square-out'
      | 'arrow-square-right'
      | 'arrow-square-up-left'
      | 'arrow-square-up'
      | 'arrow-square-up-right'
      | 'arrow-u-down-left'
      | 'arrow-u-down-right'
      | 'arrow-u-left-down'
      | 'arrow-u-left-up'
      | 'arrow-u-right-down'
      | 'arrow-u-right-up'
      | 'arrow-u-up-left'
      | 'arrow-u-up-right'
      | 'arrow-up-left'
      | 'arrow-up'
      | 'arrow-up-right'
      | 'arrows-clockwise'
      | 'arrows-counter-clockwise'
      | 'arrows-down-up'
      | 'arrows-horizontal'
      | 'arrows-in-cardinal'
      | 'arrows-in'
      | 'arrows-in-line-horizontal'
      | 'arrows-in-line-vertical'
      | 'arrows-in-simple'
      | 'arrows-left-right'
      | 'arrows-out-cardinal'
      | 'arrows-out'
      | 'arrows-out-line-horizontal'
      | 'arrows-out-line-vertical'
      | 'arrows-out-simple'
      | 'arrows-vertical'
      | 'article'
      | 'article-medium'
      | 'article-ny-times'
      | 'asterisk'
      | 'asterisk-simple'
      | 'at'
      | 'atom'
      | 'baby'
      | 'backpack'
      | 'backspace'
      | 'bag'
      | 'bag-simple'
      | 'balloon'
      | 'bandaids'
      | 'bank'
      | 'barbell'
      | 'barcode'
      | 'barricade'
      | 'baseball'
      | 'basketball'
      | 'bathtub'
      | 'battery-charging'
      | 'battery-charging-vertical'
      | 'battery-empty'
      | 'battery-full'
      | 'battery-high'
      | 'battery-low'
      | 'battery-medium'
      | 'battery-plus'
      | 'battery-warning'
      | 'battery-warning-vertical'
      | 'bed'
      | 'beer-bottle'
      | 'behance-logo'
      | 'bell'
      | 'bell-ringing'
      | 'bell-simple'
      | 'bell-simple-ringing'
      | 'bell-simple-slash'
      | 'bell-simple-z'
      | 'bell-slash'
      | 'bell-z'
      | 'bezier-curve'
      | 'bicycle'
      | 'binoculars'
      | 'bird'
      | 'bluetooth-connected'
      | 'bluetooth'
      | 'bluetooth-slash'
      | 'bluetooth-x'
      | 'boat'
      | 'book-bookmark'
      | 'book'
      | 'book-open'
      | 'bookmark'
      | 'bookmark-simple'
      | 'bookmarks'
      | 'bookmarks-simple'
      | 'books'
      | 'bounding-box'
      | 'brackets-angle'
      | 'brackets-curly'
      | 'brackets-round'
      | 'brackets-square'
      | 'brain'
      | 'brandy'
      | 'briefcase'
      | 'briefcase-metal'
      | 'broadcast'
      | 'browser'
      | 'browsers'
      | 'bug-beetle'
      | 'bug-droid'
      | 'bug'
      | 'buildings'
      | 'bus'
      | 'butterfly'
      | 'cactus'
      | 'cake'
      | 'calculator'
      | 'calendar-blank'
      | 'calendar-check'
      | 'calendar'
      | 'calendar-plus'
      | 'calendar-x'
      | 'camera'
      | 'camera-rotate'
      | 'camera-slash'
      | 'campfire'
      | 'car'
      | 'car-simple'
      | 'cardholder'
      | 'cards'
      | 'caret-circle-double-down'
      | 'caret-circle-double-left'
      | 'caret-circle-double-right'
      | 'caret-circle-double-up'
      | 'caret-circle-down'
      | 'caret-circle-left'
      | 'caret-circle-right'
      | 'caret-circle-up'
      | 'caret-double-down'
      | 'caret-double-left'
      | 'caret-double-right'
      | 'caret-double-up'
      | 'caret-down'
      | 'caret-left'
      | 'caret-right'
      | 'caret-up'
      | 'cat'
      | 'cell-signal-full'
      | 'cell-signal-high'
      | 'cell-signal-low'
      | 'cell-signal-medium'
      | 'cell-signal-none'
      | 'cell-signal-slash'
      | 'cell-signal-x'
      | 'chalkboard'
      | 'chalkboard-simple'
      | 'chalkboard-teacher'
      | 'chart-bar-horizontal'
      | 'chart-bar'
      | 'chart-line'
      | 'chart-line-up'
      | 'chart-pie'
      | 'chart-pie-slice'
      | 'chat-centered-dots'
      | 'chat-centered'
      | 'chat-centered-text'
      | 'chat-circle-dots'
      | 'chat-circle'
      | 'chat-circle-text'
      | 'chat-dots'
      | 'chat'
      | 'chat-teardrop-dots'
      | 'chat-teardrop'
      | 'chat-teardrop-text'
      | 'chat-text'
      | 'chats-circle'
      | 'chats'
      | 'chats-teardrop'
      | 'check-circle'
      | 'check'
      | 'check-square'
      | 'check-square-offset'
      | 'checks'
      | 'circle-dashed'
      | 'circle-half'
      | 'circle-half-tilt'
      | 'circle'
      | 'circle-notch'
      | 'circle-wavy-check'
      | 'circle-wavy'
      | 'circle-wavy-question'
      | 'circle-wavy-warning'
      | 'circles-four'
      | 'circles-three'
      | 'circles-three-plus'
      | 'clipboard'
      | 'clipboard-text'
      | 'clock-afternoon'
      | 'clock-clockwise'
      | 'clock-counter-clockwise'
      | 'clock'
      | 'closed-captioning'
      | 'cloud-arrow-down'
      | 'cloud-arrow-up'
      | 'cloud-check'
      | 'cloud-fog'
      | 'cloud'
      | 'cloudning-light'
      | 'cloud-moon'
      | 'cloud-rain'
      | 'cloud-slash'
      | 'cloud-snow'
      | 'cloud-sun'
      | 'club'
      | 'coat-hanger'
      | 'code'
      | 'code-simple'
      | 'codepen-logo'
      | 'codesandbox-logo'
      | 'coffee'
      | 'coin'
      | 'coin-vertical'
      | 'coins'
      | 'columns'
      | 'command'
      | 'compass'
      | 'computer-tower'
      | 'confetti'
      | 'cookie'
      | 'cooking-pot'
      | 'copy'
      | 'copy-simple'
      | 'copyleft'
      | 'copyright'
      | 'corners-in'
      | 'corners-out'
      | 'cpu'
      | 'credit-card'
      | 'crop'
      | 'crosshair'
      | 'crosshair-simple'
      | 'crown'
      | 'crown-simple'
      | 'cube'
      | 'currency-btc'
      | 'currency-circle-dollar'
      | 'currency-cny'
      | 'currency-dollar'
      | 'currency-dollar-simple'
      | 'currency-eth'
      | 'currency-eur'
      | 'currency-gbp'
      | 'currency-inr'
      | 'currency-jpy'
      | 'currency-krw'
      | 'currency-kzt'
      | 'currency-ngn'
      | 'currency-rub'
      | 'cursor'
      | 'cursor-text'
      | 'cylinder'
      | 'database'
      | 'desktop'
      | 'desktop-tower'
      | 'detective'
      | 'device-mobile-camera'
      | 'device-mobile'
      | 'device-mobile-speaker'
      | 'device-tablet-camera'
      | 'device-tablet'
      | 'device-tablet-speaker'
      | 'diamond'
      | 'diamonds-four'
      | 'dice-five'
      | 'dice-four'
      | 'dice-one'
      | 'dice-six'
      | 'dice-three'
      | 'dice-two'
      | 'disc'
      | 'discord-logo'
      | 'divide'
      | 'dog'
      | 'door'
      | 'dots-nine'
      | 'dots-six'
      | 'dots-six-vertical'
      | 'dots-three-circle'
      | 'dots-three-circle-vertical'
      | 'dots-three'
      | 'dots-three-outline'
      | 'dots-three-outline-vertical'
      | 'dots-three-vertical'
      | 'download'
      | 'download-simple'
      | 'dribbble-logo'
      | 'drop-half-bottom'
      | 'drop-half'
      | 'drop'
      | 'ear'
      | 'ear-slash'
      | 'egg-crack'
      | 'egg'
      | 'eject'
      | 'eject-simple'
      | 'envelope'
      | 'envelope-open'
      | 'envelope-simple'
      | 'envelope-simple-open'
      | 'equalizer'
      | 'equals'
      | 'eraser'
      | 'exam'
      | 'export'
      | 'eye-closed'
      | 'eye'
      | 'eye-slash'
      | 'eyedropper'
      | 'eyedropper-sample'
      | 'eyeglasses'
      | 'face-mask'
      | 'facebook-logo'
      | 'factory'
      | 'faders-horizontal'
      | 'faders'
      | 'fast-forward-circle'
      | 'fast-forward'
      | 'figma-logo'
      | 'file-arrow-down'
      | 'file-arrow-up'
      | 'file-audio'
      | 'file-cloud'
      | 'file-code'
      | 'file-css'
      | 'file-csv'
      | 'file-doc'
      | 'file-dotted'
      | 'file-html'
      | 'file-image'
      | 'file-jpg'
      | 'file-js'
      | 'file-jsx'
      | 'file'
      | 'file-lock'
      | 'file-minus'
      | 'file-pdf'
      | 'file-plus'
      | 'file-png'
      | 'file-ppt'
      | 'file-rs'
      | 'file-search'
      | 'file-text'
      | 'file-ts'
      | 'file-tsx'
      | 'file-video'
      | 'file-vue'
      | 'file-x'
      | 'file-xls'
      | 'file-zip'
      | 'files'
      | 'film-script'
      | 'film-slate'
      | 'film-strip'
      | 'fingerprint'
      | 'fingerprint-simple'
      | 'finn-the-human'
      | 'fire'
      | 'fire-simple'
      | 'first-aid-kit'
      | 'first-aid'
      | 'fish'
      | 'fish-simple'
      | 'flag-banner'
      | 'flag-checkered'
      | 'flag'
      | 'flame'
      | 'flashlight'
      | 'flask'
      | 'floppy-disk-back'
      | 'floppy-disk'
      | 'flow-arrow'
      | 'flower'
      | 'flower-lotus'
      | 'flying-saucer'
      | 'folder-dotted'
      | 'folder'
      | 'folder-lock'
      | 'folder-minus'
      | 'folder-notch'
      | 'folder-notch-minus'
      | 'folder-notch-open'
      | 'folder-notch-plus'
      | 'folder-open'
      | 'folder-plus'
      | 'folder-simple-dotted'
      | 'folder-simple'
      | 'folder-simple-lock'
      | 'folder-simple-minus'
      | 'folder-simple-plus'
      | 'folder-simple-star'
      | 'folder-simple-user'
      | 'folder-star'
      | 'folder-user'
      | 'folders'
      | 'football'
      | 'fork-knife'
      | 'frame-corners'
      | 'framer-logo'
      | 'function'
      | 'funnel'
      | 'funnel-simple'
      | 'game-controller'
      | 'gas-pump'
      | 'gauge'
      | 'gear'
      | 'gear-six'
      | 'gender-female'
      | 'gender-intersex'
      | 'gender-male'
      | 'gender-neuter'
      | 'gender-nonbinary'
      | 'gender-transgender'
      | 'ghost'
      | 'gif'
      | 'gift'
      | 'git-branch'
      | 'git-commit'
      | 'git-diff'
      | 'git-fork'
      | 'git-merge'
      | 'git-pull-request'
      | 'github-logo'
      | 'gitlab-logo'
      | 'gitlab-logo-simple'
      | 'globe-hemisphere-east'
      | 'globe-hemisphere-west'
      | 'globe'
      | 'globe-simple'
      | 'globe-stand'
      | 'google-chrome-logo'
      | 'google-logo'
      | 'google-photos-logo'
      | 'google-play-logo'
      | 'google-podcasts-logo'
      | 'gradient'
      | 'graduation-cap'
      | 'graph'
      | 'grid-four'
      | 'hamburger'
      | 'hand-eye'
      | 'hand-fist'
      | 'hand-grabbing'
      | 'hand'
      | 'hand-palm'
      | 'hand-pointing'
      | 'hand-soap'
      | 'hand-waving'
      | 'handbag'
      | 'handbag-simple'
      | 'hands-clapping'
      | 'handshake'
      | 'hard-drive'
      | 'hard-drives'
      | 'hash'
      | 'hash-straight'
      | 'headlights'
      | 'headphones'
      | 'headset'
      | 'heart-break'
      | 'heart'
      | 'heart-straight-break'
      | 'heart-straight'
      | 'heartbeat'
      | 'hexagon'
      | 'highlighter-circle'
      | 'horse'
      | 'hourglass-high'
      | 'hourglass'
      | 'hourglass-low'
      | 'hourglass-medium'
      | 'hourglass-simple-high'
      | 'hourglass-simple'
      | 'hourglass-simple-low'
      | 'hourglass-simple-medium'
      | 'house'
      | 'house-line'
      | 'house-simple'
      | 'identification-badge'
      | 'identification-card'
      | 'image'
      | 'image-square'
      | 'infinity'
      | 'info'
      | 'instagram-logo'
      | 'intersect'
      | 'jeep'
      | 'kanban'
      | 'key'
      | 'key-return'
      | 'keyboard'
      | 'keyhole'
      | 'knife'
      | 'ladder'
      | 'ladder-simple'
      | 'lamp'
      | 'laptop'
      | 'layout'
      | 'leaf'
      | 'lifebuoy'
      | 'lightbulb-filament'
      | 'lightbulb'
      | 'lightning'
      | 'lightning-slash'
      | 'line-segment'
      | 'line-segments'
      | 'link-break'
      | 'link'
      | 'link-simple-break'
      | 'link-simple-horizontal-break'
      | 'link-simple-horizontal'
      | 'link-simple'
      | 'linkedin-logo'
      | 'linux-logo'
      | 'list-bullets'
      | 'list-checks'
      | 'list-dashes'
      | 'list'
      | 'list-numbers'
      | 'list-plus'
      | 'lock-key'
      | 'lock-key-open'
      | 'lock-laminated'
      | 'lock-laminated-open'
      | 'lock'
      | 'lock-open'
      | 'lock-simple'
      | 'lock-simple-open'
      | 'magic-wand'
      | 'magnet'
      | 'magnet-straight'
      | 'magnifying-glass'
      | 'magnifying-glass-minus'
      | 'magnifying-glass-plus'
      | 'map-pin'
      | 'map-pin-line'
      | 'map-trifold'
      | 'marker-circle'
      | 'martini'
      | 'mask-happy'
      | 'mask-sad'
      | 'math-operations'
      | 'medal'
      | 'medium-logo'
      | 'megaphone'
      | 'megaphone-simple'
      | 'messenger-logo'
      | 'microphone'
      | 'microphone-slash'
      | 'microphone-stage'
      | 'microsoft-excel-logo'
      | 'microsoft-powerpoint-logo'
      | 'microsoft-teams-logo'
      | 'microsoft-word-logo'
      | 'minus-circle'
      | 'minus'
      | 'money'
      | 'monitor'
      | 'monitor-play'
      | 'moon'
      | 'moon-stars'
      | 'mountains'
      | 'mouse'
      | 'mouse-simple'
      | 'music-note'
      | 'music-note-simple'
      | 'music-notes'
      | 'music-notes-plus'
      | 'music-notes-simple'
      | 'navigation-arrow'
      | 'needle'
      | 'newspaper-clipping'
      | 'newspaper'
      | 'note-blank'
      | 'note'
      | 'note-pencil'
      | 'notebook'
      | 'notepad'
      | 'notification'
      | 'number-circle-eight'
      | 'number-circle-five'
      | 'number-circle-four'
      | 'number-circle-nine'
      | 'number-circle-one'
      | 'number-circle-seven'
      | 'number-circle-six'
      | 'number-circle-three'
      | 'number-circle-two'
      | 'number-circle-zero'
      | 'number-eight'
      | 'number-five'
      | 'number-four'
      | 'number-nine'
      | 'number-one'
      | 'number-seven'
      | 'number-six'
      | 'number-square-eight'
      | 'number-square-five'
      | 'number-square-four'
      | 'number-square-nine'
      | 'number-square-one'
      | 'number-square-seven'
      | 'number-square-six'
      | 'number-square-three'
      | 'number-square-two'
      | 'number-square-zero'
      | 'number-three'
      | 'number-two'
      | 'number-zero'
      | 'nut'
      | 'ny-times-logo'
      | 'octagon'
      | 'option'
      | 'package'
      | 'paint-brush-broad'
      | 'paint-brush-household'
      | 'paint-brush'
      | 'paint-bucket'
      | 'paint-roller'
      | 'palette'
      | 'paper-plane'
      | 'paper-plane-right'
      | 'paper-plane-tilt'
      | 'paperclip-horizontal'
      | 'paperclip'
      | 'parachute'
      | 'password'
      | 'path'
      | 'pause-circle'
      | 'pause'
      | 'paw-print'
      | 'peace'
      | 'pen'
      | 'pen-nib'
      | 'pen-nib-straight'
      | 'pencil-circle'
      | 'pencil'
      | 'pencil-line'
      | 'pencil-simple'
      | 'pencil-simple-line'
      | 'percent'
      | 'person'
      | 'person-simple'
      | 'person-simple-run'
      | 'person-simple-walk'
      | 'perspective'
      | 'phone-call'
      | 'phone-disconnect'
      | 'phone-incoming'
      | 'phone'
      | 'phone-outgoing'
      | 'phone-slash'
      | 'phone-x'
      | 'phosphor-logo'
      | 'piano-keys'
      | 'picture-in-picture'
      | 'pill'
      | 'pinterest-logo'
      | 'pinwheel'
      | 'pizza'
      | 'placeholder'
      | 'planet'
      | 'play-circle'
      | 'play'
      | 'playlist'
      | 'plug'
      | 'plugs-connected'
      | 'plugs'
      | 'plus-circle'
      | 'plus'
      | 'plus-minus'
      | 'poker-chip'
      | 'police-car'
      | 'polygon'
      | 'popcorn'
      | 'power'
      | 'prescription'
      | 'presentation-chart'
      | 'presentation'
      | 'printer'
      | 'prohibit-inset'
      | 'prohibit'
      | 'projector-screen-chart'
      | 'projector-screen'
      | 'push-pin'
      | 'push-pin-simple'
      | 'push-pin-simple-slash'
      | 'push-pin-slash'
      | 'puzzle-piece'
      | 'qr-code'
      | 'question'
      | 'queue'
      | 'quotes'
      | 'radical'
      | 'radio-button'
      | 'radio'
      | 'rainbow-cloud'
      | 'rainbow'
      | 'receipt'
      | 'record'
      | 'rectangle'
      | 'recycle'
      | 'reddit-logo'
      | 'repeat'
      | 'repeat-once'
      | 'rewind-circle'
      | 'rewind'
      | 'robot'
      | 'rocket-launch'
      | 'rocket'
      | 'rows'
      | 'rss'
      | 'rss-simple'
      | 'rug'
      | 'ruler'
      | 'scales'
      | 'scan'
      | 'scissors'
      | 'screencast'
      | 'scribble-loop'
      | 'scroll'
      | 'selection-all'
      | 'selection-background'
      | 'selection-foreground'
      | 'selection-inverse'
      | 'selection'
      | 'selection-plus'
      | 'selection-slash'
      | 'share'
      | 'share-network'
      | 'shield-check'
      | 'shield-checkered'
      | 'shield-chevron'
      | 'shield'
      | 'shield-plus'
      | 'shield-slash'
      | 'shield-star'
      | 'shield-warning'
      | 'shopping-bag'
      | 'shopping-bag-open'
      | 'shopping-cart'
      | 'shopping-cart-simple'
      | 'shower'
      | 'shuffle-angular'
      | 'shuffle'
      | 'shuffle-simple'
      | 'sidebar'
      | 'sidebar-simple'
      | 'sign-in'
      | 'sign-out'
      | 'signpost'
      | 'sim-card'
      | 'sketch-logo'
      | 'skip-back-circle'
      | 'skip-back'
      | 'skip-forward-circle'
      | 'skip-forward'
      | 'skull'
      | 'slack-logo'
      | 'sliders-horizontal'
      | 'sliders'
      | 'smiley-blank'
      | 'smiley'
      | 'smiley-meh'
      | 'smiley-nervous'
      | 'smiley-sad'
      | 'smiley-sticker'
      | 'smiley-wink'
      | 'smiley-x-eyes'
      | 'snapchat-logo'
      | 'snowflake'
      | 'soccer-ball'
      | 'sort-ascending'
      | 'sort-descending'
      | 'spade'
      | 'sparkle'
      | 'speaker-high'
      | 'speaker-low'
      | 'speaker-none'
      | 'speaker-simple-high'
      | 'speaker-simple-low'
      | 'speaker-simple-none'
      | 'speaker-simple-slash'
      | 'speaker-simple-x'
      | 'speaker-slash'
      | 'speaker-x'
      | 'spinner-gap'
      | 'spinner'
      | 'spiral'
      | 'spotify-logo'
      | 'square-half-bottom'
      | 'square-half'
      | 'square'
      | 'square-logo'
      | 'squares-four'
      | 'stack'
      | 'stack-overflow-logo'
      | 'stack-simple'
      | 'stamp'
      | 'star-four'
      | 'star-half'
      | 'star'
      | 'sticker'
      | 'stop-circle'
      | 'stop'
      | 'storefront'
      | 'strategy'
      | 'stripe-logo'
      | 'student'
      | 'suitcase'
      | 'suitcase-simple'
      | 'sun-dim'
      | 'sun-horizon'
      | 'sun'
      | 'sunglasses'
      | 'swap'
      | 'swatches'
      | 'sword'
      | 'syringe'
      | 't-shirt'
      | 'table'
      | 'tabs'
      | 'tag-chevron'
      | 'tag'
      | 'tag-simple'
      | 'target'
      | 'taxi'
      | 'telegram-logo'
      | 'television'
      | 'television-simple'
      | 'tennis-ball'
      | 'terminal'
      | 'terminal-window'
      | 'test-tube'
      | 'text-aa'
      | 'text-align-center'
      | 'text-align-justify'
      | 'text-align-left'
      | 'text-align-right'
      | 'text-bolder'
      | 'text-h-five'
      | 'text-h-four'
      | 'text-h'
      | 'text-h-one'
      | 'text-h-six'
      | 'text-h-three'
      | 'text-h-two'
      | 'text-indent'
      | 'text-italic'
      | 'text-outdent'
      | 'text-strikethrough'
      | 'text-t'
      | 'text-underline'
      | 'textbox'
      | 'thermometer-cold'
      | 'thermometer-hot'
      | 'thermometer'
      | 'thermometer-simple'
      | 'thumbs-down'
      | 'thumbs-up'
      | 'ticket'
      | 'tiktok-logo'
      | 'timer'
      | 'toggle-left'
      | 'toggle-right'
      | 'toilet'
      | 'toilet-paper'
      | 'tote'
      | 'tote-simple'
      | 'trademark-registered'
      | 'traffic-cone'
      | 'traffic-sign'
      | 'traffic-signal'
      | 'train'
      | 'train-regional'
      | 'train-simple'
      | 'translate'
      | 'trash'
      | 'trash-simple'
      | 'tray'
      | 'tree-evergreen'
      | 'tree'
      | 'tree-structure'
      | 'trend-down'
      | 'trend-up'
      | 'triangle'
      | 'trophy'
      | 'truck'
      | 'twitch-logo'
      | 'twitter-logo'
      | 'umbrella'
      | 'umbrella-simple'
      | 'upload'
      | 'upload-simple'
      | 'user-circle-gear'
      | 'user-circle'
      | 'user-circle-minus'
      | 'user-circle-plus'
      | 'user-focus'
      | 'user-gear'
      | 'user'
      | 'user-list'
      | 'user-minus'
      | 'user-plus'
      | 'user-rectangle'
      | 'user-square'
      | 'user-switch'
      | 'users-four'
      | 'users'
      | 'users-three'
      | 'vault'
      | 'vibrate'
      | 'video-camera'
      | 'video-camera-slash'
      | 'vignette'
      | 'voicemail'
      | 'volleyball'
      | 'wall'
      | 'wallet'
      | 'warning-circle'
      | 'warning'
      | 'warning-octagon'
      | 'watch'
      | 'wave-sawtooth'
      | 'wave-sine'
      | 'wave-square'
      | 'wave-triangle'
      | 'waves'
      | 'webcam'
      | 'whatsapp-logo'
      | 'wheelchair'
      | 'wifi-high'
      | 'wifi-low'
      | 'wifi-medium'
      | 'wifi-none'
      | 'wifi-slash'
      | 'wifi-x'
      | 'wind'
      | 'windows-logo'
      | 'wine'
      | 'wrench'
      | 'x-circle'
      | 'x'
      | 'x-square'
      | 'yin-yang'
      | 'youtube-logo'
    fill:
      | 'activity'
      | 'address-book'
      | 'airplane'
      | 'airplane-in-flight'
      | 'airplane-landing'
      | 'airplane-takeoff'
      | 'airplane-tilt'
      | 'airplay'
      | 'alarm'
      | 'alien'
      | 'align-bottom'
      | 'align-bottom-simple'
      | 'align-center-horizontal'
      | 'align-center-horizontal-simple'
      | 'align-center-vertical'
      | 'align-center-vertical-simple'
      | 'align-left'
      | 'align-left-simple'
      | 'align-right'
      | 'align-right-simple'
      | 'align-top'
      | 'align-top-simple'
      | 'anchor'
      | 'anchor-simple'
      | 'android-logo'
      | 'angular-logo'
      | 'aperture'
      | 'app-store-logo'
      | 'app-window'
      | 'apple-logo'
      | 'apple-podcasts-logo'
      | 'archive-box'
      | 'archive'
      | 'archive-tray'
      | 'armchair'
      | 'arrow-arc-left'
      | 'arrow-arc-right'
      | 'arrow-bend-double-up-left'
      | 'arrow-bend-double-up-right'
      | 'arrow-bend-down-left'
      | 'arrow-bend-down-right'
      | 'arrow-bend-left-down'
      | 'arrow-bend-left-up'
      | 'arrow-bend-right-down'
      | 'arrow-bend-right-up'
      | 'arrow-bend-up-left'
      | 'arrow-bend-up-right'
      | 'arrow-circle-down'
      | 'arrow-circle-down-left'
      | 'arrow-circle-down-right'
      | 'arrow-circle-left'
      | 'arrow-circle-right'
      | 'arrow-circle-up'
      | 'arrow-circle-up-left'
      | 'arrow-circle-up-right'
      | 'arrow-clockwise'
      | 'arrow-counter-clockwise'
      | 'arrow-down'
      | 'arrow-down-left'
      | 'arrow-down-right'
      | 'arrow-elbow-down-left'
      | 'arrow-elbow-down-right'
      | 'arrow-elbow-left-down'
      | 'arrow-elbow-left'
      | 'arrow-elbow-left-up'
      | 'arrow-elbow-right-down'
      | 'arrow-elbow-right'
      | 'arrow-elbow-right-up'
      | 'arrow-elbow-up-left'
      | 'arrow-elbow-up-right'
      | 'arrow-fat-down'
      | 'arrow-fat-left'
      | 'arrow-fat-line-down'
      | 'arrow-fat-line-left'
      | 'arrow-fat-line-right'
      | 'arrow-fat-line-up'
      | 'arrow-fat-lines-down'
      | 'arrow-fat-lines-left'
      | 'arrow-fat-lines-right'
      | 'arrow-fat-lines-up'
      | 'arrow-fat-right'
      | 'arrow-fat-up'
      | 'arrow-left'
      | 'arrow-line-down'
      | 'arrow-line-down-left'
      | 'arrow-line-down-right'
      | 'arrow-line-left'
      | 'arrow-line-right'
      | 'arrow-line-up'
      | 'arrow-line-up-left'
      | 'arrow-line-up-right'
      | 'arrow-right'
      | 'arrow-square-down'
      | 'arrow-square-down-left'
      | 'arrow-square-down-right'
      | 'arrow-square-in'
      | 'arrow-square-left'
      | 'arrow-square-out'
      | 'arrow-square-right'
      | 'arrow-square-up'
      | 'arrow-square-up-left'
      | 'arrow-square-up-right'
      | 'arrow-u-down-left'
      | 'arrow-u-down-right'
      | 'arrow-u-left-down'
      | 'arrow-u-left-up'
      | 'arrow-u-right-down'
      | 'arrow-u-right-up'
      | 'arrow-u-up-left'
      | 'arrow-u-up-right'
      | 'arrow-up'
      | 'arrow-up-left'
      | 'arrow-up-right'
      | 'arrows-clockwise'
      | 'arrows-counter-clockwise'
      | 'arrows-down-up'
      | 'arrows-horizontal'
      | 'arrows-in-cardinal'
      | 'arrows-in'
      | 'arrows-in-line-horizontal'
      | 'arrows-in-line-vertical'
      | 'arrows-in-simple'
      | 'arrows-left-right'
      | 'arrows-out-cardinal'
      | 'arrows-out'
      | 'arrows-out-line-horizontal'
      | 'arrows-out-line-vertical'
      | 'arrows-out-simple'
      | 'arrows-vertical'
      | 'article'
      | 'article-medium'
      | 'article-ny-times'
      | 'asterisk'
      | 'asterisk-simple'
      | 'at'
      | 'atom'
      | 'baby'
      | 'backpack'
      | 'backspace'
      | 'bag'
      | 'bag-simple'
      | 'balloon'
      | 'bandaids'
      | 'bank'
      | 'barbell'
      | 'barcode'
      | 'barricade'
      | 'baseball'
      | 'basketball'
      | 'bathtub'
      | 'battery-charging'
      | 'battery-charging-vertical'
      | 'battery-empty'
      | 'battery-full'
      | 'battery-high'
      | 'battery-low'
      | 'battery-medium'
      | 'battery-plus'
      | 'battery-warning'
      | 'battery-warning-vertical'
      | 'bed'
      | 'beer-bottle'
      | 'behance-logo'
      | 'bell'
      | 'bell-ringing'
      | 'bell-simple'
      | 'bell-simple-ringing'
      | 'bell-simple-slash'
      | 'bell-simple-z'
      | 'bell-slash'
      | 'bell-z'
      | 'bezier-curve'
      | 'bicycle'
      | 'binoculars'
      | 'bird'
      | 'bluetooth-connected'
      | 'bluetooth'
      | 'bluetooth-slash'
      | 'bluetooth-x'
      | 'boat'
      | 'book-bookmark'
      | 'book'
      | 'book-open'
      | 'bookmark'
      | 'bookmark-simple'
      | 'bookmarks'
      | 'bookmarks-simple'
      | 'books'
      | 'bounding-box'
      | 'brackets-angle'
      | 'brackets-curly'
      | 'brackets-round'
      | 'brackets-square'
      | 'brain'
      | 'brandy'
      | 'briefcase'
      | 'briefcase-metal'
      | 'broadcast'
      | 'browser'
      | 'browsers'
      | 'bug-beetle'
      | 'bug-droid'
      | 'bug'
      | 'buildings'
      | 'bus'
      | 'butterfly'
      | 'cactus'
      | 'cake'
      | 'calculator'
      | 'calendar-blank'
      | 'calendar-check'
      | 'calendar'
      | 'calendar-plus'
      | 'calendar-x'
      | 'camera'
      | 'camera-rotate'
      | 'camera-slash'
      | 'campfire'
      | 'car'
      | 'car-simple'
      | 'cardholder'
      | 'cards'
      | 'caret-circle-double-down'
      | 'caret-circle-double-left'
      | 'caret-circle-double-right'
      | 'caret-circle-double-up'
      | 'caret-circle-down'
      | 'caret-circle-left'
      | 'caret-circle-right'
      | 'caret-circle-up'
      | 'caret-double-down'
      | 'caret-double-left'
      | 'caret-double-right'
      | 'caret-double-up'
      | 'caret-down'
      | 'caret-left'
      | 'caret-right'
      | 'caret-up'
      | 'cat'
      | 'cell-signal-full'
      | 'cell-signal-high'
      | 'cell-signal-low'
      | 'cell-signal-medium'
      | 'cell-signal-none'
      | 'cell-signal-slash'
      | 'cell-signal-x'
      | 'chalkboard'
      | 'chalkboard-simple'
      | 'chalkboard-teacher'
      | 'chart-bar'
      | 'chart-bar-horizontal'
      | 'chart-line'
      | 'chart-line-up'
      | 'chart-pie'
      | 'chart-pie-slice'
      | 'chat-centered-dots'
      | 'chat-centered'
      | 'chat-centered-text'
      | 'chat-circle-dots'
      | 'chat-circle'
      | 'chat-circle-text'
      | 'chat-dots'
      | 'chat'
      | 'chat-teardrop-dots'
      | 'chat-teardrop'
      | 'chat-teardrop-text'
      | 'chat-text'
      | 'chats-circle'
      | 'chats'
      | 'chats-teardrop'
      | 'check-circle'
      | 'check'
      | 'check-square'
      | 'check-square-offset'
      | 'checks'
      | 'circle-dashed'
      | 'circle'
      | 'circle-half'
      | 'circle-half-tilt'
      | 'circle-notch'
      | 'circle-wavy-check'
      | 'circle-wavy'
      | 'circle-wavy-question'
      | 'circle-wavy-warning'
      | 'circles-four'
      | 'circles-three'
      | 'circles-three-plus'
      | 'clipboard'
      | 'clipboard-text'
      | 'clock-afternoon'
      | 'clock-clockwise'
      | 'clock-counter-clockwise'
      | 'clock'
      | 'closed-captioning'
      | 'cloud-arrow-down'
      | 'cloud-arrow-up'
      | 'cloud-check'
      | 'cloud'
      | 'cloud-fog'
      | 'cloud-lightning'
      | 'cloud-moon'
      | 'cloud-rain'
      | 'cloud-slash'
      | 'cloud-snow'
      | 'cloud-sun'
      | 'club'
      | 'coat-hanger'
      | 'code'
      | 'code-simple'
      | 'codepen-logo'
      | 'codesandbox-logo'
      | 'coffee'
      | 'coin'
      | 'coin-vertical'
      | 'coins'
      | 'columns'
      | 'command'
      | 'compass'
      | 'computer-tower'
      | 'confetti'
      | 'cookie'
      | 'cooking-pot'
      | 'copy'
      | 'copy-simple'
      | 'copyleft'
      | 'copyright'
      | 'corners-in'
      | 'corners-out'
      | 'cpu'
      | 'credit-card'
      | 'crop'
      | 'crosshair'
      | 'crosshair-simple'
      | 'crown'
      | 'crown-simple'
      | 'cube'
      | 'currency-btc'
      | 'currency-circle-dollar'
      | 'currency-cny'
      | 'currency-dollar'
      | 'currency-dollar-simple'
      | 'currency-eth'
      | 'currency-eur'
      | 'currency-gbp'
      | 'currency-inr'
      | 'currency-jpy'
      | 'currency-krw'
      | 'currency-kzt'
      | 'currency-ngn'
      | 'currency-rub'
      | 'cursor'
      | 'cursor-text'
      | 'cylinder'
      | 'database'
      | 'desktop'
      | 'desktop-tower'
      | 'detective'
      | 'device-mobile-camera'
      | 'device-mobile'
      | 'device-mobile-speaker'
      | 'device-tablet-camera'
      | 'device-tablet'
      | 'device-tablet-speaker'
      | 'diamond'
      | 'diamonds-four'
      | 'dice-five'
      | 'dice-four'
      | 'dice-one'
      | 'dice-six'
      | 'dice-three'
      | 'dice-two'
      | 'disc'
      | 'discord-logo'
      | 'divide'
      | 'dog'
      | 'door'
      | 'dots-nine'
      | 'dots-six'
      | 'dots-six-vertical'
      | 'dots-three-circle'
      | 'dots-three-circle-vertical'
      | 'dots-three'
      | 'dots-three-outline'
      | 'dots-three-outline-vertical'
      | 'dots-three-vertical'
      | 'download'
      | 'download-simple'
      | 'dribbble-logo'
      | 'drop'
      | 'drop-half-bottom'
      | 'drop-half'
      | 'ear'
      | 'ear-slash'
      | 'egg-crack'
      | 'egg'
      | 'eject'
      | 'eject-simple'
      | 'envelope'
      | 'envelope-open'
      | 'envelope-simple'
      | 'envelope-simple-open'
      | 'equalizer'
      | 'equals'
      | 'eraser'
      | 'exam'
      | 'export'
      | 'eye-closed'
      | 'eye'
      | 'eye-slash'
      | 'eyedropper'
      | 'eyedropper-sample'
      | 'eyeglasses'
      | 'face-mask'
      | 'facebook-logo'
      | 'factory'
      | 'faders'
      | 'faders-horizontal'
      | 'fast-forward-circle'
      | 'fast-forward'
      | 'figma-logo'
      | 'file-arrow-down'
      | 'file-arrow-up'
      | 'file-audio'
      | 'file-cloud'
      | 'file-code'
      | 'file-css'
      | 'file-csv'
      | 'file-doc'
      | 'file-dotted'
      | 'file'
      | 'file-html'
      | 'file-image'
      | 'file-jpg'
      | 'file-js'
      | 'file-jsx'
      | 'file-lock'
      | 'file-minus'
      | 'file-pdf'
      | 'file-plus'
      | 'file-png'
      | 'file-ppt'
      | 'file-rs'
      | 'file-search'
      | 'file-text'
      | 'file-ts'
      | 'file-tsx'
      | 'file-video'
      | 'file-vue'
      | 'file-x'
      | 'file-xls'
      | 'file-zip'
      | 'files'
      | 'film-script'
      | 'film-slate'
      | 'film-strip'
      | 'fingerprint'
      | 'fingerprint-simple'
      | 'finn-the-human'
      | 'fire'
      | 'fire-simple'
      | 'first-aid'
      | 'first-aid-kit'
      | 'fish'
      | 'fish-simple'
      | 'flag-banner'
      | 'flag-checkered'
      | 'flag'
      | 'flame'
      | 'flashlight'
      | 'flask'
      | 'floppy-disk-back'
      | 'floppy-disk'
      | 'flow-arrow'
      | 'flower'
      | 'flower-lotus'
      | 'flying-saucer'
      | 'folder-dotted'
      | 'folder'
      | 'folder-lock'
      | 'folder-minus'
      | 'folder-notch'
      | 'folder-notch-minus'
      | 'folder-notch-open'
      | 'folder-notch-plus'
      | 'folder-open'
      | 'folder-plus'
      | 'folder-simple-dotted'
      | 'folder-simple'
      | 'folder-simple-lock'
      | 'folder-simple-minus'
      | 'folder-simple-plus'
      | 'folder-simple-star'
      | 'folder-simple-user'
      | 'folder-star'
      | 'folder-user'
      | 'folders'
      | 'football'
      | 'fork-knife'
      | 'frame-corners'
      | 'framer-logo'
      | 'function'
      | 'funnel'
      | 'funnel-simple'
      | 'game-controller'
      | 'gas-pump'
      | 'gauge'
      | 'gear'
      | 'gear-six'
      | 'gender-female'
      | 'gender-intersex'
      | 'gender-male'
      | 'gender-neuter'
      | 'gender-nonbinary'
      | 'gender-transgender'
      | 'ghost'
      | 'gif'
      | 'gift'
      | 'git-branch'
      | 'git-commit'
      | 'git-diff'
      | 'git-fork'
      | 'git-merge'
      | 'git-pull-request'
      | 'github-logo'
      | 'gitlab-logo'
      | 'gitlab-logo-simple'
      | 'globe'
      | 'globe-hemisphere-east'
      | 'globe-hemisphere-west'
      | 'globe-simple'
      | 'globe-stand'
      | 'google-chrome-logo'
      | 'google-logo'
      | 'google-photos-logo'
      | 'google-play-logo'
      | 'google-podcasts-logo'
      | 'gradient'
      | 'graduation-cap'
      | 'graph'
      | 'grid-four'
      | 'hamburger'
      | 'hand-eye'
      | 'hand'
      | 'hand-fist'
      | 'hand-grabbing'
      | 'hand-palm'
      | 'hand-pointing'
      | 'hand-soap'
      | 'hand-waving'
      | 'handbag'
      | 'handbag-simple'
      | 'hands-clapping'
      | 'handshake'
      | 'hard-drive'
      | 'hard-drives'
      | 'hash'
      | 'hash-straight'
      | 'headlights'
      | 'headphones'
      | 'headset'
      | 'heart-break'
      | 'heart'
      | 'heart-straight-break'
      | 'heart-straight'
      | 'heartbeat'
      | 'hexagon'
      | 'highlighter-circle'
      | 'horse'
      | 'hourglass'
      | 'hourglass-high'
      | 'hourglass-low'
      | 'hourglass-medium'
      | 'hourglass-simple'
      | 'hourglass-simple-high'
      | 'hourglass-simple-low'
      | 'hourglass-simple-medium'
      | 'house'
      | 'house-line'
      | 'house-simple'
      | 'identification-badge'
      | 'identification-card'
      | 'image'
      | 'image-square'
      | 'infinity'
      | 'info'
      | 'instagram-logo'
      | 'intersect'
      | 'jeep'
      | 'kanban'
      | 'key'
      | 'key-return'
      | 'keyboard'
      | 'keyhole'
      | 'knife'
      | 'ladder'
      | 'ladder-simple'
      | 'lamp'
      | 'laptop'
      | 'layout'
      | 'leaf'
      | 'lifebuoy'
      | 'lightbulb-filament'
      | 'lightbulb'
      | 'lightning'
      | 'lightning-slash'
      | 'line-segment'
      | 'line-segments'
      | 'link-break'
      | 'link'
      | 'link-simple-break'
      | 'link-simple'
      | 'link-simple-horizontal-break'
      | 'link-simple-horizontal'
      | 'linkedin-logo'
      | 'linux-logo'
      | 'list-bullets'
      | 'list-checks'
      | 'list-dashes'
      | 'list'
      | 'list-numbers'
      | 'list-plus'
      | 'lock'
      | 'lock-key'
      | 'lock-key-open'
      | 'lock-laminated'
      | 'lock-laminated-open'
      | 'lock-open'
      | 'lock-simple'
      | 'lock-simple-open'
      | 'magic-wand'
      | 'magnet'
      | 'magnet-straight'
      | 'magnifying-glass'
      | 'magnifying-glass-minus'
      | 'magnifying-glass-plus'
      | 'map-pin'
      | 'map-pin-line'
      | 'map-trifold'
      | 'marker-circle'
      | 'martini'
      | 'mask-happy'
      | 'mask-sad'
      | 'math-operations'
      | 'medal'
      | 'medium-logo'
      | 'megaphone'
      | 'megaphone-simple'
      | 'messenger-logo'
      | 'microphone'
      | 'microphone-slash'
      | 'microphone-stage'
      | 'microsoft-excel-logo'
      | 'microsoft-powerpoint-logo'
      | 'microsoft-teams-logo'
      | 'microsoft-word-logo'
      | 'minus-circle'
      | 'minus'
      | 'money'
      | 'monitor'
      | 'monitor-play'
      | 'moon'
      | 'moon-stars'
      | 'mountains'
      | 'mouse'
      | 'mouse-simple'
      | 'music-note'
      | 'music-note-simple'
      | 'music-notes'
      | 'music-notes-plus'
      | 'music-notes-simple'
      | 'navigation-arrow'
      | 'needle'
      | 'newspaper-clipping'
      | 'newspaper'
      | 'note-blank'
      | 'note'
      | 'note-pencil'
      | 'notebook'
      | 'notepad'
      | 'notification'
      | 'number-circle-eight'
      | 'number-circle-five'
      | 'number-circle-four'
      | 'number-circle-nine'
      | 'number-circle-one'
      | 'number-circle-seven'
      | 'number-circle-six'
      | 'number-circle-three'
      | 'number-circle-two'
      | 'number-circle-zero'
      | 'number-eight'
      | 'number-five'
      | 'number-four'
      | 'number-nine'
      | 'number-one'
      | 'number-seven'
      | 'number-six'
      | 'number-square-eight'
      | 'number-square-five'
      | 'number-square-four'
      | 'number-square-nine'
      | 'number-square-one'
      | 'number-square-seven'
      | 'number-square-six'
      | 'number-square-three'
      | 'number-square-two'
      | 'number-square-zero'
      | 'number-three'
      | 'number-two'
      | 'number-zero'
      | 'nut'
      | 'ny-times-logo'
      | 'octagon'
      | 'option'
      | 'package'
      | 'paint-brush-broad'
      | 'paint-brush'
      | 'paint-brush-household'
      | 'paint-bucket'
      | 'paint-roller'
      | 'palette'
      | 'paper-plane'
      | 'paper-plane-right'
      | 'paper-plane-tilt'
      | 'paperclip'
      | 'paperclip-horizontal'
      | 'parachute'
      | 'password'
      | 'path'
      | 'pause-circle'
      | 'pause'
      | 'paw-print'
      | 'peace'
      | 'pen'
      | 'pen-nib'
      | 'pen-nib-straight'
      | 'pencil-circle'
      | 'pencil'
      | 'pencil-line'
      | 'pencil-simple'
      | 'pencil-simple-line'
      | 'percent'
      | 'person'
      | 'person-simple'
      | 'person-simple-run'
      | 'person-simple-walk'
      | 'perspective'
      | 'phone-call'
      | 'phone-disconnect'
      | 'phone'
      | 'phone-incoming'
      | 'phone-outgoing'
      | 'phone-slash'
      | 'phone-x'
      | 'phosphor-logo'
      | 'piano-keys'
      | 'picture-in-picture'
      | 'pill'
      | 'pinterest-logo'
      | 'pinwheel'
      | 'pizza'
      | 'placeholder'
      | 'planet'
      | 'play-circle'
      | 'play'
      | 'playlist'
      | 'plug'
      | 'plugs-connected'
      | 'plugs'
      | 'plus-circle'
      | 'plus'
      | 'plus-minus'
      | 'poker-chip'
      | 'police-car'
      | 'polygon'
      | 'popcorn'
      | 'power'
      | 'prescription'
      | 'presentation-chart'
      | 'presentation'
      | 'printer'
      | 'prohibit'
      | 'prohibit-inset'
      | 'projector-screen-chart'
      | 'projector-screen'
      | 'push-pin'
      | 'push-pin-simple'
      | 'push-pin-simple-slash'
      | 'push-pin-slash'
      | 'puzzle-piece'
      | 'qr-code'
      | 'question'
      | 'queue'
      | 'quotes'
      | 'radical'
      | 'radio-button'
      | 'radio'
      | 'rainbow-cloud'
      | 'rainbow'
      | 'receipt'
      | 'record'
      | 'rectangle'
      | 'recycle'
      | 'reddit-logo'
      | 'repeat'
      | 'repeat-once'
      | 'rewind-circle'
      | 'rewind'
      | 'robot'
      | 'rocket'
      | 'rocket-launch'
      | 'rows'
      | 'rss'
      | 'rss-simple'
      | 'rug'
      | 'ruler'
      | 'scales'
      | 'scan'
      | 'scissors'
      | 'screencast'
      | 'scribble-loop'
      | 'scroll'
      | 'selection-all'
      | 'selection-background'
      | 'selection'
      | 'selection-foreground'
      | 'selection-inverse'
      | 'selection-plus'
      | 'selection-slash'
      | 'share'
      | 'share-network'
      | 'shield-check'
      | 'shield-checkered'
      | 'shield-chevron'
      | 'shield'
      | 'shield-plus'
      | 'shield-slash'
      | 'shield-star'
      | 'shield-warning'
      | 'shopping-bag'
      | 'shopping-bag-open'
      | 'shopping-cart'
      | 'shopping-cart-simple'
      | 'shower'
      | 'shuffle-angular'
      | 'shuffle'
      | 'shuffle-simple'
      | 'sidebar'
      | 'sidebar-simple'
      | 'sign-in'
      | 'sign-out'
      | 'signpost'
      | 'sim-card'
      | 'sketch-logo'
      | 'skip-back-circle'
      | 'skip-back'
      | 'skip-forward-circle'
      | 'skip-forward'
      | 'skull'
      | 'slack-logo'
      | 'sliders'
      | 'sliders-horizontal'
      | 'smiley-blank'
      | 'smiley'
      | 'smiley-meh'
      | 'smiley-nervous'
      | 'smiley-sad'
      | 'smiley-sticker'
      | 'smiley-wink'
      | 'smiley-x-eyes'
      | 'snapchat-logo'
      | 'snowflake'
      | 'soccer-ball'
      | 'sort-ascending'
      | 'sort-descending'
      | 'spade'
      | 'sparkle'
      | 'speaker-high'
      | 'speaker-low'
      | 'speaker-none'
      | 'speaker-simple-high'
      | 'speaker-simple-low'
      | 'speaker-simple-none'
      | 'speaker-simple-slash'
      | 'speaker-simple-x'
      | 'speaker-slash'
      | 'speaker-x'
      | 'spinner'
      | 'spinner-gap'
      | 'spiral'
      | 'spotify-logo'
      | 'square'
      | 'square-half-bottom'
      | 'square-half'
      | 'square-logo'
      | 'squares-four'
      | 'stack'
      | 'stack-overflow-logo'
      | 'stack-simple'
      | 'stamp'
      | 'star'
      | 'star-four'
      | 'star-half'
      | 'sticker'
      | 'stop-circle'
      | 'stop'
      | 'storefront'
      | 'strategy'
      | 'stripe-logo'
      | 'student'
      | 'suitcase'
      | 'suitcase-simple'
      | 'sun-dim'
      | 'sun'
      | 'sun-horizon'
      | 'sunglasses'
      | 'swap'
      | 'swatches'
      | 'sword'
      | 'syringe'
      | 't-shirt'
      | 'table'
      | 'tabs'
      | 'tag-chevron'
      | 'tag'
      | 'tag-simple'
      | 'target'
      | 'taxi'
      | 'telegram-logo'
      | 'television'
      | 'television-simple'
      | 'tennis-ball'
      | 'terminal'
      | 'terminal-window'
      | 'test-tube'
      | 'text-aa'
      | 'text-align-center'
      | 'text-align-justify'
      | 'text-align-left'
      | 'text-align-right'
      | 'text-bolder'
      | 'text-h'
      | 'text-h-five'
      | 'text-h-four'
      | 'text-h-one'
      | 'text-h-six'
      | 'text-h-three'
      | 'text-h-two'
      | 'text-indent'
      | 'text-italic'
      | 'text-outdent'
      | 'text-strikethrough'
      | 'text-t'
      | 'text-underline'
      | 'textbox'
      | 'thermometer-cold'
      | 'thermometer'
      | 'thermometer-hot'
      | 'thermometer-simple'
      | 'thumbs-down'
      | 'thumbs-up'
      | 'ticket'
      | 'tiktok-logo'
      | 'timer'
      | 'toggle-left'
      | 'toggle-right'
      | 'toilet'
      | 'toilet-paper'
      | 'tote'
      | 'tote-simple'
      | 'trademark-registered'
      | 'traffic-cone'
      | 'traffic-sign'
      | 'traffic-signal'
      | 'train'
      | 'train-regional'
      | 'train-simple'
      | 'translate'
      | 'trash'
      | 'trash-simple'
      | 'tray'
      | 'tree-evergreen'
      | 'tree'
      | 'tree-structure'
      | 'trend-down'
      | 'trend-up'
      | 'triangle'
      | 'trophy'
      | 'truck'
      | 'twitch-logo'
      | 'twitter-logo'
      | 'umbrella'
      | 'umbrella-simple'
      | 'upload'
      | 'upload-simple'
      | 'user-circle'
      | 'user-circle-gear'
      | 'user-circle-minus'
      | 'user-circle-plus'
      | 'user'
      | 'user-focus'
      | 'user-gear'
      | 'user-list'
      | 'user-minus'
      | 'user-plus'
      | 'user-rectangle'
      | 'user-square'
      | 'user-switch'
      | 'users'
      | 'users-four'
      | 'users-three'
      | 'vault'
      | 'vibrate'
      | 'video-camera'
      | 'video-camera-slash'
      | 'vignette'
      | 'voicemail'
      | 'volleyball'
      | 'wall'
      | 'wallet'
      | 'warning-circle'
      | 'warning'
      | 'warning-octagon'
      | 'watch'
      | 'wave-sawtooth'
      | 'wave-sine'
      | 'wave-square'
      | 'wave-triangle'
      | 'waves'
      | 'webcam'
      | 'whatsapp-logo'
      | 'wheelchair'
      | 'wifi-high'
      | 'wifi-low'
      | 'wifi-medium'
      | 'wifi-none'
      | 'wifi-slash'
      | 'wifi-x'
      | 'wind'
      | 'windows-logo'
      | 'wine'
      | 'wrench'
      | 'x-circle'
      | 'x'
      | 'x-square'
      | 'yin-yang'
      | 'youtube-logo'
    duotone:
      | 'activity'
      | 'address-book'
      | 'airplane'
      | 'airplane-in-flight'
      | 'airplane-landing'
      | 'airplane-takeoff'
      | 'airplane-tilt'
      | 'airplay'
      | 'alarm'
      | 'alien'
      | 'align-bottom'
      | 'align-bottom-simple'
      | 'align-center-horizontal'
      | 'align-center-horizontal-simple'
      | 'align-center-vertical'
      | 'align-center-vertical-simple'
      | 'align-left'
      | 'align-left-simple'
      | 'align-right'
      | 'align-right-simple'
      | 'align-top'
      | 'align-top-simple'
      | 'anchor'
      | 'anchor-simple'
      | 'android-logo'
      | 'angular-logo'
      | 'aperture'
      | 'app-store-logo'
      | 'app-window'
      | 'apple-logo'
      | 'apple-podcasts-logo'
      | 'archive-box'
      | 'archive'
      | 'archive-tray'
      | 'armchair'
      | 'arrow-arc-left'
      | 'arrow-arc-right'
      | 'arrow-bend-double-up-left'
      | 'arrow-bend-double-up-right'
      | 'arrow-bend-down-left'
      | 'arrow-bend-down-right'
      | 'arrow-bend-left-down'
      | 'arrow-bend-left-up'
      | 'arrow-bend-right-down'
      | 'arrow-bend-right-up'
      | 'arrow-bend-up-left'
      | 'arrow-bend-up-right'
      | 'arrow-circle-down'
      | 'arrow-circle-down-left'
      | 'arrow-circle-down-right'
      | 'arrow-circle-left'
      | 'arrow-circle-right'
      | 'arrow-circle-up'
      | 'arrow-circle-up-left'
      | 'arrow-circle-up-right'
      | 'arrow-clockwise'
      | 'arrow-counter-clockwise'
      | 'arrow-down'
      | 'arrow-down-left'
      | 'arrow-down-right'
      | 'arrow-elbow-down-left'
      | 'arrow-elbow-down-right'
      | 'arrow-elbow-left-down'
      | 'arrow-elbow-left'
      | 'arrow-elbow-left-up'
      | 'arrow-elbow-right-down'
      | 'arrow-elbow-right'
      | 'arrow-elbow-right-up'
      | 'arrow-elbow-up-left'
      | 'arrow-elbow-up-right'
      | 'arrow-fat-down'
      | 'arrow-fat-left'
      | 'arrow-fat-line-down'
      | 'arrow-fat-line-left'
      | 'arrow-fat-line-right'
      | 'arrow-fat-line-up'
      | 'arrow-fat-lines-down'
      | 'arrow-fat-lines-left'
      | 'arrow-fat-lines-right'
      | 'arrow-fat-lines-up'
      | 'arrow-fat-right'
      | 'arrow-fat-up'
      | 'arrow-left'
      | 'arrow-line-down'
      | 'arrow-line-down-left'
      | 'arrow-line-down-right'
      | 'arrow-line-left'
      | 'arrow-line-right'
      | 'arrow-line-up'
      | 'arrow-line-up-left'
      | 'arrow-line-up-right'
      | 'arrow-right'
      | 'arrow-square-down'
      | 'arrow-square-down-left'
      | 'arrow-square-down-right'
      | 'arrow-square-in'
      | 'arrow-square-left'
      | 'arrow-square-out'
      | 'arrow-square-right'
      | 'arrow-square-up'
      | 'arrow-square-up-left'
      | 'arrow-square-up-right'
      | 'arrow-u-down-left'
      | 'arrow-u-down-right'
      | 'arrow-u-left-down'
      | 'arrow-u-left-up'
      | 'arrow-u-right-down'
      | 'arrow-u-right-up'
      | 'arrow-u-up-left'
      | 'arrow-u-up-right'
      | 'arrow-up'
      | 'arrow-up-left'
      | 'arrow-up-right'
      | 'arrows-clockwise'
      | 'arrows-counter-clockwise'
      | 'arrows-down-up'
      | 'arrows-horizontal'
      | 'arrows-in-cardinal'
      | 'arrows-in'
      | 'arrows-in-line-horizontal'
      | 'arrows-in-line-vertical'
      | 'arrows-in-simple'
      | 'arrows-left-right'
      | 'arrows-out-cardinal'
      | 'arrows-out'
      | 'arrows-out-line-horizontal'
      | 'arrows-out-line-vertical'
      | 'arrows-out-simple'
      | 'arrows-vertical'
      | 'article'
      | 'article-medium'
      | 'article-ny-times'
      | 'asterisk'
      | 'asterisk-simple'
      | 'at'
      | 'atom'
      | 'baby'
      | 'backpack'
      | 'backspace'
      | 'bag'
      | 'bag-simple'
      | 'balloon'
      | 'bandaids'
      | 'bank'
      | 'barbell'
      | 'barcode'
      | 'barricade'
      | 'baseball'
      | 'basketball'
      | 'bathtub'
      | 'battery-charging'
      | 'battery-charging-vertical'
      | 'battery-empty'
      | 'battery-full'
      | 'battery-high'
      | 'battery-low'
      | 'battery-medium'
      | 'battery-plus'
      | 'battery-warning'
      | 'battery-warning-vertical'
      | 'bed'
      | 'beer-bottle'
      | 'behance-logo'
      | 'bell'
      | 'bell-ringing'
      | 'bell-simple'
      | 'bell-simple-ringing'
      | 'bell-simple-slash'
      | 'bell-simple-z'
      | 'bell-slash'
      | 'bell-z'
      | 'bezier-curve'
      | 'bicycle'
      | 'binoculars'
      | 'bird'
      | 'bluetooth-connected'
      | 'bluetooth'
      | 'bluetooth-slash'
      | 'bluetooth-x'
      | 'boat'
      | 'book-bookmark'
      | 'book'
      | 'book-open'
      | 'bookmark'
      | 'bookmark-simple'
      | 'bookmarks'
      | 'bookmarks-simple'
      | 'books'
      | 'bounding-box'
      | 'brackets-angle'
      | 'brackets-curly'
      | 'brackets-round'
      | 'brackets-square'
      | 'brain'
      | 'brandy'
      | 'briefcase'
      | 'briefcase-metal'
      | 'broadcast'
      | 'browser'
      | 'browsers'
      | 'bug-beetle'
      | 'bug-droid'
      | 'bug'
      | 'buildings'
      | 'bus'
      | 'butterfly'
      | 'cactus'
      | 'cake'
      | 'calculator'
      | 'calendar-blank'
      | 'calendar-check'
      | 'calendar'
      | 'calendar-plus'
      | 'calendar-x'
      | 'camera'
      | 'camera-rotate'
      | 'camera-slash'
      | 'campfire'
      | 'car'
      | 'car-simple'
      | 'cardholder'
      | 'cards'
      | 'caret-circle-double-down'
      | 'caret-circle-double-left'
      | 'caret-circle-double-right'
      | 'caret-circle-double-up'
      | 'caret-circle-down'
      | 'caret-circle-left'
      | 'caret-circle-right'
      | 'caret-circle-up'
      | 'caret-double-down'
      | 'caret-double-left'
      | 'caret-double-right'
      | 'caret-double-up'
      | 'caret-down'
      | 'caret-left'
      | 'caret-right'
      | 'caret-up'
      | 'cat'
      | 'cell-signal-full'
      | 'cell-signal-high'
      | 'cell-signal-low'
      | 'cell-signal-medium'
      | 'cell-signal-none'
      | 'cell-signal-slash'
      | 'cell-signal-x'
      | 'chalkboard'
      | 'chalkboard-simple'
      | 'chalkboard-teacher'
      | 'chart-bar'
      | 'chart-bar-horizontal'
      | 'chart-line'
      | 'chart-line-up'
      | 'chart-pie'
      | 'chart-pie-slice'
      | 'chat-centered-dots'
      | 'chat-centered'
      | 'chat-centered-text'
      | 'chat-circle-dots'
      | 'chat-circle'
      | 'chat-circle-text'
      | 'chat-dots'
      | 'chat'
      | 'chat-teardrop-dots'
      | 'chat-teardrop'
      | 'chat-teardrop-text'
      | 'chat-text'
      | 'chats-circle'
      | 'chats'
      | 'chats-teardrop'
      | 'check-circle'
      | 'check'
      | 'check-square'
      | 'check-square-offset'
      | 'checks'
      | 'circle-dashed'
      | 'circle'
      | 'circle-half'
      | 'circle-half-tilt'
      | 'circle-notch'
      | 'circle-wavy-check'
      | 'circle-wavy'
      | 'circle-wavy-question'
      | 'circle-wavy-warning'
      | 'circles-four'
      | 'circles-three'
      | 'circles-three-plus'
      | 'clipboard'
      | 'clipboard-text'
      | 'clock-afternoon'
      | 'clock-clockwise'
      | 'clock-counter-clockwise'
      | 'clock'
      | 'closed-captioning'
      | 'cloud-arrow-down'
      | 'cloud-arrow-up'
      | 'cloud-check'
      | 'cloud'
      | 'cloud-fog'
      | 'cloud-lightning'
      | 'cloud-moon'
      | 'cloud-rain'
      | 'cloud-slash'
      | 'cloud-snow'
      | 'cloud-sun'
      | 'club'
      | 'coat-hanger'
      | 'code'
      | 'code-simple'
      | 'codepen-logo'
      | 'codesandbox-logo'
      | 'coffee'
      | 'coin'
      | 'coin-vertical'
      | 'coins'
      | 'columns'
      | 'command'
      | 'compass'
      | 'computer-tower'
      | 'confetti'
      | 'cookie'
      | 'cooking-pot'
      | 'copy'
      | 'copy-simple'
      | 'copyleft'
      | 'copyright'
      | 'corners-in'
      | 'corners-out'
      | 'cpu'
      | 'credit-card'
      | 'crop'
      | 'crosshair'
      | 'crosshair-simple'
      | 'crown'
      | 'crown-simple'
      | 'cube'
      | 'currency-btc'
      | 'currency-circle-dollar'
      | 'currency-cny'
      | 'currency-dollar'
      | 'currency-dollar-simple'
      | 'currency-eth'
      | 'currency-eur'
      | 'currency-gbp'
      | 'currency-inr'
      | 'currency-jpy'
      | 'currency-krw'
      | 'currency-kzt'
      | 'currency-ngn'
      | 'currency-rub'
      | 'cursor'
      | 'cursor-text'
      | 'cylinder'
      | 'database'
      | 'desktop'
      | 'desktop-tower'
      | 'detective'
      | 'device-mobile-camera'
      | 'device-mobile'
      | 'device-mobile-speaker'
      | 'device-tablet-camera'
      | 'device-tablet'
      | 'device-tablet-speaker'
      | 'diamond'
      | 'diamonds-four'
      | 'dice-five'
      | 'dice-four'
      | 'dice-one'
      | 'dice-six'
      | 'dice-three'
      | 'dice-two'
      | 'disc'
      | 'discord-logo'
      | 'divide'
      | 'dog'
      | 'door'
      | 'dots-nine'
      | 'dots-six'
      | 'dots-six-vertical'
      | 'dots-three-circle'
      | 'dots-three-circle-vertical'
      | 'dots-three'
      | 'dots-three-outline'
      | 'dots-three-outline-vertical'
      | 'dots-three-vertical'
      | 'download'
      | 'download-simple'
      | 'dribbble-logo'
      | 'drop'
      | 'drop-half-bottom'
      | 'drop-half'
      | 'ear'
      | 'ear-slash'
      | 'egg-crack'
      | 'egg'
      | 'eject'
      | 'eject-simple'
      | 'envelope'
      | 'envelope-open'
      | 'envelope-simple'
      | 'envelope-simple-open'
      | 'equalizer'
      | 'equals'
      | 'eraser'
      | 'exam'
      | 'export'
      | 'eye-closed'
      | 'eye'
      | 'eye-slash'
      | 'eyedropper'
      | 'eyedropper-sample'
      | 'eyeglasses'
      | 'face-mask'
      | 'facebook-logo'
      | 'factory'
      | 'faders'
      | 'faders-horizontal'
      | 'fast-forward-circle'
      | 'fast-forward'
      | 'figma-logo'
      | 'file-arrow-down'
      | 'file-arrow-up'
      | 'file-audio'
      | 'file-cloud'
      | 'file-code'
      | 'file-css'
      | 'file-csv'
      | 'file-doc'
      | 'file-dotted'
      | 'file'
      | 'file-html'
      | 'file-image'
      | 'file-jpg'
      | 'file-js'
      | 'file-jsx'
      | 'file-lock'
      | 'file-minus'
      | 'file-pdf'
      | 'file-plus'
      | 'file-png'
      | 'file-ppt'
      | 'file-rs'
      | 'file-search'
      | 'file-text'
      | 'file-ts'
      | 'file-tsx'
      | 'file-video'
      | 'file-vue'
      | 'file-x'
      | 'file-xls'
      | 'file-zip'
      | 'files'
      | 'film-script'
      | 'film-slate'
      | 'film-strip'
      | 'fingerprint'
      | 'fingerprint-simple'
      | 'finn-the-human'
      | 'fire'
      | 'fire-simple'
      | 'first-aid'
      | 'first-aid-kit'
      | 'fish'
      | 'fish-simple'
      | 'flag-banner'
      | 'flag-checkered'
      | 'flag'
      | 'flame'
      | 'flashlight'
      | 'flask'
      | 'floppy-disk-back'
      | 'floppy-disk'
      | 'flow-arrow'
      | 'flower'
      | 'flower-lotus'
      | 'flying-saucer'
      | 'folder-dotted'
      | 'folder'
      | 'folder-lock'
      | 'folder-minus'
      | 'folder-notch'
      | 'folder-notch-minus'
      | 'folder-notch-open'
      | 'folder-notch-plus'
      | 'folder-open'
      | 'folder-plus'
      | 'folder-simple-dotted'
      | 'folder-simple'
      | 'folder-simple-lock'
      | 'folder-simple-minus'
      | 'folder-simple-plus'
      | 'folder-simple-star'
      | 'folder-simple-user'
      | 'folder-star'
      | 'folder-user'
      | 'folders'
      | 'football'
      | 'fork-knife'
      | 'frame-corners'
      | 'framer-logo'
      | 'function'
      | 'funnel'
      | 'funnel-simple'
      | 'game-controller'
      | 'gas-pump'
      | 'gauge'
      | 'gear'
      | 'gear-six'
      | 'gender-female'
      | 'gender-intersex'
      | 'gender-male'
      | 'gender-neuter'
      | 'gender-nonbinary'
      | 'gender-transgender'
      | 'ghost'
      | 'gif'
      | 'gift'
      | 'git-branch'
      | 'git-commit'
      | 'git-diff'
      | 'git-fork'
      | 'git-merge'
      | 'git-pull-request'
      | 'github-logo'
      | 'gitlab-logo'
      | 'gitlab-logo-simple'
      | 'globe'
      | 'globe-hemisphere-east'
      | 'globe-hemisphere-west'
      | 'globe-simple'
      | 'globe-stand'
      | 'google-chrome-logo'
      | 'google-logo'
      | 'google-photos-logo'
      | 'google-play-logo'
      | 'google-podcasts-logo'
      | 'gradient'
      | 'graduation-cap'
      | 'graph'
      | 'grid-four'
      | 'hamburger'
      | 'hand'
      | 'hand-eye'
      | 'hand-fist'
      | 'hand-grabbing'
      | 'hand-palm'
      | 'hand-pointing'
      | 'hand-soap'
      | 'hand-waving'
      | 'handbag'
      | 'handbag-simple'
      | 'hands-clapping'
      | 'handshake'
      | 'hard-drive'
      | 'hard-drives'
      | 'hash'
      | 'hash-straight'
      | 'headlights'
      | 'headphones'
      | 'headset'
      | 'heart-break'
      | 'heart'
      | 'heart-straight-break'
      | 'heart-straight'
      | 'heartbeat'
      | 'hexagon'
      | 'highlighter-circle'
      | 'horse'
      | 'hourglass'
      | 'hourglass-high'
      | 'hourglass-low'
      | 'hourglass-medium'
      | 'hourglass-simple'
      | 'hourglass-simple-high'
      | 'hourglass-simple-low'
      | 'hourglass-simple-medium'
      | 'house'
      | 'house-line'
      | 'house-simple'
      | 'identification-badge'
      | 'identification-card'
      | 'image'
      | 'image-square'
      | 'infinity'
      | 'info'
      | 'instagram-logo'
      | 'intersect'
      | 'jeep'
      | 'kanban'
      | 'key'
      | 'key-return'
      | 'keyboard'
      | 'keyhole'
      | 'knife'
      | 'ladder'
      | 'ladder-simple'
      | 'lamp'
      | 'laptop'
      | 'layout'
      | 'leaf'
      | 'lifebuoy'
      | 'lightbulb'
      | 'lightbulb-filament'
      | 'lightning'
      | 'lightning-slash'
      | 'line-segment'
      | 'line-segments'
      | 'link-break'
      | 'link'
      | 'link-simple-break'
      | 'link-simple'
      | 'link-simple-horizontal-break'
      | 'link-simple-horizontal'
      | 'linkedin-logo'
      | 'linux-logo'
      | 'list-bullets'
      | 'list-checks'
      | 'list-dashes'
      | 'list'
      | 'list-numbers'
      | 'list-plus'
      | 'lock'
      | 'lock-key'
      | 'lock-key-open'
      | 'lock-laminated'
      | 'lock-laminated-open'
      | 'lock-open'
      | 'lock-simple'
      | 'lock-simple-open'
      | 'magic-wand'
      | 'magnet'
      | 'magnet-straight'
      | 'magnifying-glass'
      | 'magnifying-glass-minus'
      | 'magnifying-glass-plus'
      | 'map-pin'
      | 'map-pin-line'
      | 'map-trifold'
      | 'marker-circle'
      | 'martini'
      | 'mask-happy'
      | 'mask-sad'
      | 'math-operations'
      | 'medal'
      | 'medium-logo'
      | 'megaphone'
      | 'megaphone-simple'
      | 'messenger-logo'
      | 'microphone'
      | 'microphone-slash'
      | 'microphone-stage'
      | 'microsoft-excel-logo'
      | 'microsoft-powerpoint-logo'
      | 'microsoft-teams-logo'
      | 'microsoft-word-logo'
      | 'minus-circle'
      | 'minus'
      | 'money'
      | 'monitor'
      | 'monitor-play'
      | 'moon'
      | 'moon-stars'
      | 'mountains'
      | 'mouse'
      | 'mouse-simple'
      | 'music-note'
      | 'music-note-simple'
      | 'music-notes'
      | 'music-notes-plus'
      | 'music-notes-simple'
      | 'navigation-arrow'
      | 'needle'
      | 'newspaper-clipping'
      | 'newspaper'
      | 'note-blank'
      | 'note'
      | 'note-pencil'
      | 'notebook'
      | 'notepad'
      | 'notification'
      | 'number-circle-eight'
      | 'number-circle-five'
      | 'number-circle-four'
      | 'number-circle-nine'
      | 'number-circle-one'
      | 'number-circle-seven'
      | 'number-circle-six'
      | 'number-circle-three'
      | 'number-circle-two'
      | 'number-circle-zero'
      | 'number-eight'
      | 'number-five'
      | 'number-four'
      | 'number-nine'
      | 'number-one'
      | 'number-seven'
      | 'number-six'
      | 'number-square-eight'
      | 'number-square-five'
      | 'number-square-four'
      | 'number-square-nine'
      | 'number-square-one'
      | 'number-square-seven'
      | 'number-square-six'
      | 'number-square-three'
      | 'number-square-two'
      | 'number-square-zero'
      | 'number-three'
      | 'number-two'
      | 'number-zero'
      | 'nut'
      | 'ny-times-logo'
      | 'octagon'
      | 'option'
      | 'package'
      | 'paint-brush-broad'
      | 'paint-brush'
      | 'paint-brush-household'
      | 'paint-bucket'
      | 'paint-roller'
      | 'palette'
      | 'paper-plane'
      | 'paper-plane-right'
      | 'paper-plane-tilt'
      | 'paperclip'
      | 'paperclip-horizontal'
      | 'parachute'
      | 'password'
      | 'path'
      | 'pause-circle'
      | 'pause'
      | 'paw-print'
      | 'peace'
      | 'pen'
      | 'pen-nib'
      | 'pen-nib-straight'
      | 'pencil-circle'
      | 'pencil'
      | 'pencil-line'
      | 'pencil-simple'
      | 'pencil-simple-line'
      | 'percent'
      | 'person'
      | 'person-simple'
      | 'person-simple-run'
      | 'person-simple-walk'
      | 'perspective'
      | 'phone-call'
      | 'phone-disconnect'
      | 'phone'
      | 'phone-incoming'
      | 'phone-outgoing'
      | 'phone-slash'
      | 'phone-x'
      | 'phosphor-logo'
      | 'piano-keys'
      | 'picture-in-picture'
      | 'pill'
      | 'pinterest-logo'
      | 'pinwheel'
      | 'pizza'
      | 'placeholder'
      | 'planet'
      | 'play-circle'
      | 'play'
      | 'playlist'
      | 'plug'
      | 'plugs-connected'
      | 'plugs'
      | 'plus-circle'
      | 'plus'
      | 'plus-minus'
      | 'poker-chip'
      | 'police-car'
      | 'polygon'
      | 'popcorn'
      | 'power'
      | 'prescription'
      | 'presentation-chart'
      | 'presentation'
      | 'printer'
      | 'prohibit'
      | 'prohibit-inset'
      | 'projector-screen-chart'
      | 'projector-screen'
      | 'push-pin'
      | 'push-pin-simple'
      | 'push-pin-simple-slash'
      | 'push-pin-slash'
      | 'puzzle-piece'
      | 'qr-code'
      | 'question'
      | 'queue'
      | 'quotes'
      | 'radical'
      | 'radio-button'
      | 'radio'
      | 'rainbow-cloud'
      | 'rainbow'
      | 'receipt'
      | 'record'
      | 'rectangle'
      | 'recycle'
      | 'reddit-logo'
      | 'repeat'
      | 'repeat-once'
      | 'rewind-circle'
      | 'rewind'
      | 'robot'
      | 'rocket'
      | 'rocket-launch'
      | 'rows'
      | 'rss'
      | 'rss-simple'
      | 'rug'
      | 'ruler'
      | 'scales'
      | 'scan'
      | 'scissors'
      | 'screencast'
      | 'scribble-loop'
      | 'scroll'
      | 'selection-all'
      | 'selection-background'
      | 'selection'
      | 'selection-foreground'
      | 'selection-inverse'
      | 'selection-plus'
      | 'selection-slash'
      | 'share'
      | 'share-network'
      | 'shield-check'
      | 'shield-checkered'
      | 'shield-chevron'
      | 'shield'
      | 'shield-plus'
      | 'shield-slash'
      | 'shield-star'
      | 'shield-warning'
      | 'shopping-bag'
      | 'shopping-bag-open'
      | 'shopping-cart'
      | 'shopping-cart-simple'
      | 'shower'
      | 'shuffle-angular'
      | 'shuffle'
      | 'shuffle-simple'
      | 'sidebar'
      | 'sidebar-simple'
      | 'sign-in'
      | 'sign-out'
      | 'signpost'
      | 'sim-card'
      | 'sketch-logo'
      | 'skip-back-circle'
      | 'skip-back'
      | 'skip-forward-circle'
      | 'skip-forward'
      | 'skull'
      | 'slack-logo'
      | 'sliders'
      | 'sliders-horizontal'
      | 'smiley-blank'
      | 'smiley'
      | 'smiley-meh'
      | 'smiley-nervous'
      | 'smiley-sad'
      | 'smiley-sticker'
      | 'smiley-wink'
      | 'smiley-x-eyes'
      | 'snapchat-logo'
      | 'snowflake'
      | 'soccer-ball'
      | 'sort-ascending'
      | 'sort-descending'
      | 'spade'
      | 'sparkle'
      | 'speaker-high'
      | 'speaker-low'
      | 'speaker-none'
      | 'speaker-simple-high'
      | 'speaker-simple-low'
      | 'speaker-simple-none'
      | 'speaker-simple-slash'
      | 'speaker-simple-x'
      | 'speaker-slash'
      | 'speaker-x'
      | 'spinner'
      | 'spinner-gap'
      | 'spiral'
      | 'spotify-logo'
      | 'square'
      | 'square-half-bottom'
      | 'square-half'
      | 'square-logo'
      | 'squares-four'
      | 'stack'
      | 'stack-overflow-logo'
      | 'stack-simple'
      | 'stamp'
      | 'star'
      | 'star-four'
      | 'star-half'
      | 'sticker'
      | 'stop-circle'
      | 'stop'
      | 'storefront'
      | 'strategy'
      | 'stripe-logo'
      | 'student'
      | 'suitcase'
      | 'suitcase-simple'
      | 'sun-dim'
      | 'sun'
      | 'sun-horizon'
      | 'sunglasses'
      | 'swap'
      | 'swatches'
      | 'sword'
      | 'syringe'
      | 't-shirt'
      | 'table'
      | 'tabs'
      | 'tag-chevron'
      | 'tag'
      | 'tag-simple'
      | 'target'
      | 'taxi'
      | 'telegram-logo'
      | 'television'
      | 'television-simple'
      | 'tennis-ball'
      | 'terminal'
      | 'terminal-window'
      | 'test-tube'
      | 'text-aa'
      | 'text-align-center'
      | 'text-align-justify'
      | 'text-align-left'
      | 'text-align-right'
      | 'text-bolder'
      | 'text-h'
      | 'text-h-five'
      | 'text-h-four'
      | 'text-h-one'
      | 'text-h-six'
      | 'text-h-three'
      | 'text-h-two'
      | 'text-indent'
      | 'text-italic'
      | 'text-outdent'
      | 'text-strikethrough'
      | 'text-t'
      | 'text-underline'
      | 'textbox'
      | 'thermometer-cold'
      | 'thermometer'
      | 'thermometer-hot'
      | 'thermometer-simple'
      | 'thumbs-down'
      | 'thumbs-up'
      | 'ticket'
      | 'tiktok-logo'
      | 'timer'
      | 'toggle-left'
      | 'toggle-right'
      | 'toilet'
      | 'toilet-paper'
      | 'tote'
      | 'tote-simple'
      | 'trademark-registered'
      | 'traffic-cone'
      | 'traffic-sign'
      | 'traffic-signal'
      | 'train'
      | 'train-regional'
      | 'train-simple'
      | 'translate'
      | 'trash'
      | 'trash-simple'
      | 'tray'
      | 'tree'
      | 'tree-evergreen'
      | 'tree-structure'
      | 'trend-down'
      | 'trend-up'
      | 'triangle'
      | 'trophy'
      | 'truck'
      | 'twitch-logo'
      | 'twitter-logo'
      | 'umbrella'
      | 'umbrella-simple'
      | 'upload'
      | 'upload-simple'
      | 'user-circle'
      | 'user-circle-gear'
      | 'user-circle-minus'
      | 'user-circle-plus'
      | 'user'
      | 'user-focus'
      | 'user-gear'
      | 'user-list'
      | 'user-minus'
      | 'user-plus'
      | 'user-rectangle'
      | 'user-square'
      | 'user-switch'
      | 'users'
      | 'users-four'
      | 'users-three'
      | 'vault'
      | 'vibrate'
      | 'video-camera'
      | 'video-camera-slash'
      | 'vignette'
      | 'voicemail'
      | 'volleyball'
      | 'wall'
      | 'wallet'
      | 'warning-circle'
      | 'warning'
      | 'warning-octagon'
      | 'watch'
      | 'wave-sawtooth'
      | 'wave-sine'
      | 'wave-square'
      | 'wave-triangle'
      | 'waves'
      | 'webcam'
      | 'whatsapp-logo'
      | 'wheelchair'
      | 'wifi-high'
      | 'wifi-low'
      | 'wifi-medium'
      | 'wifi-none'
      | 'wifi-slash'
      | 'wifi-x'
      | 'wind'
      | 'windows-logo'
      | 'wine'
      | 'wrench'
      | 'x-circle'
      | 'x'
      | 'x-square'
      | 'yin-yang'
      | 'youtube-logo'
    bold:
      | 'activity'
      | 'address-book'
      | 'airplane'
      | 'airplane-in-flight'
      | 'airplane-landing'
      | 'airplane-takeoff'
      | 'airplane-tilt'
      | 'airplay'
      | 'alarm'
      | 'alien'
      | 'align-bottom'
      | 'align-bottom-simple'
      | 'align-center-horizontal'
      | 'align-center-horizontal-simple'
      | 'align-center-vertical'
      | 'align-center-vertical-simple'
      | 'align-left'
      | 'align-left-simple'
      | 'align-right'
      | 'align-right-simple'
      | 'align-top'
      | 'align-top-simple'
      | 'anchor'
      | 'anchor-simple'
      | 'android-logo'
      | 'angular-logo'
      | 'aperture'
      | 'app-store-logo'
      | 'app-window'
      | 'apple-logo'
      | 'apple-podcasts-logo'
      | 'archive'
      | 'archive-box'
      | 'archive-tray'
      | 'armchair'
      | 'arrow-arc-left'
      | 'arrow-arc-right'
      | 'arrow-bend-double-up-left'
      | 'arrow-bend-double-up-right'
      | 'arrow-bend-down-left'
      | 'arrow-bend-down-right'
      | 'arrow-bend-left-down'
      | 'arrow-bend-left-up'
      | 'arrow-bend-right-down'
      | 'arrow-bend-right-up'
      | 'arrow-bend-up-left'
      | 'arrow-bend-up-right'
      | 'arrow-circle-down'
      | 'arrow-circle-down-left'
      | 'arrow-circle-down-right'
      | 'arrow-circle-left'
      | 'arrow-circle-right'
      | 'arrow-circle-up'
      | 'arrow-circle-up-left'
      | 'arrow-circle-up-right'
      | 'arrow-clockwise'
      | 'arrow-counter-clockwise'
      | 'arrow-down'
      | 'arrow-down-left'
      | 'arrow-down-right'
      | 'arrow-elbow-down-left'
      | 'arrow-elbow-down-right'
      | 'arrow-elbow-left'
      | 'arrow-elbow-left-down'
      | 'arrow-elbow-left-up'
      | 'arrow-elbow-right'
      | 'arrow-elbow-right-down'
      | 'arrow-elbow-right-up'
      | 'arrow-elbow-up-left'
      | 'arrow-elbow-up-right'
      | 'arrow-fat-down'
      | 'arrow-fat-left'
      | 'arrow-fat-line-down'
      | 'arrow-fat-line-left'
      | 'arrow-fat-line-right'
      | 'arrow-fat-line-up'
      | 'arrow-fat-lines-down'
      | 'arrow-fat-lines-left'
      | 'arrow-fat-lines-right'
      | 'arrow-fat-lines-up'
      | 'arrow-fat-right'
      | 'arrow-fat-up'
      | 'arrow-left'
      | 'arrow-line-down'
      | 'arrow-line-down-left'
      | 'arrow-line-down-right'
      | 'arrow-line-left'
      | 'arrow-line-right'
      | 'arrow-line-up'
      | 'arrow-line-up-left'
      | 'arrow-line-up-right'
      | 'arrow-right'
      | 'arrow-square-down'
      | 'arrow-square-down-left'
      | 'arrow-square-down-right'
      | 'arrow-square-in'
      | 'arrow-square-left'
      | 'arrow-square-out'
      | 'arrow-square-right'
      | 'arrow-square-up'
      | 'arrow-square-up-left'
      | 'arrow-square-up-right'
      | 'arrow-u-down-left'
      | 'arrow-u-down-right'
      | 'arrow-u-left-down'
      | 'arrow-u-left-up'
      | 'arrow-u-right-down'
      | 'arrow-u-right-up'
      | 'arrow-u-up-left'
      | 'arrow-u-up-right'
      | 'arrow-up'
      | 'arrow-up-left'
      | 'arrow-up-right'
      | 'arrows-clockwise'
      | 'arrows-counter-clockwise'
      | 'arrows-down-up'
      | 'arrows-horizontal'
      | 'arrows-in'
      | 'arrows-in-cardinal'
      | 'arrows-in-line-horizontal'
      | 'arrows-in-line-vertical'
      | 'arrows-in-simple'
      | 'arrows-left-right'
      | 'arrows-out'
      | 'arrows-out-cardinal'
      | 'arrows-out-line-horizontal'
      | 'arrows-out-line-vertical'
      | 'arrows-out-simple'
      | 'arrows-vertical'
      | 'article'
      | 'article-medium'
      | 'article-ny-times'
      | 'asterisk'
      | 'asterisk-simple'
      | 'at'
      | 'atom'
      | 'baby'
      | 'backpack'
      | 'backspace'
      | 'bag'
      | 'bag-simple'
      | 'balloon'
      | 'bandaids'
      | 'bank'
      | 'barbell'
      | 'barcode'
      | 'barricade'
      | 'baseball'
      | 'basketball'
      | 'bathtub'
      | 'battery-charging'
      | 'battery-charging-vertical'
      | 'battery-empty'
      | 'battery-full'
      | 'battery-high'
      | 'battery-low'
      | 'battery-medium'
      | 'battery-plus'
      | 'battery-warning'
      | 'battery-warning-vertical'
      | 'bed'
      | 'beer-bottle'
      | 'behance-logo'
      | 'bell'
      | 'bell-ringing'
      | 'bell-simple'
      | 'bell-simple-ringing'
      | 'bell-simple-slash'
      | 'bell-simple-z'
      | 'bell-slash'
      | 'bell-z'
      | 'bezier-curve'
      | 'bicycle'
      | 'binoculars'
      | 'bird'
      | 'bluetooth'
      | 'bluetooth-connected'
      | 'bluetooth-slash'
      | 'bluetooth-x'
      | 'boat'
      | 'book'
      | 'book-bookmark'
      | 'book-open'
      | 'bookmark'
      | 'bookmark-simple'
      | 'bookmarks'
      | 'bookmarks-simple'
      | 'books'
      | 'bounding-box'
      | 'brackets-angle'
      | 'brackets-curly'
      | 'brackets-round'
      | 'brackets-square'
      | 'brain'
      | 'brandy'
      | 'briefcase'
      | 'briefcase-metal'
      | 'broadcast'
      | 'browser'
      | 'browsers'
      | 'bug-beetle'
      | 'bug'
      | 'bug-droid'
      | 'buildings'
      | 'bus'
      | 'butterfly'
      | 'cactus'
      | 'cake'
      | 'calculator'
      | 'calendar-blank'
      | 'calendar'
      | 'calendar-check'
      | 'calendar-plus'
      | 'calendar-x'
      | 'camera'
      | 'camera-rotate'
      | 'camera-slash'
      | 'campfire'
      | 'car'
      | 'car-simple'
      | 'cardholder'
      | 'cards'
      | 'caret-circle-double-down'
      | 'caret-circle-double-left'
      | 'caret-circle-double-right'
      | 'caret-circle-double-up'
      | 'caret-circle-down'
      | 'caret-circle-left'
      | 'caret-circle-right'
      | 'caret-circle-up'
      | 'caret-double-down'
      | 'caret-double-left'
      | 'caret-double-right'
      | 'caret-double-up'
      | 'caret-down'
      | 'caret-left'
      | 'caret-right'
      | 'caret-up'
      | 'cat'
      | 'cell-signal-full'
      | 'cell-signal-high'
      | 'cell-signal-low'
      | 'cell-signal-medium'
      | 'cell-signal-none'
      | 'cell-signal-slash'
      | 'cell-signal-x'
      | 'chalkboard'
      | 'chalkboard-simple'
      | 'chalkboard-teacher'
      | 'chart-bar'
      | 'chart-bar-horizontal'
      | 'chart-line'
      | 'chart-line-up'
      | 'chart-pie'
      | 'chart-pie-slice'
      | 'chat'
      | 'chat-centered'
      | 'chat-centered-dots'
      | 'chat-centered-text'
      | 'chat-circle'
      | 'chat-circle-dots'
      | 'chat-circle-text'
      | 'chat-dots'
      | 'chat-teardrop'
      | 'chat-teardrop-dots'
      | 'chat-teardrop-text'
      | 'chat-text'
      | 'chats'
      | 'chats-circle'
      | 'chats-teardrop'
      | 'check'
      | 'check-circle'
      | 'check-square'
      | 'check-square-offset'
      | 'checks'
      | 'circle'
      | 'circle-dashed'
      | 'circle-half'
      | 'circle-half-tilt'
      | 'circle-notch'
      | 'circle-wavy'
      | 'circle-wavy-check'
      | 'circle-wavy-question'
      | 'circle-wavy-warning'
      | 'circles-four'
      | 'circles-three'
      | 'circles-three-plus'
      | 'clipboard'
      | 'clipboard-text'
      | 'clock-afternoon'
      | 'clock'
      | 'clock-clockwise'
      | 'clock-counter-clockwise'
      | 'closed-captioning'
      | 'cloud-arrow-down'
      | 'cloud-arrow-up'
      | 'cloud'
      | 'cloud-check'
      | 'cloud-fog'
      | 'cloud-lightning'
      | 'cloud-moon'
      | 'cloud-rain'
      | 'cloud-slash'
      | 'cloud-snow'
      | 'cloud-sun'
      | 'club'
      | 'coat-hanger'
      | 'code'
      | 'code-simple'
      | 'codepen-logo'
      | 'codesandbox-logo'
      | 'coffee'
      | 'coin'
      | 'coin-vertical'
      | 'coins'
      | 'columns'
      | 'command'
      | 'compass'
      | 'computer-tower'
      | 'confetti'
      | 'cookie'
      | 'cooking-pot'
      | 'copy'
      | 'copy-simple'
      | 'copyleft'
      | 'copyright'
      | 'corners-in'
      | 'corners-out'
      | 'cpu'
      | 'credit-card'
      | 'crop'
      | 'crosshair'
      | 'crosshair-simple'
      | 'crown'
      | 'crown-simple'
      | 'cube'
      | 'currency-btc'
      | 'currency-circle-dollar'
      | 'currency-cny'
      | 'currency-dollar'
      | 'currency-dollar-simple'
      | 'currency-eth'
      | 'currency-eur'
      | 'currency-gbp'
      | 'currency-inr'
      | 'currency-jpy'
      | 'currency-krw'
      | 'currency-kzt'
      | 'currency-ngn'
      | 'currency-rub'
      | 'cursor'
      | 'cursor-text'
      | 'cylinder'
      | 'database'
      | 'desktop'
      | 'desktop-tower'
      | 'detective'
      | 'device-mobile'
      | 'device-mobile-camera'
      | 'device-mobile-speaker'
      | 'device-tablet'
      | 'device-tablet-camera'
      | 'device-tablet-speaker'
      | 'diamond'
      | 'diamonds-four'
      | 'dice-five'
      | 'dice-four'
      | 'dice-one'
      | 'dice-six'
      | 'dice-three'
      | 'dice-two'
      | 'disc'
      | 'discord-logo'
      | 'divide'
      | 'dog'
      | 'door'
      | 'dots-nine'
      | 'dots-six'
      | 'dots-six-vertical'
      | 'dots-three'
      | 'dots-three-circle'
      | 'dots-three-circle-vertical'
      | 'dots-three-outline'
      | 'dots-three-outline-vertical'
      | 'dots-three-vertical'
      | 'download'
      | 'download-simple'
      | 'dribbble-logo'
      | 'drop'
      | 'drop-half'
      | 'drop-half-bottom'
      | 'ear'
      | 'ear-slash'
      | 'egg'
      | 'egg-crack'
      | 'eject'
      | 'eject-simple'
      | 'envelope'
      | 'envelope-open'
      | 'envelope-simple'
      | 'envelope-simple-open'
      | 'equalizer'
      | 'equals'
      | 'eraser'
      | 'exam'
      | 'export'
      | 'eye'
      | 'eye-closed'
      | 'eye-slash'
      | 'eyedropper'
      | 'eyedropper-sample'
      | 'eyeglasses'
      | 'face-mask'
      | 'facebook-logo'
      | 'factory'
      | 'faders'
      | 'faders-horizontal'
      | 'fast-forward'
      | 'fast-forward-circle'
      | 'figma-logo'
      | 'file-arrow-down'
      | 'file-arrow-up'
      | 'file-audio'
      | 'file'
      | 'file-cloud'
      | 'file-code'
      | 'file-css'
      | 'file-csv'
      | 'file-doc'
      | 'file-dotted'
      | 'file-html'
      | 'file-image'
      | 'file-jpg'
      | 'file-js'
      | 'file-jsx'
      | 'file-lock'
      | 'file-minus'
      | 'file-pdf'
      | 'file-plus'
      | 'file-png'
      | 'file-ppt'
      | 'file-rs'
      | 'file-search'
      | 'file-text'
      | 'file-ts'
      | 'file-tsx'
      | 'file-video'
      | 'file-vue'
      | 'file-x'
      | 'file-xls'
      | 'file-zip'
      | 'files'
      | 'film-script'
      | 'film-slate'
      | 'film-strip'
      | 'fingerprint'
      | 'fingerprint-simple'
      | 'finn-the-human'
      | 'fire'
      | 'fire-simple'
      | 'first-aid'
      | 'first-aid-kit'
      | 'fish'
      | 'fish-simple'
      | 'flag-banner'
      | 'flag'
      | 'flag-checkered'
      | 'flame'
      | 'flashlight'
      | 'flask'
      | 'floppy-disk-back'
      | 'floppy-disk'
      | 'flow-arrow'
      | 'flower'
      | 'flower-lotus'
      | 'flying-saucer'
      | 'folder'
      | 'folder-dotted'
      | 'folder-lock'
      | 'folder-minus'
      | 'folder-notch'
      | 'folder-notch-minus'
      | 'folder-notch-open'
      | 'folder-notch-plus'
      | 'folder-open'
      | 'folder-plus'
      | 'folder-simple'
      | 'folder-simple-dotted'
      | 'folder-simple-lock'
      | 'folder-simple-minus'
      | 'folder-simple-plus'
      | 'folder-simple-star'
      | 'folder-simple-user'
      | 'folder-star'
      | 'folder-user'
      | 'folders'
      | 'football'
      | 'fork-knife'
      | 'frame-corners'
      | 'framer-logo'
      | 'function'
      | 'funnel'
      | 'funnel-simple'
      | 'game-controller'
      | 'gas-pump'
      | 'gauge'
      | 'gear'
      | 'gear-six'
      | 'gender-female'
      | 'gender-intersex'
      | 'gender-male'
      | 'gender-neuter'
      | 'gender-nonbinary'
      | 'gender-transgender'
      | 'ghost'
      | 'gif'
      | 'gift'
      | 'git-branch'
      | 'git-commit'
      | 'git-diff'
      | 'git-fork'
      | 'git-merge'
      | 'git-pull-request'
      | 'github-logo'
      | 'gitlab-logo'
      | 'gitlab-logo-simple'
      | 'globe'
      | 'globe-hemisphere-east'
      | 'globe-hemisphere-west'
      | 'globe-simple'
      | 'globe-stand'
      | 'google-chrome-logo'
      | 'google-logo'
      | 'google-photos-logo'
      | 'google-play-logo'
      | 'google-podcasts-logo'
      | 'gradient'
      | 'graduation-cap'
      | 'graph'
      | 'grid-four'
      | 'hamburger'
      | 'hand'
      | 'hand-eye'
      | 'hand-fist'
      | 'hand-grabbing'
      | 'hand-palm'
      | 'hand-pointing'
      | 'hand-soap'
      | 'hand-waving'
      | 'handbag'
      | 'handbag-simple'
      | 'hands-clapping'
      | 'handshake'
      | 'hard-drive'
      | 'hard-drives'
      | 'hash'
      | 'hash-straight'
      | 'headlights'
      | 'headphones'
      | 'headset'
      | 'heart'
      | 'heart-break'
      | 'heart-straight'
      | 'heart-straight-break'
      | 'heartbeat'
      | 'hexagon'
      | 'highlighter-circle'
      | 'horse'
      | 'hourglass'
      | 'hourglass-high'
      | 'hourglass-low'
      | 'hourglass-medium'
      | 'hourglass-simple'
      | 'hourglass-simple-high'
      | 'hourglass-simple-low'
      | 'hourglass-simple-medium'
      | 'house'
      | 'house-line'
      | 'house-simple'
      | 'identification-badge'
      | 'identification-card'
      | 'image'
      | 'image-square'
      | 'infinity'
      | 'info'
      | 'instagram-logo'
      | 'intersect'
      | 'jeep'
      | 'kanban'
      | 'key'
      | 'key-return'
      | 'keyboard'
      | 'keyhole'
      | 'knife'
      | 'ladder'
      | 'ladder-simple'
      | 'lamp'
      | 'laptop'
      | 'layout'
      | 'leaf'
      | 'lifebuoy'
      | 'lightbulb'
      | 'lightbulb-filament'
      | 'lightning'
      | 'lightning-slash'
      | 'line-segment'
      | 'line-segments'
      | 'link'
      | 'link-break'
      | 'link-simple'
      | 'link-simple-break'
      | 'link-simple-horizontal'
      | 'link-simple-horizontal-break'
      | 'linkedin-logo'
      | 'linux-logo'
      | 'list'
      | 'list-bullets'
      | 'list-checks'
      | 'list-dashes'
      | 'list-numbers'
      | 'list-plus'
      | 'lock'
      | 'lock-key'
      | 'lock-key-open'
      | 'lock-laminated'
      | 'lock-laminated-open'
      | 'lock-open'
      | 'lock-simple'
      | 'lock-simple-open'
      | 'magic-wand'
      | 'magnet'
      | 'magnet-straight'
      | 'magnifying-glass'
      | 'magnifying-glass-minus'
      | 'magnifying-glass-plus'
      | 'map-pin'
      | 'map-pin-line'
      | 'map-trifold'
      | 'marker-circle'
      | 'martini'
      | 'mask-happy'
      | 'mask-sad'
      | 'math-operations'
      | 'medal'
      | 'medium-logo'
      | 'megaphone'
      | 'megaphone-simple'
      | 'messenger-logo'
      | 'microphone'
      | 'microphone-slash'
      | 'microphone-stage'
      | 'microsoft-excel-logo'
      | 'microsoft-powerpoint-logo'
      | 'microsoft-teams-logo'
      | 'microsoft-word-logo'
      | 'minus'
      | 'minus-circle'
      | 'money'
      | 'monitor'
      | 'monitor-play'
      | 'moon'
      | 'moon-stars'
      | 'mountains'
      | 'mouse'
      | 'mouse-simple'
      | 'music-note'
      | 'music-note-simple'
      | 'music-notes'
      | 'music-notes-plus'
      | 'music-notes-simple'
      | 'navigation-arrow'
      | 'needle'
      | 'newspaper'
      | 'newspaper-clipping'
      | 'note-blank'
      | 'note'
      | 'note-pencil'
      | 'notebook'
      | 'notepad'
      | 'notification'
      | 'number-circle-eight'
      | 'number-circle-five'
      | 'number-circle-four'
      | 'number-circle-nine'
      | 'number-circle-one'
      | 'number-circle-seven'
      | 'number-circle-six'
      | 'number-circle-three'
      | 'number-circle-two'
      | 'number-circle-zero'
      | 'number-eight'
      | 'number-five'
      | 'number-four'
      | 'number-nine'
      | 'number-one'
      | 'number-seven'
      | 'number-six'
      | 'number-square-eight'
      | 'number-square-five'
      | 'number-square-four'
      | 'number-square-nine'
      | 'number-square-one'
      | 'number-square-seven'
      | 'number-square-six'
      | 'number-square-three'
      | 'number-square-two'
      | 'number-square-zero'
      | 'number-three'
      | 'number-two'
      | 'number-zero'
      | 'nut'
      | 'ny-times-logo'
      | 'octagon'
      | 'option'
      | 'package'
      | 'paint-brush'
      | 'paint-brush-broad'
      | 'paint-brush-household'
      | 'paint-bucket'
      | 'paint-roller'
      | 'palette'
      | 'paper-plane'
      | 'paper-plane-right'
      | 'paper-plane-tilt'
      | 'paperclip'
      | 'paperclip-horizontal'
      | 'parachute'
      | 'password'
      | 'path'
      | 'pause'
      | 'pause-circle'
      | 'paw-print'
      | 'peace'
      | 'pen'
      | 'pen-nib'
      | 'pen-nib-straight'
      | 'pencil'
      | 'pencil-circle'
      | 'pencil-line'
      | 'pencil-simple'
      | 'pencil-simple-line'
      | 'percent'
      | 'person'
      | 'person-simple'
      | 'person-simple-run'
      | 'person-simple-walk'
      | 'perspective'
      | 'phone'
      | 'phone-call'
      | 'phone-disconnect'
      | 'phone-incoming'
      | 'phone-outgoing'
      | 'phone-slash'
      | 'phone-x'
      | 'phosphor-logo'
      | 'piano-keys'
      | 'picture-in-picture'
      | 'pill'
      | 'pinterest-logo'
      | 'pinwheel'
      | 'pizza'
      | 'placeholder'
      | 'planet'
      | 'play'
      | 'play-circle'
      | 'playlist'
      | 'plug'
      | 'plugs'
      | 'plugs-connected'
      | 'plus'
      | 'plus-circle'
      | 'plus-minus'
      | 'poker-chip'
      | 'police-car'
      | 'polygon'
      | 'popcorn'
      | 'power'
      | 'prescription'
      | 'presentation'
      | 'presentation-chart'
      | 'printer'
      | 'prohibit'
      | 'prohibit-inset'
      | 'projector-screen'
      | 'projector-screen-chart'
      | 'push-pin'
      | 'push-pin-simple'
      | 'push-pin-simple-slash'
      | 'push-pin-slash'
      | 'puzzle-piece'
      | 'qr-code'
      | 'question'
      | 'queue'
      | 'quotes'
      | 'radical'
      | 'radio'
      | 'radio-button'
      | 'rainbow'
      | 'rainbow-cloud'
      | 'receipt'
      | 'record'
      | 'rectangle'
      | 'recycle'
      | 'reddit-logo'
      | 'repeat'
      | 'repeat-once'
      | 'rewind'
      | 'rewind-circle'
      | 'robot'
      | 'rocket'
      | 'rocket-launch'
      | 'rows'
      | 'rss'
      | 'rss-simple'
      | 'rug'
      | 'ruler'
      | 'scales'
      | 'scan'
      | 'scissors'
      | 'screencast'
      | 'scribble-loop'
      | 'scroll'
      | 'selection-all'
      | 'selection-background'
      | 'selection'
      | 'selection-foreground'
      | 'selection-inverse'
      | 'selection-plus'
      | 'selection-slash'
      | 'share'
      | 'share-network'
      | 'shield'
      | 'shield-check'
      | 'shield-checkered'
      | 'shield-chevron'
      | 'shield-plus'
      | 'shield-slash'
      | 'shield-star'
      | 'shield-warning'
      | 'shopping-bag'
      | 'shopping-bag-open'
      | 'shopping-cart'
      | 'shopping-cart-simple'
      | 'shower'
      | 'shuffle-angular'
      | 'shuffle'
      | 'shuffle-simple'
      | 'sidebar'
      | 'sidebar-simple'
      | 'sign-in'
      | 'sign-out'
      | 'signpost'
      | 'sim-card'
      | 'sketch-logo'
      | 'skip-back'
      | 'skip-back-circle'
      | 'skip-forward'
      | 'skip-forward-circle'
      | 'skull'
      | 'slack-logo'
      | 'sliders'
      | 'sliders-horizontal'
      | 'smiley-blank'
      | 'smiley'
      | 'smiley-meh'
      | 'smiley-nervous'
      | 'smiley-sad'
      | 'smiley-sticker'
      | 'smiley-wink'
      | 'smiley-x-eyes'
      | 'snapchat-logo'
      | 'snowflake'
      | 'soccer-ball'
      | 'sort-ascending'
      | 'sort-descending'
      | 'spade'
      | 'sparkle'
      | 'speaker-high'
      | 'speaker-low'
      | 'speaker-none'
      | 'speaker-simple-high'
      | 'speaker-simple-low'
      | 'speaker-simple-none'
      | 'speaker-simple-slash'
      | 'speaker-simple-x'
      | 'speaker-slash'
      | 'speaker-x'
      | 'spinner'
      | 'spinner-gap'
      | 'spiral'
      | 'spotify-logo'
      | 'square'
      | 'square-half'
      | 'square-half-bottom'
      | 'square-logo'
      | 'squares-four'
      | 'stack'
      | 'stack-overflow-logo'
      | 'stack-simple'
      | 'stamp'
      | 'star'
      | 'star-four'
      | 'star-half'
      | 'sticker'
      | 'stop'
      | 'stop-circle'
      | 'storefront'
      | 'strategy'
      | 'stripe-logo'
      | 'student'
      | 'suitcase'
      | 'suitcase-simple'
      | 'sun'
      | 'sun-dim'
      | 'sun-horizon'
      | 'sunglasses'
      | 'swap'
      | 'swatches'
      | 'sword'
      | 'syringe'
      | 't-shirt'
      | 'table'
      | 'tabs'
      | 'tag'
      | 'tag-chevron'
      | 'tag-simple'
      | 'target'
      | 'taxi'
      | 'telegram-logo'
      | 'television'
      | 'television-simple'
      | 'tennis-ball'
      | 'terminal'
      | 'terminal-window'
      | 'test-tube'
      | 'text-aa'
      | 'text-align-center'
      | 'text-align-justify'
      | 'text-align-left'
      | 'text-align-right'
      | 'texter-bold'
      | 'text-h'
      | 'text-h-five'
      | 'text-h-four'
      | 'text-h-one'
      | 'text-h-six'
      | 'text-h-three'
      | 'text-h-two'
      | 'text-indent'
      | 'text-italic'
      | 'text-outdent'
      | 'text-strikethrough'
      | 'text-t'
      | 'text-underline'
      | 'textbox'
      | 'thermometer'
      | 'thermometer-cold'
      | 'thermometer-hot'
      | 'thermometer-simple'
      | 'thumbs-down'
      | 'thumbs-up'
      | 'ticket'
      | 'tiktok-logo'
      | 'timer'
      | 'toggle-left'
      | 'toggle-right'
      | 'toilet'
      | 'toilet-paper'
      | 'tote'
      | 'tote-simple'
      | 'trademark-registered'
      | 'traffic-cone'
      | 'traffic-sign'
      | 'traffic-signal'
      | 'train'
      | 'train-regional'
      | 'train-simple'
      | 'translate'
      | 'trash'
      | 'trash-simple'
      | 'tray'
      | 'tree'
      | 'tree-evergreen'
      | 'tree-structure'
      | 'trend-down'
      | 'trend-up'
      | 'triangle'
      | 'trophy'
      | 'truck'
      | 'twitch-logo'
      | 'twitter-logo'
      | 'umbrella'
      | 'umbrella-simple'
      | 'upload'
      | 'upload-simple'
      | 'user'
      | 'user-circle'
      | 'user-circle-gear'
      | 'user-circle-minus'
      | 'user-circle-plus'
      | 'user-focus'
      | 'user-gear'
      | 'user-list'
      | 'user-minus'
      | 'user-plus'
      | 'user-rectangle'
      | 'user-square'
      | 'user-switch'
      | 'users'
      | 'users-four'
      | 'users-three'
      | 'vault'
      | 'vibrate'
      | 'video-camera'
      | 'video-camera-slash'
      | 'vignette'
      | 'voicemail'
      | 'volleyball'
      | 'wall'
      | 'wallet'
      | 'warning'
      | 'warning-circle'
      | 'warning-octagon'
      | 'watch'
      | 'wave-sawtooth'
      | 'wave-sine'
      | 'wave-square'
      | 'wave-triangle'
      | 'waves'
      | 'webcam'
      | 'whatsapp-logo'
      | 'wheelchair'
      | 'wifi-high'
      | 'wifi-low'
      | 'wifi-medium'
      | 'wifi-none'
      | 'wifi-slash'
      | 'wifi-x'
      | 'wind'
      | 'windows-logo'
      | 'wine'
      | 'wrench'
      | 'x'
      | 'x-circle'
      | 'x-square'
      | 'yin-yang'
      | 'youtube-logo'
  }
  supertiny:
    | 'acast'
    | 'access'
    | 'adobe'
    | 'airbnb'
    | 'amazon'
    | 'amazon_alexa'
    | 'amazon_s3'
    | 'amberframework'
    | 'andotp'
    | 'android'
    | 'angellist'
    | 'angular'
    | 'ansible'
    | 'apereo'
    | 'apple'
    | 'apple_music'
    | 'arch_linux'
    | 'auth0'
    | 'authy'
    | 'backbone'
    | 'badoo'
    | 'baidu'
    | 'bandcamp'
    | 'behance'
    | 'bing'
    | 'bitbucket'
    | 'bitcoin'
    | 'bitwarden'
    | 'blogger'
    | 'bluetooth'
    | 'buffer'
    | 'calendar'
    | 'centos'
    | 'chrome'
    | 'chromium'
    | 'clojure'
    | 'cloudflare'
    | 'codeberg'
    | 'codepen'
    | 'coffeescript'
    | 'coil'
    | 'coinpot'
    | 'crystal'
    | 'debian'
    | 'deezer'
    | 'delicious'
    | 'dev_to'
    | 'digidentity'
    | 'digitalocean'
    | 'discord'
    | 'disqus'
    | 'djangoproject'
    | 'docker'
    | 'dribbble'
    | 'drone'
    | 'dropbox'
    | 'drupal'
    | 'duckduckgo'
    | 'ea'
    | 'ebay'
    | 'edge'
    | 'element'
    | 'elementaryos'
    | 'email'
    | 'epub'
    | 'espressif'
    | 'ethereum'
    | 'evernote'
    | 'facebook'
    | 'finder'
    | 'firefox'
    | 'flattr'
    | 'flickr'
    | 'flutter'
    | 'freecodecamp'
    | 'friendica'
    | 'fritz'
    | 'gandi'
    | 'gatehub'
    | 'ghost'
    | 'git'
    | 'gitea'
    | 'github'
    | 'gitlab'
    | 'glitch'
    | 'gmail'
    | 'gmail_old'
    | 'go'
    | 'gogcom'
    | 'gojek'
    | 'goodreads'
    | 'google'
    | 'google_calendar'
    | 'google_collaborative_content_tools'
    | 'google_docs_editors'
    | 'google_drive'
    | 'google_drive_old'
    | 'google_maps'
    | 'google_maps_old'
    | 'google_meet'
    | 'google_play'
    | 'google_plus'
    | 'google_podcasts'
    | 'google_scholar'
    | 'gradle'
    | 'grafana'
    | 'hackernews'
    | 'hackerone'
    | 'haml'
    | 'heroku'
    | 'homekit'
    | 'hp'
    | 'html5'
    | 'humblebundle'
    | 'ibm'
    | 'iheartradio'
    | 'imdb'
    | 'imgur'
    | 'instagram'
    | 'intel'
    | 'internet_archive'
    | 'itch_io'
    | 'itunes_podcasts'
    | 'java'
    | 'javascript'
    | 'jellyfin'
    | 'json'
    | 'julia'
    | 'kaggle'
    | 'keepassdx'
    | 'kemal'
    | 'keskonfai'
    | 'keybase'
    | 'kickstarter'
    | 'ko-fi'
    | 'kodi'
    | 'kotlin'
    | 'laravel'
    | 'lastpass'
    | 'liberapay'
    | 'line'
    | 'linkedin'
    | 'linux'
    | 'linux_mint'
    | 'lock'
    | 'luckyframework'
    | 'macos'
    | 'mail'
    | 'mailchimp'
    | 'markdown'
    | 'mastodon'
    | 'mattermost'
    | 'medium'
    | 'meetup'
    | 'messenger'
    | 'microformats'
    | 'microsoft'
    | 'minecraft'
    | 'nextcloud'
    | 'nhs'
    | 'npm'
    | 'ok'
    | 'openbenches'
    | 'openbugbounty'
    | 'opencast'
    | 'opencollective'
    | 'opencores'
    | 'opensource'
    | 'openvpn'
    | 'opera'
    | 'orcid'
    | 'overcast'
    | 'patreon'
    | 'paypal'
    | 'pdf'
    | 'phone'
    | 'php'
    | 'pinboard'
    | 'pinterest'
    | 'pixelfed'
    | 'plex'
    | 'pocket'
    | 'pocketcasts'
    | 'preact'
    | 'print'
    | 'protonmail'
    | 'python'
    | 'qq'
    | 'raspberry_pi'
    | 'react'
    | 'reddit'
    | 'redhat'
    | 'researchgate'
    | 'roundcube'
    | 'rss'
    | 'ruby'
    | 'rubygems'
    | 'rubyonrails'
    | 'rust'
    | 'safari'
    | 'samsung'
    | 'samsung_internet'
    | 'samsung_s'
    | 'samsung_swoop'
    | 'sass'
    | 'semaphoreci'
    | 'sentry'
    | 'signal'
    | 'sketch'
    | 'skype'
    | 'slack'
    | 'slideshare'
    | 'snapchat'
    | 'soundcloud'
    | 'spotify'
    | 'square_cash'
    | 'stackexchange'
    | 'stackoverflow'
    | 'steam'
    | 'stitcher'
    | 'strava'
    | 'stumbleupon'
    | 'svelte'
    | 'svg'
    | 'symantec'
    | 'taiga'
    | 'teamspeak'
    | 'telegram'
    | 'threema'
    | 'tiktok'
    | 'tox'
    | 'trello'
    | 'tripadvisor'
    | 'tumblr'
    | 'tunein'
    | 'tutanota'
    | 'twilio'
    | 'twitch'
    | 'twitter'
    | 'uber'
    | 'ubiquiti'
    | 'ubisoft'
    | 'ubuntu'
    | 'unicode'
    | 'untappd'
    | 'uphold'
    | 'uplay'
    | 'upwork'
    | 'vegetarian'
    | 'venmo'
    | 'viber'
    | 'vimeo'
    | 'vivino'
    | 'vk'
    | 'vlc'
    | 'vue'
    | 'w3c'
    | 'wechat'
    | 'wekan'
    | 'whatsapp'
    | 'wifi'
    | 'wikipedia'
    | 'windows'
    | 'wire'
    | 'wireguard'
    | 'wordpress'
    | 'workato'
    | 'xing'
    | 'xmpp'
    | 'yahoo'
    | 'yammer'
    | 'yarn'
    | 'yelp'
    | 'youtube'
    | 'yubico'
    | 'zoom'
  tabler:
    | '2fa'
    | '3d-cube-sphere'
    | '3d-rotate'
    | 'a-b'
    | 'abacus'
    | 'access-point'
    | 'access-point-off'
    | 'accessible'
    | 'activity'
    | 'ad'
    | 'ad-2'
    | 'address-book'
    | 'adjustments'
    | 'adjustments-alt'
    | 'adjustments-horizontal'
    | 'aerial-lift'
    | 'affiliate'
    | 'alarm'
    | 'album'
    | 'alert-circle'
    | 'alert-octagon'
    | 'alert-triangle'
    | 'alien'
    | 'align-center'
    | 'align-justified'
    | 'align-left'
    | 'align-right'
    | 'ambulance'
    | 'anchor'
    | 'angle'
    | 'antenna-bars-1'
    | 'antenna-bars-2'
    | 'antenna-bars-3'
    | 'antenna-bars-4'
    | 'antenna-bars-5'
    | 'aperture'
    | 'api'
    | 'api-app'
    | 'app-window'
    | 'apple'
    | 'apps'
    | 'archive'
    | 'armchair'
    | 'armchair-2'
    | 'arrow-autofit-content'
    | 'arrow-autofit-down'
    | 'arrow-autofit-height'
    | 'arrow-autofit-left'
    | 'arrow-autofit-right'
    | 'arrow-autofit-up'
    | 'arrow-autofit-width'
    | 'arrow-back'
    | 'arrow-back-up'
    | 'arrow-bar-down'
    | 'arrow-bar-left'
    | 'arrow-bar-right'
    | 'arrow-bar-to-down'
    | 'arrow-bar-to-left'
    | 'arrow-bar-to-right'
    | 'arrow-bar-to-up'
    | 'arrow-bar-up'
    | 'arrow-bear-left'
    | 'arrow-bear-left-2'
    | 'arrow-bear-right'
    | 'arrow-bear-right-2'
    | 'arrow-big-down'
    | 'arrow-big-down-line'
    | 'arrow-big-down-lines'
    | 'arrow-big-left'
    | 'arrow-big-left-line'
    | 'arrow-big-left-lines'
    | 'arrow-big-right'
    | 'arrow-big-right-line'
    | 'arrow-big-right-lines'
    | 'arrow-big-top'
    | 'arrow-big-up-line'
    | 'arrow-big-up-lines'
    | 'arrow-bottom-bar'
    | 'arrow-bottom-circle'
    | 'arrow-bottom-square'
    | 'arrow-bottom-tail'
    | 'arrow-curve-left'
    | 'arrow-curve-right'
    | 'arrow-down'
    | 'arrow-down-circle'
    | 'arrow-down-left'
    | 'arrow-down-left-circle'
    | 'arrow-down-right'
    | 'arrow-down-right-circle'
    | 'arrow-fork'
    | 'arrow-forward'
    | 'arrow-forward-up'
    | 'arrow-left'
    | 'arrow-left-bar'
    | 'arrow-left-circle'
    | 'arrow-left-right'
    | 'arrow-left-square'
    | 'arrow-left-tail'
    | 'arrow-loop-left'
    | 'arrow-loop-left-2'
    | 'arrow-loop-right'
    | 'arrow-loop-right-2'
    | 'arrow-merge'
    | 'arrow-narrow-down'
    | 'arrow-narrow-left'
    | 'arrow-narrow-right'
    | 'arrow-narrow-up'
    | 'arrow-ramp-left'
    | 'arrow-ramp-left-2'
    | 'arrow-ramp-left-3'
    | 'arrow-ramp-right'
    | 'arrow-ramp-right-2'
    | 'arrow-ramp-right-3'
    | 'arrow-right'
    | 'arrow-right-bar'
    | 'arrow-right-circle'
    | 'arrow-right-square'
    | 'arrow-right-tail'
    | 'arrow-rotary-first-left'
    | 'arrow-rotary-first-right'
    | 'arrow-rotary-last-left'
    | 'arrow-rotary-last-right'
    | 'arrow-rotary-left'
    | 'arrow-rotary-right'
    | 'arrow-rotary-straight'
    | 'arrow-sharp-turn-left'
    | 'arrow-sharp-turn-right'
    | 'arrow-top-bar'
    | 'arrow-top-circle'
    | 'arrow-top-square'
    | 'arrow-top-tail'
    | 'arrow-up'
    | 'arrow-up-circle'
    | 'arrow-up-left'
    | 'arrow-up-left-circle'
    | 'arrow-up-right'
    | 'arrow-up-right-circle'
    | 'arrow-wave-left-down'
    | 'arrow-wave-left-up'
    | 'arrow-wave-right-down'
    | 'arrow-wave-right-up'
    | 'arrows-cross'
    | 'arrows-diagonal'
    | 'arrows-diagonal-2'
    | 'arrows-diagonal-minimize'
    | 'arrows-diagonal-minimize-2'
    | 'arrows-double-ne-sw'
    | 'arrows-double-nw-se'
    | 'arrows-double-se-nw'
    | 'arrows-double-sw-ne'
    | 'arrows-down'
    | 'arrows-down-up'
    | 'arrows-horizontal'
    | 'arrows-join'
    | 'arrows-join-2'
    | 'arrows-left'
    | 'arrows-left-down'
    | 'arrows-left-right'
    | 'arrows-maximize'
    | 'arrows-minimize'
    | 'arrows-right'
    | 'arrows-right-down'
    | 'arrows-right-left'
    | 'arrows-shuffle'
    | 'arrows-shuffle-2'
    | 'arrows-sort'
    | 'arrows-split'
    | 'arrows-split-2'
    | 'arrows-up'
    | 'arrows-up-down'
    | 'arrows-up-left'
    | 'arrows-up-right'
    | 'arrows-vertical'
    | 'artboard'
    | 'aspect-ratio'
    | 'asterisk'
    | 'asterisk-simple'
    | 'at'
    | 'atom'
    | 'atom-2'
    | 'augmented-reality'
    | 'award'
    | 'axe'
    | 'axis-x'
    | 'axis-y'
    | 'baby-carriage'
    | 'backhoe'
    | 'backpack'
    | 'backspace'
    | 'badge'
    | 'badges'
    | 'ball-american-football'
    | 'ball-baseball'
    | 'ball-basketball'
    | 'ball-bowling'
    | 'ball-football'
    | 'ball-football-off'
    | 'ball-tennis'
    | 'ball-volleyball'
    | 'ballon'
    | 'ban'
    | 'bandage'
    | 'barbell'
    | 'barcode'
    | 'barrier-block'
    | 'baseline'
    | 'basket'
    | 'bath'
    | 'battery'
    | 'battery-1'
    | 'battery-2'
    | 'battery-3'
    | 'battery-4'
    | 'battery-automotive'
    | 'battery-charging'
    | 'battery-charging-2'
    | 'battery-eco'
    | 'battery-off'
    | 'beach'
    | 'bed'
    | 'beer'
    | 'bell'
    | 'bell-minus'
    | 'bell-off'
    | 'bell-plus'
    | 'bell-ringing'
    | 'bell-ringing-2'
    | 'bell-school'
    | 'bell-x'
    | 'bell-z'
    | 'bible'
    | 'bike'
    | 'binary'
    | 'biohazard'
    | 'blockquote'
    | 'bluetooth'
    | 'bluetooth-connected'
    | 'bluetooth-off'
    | 'blur'
    | 'bold'
    | 'bolt'
    | 'bolt-off'
    | 'bone'
    | 'book'
    | 'book-2'
    | 'bookmark'
    | 'bookmark-off'
    | 'bookmarks'
    | 'books'
    | 'border-all'
    | 'border-bottom'
    | 'border-horizontal'
    | 'border-inner'
    | 'border-left'
    | 'border-none'
    | 'border-outer'
    | 'border-radius'
    | 'border-right'
    | 'border-style'
    | 'border-style-2'
    | 'border-top'
    | 'border-vertical'
    | 'bottle'
    | 'box'
    | 'box-margin'
    | 'box-model'
    | 'box-model-2'
    | 'box-multiple'
    | 'box-multiple-0'
    | 'box-multiple-1'
    | 'box-multiple-2'
    | 'box-multiple-3'
    | 'box-multiple-4'
    | 'box-multiple-5'
    | 'box-multiple-6'
    | 'box-multiple-7'
    | 'box-multiple-8'
    | 'box-multiple-9'
    | 'box-padding'
    | 'braces'
    | 'brackets'
    | 'brand-airbnb'
    | 'brand-airtable'
    | 'brand-android'
    | 'brand-angular'
    | 'brand-apple'
    | 'brand-apple-arcade'
    | 'brand-appstore'
    | 'brand-asana'
    | 'brand-behance'
    | 'brand-bing'
    | 'brand-bitbucket'
    | 'brand-booking'
    | 'brand-bootstrap'
    | 'brand-chrome'
    | 'brand-codepen'
    | 'brand-codesandbox'
    | 'brand-css3'
    | 'brand-cucumber'
    | 'brand-debian'
    | 'brand-deviantart'
    | 'brand-discord'
    | 'brand-disqus'
    | 'brand-docker'
    | 'brand-doctrine'
    | 'brand-dribbble'
    | 'brand-edge'
    | 'brand-facebook'
    | 'brand-figma'
    | 'brand-firebase'
    | 'brand-firefox'
    | 'brand-flickr'
    | 'brand-foursquare'
    | 'brand-framer'
    | 'brand-git'
    | 'brand-github'
    | 'brand-gitlab'
    | 'brand-gmail'
    | 'brand-google'
    | 'brand-google-analytics'
    | 'brand-google-drive'
    | 'brand-google-play'
    | 'brand-gravatar'
    | 'brand-hipchat'
    | 'brand-html5'
    | 'brand-instagram'
    | 'brand-javascript'
    | 'brand-kickstarter'
    | 'brand-kotlin'
    | 'brand-lastfm'
    | 'brand-linkedin'
    | 'brand-loom'
    | 'brand-mastercard'
    | 'brand-medium'
    | 'brand-messenger'
    | 'brand-meta'
    | 'brand-netbeans'
    | 'brand-netflix'
    | 'brand-notion'
    | 'brand-nytimes'
    | 'brand-open-source'
    | 'brand-opera'
    | 'brand-pagekit'
    | 'brand-patreon'
    | 'brand-paypal'
    | 'brand-php'
    | 'brand-pinterest'
    | 'brand-pocket'
    | 'brand-producthunt'
    | 'brand-python'
    | 'brand-react-native'
    | 'brand-reddit'
    | 'brand-safari'
    | 'brand-sass'
    | 'brand-sentry'
    | 'brand-shazam'
    | 'brand-sketch'
    | 'brand-skype'
    | 'brand-slack'
    | 'brand-snapchat'
    | 'brand-soundcloud'
    | 'brand-spotify'
    | 'brand-stackoverflow'
    | 'brand-steam'
    | 'brand-stripe'
    | 'brand-sublime-text'
    | 'brand-tabler'
    | 'brand-tailwind'
    | 'brand-telegram'
    | 'brand-tidal'
    | 'brand-tiktok'
    | 'brand-tinder'
    | 'brand-tripadvisor'
    | 'brand-tumblr'
    | 'brand-twitch'
    | 'brand-twitter'
    | 'brand-uber'
    | 'brand-ubuntu'
    | 'brand-unsplash'
    | 'brand-vercel'
    | 'brand-vimeo'
    | 'brand-visual-studio'
    | 'brand-vk'
    | 'brand-whatsapp'
    | 'brand-windows'
    | 'brand-yahoo'
    | 'brand-ycombinator'
    | 'brand-youtube'
    | 'bread'
    | 'briefcase'
    | 'brightness'
    | 'brightness-2'
    | 'brightness-down'
    | 'brightness-half'
    | 'brightness-up'
    | 'browser'
    | 'browser-check'
    | 'browser-plus'
    | 'browser-x'
    | 'brush'
    | 'bucket'
    | 'bug'
    | 'building'
    | 'building-arch'
    | 'building-bank'
    | 'building-bridge'
    | 'building-bridge-2'
    | 'building-carousel'
    | 'building-castle'
    | 'building-church'
    | 'building-community'
    | 'building-cottage'
    | 'building-factory'
    | 'building-fortress'
    | 'building-hospital'
    | 'building-lighthouse'
    | 'building-monument'
    | 'building-pavilon'
    | 'building-skyscraper'
    | 'building-store'
    | 'building-warehouse'
    | 'bulb'
    | 'bulb-off'
    | 'bulldozer'
    | 'bus'
    | 'businessplan'
    | 'butterfly'
    | 'c-sharp'
    | 'cake'
    | 'calculator'
    | 'calendar'
    | 'calendar-event'
    | 'calendar-minus'
    | 'calendar-off'
    | 'calendar-plus'
    | 'calendar-stats'
    | 'calendar-time'
    | 'camera'
    | 'camera-minus'
    | 'camera-off'
    | 'camera-plus'
    | 'camera-rotate'
    | 'camera-selfie'
    | 'candle'
    | 'candy'
    | 'capture'
    | 'car'
    | 'car-crane'
    | 'car-crash'
    | 'caravan'
    | 'cardboards'
    | 'caret-down'
    | 'caret-left'
    | 'caret-right'
    | 'caret-up'
    | 'cash'
    | 'cash-banknote'
    | 'cash-banknote-off'
    | 'cast'
    | 'ce'
    | 'cell'
    | 'certificate'
    | 'charging-pile'
    | 'chart-arcs'
    | 'chart-arcs-3'
    | 'chart-area'
    | 'chart-area-line'
    | 'chart-arrows'
    | 'chart-arrows-vertical'
    | 'chart-bar'
    | 'chart-bubble'
    | 'chart-candle'
    | 'chart-circles'
    | 'chart-donut'
    | 'chart-donut-2'
    | 'chart-donut-3'
    | 'chart-donut-4'
    | 'chart-dots'
    | 'chart-infographic'
    | 'chart-line'
    | 'chart-pie'
    | 'chart-pie-2'
    | 'chart-pie-3'
    | 'chart-pie-4'
    | 'chart-radar'
    | 'check'
    | 'checkbox'
    | 'checks'
    | 'checkup-list'
    | 'cheese'
    | 'chevron-down'
    | 'chevron-down-left'
    | 'chevron-down-right'
    | 'chevron-left'
    | 'chevron-right'
    | 'chevron-up'
    | 'chevron-up-left'
    | 'chevron-up-right'
    | 'chevrons-down'
    | 'chevrons-down-left'
    | 'chevrons-down-right'
    | 'chevrons-left'
    | 'chevrons-right'
    | 'chevrons-up'
    | 'chevrons-up-left'
    | 'chevrons-up-right'
    | 'christmas-tree'
    | 'circle'
    | 'circle-0'
    | 'circle-1'
    | 'circle-2'
    | 'circle-3'
    | 'circle-4'
    | 'circle-5'
    | 'circle-6'
    | 'circle-7'
    | 'circle-8'
    | 'circle-9'
    | 'circle-check'
    | 'circle-dashed'
    | 'circle-dot'
    | 'circle-dotted'
    | 'circle-half'
    | 'circle-half-2'
    | 'circle-half-vertical'
    | 'circle-minus'
    | 'circle-off'
    | 'circle-plus'
    | 'circle-rectangle'
    | 'circle-square'
    | 'circle-triangle'
    | 'circle-x'
    | 'circles'
    | 'clear-all'
    | 'clear-formatting'
    | 'click'
    | 'clipboard'
    | 'clipboard-check'
    | 'clipboard-list'
    | 'clipboard-plus'
    | 'clipboard-x'
    | 'clock'
    | 'cloud'
    | 'cloud-download'
    | 'cloud-fog'
    | 'cloud-lock'
    | 'cloud-lock-open'
    | 'cloud-off'
    | 'cloud-rain'
    | 'cloud-snow'
    | 'cloud-storm'
    | 'cloud-upload'
    | 'clubs'
    | 'code'
    | 'code-minus'
    | 'code-plus'
    | 'coffee'
    | 'coin'
    | 'color-picker'
    | 'color-swatch'
    | 'column-insert-left'
    | 'column-insert-right'
    | 'columns'
    | 'comet'
    | 'command'
    | 'compass'
    | 'components'
    | 'cone'
    | 'cone-2'
    | 'confetti'
    | 'container'
    | 'contrast'
    | 'contrast-2'
    | 'cookie'
    | 'copy'
    | 'copyleft'
    | 'copyright'
    | 'corner-down-left'
    | 'corner-down-left-double'
    | 'corner-down-right'
    | 'corner-down-right-double'
    | 'corner-left-down'
    | 'corner-left-down-double'
    | 'corner-left-up'
    | 'corner-left-up-double'
    | 'corner-right-down'
    | 'corner-right-down-double'
    | 'corner-right-up'
    | 'corner-right-up-double'
    | 'corner-up-left'
    | 'corner-up-left-double'
    | 'corner-up-right'
    | 'corner-up-right-double'
    | 'cpu'
    | 'crane'
    | 'creative-commons'
    | 'credit-card'
    | 'credit-card-off'
    | 'crop'
    | 'cross'
    | 'crosshair'
    | 'crown'
    | 'crown-off'
    | 'crutches'
    | 'cup'
    | 'curling'
    | 'curly-loop'
    | 'currency'
    | 'currency-bahraini'
    | 'currency-bath'
    | 'currency-bitcoin'
    | 'currency-cent'
    | 'currency-dinar'
    | 'currency-dirham'
    | 'currency-dogecoin'
    | 'currency-dollar'
    | 'currency-dollar-australian'
    | 'currency-dollar-canadian'
    | 'currency-dollar-singapore'
    | 'currency-ethereum'
    | 'currency-euro'
    | 'currency-forint'
    | 'currency-frank'
    | 'currency-krone-czech'
    | 'currency-krone-danish'
    | 'currency-krone-swedish'
    | 'currency-leu'
    | 'currency-lira'
    | 'currency-litecoin'
    | 'currency-naira'
    | 'currency-pound'
    | 'currency-real'
    | 'currency-renminbi'
    | 'currency-ripple'
    | 'currency-riyal'
    | 'currency-rubel'
    | 'currency-rupee'
    | 'currency-shekel'
    | 'currency-taka'
    | 'currency-tugrik'
    | 'currency-won'
    | 'currency-yen'
    | 'currency-zloty'
    | 'current-location'
    | 'cursor-text'
    | 'cut'
    | 'dashboard'
    | 'database'
    | 'database-export'
    | 'database-import'
    | 'database-off'
    | 'dental'
    | 'details'
    | 'device-analytics'
    | 'device-audio-tape'
    | 'device-cctv'
    | 'device-computer-camera'
    | 'device-computer-camera-off'
    | 'device-desktop'
    | 'device-desktop-analytics'
    | 'device-desktop-off'
    | 'device-floppy'
    | 'device-gamepad'
    | 'device-heart-monitor'
    | 'device-laptop'
    | 'device-laptop-off'
    | 'device-mobile'
    | 'device-mobile-message'
    | 'device-mobile-off'
    | 'device-mobile-rotated'
    | 'device-mobile-vibration'
    | 'device-nintendo'
    | 'device-speaker'
    | 'device-tablet'
    | 'device-tablet-off'
    | 'device-tv'
    | 'device-tv-off'
    | 'device-watch'
    | 'device-watch-off'
    | 'device-watch-stats'
    | 'device-watch-stats-2'
    | 'devices'
    | 'devices-2'
    | 'devices-off'
    | 'devices-pc'
    | 'dialpad'
    | 'diamond'
    | 'diamonds'
    | 'dice'
    | 'dimensions'
    | 'direction'
    | 'direction-horizontal'
    | 'directions'
    | 'disabled'
    | 'disabled-2'
    | 'disc'
    | 'discount'
    | 'discount-2'
    | 'divide'
    | 'dna'
    | 'dna-2'
    | 'dog-bowl'
    | 'door'
    | 'door-enter'
    | 'door-exit'
    | 'dots'
    | 'dots-circle-horizontal'
    | 'dots-diagonal'
    | 'dots-diagonal-2'
    | 'dots-vertical'
    | 'download'
    | 'drag-drop'
    | 'drag-drop-2'
    | 'drone'
    | 'drone-off'
    | 'drop-circle'
    | 'droplet'
    | 'droplet-filled'
    | 'droplet-filled-2'
    | 'droplet-half'
    | 'droplet-half-2'
    | 'droplet-off'
    | 'ear'
    | 'ear-off'
    | 'edit'
    | 'edit-circle'
    | 'egg'
    | 'elevator'
    | 'emergency-bed'
    | 'emphasis'
    | 'engine'
    | 'equal'
    | 'equal-not'
    | 'eraser'
    | 'error-404'
    | 'exchange'
    | 'exclamation-mark'
    | 'exposure'
    | 'external-link'
    | 'eye'
    | 'eye-check'
    | 'eye-off'
    | 'eye-table'
    | 'eyeglass'
    | 'eyeglass-2'
    | 'face-id'
    | 'face-id-error'
    | 'face-mask'
    | 'fall'
    | 'feather'
    | 'fence'
    | 'fidget-spinner'
    | 'file'
    | 'file-3d'
    | 'file-alert'
    | 'file-analytics'
    | 'file-arrow-left'
    | 'file-arrow-right'
    | 'file-barcode'
    | 'file-certificate'
    | 'file-chart'
    | 'file-check'
    | 'file-code'
    | 'file-code-2'
    | 'file-database'
    | 'file-description'
    | 'file-diff'
    | 'file-digit'
    | 'file-dislike'
    | 'file-dollar'
    | 'file-dots'
    | 'file-download'
    | 'file-euro'
    | 'file-export'
    | 'file-horizontal'
    | 'file-import'
    | 'file-info'
    | 'file-invoice'
    | 'file-like'
    | 'file-minus'
    | 'file-music'
    | 'file-off'
    | 'file-pencil'
    | 'file-phone'
    | 'file-plus'
    | 'file-power'
    | 'file-report'
    | 'file-rss'
    | 'file-scissors'
    | 'file-search'
    | 'file-settings'
    | 'file-shredder'
    | 'file-signal'
    | 'file-spreadsheet'
    | 'file-star'
    | 'file-symlink'
    | 'file-text'
    | 'file-time'
    | 'file-typography'
    | 'file-unknown'
    | 'file-upload'
    | 'file-vector'
    | 'file-x'
    | 'file-zip'
    | 'files'
    | 'files-off'
    | 'filter'
    | 'filter-off'
    | 'fingerprint'
    | 'firetruck'
    | 'first-aid-kit'
    | 'fish'
    | 'flag'
    | 'flag-2'
    | 'flag-3'
    | 'flame'
    | 'flare'
    | 'flask'
    | 'flask-2'
    | 'flip-horizontal'
    | 'flip-vertical'
    | 'float-center'
    | 'float-left'
    | 'float-none'
    | 'float-right'
    | 'flower'
    | 'focus'
    | 'focus-2'
    | 'focus-centered'
    | 'fold'
    | 'fold-down'
    | 'fold-up'
    | 'folder'
    | 'folder-minus'
    | 'folder-off'
    | 'folder-plus'
    | 'folder-x'
    | 'folders'
    | 'forbid'
    | 'forbid-2'
    | 'forklift'
    | 'forms'
    | 'frame'
    | 'free-rights'
    | 'friends'
    | 'gas-station'
    | 'gauge'
    | 'gavel'
    | 'geometry'
    | 'ghost'
    | 'gift'
    | 'git-branch'
    | 'git-commit'
    | 'git-compare'
    | 'git-fork'
    | 'git-merge'
    | 'git-pull-request'
    | 'git-pull-request-closed'
    | 'git-pull-request-draft'
    | 'gizmo'
    | 'glass'
    | 'glass-full'
    | 'glass-off'
    | 'globe'
    | 'golf'
    | 'gps'
    | 'grain'
    | 'grid-dots'
    | 'grid-pattern'
    | 'grill'
    | 'grip-horizontal'
    | 'grip-vertical'
    | 'growth'
    | 'h-1'
    | 'h-2'
    | 'h-3'
    | 'h-4'
    | 'h-5'
    | 'h-6'
    | 'hammer'
    | 'hand-click'
    | 'hand-finger'
    | 'hand-little-finger'
    | 'hand-middle-finger'
    | 'hand-move'
    | 'hand-off'
    | 'hand-ring-finger'
    | 'hand-rock'
    | 'hand-stop'
    | 'hand-three-fingers'
    | 'hand-two-fingers'
    | 'hanger'
    | 'hash'
    | 'haze'
    | 'heading'
    | 'headphones'
    | 'headphones-off'
    | 'headset'
    | 'heart'
    | 'heart-broken'
    | 'heart-rate-monitor'
    | 'heartbeat'
    | 'helicopter'
    | 'helicopter-landing'
    | 'helmet'
    | 'help'
    | 'hexagon'
    | 'hexagon-off'
    | 'hierarchy'
    | 'hierarchy-2'
    | 'highlight'
    | 'history'
    | 'home'
    | 'home-2'
    | 'hotel-service'
    | 'hourglass'
    | 'ice-cream'
    | 'ice-cream-2'
    | 'ice-skating'
    | 'id'
    | 'id-badge'
    | 'inbox'
    | 'indent-decrease'
    | 'indent-increase'
    | 'infinity'
    | 'info-circle'
    | 'info-square'
    | 'italic'
    | 'jump-rope'
    | 'karate'
    | 'kering'
    | 'key'
    | 'keyboard'
    | 'keyboard-hide'
    | 'keyboard-off'
    | 'keyboard-show'
    | 'ladder'
    | 'lamp'
    | 'language'
    | 'language-hiragana'
    | 'language-katakana'
    | 'lasso'
    | 'layers-difference'
    | 'layers-intersect'
    | 'layers-intersect-2'
    | 'layers-linked'
    | 'layers-subtract'
    | 'layers-union'
    | 'layout'
    | 'layout-2'
    | 'layout-align-bottom'
    | 'layout-align-center'
    | 'layout-align-left'
    | 'layout-align-middle'
    | 'layout-align-right'
    | 'layout-align-top'
    | 'layout-board'
    | 'layout-board-split'
    | 'layout-bottombar'
    | 'layout-cards'
    | 'layout-columns'
    | 'layout-dashboard'
    | 'layout-distribute-horizontal'
    | 'layout-distribute-vertical'
    | 'layout-grid'
    | 'layout-grid-add'
    | 'layout-kanban'
    | 'layout-list'
    | 'layout-navbar'
    | 'layout-rows'
    | 'layout-sidebar'
    | 'layout-sidebar-left-collapse'
    | 'layout-sidebar-left-expand'
    | 'layout-sidebar-right'
    | 'layout-sidebar-right-collapse'
    | 'layout-sidebar-right-expand'
    | 'leaf'
    | 'lego'
    | 'lemon'
    | 'lemon-2'
    | 'letter-a'
    | 'letter-b'
    | 'letter-c'
    | 'letter-case'
    | 'letter-case-lower'
    | 'letter-case-toggle'
    | 'letter-case-upper'
    | 'letter-d'
    | 'letter-e'
    | 'letter-f'
    | 'letter-g'
    | 'letter-h'
    | 'letter-i'
    | 'letter-j'
    | 'letter-k'
    | 'letter-l'
    | 'letter-m'
    | 'letter-n'
    | 'letter-o'
    | 'letter-p'
    | 'letter-q'
    | 'letter-r'
    | 'letter-s'
    | 'letter-spacing'
    | 'letter-t'
    | 'letter-u'
    | 'letter-v'
    | 'letter-w'
    | 'letter-x'
    | 'letter-y'
    | 'letter-z'
    | 'license'
    | 'lifebuoy'
    | 'line'
    | 'line-dashed'
    | 'line-dotted'
    | 'line-height'
    | 'link'
    | 'list'
    | 'list-check'
    | 'list-details'
    | 'list-numbers'
    | 'list-search'
    | 'live-photo'
    | 'live-view'
    | 'loader'
    | 'loader-quarter'
    | 'location'
    | 'lock'
    | 'lock-access'
    | 'lock-off'
    | 'lock-open'
    | 'lock-square'
    | 'login'
    | 'logout'
    | 'lollipop'
    | 'luggage'
    | 'lungs'
    | 'macro'
    | 'magnet'
    | 'mail'
    | 'mail-fast'
    | 'mail-forward'
    | 'mail-opened'
    | 'mailbox'
    | 'man'
    | 'manual-gearbox'
    | 'map'
    | 'map-2'
    | 'map-pin'
    | 'map-pin-off'
    | 'map-pins'
    | 'map-search'
    | 'markdown'
    | 'marquee'
    | 'marquee-2'
    | 'mars'
    | 'mask'
    | 'mask-off'
    | 'massage'
    | 'math'
    | 'math-function'
    | 'math-symbols'
    | 'maximize'
    | 'meat'
    | 'medal'
    | 'medal-2'
    | 'medical-cross'
    | 'medicine-syrup'
    | 'menu'
    | 'menu-2'
    | 'message'
    | 'message-2'
    | 'message-2-code'
    | 'message-circle'
    | 'message-circle-2'
    | 'message-circle-off'
    | 'message-code'
    | 'message-dots'
    | 'message-language'
    | 'message-off'
    | 'message-plus'
    | 'message-report'
    | 'messages'
    | 'messages-off'
    | 'microphone'
    | 'microphone-2'
    | 'microphone-off'
    | 'microscope'
    | 'miliraty-award'
    | 'military-rank'
    | 'milk'
    | 'minimize'
    | 'minus'
    | 'minus-vertical'
    | 'mist'
    | 'mood-boy'
    | 'mood-confuzed'
    | 'mood-crazy-happy'
    | 'mood-cry'
    | 'mood-empty'
    | 'mood-happy'
    | 'mood-kid'
    | 'mood-nervous'
    | 'mood-neutral'
    | 'mood-sad'
    | 'mood-smile'
    | 'mood-suprised'
    | 'mood-tongue'
    | 'moon'
    | 'moon-2'
    | 'moon-stars'
    | 'moped'
    | 'motorbike'
    | 'mountain'
    | 'mouse'
    | 'movie'
    | 'mug'
    | 'multiplier-0-5x'
    | 'multiplier-1-5x'
    | 'multiplier-1x'
    | 'multiplier-2x'
    | 'mushroom'
    | 'music'
    | 'new-section'
    | 'news'
    | 'nfc'
    | 'no-copyright'
    | 'no-creative-commons'
    | 'no-derivatives'
    | 'north-star'
    | 'note'
    | 'notebook'
    | 'notes'
    | 'notification'
    | 'number-0'
    | 'number-1'
    | 'number-2'
    | 'number-3'
    | 'number-4'
    | 'number-5'
    | 'number-6'
    | 'number-7'
    | 'number-8'
    | 'number-9'
    | 'numbers'
    | 'nurse'
    | 'octagon'
    | 'octagon-off'
    | 'old'
    | 'olympics'
    | 'omega'
    | 'outlet'
    | 'oval'
    | 'oval-vertical'
    | 'overline'
    | 'package'
    | 'pacman'
    | 'page-break'
    | 'paint'
    | 'palette'
    | 'panorama-horizontal'
    | 'panorama-vertical'
    | 'paper-bag'
    | 'paperclip'
    | 'parachute'
    | 'parentheses'
    | 'parking'
    | 'paw'
    | 'peace'
    | 'pencil'
    | 'pennant'
    | 'pennant-2'
    | 'pentagon'
    | 'pepper'
    | 'percentage'
    | 'perspective'
    | 'phone'
    | 'phone-call'
    | 'phone-calling'
    | 'phone-check'
    | 'phone-incoming'
    | 'phone-off'
    | 'phone-outgoing'
    | 'phone-pause'
    | 'phone-plus'
    | 'phone-x'
    | 'photo'
    | 'photo-off'
    | 'physotherapist'
    | 'picture-in-picture'
    | 'picture-in-picture-off'
    | 'picture-in-picture-on'
    | 'picture-in-picture-top'
    | 'pig'
    | 'pill'
    | 'pills'
    | 'pin'
    | 'pinned'
    | 'pinned-off'
    | 'pizza'
    | 'plane'
    | 'plane-arrival'
    | 'plane-departure'
    | 'plane-inflight'
    | 'planet'
    | 'plant'
    | 'plant-2'
    | 'play-card'
    | 'player-eject'
    | 'player-pause'
    | 'player-play'
    | 'player-record'
    | 'player-skip-back'
    | 'player-skip-forward'
    | 'player-stop'
    | 'player-track-next'
    | 'player-track-prev'
    | 'playlist'
    | 'playlist-add'
    | 'playlist-x'
    | 'plug'
    | 'plug-connected'
    | 'plus'
    | 'point'
    | 'pokeball'
    | 'polaroid'
    | 'polygon'
    | 'pool'
    | 'power'
    | 'pray'
    | 'premium-rights'
    | 'prescription'
    | 'presentation'
    | 'presentation-analytics'
    | 'printer'
    | 'prison'
    | 'prompt'
    | 'propeller'
    | 'puzzle'
    | 'puzzle-2'
    | 'pyramid'
    | 'qrcode'
    | 'question-mark'
    | 'quote'
    | 'radar'
    | 'radar-2'
    | 'radio'
    | 'radioactive'
    | 'radius-bottom-left'
    | 'radius-bottom-right'
    | 'radius-top-left'
    | 'radius-top-right'
    | 'rainbow'
    | 'receipt'
    | 'receipt-2'
    | 'receipt-off'
    | 'receipt-refund'
    | 'receipt-tax'
    | 'recharging'
    | 'record-mail'
    | 'rectangle'
    | 'rectangle-vertical'
    | 'recycle'
    | 'refresh'
    | 'refresh-alert'
    | 'refresh-dot'
    | 'registered'
    | 'relation-many-to-many'
    | 'relation-one-to-many'
    | 'relation-one-to-one'
    | 'repeat'
    | 'repeat-once'
    | 'replace'
    | 'report'
    | 'report-analytics'
    | 'report-medical'
    | 'report-money'
    | 'report-search'
    | 'resize'
    | 'ripple'
    | 'road'
    | 'road-sign'
    | 'robot'
    | 'rocket'
    | 'roller-skating'
    | 'rotate'
    | 'rotate-2'
    | 'rotate-360'
    | 'rotate-clockwise'
    | 'rotate-clockwise-2'
    | 'rotate-dot'
    | 'rotate-rectangle'
    | 'route'
    | 'router'
    | 'row-insert-bottom'
    | 'row-insert-top'
    | 'rss'
    | 'ruler'
    | 'ruler-2'
    | 'run'
    | 'sailboat'
    | 'salt'
    | 'satellite'
    | 'sausage'
    | 'scale'
    | 'scale-outline'
    | 'scan'
    | 'school'
    | 'scissors'
    | 'scooter'
    | 'scooter-electric'
    | 'screen-share'
    | 'screen-share-off'
    | 'scuba-mask'
    | 'search'
    | 'section'
    | 'section-sign'
    | 'seeding'
    | 'select'
    | 'selector'
    | 'send'
    | 'separator'
    | 'separator-horizontal'
    | 'separator-vertical'
    | 'server'
    | 'servicemark'
    | 'settings'
    | 'settings-automation'
    | 'shadow'
    | 'shadow-off'
    | 'shape'
    | 'shape-2'
    | 'shape-3'
    | 'share'
    | 'shield'
    | 'shield-check'
    | 'shield-checkered'
    | 'shield-chevron'
    | 'shield-lock'
    | 'shield-off'
    | 'shield-x'
    | 'ship'
    | 'shirt'
    | 'shoe'
    | 'shopping-cart'
    | 'shopping-cart-discount'
    | 'shopping-cart-off'
    | 'shopping-cart-plus'
    | 'shopping-cart-x'
    | 'shredder'
    | 'sign-left'
    | 'sign-right'
    | 'signature'
    | 'sitemap'
    | 'skateboard'
    | 'sleigh'
    | 'slice'
    | 'slideshow'
    | 'smart-home'
    | 'smoking'
    | 'smoking-no'
    | 'snowflake'
    | 'soccer-field'
    | 'social'
    | 'sock'
    | 'sofa'
    | 'sort-ascending'
    | 'sort-ascending-2'
    | 'sort-ascending-letters'
    | 'sort-ascending-numbers'
    | 'sort-descending'
    | 'sort-descending-2'
    | 'sort-descending-letters'
    | 'sort-descending-numbers'
    | 'soup'
    | 'space'
    | 'spacing-horizontal'
    | 'spacing-vertical'
    | 'spade'
    | 'speakerphone'
    | 'speedboat'
    | 'sport-billard'
    | 'square'
    | 'square-0'
    | 'square-1'
    | 'square-2'
    | 'square-3'
    | 'square-4'
    | 'square-5'
    | 'square-6'
    | 'square-7'
    | 'square-8'
    | 'square-9'
    | 'square-asterisk'
    | 'square-check'
    | 'square-dot'
    | 'square-forbid'
    | 'square-forbid-2'
    | 'square-half'
    | 'square-minus'
    | 'square-off'
    | 'square-plus'
    | 'square-root'
    | 'square-root-2'
    | 'square-rotated'
    | 'square-rotated-forbid'
    | 'square-rotated-forbid-2'
    | 'square-rotated-off'
    | 'square-toggle'
    | 'square-toggle-horizontal'
    | 'square-x'
    | 'squares-diagonal'
    | 'squares-filled'
    | 'stack'
    | 'stack-2'
    | 'stack-3'
    | 'stairs'
    | 'stairs-down'
    | 'stairs-up'
    | 'star'
    | 'star-half'
    | 'star-off'
    | 'stars'
    | 'steering-wheel'
    | 'step-into'
    | 'step-out'
    | 'stethoscope'
    | 'sticker'
    | 'strikethrough'
    | 'submarine'
    | 'subscript'
    | 'subtask'
    | 'sum'
    | 'sun'
    | 'sun-off'
    | 'sunrise'
    | 'sunset'
    | 'superscript'
    | 'swimming'
    | 'switch'
    | 'switch-2'
    | 'switch-3'
    | 'switch-horizontal'
    | 'switch-vertical'
    | 'sword'
    | 'table'
    | 'table-export'
    | 'table-import'
    | 'table-off'
    | 'tag'
    | 'tag-off'
    | 'tags'
    | 'tags-off'
    | 'tallymark-1'
    | 'tallymark-2'
    | 'tallymark-3'
    | 'tallymark-4'
    | 'tallymarks'
    | 'tank'
    | 'target'
    | 'temperature'
    | 'temperature-celsius'
    | 'temperature-fahrenheit'
    | 'temperature-minus'
    | 'temperature-plus'
    | 'template'
    | 'tent'
    | 'terminal'
    | 'terminal-2'
    | 'test-pipe'
    | 'text-direction-ltr'
    | 'text-direction-rtl'
    | 'text-resize'
    | 'text-wrap'
    | 'text-wrap-disabled'
    | 'thermometer'
    | 'thumb-down'
    | 'thumb-up'
    | 'ticket'
    | 'tilt-shift'
    | 'timeline'
    | 'tir'
    | 'toggle-left'
    | 'toggle-right'
    | 'toilet-paper'
    | 'tool'
    | 'tools'
    | 'tools-kitchen'
    | 'tools-kitchen-2'
    | 'tornado'
    | 'tournament'
    | 'track'
    | 'tractor'
    | 'trademark'
    | 'traffic-cone'
    | 'traffic-lights'
    | 'train'
    | 'transfer-in'
    | 'transfer-out'
    | 'trash'
    | 'trash-off'
    | 'trash-x'
    | 'tree'
    | 'trees'
    | 'trending-down'
    | 'trending-down-2'
    | 'trending-down-3'
    | 'trending-up'
    | 'trending-up-2'
    | 'trending-up-3'
    | 'triangle'
    | 'triangle-inverted'
    | 'triangle-off'
    | 'triangle-square-circle'
    | 'trident'
    | 'trophy'
    | 'truck'
    | 'truck-delivery'
    | 'truck-off'
    | 'truck-return'
    | 'typography'
    | 'umbrella'
    | 'underline'
    | 'unlink'
    | 'upload'
    | 'urgent'
    | 'usb'
    | 'user'
    | 'user-check'
    | 'user-circle'
    | 'user-exclamation'
    | 'user-minus'
    | 'user-off'
    | 'user-plus'
    | 'user-search'
    | 'user-x'
    | 'users'
    | 'vaccine'
    | 'vaccine-bottle'
    | 'variable'
    | 'vector'
    | 'vector-beizer-2'
    | 'vector-bezier'
    | 'vector-triangle'
    | 'venus'
    | 'versions'
    | 'video'
    | 'video-minus'
    | 'video-off'
    | 'video-plus'
    | 'view-360'
    | 'viewfinder'
    | 'viewport-narrow'
    | 'viewport-wide'
    | 'vinyl'
    | 'virus'
    | 'virus-off'
    | 'virus-search'
    | 'vocabulary'
    | 'volume'
    | 'volume-2'
    | 'volume-3'
    | 'walk'
    | 'wall'
    | 'wallet'
    | 'wallpaper'
    | 'wand'
    | 'wave-saw-tool'
    | 'wave-sine'
    | 'wave-square'
    | 'webhook'
    | 'wifi'
    | 'wifi-0'
    | 'wifi-1'
    | 'wifi-2'
    | 'wifi-off'
    | 'wind'
    | 'windmill'
    | 'window'
    | 'windsock'
    | 'wiper'
    | 'wiper-wash'
    | 'woman'
    | 'world'
    | 'world-download'
    | 'world-latitude'
    | 'world-longitude'
    | 'world-upload'
    | 'wrecking-ball'
    | 'writing'
    | 'writing-sign'
    | 'x'
    | 'yin-yang'
    | 'yoga'
    | 'zodiac-aquarius'
    | 'zodiac-aries'
    | 'zodiac-cancer'
    | 'zodiac-capricorn'
    | 'zodiac-gemini'
    | 'zodiac-leo'
    | 'zodiac-libra'
    | 'zodiac-pisces'
    | 'zodiac-sagittarius'
    | 'zodiac-scorpio'
    | 'zodiac-taurus'
    | 'zodiac-virgo'
    | 'zoom-cancel'
    | 'zoom-check'
    | 'zoom-in'
    | 'zoom-money'
    | 'zoom-out'
    | 'zoom-question'
}

export interface IconTypes {
  boxicons: 'solid' | 'regular' | 'logos'
  eos: 'animated' | 'outlined' | 'solid'
  fontawesome: 'solid' | 'regular' | 'brands'
  iconpark:
    | 'Datas'
    | 'Connect'
    | 'Communicate'
    | 'Clothes'
    | 'Child'
    | 'Charts'
    | 'Character'
    | 'Build'
    | 'Brand'
    | 'Books'
    | 'Base'
    | 'Arrows'
    | 'Abstract'
    | 'Edit'
    | 'Emoji'
    | 'Foods'
    | 'Graphics'
    | 'Hands'
    | 'Hardware'
    | 'Health'
    | 'Industry'
    | 'Life'
    | 'Makeups'
    | 'Money'
    | 'Music'
    | 'Office'
    | 'Operate'
    | 'Others'
    | 'Peoples'
    | 'Sports'
    | 'Time'
    | 'Travel'
    | 'Weather'
  phosphor: 'thin' | 'regular' | 'light' | 'fill' | 'duotone' | 'bold'
}

export interface IconKinds {
  flags: '4x3' | '1x1'
  material: 'baseline' | 'outline' | 'round' | 'sharp' | 'twotone'
}
